import {
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  enumEntries20mr21zbe3az4 as enumEntries,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  protoOf180f3jzyo7rfj as protoOf,
  defineProp3ur6h3slcvq4x as defineProp,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString30pk9tzaqopn as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  emptyList1g2z5xcrvp2zy as emptyList,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  listOfvhqybd2zx248 as listOf,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Companion_getInstance1cdckxf15vkye as Companion_getInstance,
  Companion_getInstance1jfygh5e58evr as Companion_getInstance_0,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getKClass3t8tygqu4lcxf as getKClass,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
  UnknownFieldException_init_$Create$hprktcyan42n as UnknownFieldException_init_$Create$,
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  INT_getInstancev41irj55hx3n as INT_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  FloatSerializer_getInstance2fspe61zbqree as FloatSerializer_getInstance,
  STRING_getInstance2ou4lro9xn2qn as STRING_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { Resource72wyew2hkpsj as Resource } from './ktor-ktor-resources.mjs';
import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  Companion_getInstancefc1kb6w5z78x as Companion_getInstance_1,
} from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  JsonContentPolymorphicSerializer1zt3sp8asmujz as JsonContentPolymorphicSerializer,
  get_jsonObject2u4z2ch1uuca9 as get_jsonObject,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(AnalyticsAuthErrorCode, 'AnalyticsAuthErrorCode', VOID, Enum);
initMetadataForClass(AnalyticsAuthMethod, 'AnalyticsAuthMethod', VOID, Enum);
initMetadataForClass(AnalyticsAuthStage, 'AnalyticsAuthStage', VOID, Enum);
initMetadataForObject(AnalyticsChartType_0, 'AnalyticsChartType');
initMetadataForObject(AnalyticsClickId_0, 'AnalyticsClickId');
initMetadataForObject(AnalyticsContentId_0, 'AnalyticsContentId');
initMetadataForClass(AnalyticsContentType, 'AnalyticsContentType', VOID, Enum);
initMetadataForObject(AnalyticsCtaId_0, 'AnalyticsCtaId');
initMetadataForObject(AnalyticsDestination_0, 'AnalyticsDestination');
initMetadataForObject(AnalyticsDropdownId_0, 'AnalyticsDropdownId');
initMetadataForObject(AnalyticsEvents_0, 'AnalyticsEvents');
initMetadataForObject(AnalyticsFilterType_0, 'AnalyticsFilterType');
initMetadataForObject(AnalyticsFormId_0, 'AnalyticsFormId');
initMetadataForClass(AnalyticsFormOutcome, 'AnalyticsFormOutcome', VOID, Enum);
initMetadataForObject(AnalyticsLinkId_0, 'AnalyticsLinkId');
initMetadataForObject(AnalyticsNavLocation_0, 'AnalyticsNavLocation');
initMetadataForObject(AnalyticsParams_0, 'AnalyticsParams');
initMetadataForClass(AnalyticsPaymentType, 'AnalyticsPaymentType', VOID, Enum);
initMetadataForObject(AnalyticsScreenName_0, 'AnalyticsScreenName');
initMetadataForObject(AnalyticsTimeRange_0, 'AnalyticsTimeRange');
initMetadataForClass(AnalyticsTransactionStage, 'AnalyticsTransactionStage', VOID, Enum);
initMetadataForClass(AnalyticsTransactionType, 'AnalyticsTransactionType', VOID, Enum);
initMetadataForObject(AnalyticsUserProperties_0, 'AnalyticsUserProperties');
initMetadataForObject(AnalyticsValue_0, 'AnalyticsValue');
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PasswordlessRequest, 'PasswordlessRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PasswordlessResponse, 'PasswordlessResponse', PasswordlessResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ProfileResponse, 'ProfileResponse', ProfileResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RenewJWTRequest, 'RenewJWTRequest', RenewJWTRequest, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TokenResponse, 'TokenResponse', TokenResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_4);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VerifyAuthRequest, 'VerifyAuthRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_5);
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VerifyAuthResponse, 'VerifyAuthResponse', VerifyAuthResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_6);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RequestChallengeResponse, 'RequestChallengeResponse', RequestChallengeResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_7);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RequestChallengeResponsePublicKey, 'RequestChallengeResponsePublicKey', RequestChallengeResponsePublicKey, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_8);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RequestChallengeResponseAllowCredential, 'RequestChallengeResponseAllowCredential', RequestChallengeResponseAllowCredential, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_9);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VersionResponse, 'VersionResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_10, VOID, [SerializerFactory]);
initMetadataForClass(AccountStatus, 'AccountStatus', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_13});
initMetadataForCompanion(Companion_11, VOID, [SerializerFactory]);
initMetadataForClass(ApiFeedbackSurveyTypeEnum, 'ApiFeedbackSurveyTypeEnum', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_14});
initMetadataForCompanion(Companion_12, VOID, [SerializerFactory]);
initMetadataForClass(DevicePlatformEnum, 'DevicePlatformEnum', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_15});
initMetadataForCompanion(Companion_13, VOID, [SerializerFactory]);
initMetadataForClass(FeedbackSurveyStatusEnum, 'FeedbackSurveyStatusEnum', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_16});
initMetadataForCompanion(Companion_14, VOID, [SerializerFactory]);
initMetadataForClass(InvestorTierEnum, 'InvestorTierEnum', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_17});
initMetadataForCompanion(Companion_15, VOID, [SerializerFactory]);
initMetadataForClass(LoginMethod, 'LoginMethod', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_18});
initMetadataForCompanion(Companion_16, VOID, [SerializerFactory]);
initMetadataForClass(PermissionScope, 'PermissionScope', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_19});
initMetadataForCompanion(Companion_17, VOID, [SerializerFactory]);
initMetadataForClass(SecretType, 'SecretType', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_20});
initMetadataForCompanion(Companion_18, VOID, [SerializerFactory]);
initMetadataForClass(TransactionTypeEnum, 'TransactionTypeEnum', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_21});
initMetadataForCompanion(Companion_19, VOID, [SerializerFactory]);
initMetadataForClass(TransactionStatusEnum, 'TransactionStatusEnum', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_22});
initMetadataForCompanion(Companion_20, VOID, [SerializerFactory]);
initMetadataForClass(TwoFactor, 'TwoFactor', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_23});
initMetadataForCompanion(Companion_21, VOID, [SerializerFactory]);
initMetadataForClass(ErrorCode, 'ErrorCode', VOID, Enum, VOID, VOID, VOID, {0: ErrorCodeSerializer_getInstance});
initMetadataForObject(ErrorCodeSerializer, 'ErrorCodeSerializer', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_22);
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MohaApiError, 'MohaApiError', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_23);
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Dividend, 'Dividend', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_24, VOID, [SerializerFactory]);
initMetadataForClass(DividendPeriodStatus, 'DividendPeriodStatus', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_27});
initMetadataForCompanion(Companion_25, VOID, [SerializerFactory]);
initMetadataForClass(PayoutStatus, 'PayoutStatus', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_28});
initMetadataForCompanion(Companion_26, VOID, [SerializerFactory]);
initMetadataForClass(DivEarningsBreakdownType, 'DivEarningsBreakdownType', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_29});
initMetadataForCompanion(Companion_27);
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DivEarningsBreakdown, 'DivEarningsBreakdown', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_28);
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DividendPeriodPayout, 'DividendPeriodPayout', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForCompanion(Companion_29);
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DividendPeriod, 'DividendPeriod', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCompanion(Companion_30);
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Fund, 'Fund', Fund, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_31);
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TickersResponse, 'TickersResponse', TickersResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForCompanion(Companion_32);
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(KycReferenceResponse, 'KycReferenceResponse', KycReferenceResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
initMetadataForCompanion(Companion_33);
initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ShuftiMobileConfigResponse, 'ShuftiMobileConfigResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
initMetadataForCompanion(Companion_34);
initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_35);
initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VerifyKycResponse, 'VerifyKycResponse', VOID, VOID, VOID, VOID, VOID, {0: VerifyKycResponseSerializer_getInstance});
initMetadataForClass(Success, 'Success', VOID, VerifyKycResponse, VOID, VOID, VOID, {0: $serializer_getInstance_19});
initMetadataForClass(Error_0, 'Error', VOID, VerifyKycResponse, VOID, VOID, VOID, {0: $serializer_getInstance_20});
initMetadataForCompanion(Companion_36);
initMetadataForCompanion(Companion_37);
initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VerifyKyErrorDetails, 'VerifyKyErrorDetails', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
initMetadataForInterface(IPortfolio, 'IPortfolio');
initMetadataForCompanion(Companion_38);
initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(OverallPortfolio, 'OverallPortfolio', VOID, VOID, [IPortfolio], VOID, VOID, {0: $serializer_getInstance_22});
initMetadataForCompanion(Companion_39);
initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EstimatedDividend, 'EstimatedDividend', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
initMetadataForCompanion(Companion_40);
initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Position, 'Position', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
initMetadataForCompanion(Companion_41);
initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Portfolio, 'Portfolio', Portfolio, VOID, [IPortfolio], VOID, VOID, {0: $serializer_getInstance_25});
initMetadataForCompanion(Companion_42);
initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LotDetail, 'LotDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
initMetadataForCompanion(Companion_43);
initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ChartPoint, 'ChartPoint', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
initMetadataForCompanion(Companion_44);
initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CreatePropertyRequest, 'CreatePropertyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
initMetadataForCompanion(Companion_45);
initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CreatePropertyResponse, 'CreatePropertyResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
initMetadataForCompanion(Companion_46);
initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UploadHoldingsRequest, 'UploadHoldingsRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
initMetadataForCompanion(Companion_47);
initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_48);
initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_49);
initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_50);
initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_51);
initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_52);
initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Passwordless, 'Passwordless', Passwordless, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
initMetadataForClass(Verify, 'Verify', Verify, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
initMetadataForClass(Renew, 'Renew', Renew, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_33});
initMetadataForClass(Profile, 'Profile', Profile, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
initMetadataForClass(ShuftiReference, 'ShuftiReference', ShuftiReference, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
initMetadataForClass(ShuftiVerification, 'ShuftiVerification', ShuftiVerification, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
initMetadataForCompanion(Companion_53);
initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AuthRoutes, 'AuthRoutes', AuthRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_37});
initMetadataForCompanion(Companion_54);
initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ByPath, 'ByPath', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_38});
initMetadataForCompanion(Companion_55);
initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FileRoutes, 'FileRoutes', FileRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_39});
initMetadataForCompanion(Companion_56);
initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ByPath_0, 'ByPath', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_40});
initMetadataForCompanion(Companion_57);
initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ContentRoutes, 'ContentRoutes', ContentRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_41});
initMetadataForCompanion(Companion_58);
initMetadataForObject($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_59);
initMetadataForObject($serializer_43, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_60);
initMetadataForObject($serializer_44, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(List, 'List', List, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
initMetadataForClass(ByTicker, 'ByTicker', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_43});
initMetadataForClass(Dividends, 'Dividends', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_44});
initMetadataForCompanion(Companion_61);
initMetadataForObject($serializer_45, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FundsRoutes, 'FundsRoutes', FundsRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_45});
initMetadataForCompanion(Companion_62);
initMetadataForObject($serializer_46, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_63);
initMetadataForObject($serializer_47, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_64);
initMetadataForObject($serializer_48, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_65);
initMetadataForObject($serializer_49, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_66);
initMetadataForObject($serializer_50, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_67);
initMetadataForObject($serializer_51, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_68);
initMetadataForObject($serializer_52, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Settings, 'Settings', Settings, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_46});
initMetadataForClass(SetDefault2FA, 'SetDefault2FA', SetDefault2FA, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_47});
initMetadataForClass(Totp, 'Totp', Totp, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_48});
initMetadataForClass(Password, 'Password', Password, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_49});
initMetadataForClass(WebAuthn, 'WebAuthn', WebAuthn, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_50});
initMetadataForClass(WebAuthnRegister, 'WebAuthnRegister', WebAuthnRegister, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_51});
initMetadataForClass(WebAuthnByUuid, 'WebAuthnByUuid', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_52});
initMetadataForCompanion(Companion_69);
initMetadataForObject($serializer_53, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SecurityRoutes, 'SecurityRoutes', SecurityRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_53});
initMetadataForCompanion(Companion_70);
initMetadataForObject($serializer_54, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MobileConfig, 'MobileConfig', MobileConfig, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_54});
initMetadataForCompanion(Companion_71);
initMetadataForObject($serializer_55, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ShuftiRoutes, 'ShuftiRoutes', ShuftiRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
initMetadataForCompanion(Companion_72);
initMetadataForObject($serializer_56, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VersionRoute, 'VersionRoute', VersionRoute, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
initMetadataForCompanion(Companion_73);
initMetadataForObject($serializer_57, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_74);
initMetadataForObject($serializer_58, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_75);
initMetadataForObject($serializer_59, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_76);
initMetadataForObject($serializer_60, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_77);
initMetadataForObject($serializer_61, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_78);
initMetadataForObject($serializer_62, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_79);
initMetadataForObject($serializer_63, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_80);
initMetadataForObject($serializer_64, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_81);
initMetadataForObject($serializer_65, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_82);
initMetadataForObject($serializer_66, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_83);
initMetadataForObject($serializer_67, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_84);
initMetadataForObject($serializer_68, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_85);
initMetadataForObject($serializer_69, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TransactionById, 'TransactionById', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_57});
initMetadataForClass(DepositBankDetail, 'DepositBankDetail', DepositBankDetail, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_58});
initMetadataForClass(PayoutBank, 'PayoutBank', PayoutBank, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_59});
initMetadataForClass(BankAccountBeneficiary, 'BankAccountBeneficiary', BankAccountBeneficiary, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_60});
initMetadataForClass(BankAccount, 'BankAccount', BankAccount, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_61});
initMetadataForClass(ShuftiAccessToken, 'ShuftiAccessToken', ShuftiAccessToken, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_62});
initMetadataForClass(PortfolioByTicker, 'PortfolioByTicker', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_63});
initMetadataForClass(Portfolios, 'Portfolios', Portfolios, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_64});
initMetadataForClass(Transactions, 'Transactions', Transactions, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_65});
initMetadataForClass(Reservation, 'Reservation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_66});
initMetadataForClass(CreateTransaction, 'CreateTransaction', CreateTransaction, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_67});
initMetadataForClass(FeedbackSurvey, 'FeedbackSurvey', FeedbackSurvey, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_68});
initMetadataForClass(UpdateThreshold, 'UpdateThreshold', UpdateThreshold, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_69});
initMetadataForCompanion(Companion_86);
initMetadataForObject($serializer_70, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UserRoutes, 'UserRoutes', UserRoutes, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_70});
initMetadataForCompanion(Companion_87);
initMetadataForObject($serializer_71, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ActivateTotpResponse, 'ActivateTotpResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_71});
initMetadataForCompanion(Companion_88);
initMetadataForObject($serializer_72, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EnablePasswordRequest, 'EnablePasswordRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_72});
initMetadataForCompanion(Companion_89);
initMetadataForObject($serializer_73, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GetUserSettingsResponseEnable, 'GetUserSettingsResponseEnable', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_73});
initMetadataForCompanion(Companion_90);
initMetadataForObject($serializer_74, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GetUserSettingsResponseWebAuthn, 'GetUserSettingsResponseWebAuthn', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_74});
initMetadataForCompanion(Companion_91);
initMetadataForObject($serializer_75, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(WebAuthnDevice, 'WebAuthnDevice', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_75});
initMetadataForCompanion(Companion_92);
initMetadataForObject($serializer_76, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GetUserSettingsResponse, 'GetUserSettingsResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_76});
initMetadataForCompanion(Companion_93);
initMetadataForObject($serializer_77, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterWebAuthnRequest, 'RegisterWebAuthnRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_77});
initMetadataForCompanion(Companion_94);
initMetadataForObject($serializer_78, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterWebAuthnRequestResponse, 'RegisterWebAuthnRequestResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_78});
initMetadataForCompanion(Companion_95);
initMetadataForObject($serializer_79, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterWebAuthnRequestClientExtensionResults, 'RegisterWebAuthnRequestClientExtensionResults', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_79});
initMetadataForCompanion(Companion_96);
initMetadataForObject($serializer_80, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterWebAuthnRequestCredProps, 'RegisterWebAuthnRequestCredProps', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_80});
initMetadataForCompanion(Companion_97);
initMetadataForObject($serializer_81, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetDefault2FARequest, 'SetDefault2FARequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_81});
initMetadataForCompanion(Companion_98);
initMetadataForObject($serializer_82, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StartRegisterWebAuthnRequest, 'StartRegisterWebAuthnRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_82});
initMetadataForCompanion(Companion_99);
initMetadataForObject($serializer_83, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PublicKeyCredentialCreationRp, 'PublicKeyCredentialCreationRp', PublicKeyCredentialCreationRp, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_83});
initMetadataForCompanion(Companion_100);
initMetadataForObject($serializer_84, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PublicKeyCredentialCreationUser, 'PublicKeyCredentialCreationUser', PublicKeyCredentialCreationUser, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_84});
initMetadataForCompanion(Companion_101);
initMetadataForObject($serializer_85, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PublicKeyCredentialCreationPubKeyCredParam, 'PublicKeyCredentialCreationPubKeyCredParam', PublicKeyCredentialCreationPubKeyCredParam, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_85});
initMetadataForCompanion(Companion_102);
initMetadataForObject($serializer_86, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PublicKeyCredentialCreationAuthenticatorSelection, 'PublicKeyCredentialCreationAuthenticatorSelection', PublicKeyCredentialCreationAuthenticatorSelection, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_86});
initMetadataForCompanion(Companion_103);
initMetadataForObject($serializer_87, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PublicKeyCredentialCreationExtensions, 'PublicKeyCredentialCreationExtensions', PublicKeyCredentialCreationExtensions, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_87});
initMetadataForCompanion(Companion_104);
initMetadataForObject($serializer_88, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MHPublicKeyCredentialCreationOptions, 'MHPublicKeyCredentialCreationOptions', MHPublicKeyCredentialCreationOptions, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_88});
initMetadataForCompanion(Companion_105);
initMetadataForObject($serializer_89, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StartRegisterWebAuthnResponse, 'StartRegisterWebAuthnResponse', StartRegisterWebAuthnResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_89});
initMetadataForObject(LocalDateSerializer, 'LocalDateSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(VerifyKycResponseSerializer, 'VerifyKycResponseSerializer', VOID, JsonContentPolymorphicSerializer);
initMetadataForCompanion(Companion_106);
initMetadataForObject($serializer_90, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(FeedbackSurveyStatusRequest, 'FeedbackSurveyStatusRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_90});
initMetadataForCompanion(Companion_107);
initMetadataForObject($serializer_91, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SupportFormResponse, 'SupportFormResponse', SupportFormResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_91});
initMetadataForCompanion(Companion_108);
initMetadataForObject($serializer_92, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SupportFormTicketResponse, 'SupportFormTicketResponse', SupportFormTicketResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_92});
initMetadataForCompanion(Companion_109);
initMetadataForObject($serializer_93, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SupportFormTicketResponseTicket, 'SupportFormTicketResponseTicket', SupportFormTicketResponseTicket, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_93});
initMetadataForCompanion(Companion_110);
initMetadataForObject($serializer_94, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SupportFormUploadResponse, 'SupportFormUploadResponse', SupportFormUploadResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_94});
initMetadataForCompanion(Companion_111);
initMetadataForObject($serializer_95, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SupportFormUploadResponseUpload, 'SupportFormUploadResponseUpload', SupportFormUploadResponseUpload, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_95});
initMetadataForCompanion(Companion_112);
initMetadataForObject($serializer_96, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SupportFormUploadResponseUploadAttachment, 'SupportFormUploadResponseUploadAttachment', SupportFormUploadResponseUploadAttachment, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_96});
initMetadataForCompanion(Companion_113);
initMetadataForClass(IsoDate, 'IsoDate', VOID, VOID, [Comparable], VOID, VOID, {0: IsoDateSerializer_getInstance});
initMetadataForObject(IsoDateSerializer, 'IsoDateSerializer', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_114);
initMetadataForClass(IsoTimestamp, 'IsoTimestamp', VOID, VOID, [Comparable], VOID, VOID, {0: IsoTimestampSerializer_getInstance});
initMetadataForObject(IsoTimestampSerializer, 'IsoTimestampSerializer', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_115);
initMetadataForClass(UuidString, 'UuidString', VOID, VOID, VOID, VOID, VOID, {0: UuidStringSerializer_getInstance});
initMetadataForObject(UuidStringSerializer, 'UuidStringSerializer', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_116);
initMetadataForObject($serializer_97, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AccountHolderDetailsRequest, 'AccountHolderDetailsRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_97});
initMetadataForCompanion(Companion_117);
initMetadataForObject($serializer_98, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BankDetails, 'BankDetails', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_98});
initMetadataForCompanion(Companion_118);
initMetadataForObject($serializer_99, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BankDetailsResponse, 'BankDetailsResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_99});
initMetadataForCompanion(Companion_119);
initMetadataForObject($serializer_100, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PayoutBankDetails, 'PayoutBankDetails', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_100});
initMetadataForCompanion(Companion_120);
initMetadataForObject($serializer_101, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PersonalDetails, 'PersonalDetails', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_101});
initMetadataForCompanion(Companion_121);
initMetadataForObject($serializer_102, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterFcmTokenRequest, 'RegisterFcmTokenRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_102});
initMetadataForCompanion(Companion_122);
initMetadataForObject($serializer_103, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterFcmTokenResponse, 'RegisterFcmTokenResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_103});
initMetadataForCompanion(Companion_123);
initMetadataForObject($serializer_104, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ReserveShareInfoResponse, 'ReserveShareInfoResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_104});
initMetadataForCompanion(Companion_124);
initMetadataForObject($serializer_105, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ReserveSharesResponse, 'ReserveSharesResponse', ReserveSharesResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_105});
initMetadataForCompanion(Companion_125);
initMetadataForObject($serializer_106, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SellSharesResponse, 'SellSharesResponse', SellSharesResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_106});
initMetadataForCompanion(Companion_126);
initMetadataForObject($serializer_107, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TransactSharesRequest, 'TransactSharesRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_107});
initMetadataForCompanion(Companion_127);
initMetadataForObject($serializer_108, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TransactionRecord, 'TransactionRecord', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_108});
initMetadataForCompanion(Companion_128);
initMetadataForObject($serializer_109, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TransactionStatus, 'TransactionStatus', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_109});
initMetadataForCompanion(Companion_129);
initMetadataForObject($serializer_110, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpdateThresholdRequest, 'UpdateThresholdRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_110});
initMetadataForCompanion(Companion_130);
initMetadataForObject($serializer_111, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(UpdateTransactionStatusRequest, 'UpdateTransactionStatusRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_111});
//endregion
var AnalyticsAuthErrorCode_InvalidPassword_instance;
var AnalyticsAuthErrorCode_InvalidMagicLink_instance;
var AnalyticsAuthErrorCode_InvalidTotp_instance;
var AnalyticsAuthErrorCode_InvalidPasskey_instance;
var AnalyticsAuthErrorCode_InvalidAppLock_instance;
var AnalyticsAuthErrorCode_AppLockUnavailable_instance;
var AnalyticsAuthErrorCode_NetworkError_instance;
var AnalyticsAuthErrorCode_Unknown_instance;
function values() {
  return [AnalyticsAuthErrorCode_InvalidPassword_getInstance(), AnalyticsAuthErrorCode_InvalidMagicLink_getInstance(), AnalyticsAuthErrorCode_InvalidTotp_getInstance(), AnalyticsAuthErrorCode_InvalidPasskey_getInstance(), AnalyticsAuthErrorCode_InvalidAppLock_getInstance(), AnalyticsAuthErrorCode_AppLockUnavailable_getInstance(), AnalyticsAuthErrorCode_NetworkError_getInstance(), AnalyticsAuthErrorCode_Unknown_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'InvalidPassword':
      return AnalyticsAuthErrorCode_InvalidPassword_getInstance();
    case 'InvalidMagicLink':
      return AnalyticsAuthErrorCode_InvalidMagicLink_getInstance();
    case 'InvalidTotp':
      return AnalyticsAuthErrorCode_InvalidTotp_getInstance();
    case 'InvalidPasskey':
      return AnalyticsAuthErrorCode_InvalidPasskey_getInstance();
    case 'InvalidAppLock':
      return AnalyticsAuthErrorCode_InvalidAppLock_getInstance();
    case 'AppLockUnavailable':
      return AnalyticsAuthErrorCode_AppLockUnavailable_getInstance();
    case 'NetworkError':
      return AnalyticsAuthErrorCode_NetworkError_getInstance();
    case 'Unknown':
      return AnalyticsAuthErrorCode_Unknown_getInstance();
    default:
      AnalyticsAuthErrorCode_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsAuthErrorCode.' + value);
      break;
  }
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var AnalyticsAuthErrorCode_entriesInitialized;
function AnalyticsAuthErrorCode_initEntries() {
  if (AnalyticsAuthErrorCode_entriesInitialized)
    return Unit_instance;
  AnalyticsAuthErrorCode_entriesInitialized = true;
  AnalyticsAuthErrorCode_InvalidPassword_instance = new AnalyticsAuthErrorCode('InvalidPassword', 0, 'invalid_password');
  AnalyticsAuthErrorCode_InvalidMagicLink_instance = new AnalyticsAuthErrorCode('InvalidMagicLink', 1, 'invalid_magic_link');
  AnalyticsAuthErrorCode_InvalidTotp_instance = new AnalyticsAuthErrorCode('InvalidTotp', 2, 'invalid_totp');
  AnalyticsAuthErrorCode_InvalidPasskey_instance = new AnalyticsAuthErrorCode('InvalidPasskey', 3, 'invalid_passkey');
  AnalyticsAuthErrorCode_InvalidAppLock_instance = new AnalyticsAuthErrorCode('InvalidAppLock', 4, 'invalid_app_lock');
  AnalyticsAuthErrorCode_AppLockUnavailable_instance = new AnalyticsAuthErrorCode('AppLockUnavailable', 5, 'app_lock_unavailable');
  AnalyticsAuthErrorCode_NetworkError_instance = new AnalyticsAuthErrorCode('NetworkError', 6, 'network_error');
  AnalyticsAuthErrorCode_Unknown_instance = new AnalyticsAuthErrorCode('Unknown', 7, 'unknown');
}
var $ENTRIES;
function AnalyticsAuthErrorCode(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsAuthErrorCode).w = function () {
  return this.value;
};
protoOf(AnalyticsAuthErrorCode).toString = function () {
  return this.value;
};
function AnalyticsAuthErrorCode_InvalidPassword_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_InvalidPassword_instance;
}
function AnalyticsAuthErrorCode_InvalidMagicLink_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_InvalidMagicLink_instance;
}
function AnalyticsAuthErrorCode_InvalidTotp_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_InvalidTotp_instance;
}
function AnalyticsAuthErrorCode_InvalidPasskey_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_InvalidPasskey_instance;
}
function AnalyticsAuthErrorCode_InvalidAppLock_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_InvalidAppLock_instance;
}
function AnalyticsAuthErrorCode_AppLockUnavailable_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_AppLockUnavailable_instance;
}
function AnalyticsAuthErrorCode_NetworkError_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_NetworkError_instance;
}
function AnalyticsAuthErrorCode_Unknown_getInstance() {
  AnalyticsAuthErrorCode_initEntries();
  return AnalyticsAuthErrorCode_Unknown_instance;
}
var AnalyticsAuthMethod_Email_instance;
var AnalyticsAuthMethod_Password_instance;
var AnalyticsAuthMethod_MagicLink_instance;
var AnalyticsAuthMethod_Passkey_instance;
var AnalyticsAuthMethod_Totp_instance;
var AnalyticsAuthMethod_SecurityConfig_instance;
var AnalyticsAuthMethod_PayoutSetting_instance;
function values_0() {
  return [AnalyticsAuthMethod_Email_getInstance(), AnalyticsAuthMethod_Password_getInstance(), AnalyticsAuthMethod_MagicLink_getInstance(), AnalyticsAuthMethod_Passkey_getInstance(), AnalyticsAuthMethod_Totp_getInstance(), AnalyticsAuthMethod_SecurityConfig_getInstance(), AnalyticsAuthMethod_PayoutSetting_getInstance()];
}
function valueOf_0(value) {
  switch (value) {
    case 'Email':
      return AnalyticsAuthMethod_Email_getInstance();
    case 'Password':
      return AnalyticsAuthMethod_Password_getInstance();
    case 'MagicLink':
      return AnalyticsAuthMethod_MagicLink_getInstance();
    case 'Passkey':
      return AnalyticsAuthMethod_Passkey_getInstance();
    case 'Totp':
      return AnalyticsAuthMethod_Totp_getInstance();
    case 'SecurityConfig':
      return AnalyticsAuthMethod_SecurityConfig_getInstance();
    case 'PayoutSetting':
      return AnalyticsAuthMethod_PayoutSetting_getInstance();
    default:
      AnalyticsAuthMethod_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsAuthMethod.' + value);
      break;
  }
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var AnalyticsAuthMethod_entriesInitialized;
function AnalyticsAuthMethod_initEntries() {
  if (AnalyticsAuthMethod_entriesInitialized)
    return Unit_instance;
  AnalyticsAuthMethod_entriesInitialized = true;
  AnalyticsAuthMethod_Email_instance = new AnalyticsAuthMethod('Email', 0, 'email');
  AnalyticsAuthMethod_Password_instance = new AnalyticsAuthMethod('Password', 1, 'password');
  AnalyticsAuthMethod_MagicLink_instance = new AnalyticsAuthMethod('MagicLink', 2, 'magic_link');
  AnalyticsAuthMethod_Passkey_instance = new AnalyticsAuthMethod('Passkey', 3, 'passkey');
  AnalyticsAuthMethod_Totp_instance = new AnalyticsAuthMethod('Totp', 4, 'totp');
  AnalyticsAuthMethod_SecurityConfig_instance = new AnalyticsAuthMethod('SecurityConfig', 5, 'security_config');
  AnalyticsAuthMethod_PayoutSetting_instance = new AnalyticsAuthMethod('PayoutSetting', 6, 'payout_setting');
}
var $ENTRIES_0;
function AnalyticsAuthMethod(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsAuthMethod).w = function () {
  return this.value;
};
protoOf(AnalyticsAuthMethod).toString = function () {
  return this.value;
};
function AnalyticsAuthMethod_Email_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_Email_instance;
}
function AnalyticsAuthMethod_Password_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_Password_instance;
}
function AnalyticsAuthMethod_MagicLink_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_MagicLink_instance;
}
function AnalyticsAuthMethod_Passkey_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_Passkey_instance;
}
function AnalyticsAuthMethod_Totp_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_Totp_instance;
}
function AnalyticsAuthMethod_SecurityConfig_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_SecurityConfig_instance;
}
function AnalyticsAuthMethod_PayoutSetting_getInstance() {
  AnalyticsAuthMethod_initEntries();
  return AnalyticsAuthMethod_PayoutSetting_instance;
}
var AnalyticsAuthStage_Initiated_instance;
var AnalyticsAuthStage_Success_instance;
var AnalyticsAuthStage_Failed_instance;
var AnalyticsAuthStage_Resend_instance;
var AnalyticsAuthStage_Retry_instance;
var AnalyticsAuthStage_MethodSwitch_instance;
var AnalyticsAuthStage_Back_instance;
function values_1() {
  return [AnalyticsAuthStage_Initiated_getInstance(), AnalyticsAuthStage_Success_getInstance(), AnalyticsAuthStage_Failed_getInstance(), AnalyticsAuthStage_Resend_getInstance(), AnalyticsAuthStage_Retry_getInstance(), AnalyticsAuthStage_MethodSwitch_getInstance(), AnalyticsAuthStage_Back_getInstance()];
}
function valueOf_1(value) {
  switch (value) {
    case 'Initiated':
      return AnalyticsAuthStage_Initiated_getInstance();
    case 'Success':
      return AnalyticsAuthStage_Success_getInstance();
    case 'Failed':
      return AnalyticsAuthStage_Failed_getInstance();
    case 'Resend':
      return AnalyticsAuthStage_Resend_getInstance();
    case 'Retry':
      return AnalyticsAuthStage_Retry_getInstance();
    case 'MethodSwitch':
      return AnalyticsAuthStage_MethodSwitch_getInstance();
    case 'Back':
      return AnalyticsAuthStage_Back_getInstance();
    default:
      AnalyticsAuthStage_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsAuthStage.' + value);
      break;
  }
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var AnalyticsAuthStage_entriesInitialized;
function AnalyticsAuthStage_initEntries() {
  if (AnalyticsAuthStage_entriesInitialized)
    return Unit_instance;
  AnalyticsAuthStage_entriesInitialized = true;
  AnalyticsAuthStage_Initiated_instance = new AnalyticsAuthStage('Initiated', 0, 'initiated');
  AnalyticsAuthStage_Success_instance = new AnalyticsAuthStage('Success', 1, 'success');
  AnalyticsAuthStage_Failed_instance = new AnalyticsAuthStage('Failed', 2, 'failed');
  AnalyticsAuthStage_Resend_instance = new AnalyticsAuthStage('Resend', 3, 'resend');
  AnalyticsAuthStage_Retry_instance = new AnalyticsAuthStage('Retry', 4, 'retry');
  AnalyticsAuthStage_MethodSwitch_instance = new AnalyticsAuthStage('MethodSwitch', 5, 'method_switch');
  AnalyticsAuthStage_Back_instance = new AnalyticsAuthStage('Back', 6, 'back');
}
var $ENTRIES_1;
function AnalyticsAuthStage(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsAuthStage).w = function () {
  return this.value;
};
protoOf(AnalyticsAuthStage).toString = function () {
  return this.value;
};
function AnalyticsAuthStage_Initiated_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_Initiated_instance;
}
function AnalyticsAuthStage_Success_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_Success_instance;
}
function AnalyticsAuthStage_Failed_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_Failed_instance;
}
function AnalyticsAuthStage_Resend_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_Resend_instance;
}
function AnalyticsAuthStage_Retry_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_Retry_instance;
}
function AnalyticsAuthStage_MethodSwitch_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_MethodSwitch_instance;
}
function AnalyticsAuthStage_Back_getInstance() {
  AnalyticsAuthStage_initEntries();
  return AnalyticsAuthStage_Back_instance;
}
function AnalyticsChartType_0() {
  this.OCCUPANCY = 'occupancy';
  this.INCOME = 'income';
}
protoOf(AnalyticsChartType_0).d3h = function () {
  return this.OCCUPANCY;
};
protoOf(AnalyticsChartType_0).e3h = function () {
  return this.INCOME;
};
var AnalyticsChartType_instance;
function AnalyticsChartType_getInstance() {
  return AnalyticsChartType_instance;
}
function AnalyticsClickId_0() {
  this.ACCEPT_TNCS = 'accept_tncs';
  this.ADD_PASSKEY = 'add_passkey';
  this.ADD_PASSKEY_CANCEL = 'add_passkey_cancel';
  this.APP_LOCK = 'app_lock';
  this.AUTH_APP = 'auth_app';
  this.AUTH_APP_DISABLE_CANCEL = 'auth_app_disable_cancel';
  this.AUTH_APP_DISABLE_CONFIRM = 'auth_app_disable_confirm';
  this.BANK_DETAILS = 'bank_details';
  this.CANT_SCAN_QR = 'cant_scan_qr';
  this.CLEAR = 'clear';
  this.CLEAR_FORM = 'clear_form';
  this.CLOSE = 'close';
  this.CLOSE_SHARE_CANCELLED_FEEDBACK = 'close_share_cancelled_feedback';
  this.CLOSE_SHARE_RESERVED_FEEDBACK = 'close_share_reserved_feedback';
  this.COPY_QR = 'copy_qr';
  this.DELETE_ACCOUNT = 'delete_account';
  this.DELETE_PASSKEY = 'delete_passkey';
  this.DELETE_PASSKEY_CANCEL = 'delete_passkey_cancel';
  this.DELETE_PASSKEY_CONFIRM = 'delete_passkey_confirm';
  this.LOG_OUT = 'log_out';
  this.PASSKEY = 'passkey';
  this.PASSKEY_DISABLE_CANCEL = 'passkey_disable_cancel';
  this.PASSKEY_DISABLE_CONFIRM = 'passkey_disable_confirm';
  this.PASSKEY_ENABLE_CANCEL = 'passkey_enable_cancel';
  this.PUSH_NOTIFICATIONS = 'push_notifications';
  this.QR_CODE_SCANNED = 'qr_code_scanned';
  this.SAME_AS_RESIDENTIAL = 'same_as_residential';
  this.SAVE_PASSWORD = 'save_password';
  this.SECURITY_SETTINGS = 'security_settings';
  this.SHARE_APP = 'share_app';
  this.SHARE_APP_WIDE = 'share_app_wide';
  this.UPLOAD_FILE = 'upload_file';
}
protoOf(AnalyticsClickId_0).f3h = function () {
  return this.ACCEPT_TNCS;
};
protoOf(AnalyticsClickId_0).g3h = function () {
  return this.ADD_PASSKEY;
};
protoOf(AnalyticsClickId_0).h3h = function () {
  return this.ADD_PASSKEY_CANCEL;
};
protoOf(AnalyticsClickId_0).i3h = function () {
  return this.APP_LOCK;
};
protoOf(AnalyticsClickId_0).j3h = function () {
  return this.AUTH_APP;
};
protoOf(AnalyticsClickId_0).k3h = function () {
  return this.AUTH_APP_DISABLE_CANCEL;
};
protoOf(AnalyticsClickId_0).l3h = function () {
  return this.AUTH_APP_DISABLE_CONFIRM;
};
protoOf(AnalyticsClickId_0).m3h = function () {
  return this.BANK_DETAILS;
};
protoOf(AnalyticsClickId_0).n3h = function () {
  return this.CANT_SCAN_QR;
};
protoOf(AnalyticsClickId_0).o3h = function () {
  return this.CLEAR;
};
protoOf(AnalyticsClickId_0).p3h = function () {
  return this.CLEAR_FORM;
};
protoOf(AnalyticsClickId_0).q3h = function () {
  return this.CLOSE;
};
protoOf(AnalyticsClickId_0).r3h = function () {
  return this.CLOSE_SHARE_CANCELLED_FEEDBACK;
};
protoOf(AnalyticsClickId_0).s3h = function () {
  return this.CLOSE_SHARE_RESERVED_FEEDBACK;
};
protoOf(AnalyticsClickId_0).t3h = function () {
  return this.COPY_QR;
};
protoOf(AnalyticsClickId_0).u3h = function () {
  return this.DELETE_ACCOUNT;
};
protoOf(AnalyticsClickId_0).v3h = function () {
  return this.DELETE_PASSKEY;
};
protoOf(AnalyticsClickId_0).w3h = function () {
  return this.DELETE_PASSKEY_CANCEL;
};
protoOf(AnalyticsClickId_0).x3h = function () {
  return this.DELETE_PASSKEY_CONFIRM;
};
protoOf(AnalyticsClickId_0).y3h = function () {
  return this.LOG_OUT;
};
protoOf(AnalyticsClickId_0).z3h = function () {
  return this.PASSKEY;
};
protoOf(AnalyticsClickId_0).a3i = function () {
  return this.PASSKEY_DISABLE_CANCEL;
};
protoOf(AnalyticsClickId_0).b3i = function () {
  return this.PASSKEY_DISABLE_CONFIRM;
};
protoOf(AnalyticsClickId_0).c3i = function () {
  return this.PASSKEY_ENABLE_CANCEL;
};
protoOf(AnalyticsClickId_0).d3i = function () {
  return this.PUSH_NOTIFICATIONS;
};
protoOf(AnalyticsClickId_0).e3i = function () {
  return this.QR_CODE_SCANNED;
};
protoOf(AnalyticsClickId_0).f3i = function () {
  return this.SAME_AS_RESIDENTIAL;
};
protoOf(AnalyticsClickId_0).g3i = function () {
  return this.SAVE_PASSWORD;
};
protoOf(AnalyticsClickId_0).h3i = function () {
  return this.SECURITY_SETTINGS;
};
protoOf(AnalyticsClickId_0).i3i = function () {
  return this.SHARE_APP;
};
protoOf(AnalyticsClickId_0).j3i = function () {
  return this.SHARE_APP_WIDE;
};
protoOf(AnalyticsClickId_0).k3i = function () {
  return this.UPLOAD_FILE;
};
var AnalyticsClickId_instance;
function AnalyticsClickId_getInstance() {
  return AnalyticsClickId_instance;
}
function AnalyticsContentId_0() {
  this.ACCESS_DIVIDENDS = 'access_dividends';
  this.ACCOUNT_OPENING_FEE = 'account_opening_fee';
  this.ANNUAL_MAINTENANCE_FEE = 'annual_maintenance_fee';
  this.BANK_TRANSFER_FEE = 'bank_transfer_fee';
  this.ESTIMATE_DIVIDEND = 'estimate_dividend';
  this.EXPENSE_RATIO = 'expense_ratio';
  this.HOLDING_TYPE = 'holding_type';
  this.MATURATION_STATUS = 'maturation_status';
  this.NEXT_PAYOUT_DATE = 'next_payout_date';
  this.RECEIVE_FUNDS = 'receive_funds';
  this.RESERVE_SHARES = 'reserve_shares';
  this.STAY_UPDATED = 'stay_updated';
  this.TRANSFER_FUNDS = 'transfer_funds';
}
protoOf(AnalyticsContentId_0).l3i = function () {
  return this.ACCESS_DIVIDENDS;
};
protoOf(AnalyticsContentId_0).m3i = function () {
  return this.ACCOUNT_OPENING_FEE;
};
protoOf(AnalyticsContentId_0).n3i = function () {
  return this.ANNUAL_MAINTENANCE_FEE;
};
protoOf(AnalyticsContentId_0).o3i = function () {
  return this.BANK_TRANSFER_FEE;
};
protoOf(AnalyticsContentId_0).p3i = function () {
  return this.ESTIMATE_DIVIDEND;
};
protoOf(AnalyticsContentId_0).q3i = function () {
  return this.EXPENSE_RATIO;
};
protoOf(AnalyticsContentId_0).r3i = function () {
  return this.HOLDING_TYPE;
};
protoOf(AnalyticsContentId_0).s3i = function () {
  return this.MATURATION_STATUS;
};
protoOf(AnalyticsContentId_0).t3i = function () {
  return this.NEXT_PAYOUT_DATE;
};
protoOf(AnalyticsContentId_0).u3i = function () {
  return this.RECEIVE_FUNDS;
};
protoOf(AnalyticsContentId_0).v3i = function () {
  return this.RESERVE_SHARES;
};
protoOf(AnalyticsContentId_0).w3i = function () {
  return this.STAY_UPDATED;
};
protoOf(AnalyticsContentId_0).x3i = function () {
  return this.TRANSFER_FUNDS;
};
var AnalyticsContentId_instance;
function AnalyticsContentId_getInstance() {
  return AnalyticsContentId_instance;
}
var AnalyticsContentType_Property_instance;
var AnalyticsContentType_Tooltip_instance;
function values_2() {
  return [AnalyticsContentType_Property_getInstance(), AnalyticsContentType_Tooltip_getInstance()];
}
function valueOf_2(value) {
  switch (value) {
    case 'Property':
      return AnalyticsContentType_Property_getInstance();
    case 'Tooltip':
      return AnalyticsContentType_Tooltip_getInstance();
    default:
      AnalyticsContentType_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsContentType.' + value);
      break;
  }
}
function get_entries_2() {
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_2());
  return $ENTRIES_2;
}
var AnalyticsContentType_entriesInitialized;
function AnalyticsContentType_initEntries() {
  if (AnalyticsContentType_entriesInitialized)
    return Unit_instance;
  AnalyticsContentType_entriesInitialized = true;
  AnalyticsContentType_Property_instance = new AnalyticsContentType('Property', 0, 'property');
  AnalyticsContentType_Tooltip_instance = new AnalyticsContentType('Tooltip', 1, 'tooltip');
}
var $ENTRIES_2;
function AnalyticsContentType(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsContentType).w = function () {
  return this.value;
};
protoOf(AnalyticsContentType).toString = function () {
  return this.value;
};
function AnalyticsContentType_Property_getInstance() {
  AnalyticsContentType_initEntries();
  return AnalyticsContentType_Property_instance;
}
function AnalyticsContentType_Tooltip_getInstance() {
  AnalyticsContentType_initEntries();
  return AnalyticsContentType_Tooltip_instance;
}
function AnalyticsCtaId_0() {
  this.BANK_DETAILS = 'bank_details';
  this.BUY = 'buy';
  this.CANCEL_ORDER = 'cancel_order';
  this.COMPLETE_ACCOUNT_SETUP = 'complete_account_setup';
  this.EXIT = 'exit';
  this.GET_STARTED = 'get_started';
  this.INDICATOR = 'indicator';
  this.INVEST_NOW = 'invest_now';
  this.I_UNDERSTAND = 'i_understand';
  this.LOG_IN_REGISTER = 'log_in_register';
  this.MAKE_THE_TRANSFER = 'make_the_transfer';
  this.MINIMUM_INVESTMENT = 'minimum_investment';
  this.NEXT = 'next';
  this.SELL = 'sell';
  this.SKIP = 'skip';
}
protoOf(AnalyticsCtaId_0).m3h = function () {
  return this.BANK_DETAILS;
};
protoOf(AnalyticsCtaId_0).a3j = function () {
  return this.BUY;
};
protoOf(AnalyticsCtaId_0).b3j = function () {
  return this.CANCEL_ORDER;
};
protoOf(AnalyticsCtaId_0).c3j = function () {
  return this.COMPLETE_ACCOUNT_SETUP;
};
protoOf(AnalyticsCtaId_0).d3j = function () {
  return this.EXIT;
};
protoOf(AnalyticsCtaId_0).e3j = function () {
  return this.GET_STARTED;
};
protoOf(AnalyticsCtaId_0).f3j = function () {
  return this.INDICATOR;
};
protoOf(AnalyticsCtaId_0).g3j = function () {
  return this.INVEST_NOW;
};
protoOf(AnalyticsCtaId_0).h3j = function () {
  return this.I_UNDERSTAND;
};
protoOf(AnalyticsCtaId_0).i3j = function () {
  return this.LOG_IN_REGISTER;
};
protoOf(AnalyticsCtaId_0).j3j = function () {
  return this.MAKE_THE_TRANSFER;
};
protoOf(AnalyticsCtaId_0).k3j = function () {
  return this.MINIMUM_INVESTMENT;
};
protoOf(AnalyticsCtaId_0).l3j = function () {
  return this.NEXT;
};
protoOf(AnalyticsCtaId_0).m3j = function () {
  return this.SELL;
};
protoOf(AnalyticsCtaId_0).n3j = function () {
  return this.SKIP;
};
var AnalyticsCtaId_instance;
function AnalyticsCtaId_getInstance() {
  return AnalyticsCtaId_instance;
}
function AnalyticsDestination_0() {
  this.BLOG = 'blog';
  this.COOKIE_POLICY = 'cookie_policy';
  this.CREATE_SUPPORT_ISSUE = 'create_support_issue';
  this.DISCLAIMER = 'disclaimer';
  this.END_USER_AGREEMENT = 'end_user_agreement';
  this.FAQS = 'faqs';
  this.HELP_CENTRE = 'help_centre';
  this.HOME = 'home';
  this.INVEST_NOW = 'invest_now';
  this.MENU = 'menu';
  this.MY_PORTFOLIO = 'my_portfolio';
  this.PRIVACY_POLICY = 'privacy_policy';
  this.PROFILE = 'profile';
  this.SUBSCRIPTION_AGREEMENT = 'subscription_agreement';
  this.SUPPORT = 'support';
  this.TERMS_CONDITIONS = 'terms_conditions';
  this.TRANSACTION_HISTORY = 'transaction_history';
}
protoOf(AnalyticsDestination_0).o3j = function () {
  return this.BLOG;
};
protoOf(AnalyticsDestination_0).p3j = function () {
  return this.COOKIE_POLICY;
};
protoOf(AnalyticsDestination_0).q3j = function () {
  return this.CREATE_SUPPORT_ISSUE;
};
protoOf(AnalyticsDestination_0).r3j = function () {
  return this.DISCLAIMER;
};
protoOf(AnalyticsDestination_0).s3j = function () {
  return this.END_USER_AGREEMENT;
};
protoOf(AnalyticsDestination_0).t3j = function () {
  return this.FAQS;
};
protoOf(AnalyticsDestination_0).u3j = function () {
  return this.HELP_CENTRE;
};
protoOf(AnalyticsDestination_0).v3j = function () {
  return this.HOME;
};
protoOf(AnalyticsDestination_0).g3j = function () {
  return this.INVEST_NOW;
};
protoOf(AnalyticsDestination_0).w3j = function () {
  return this.MENU;
};
protoOf(AnalyticsDestination_0).x3j = function () {
  return this.MY_PORTFOLIO;
};
protoOf(AnalyticsDestination_0).y3j = function () {
  return this.PRIVACY_POLICY;
};
protoOf(AnalyticsDestination_0).z3j = function () {
  return this.PROFILE;
};
protoOf(AnalyticsDestination_0).a3k = function () {
  return this.SUBSCRIPTION_AGREEMENT;
};
protoOf(AnalyticsDestination_0).b3k = function () {
  return this.SUPPORT;
};
protoOf(AnalyticsDestination_0).c3k = function () {
  return this.TERMS_CONDITIONS;
};
protoOf(AnalyticsDestination_0).d3k = function () {
  return this.TRANSACTION_HISTORY;
};
var AnalyticsDestination_instance;
function AnalyticsDestination_getInstance() {
  return AnalyticsDestination_instance;
}
function AnalyticsDropdownId_0() {
  this.DIVIDEND_HISTORY = 'dividend_history';
  this.DIVIDEND_PAYOUT = 'dividend_payout';
  this.TICKER_PICKER = 'ticker_picker';
}
protoOf(AnalyticsDropdownId_0).e3k = function () {
  return this.DIVIDEND_HISTORY;
};
protoOf(AnalyticsDropdownId_0).f3k = function () {
  return this.DIVIDEND_PAYOUT;
};
protoOf(AnalyticsDropdownId_0).g3k = function () {
  return this.TICKER_PICKER;
};
var AnalyticsDropdownId_instance;
function AnalyticsDropdownId_getInstance() {
  return AnalyticsDropdownId_instance;
}
function AnalyticsEvents_0() {
  this.SCREEN_VIEW = 'screen_view';
  this.PAGE_VIEW = 'page_view';
  this.SIGN_UP = 'sign_up';
  this.LOGIN = 'login';
  this.REAUTH = 'reauth';
  this.ADD_TO_CART = 'add_to_cart';
  this.BEGIN_CHECKOUT = 'begin_checkout';
  this.ADD_PAYMENT_INFO = 'add_payment_info';
  this.APP_UNLOCK = 'app_unlock';
  this.CTA_CLICK = 'cta_click';
  this.CLICK_APPLY = 'click_apply';
  this.NAV_CLICK = 'nav_click';
  this.LINK_CLICK = 'link_click';
  this.FILTER_APPLY = 'filter_apply';
  this.DROPDOWN_SELECT = 'dropdown_select';
  this.SWIPE = 'swipe';
  this.CONTENT_VIEW = 'content_view';
  this.FORM_START = 'form_start';
  this.FORM_SUBMIT = 'form_submit';
  this.SELL_INITIATED = 'sell_initiated';
  this.SELL_PENDING = 'sell_pending';
  this.TRANSACTION_CANCELLED = 'transaction_cancelled';
}
protoOf(AnalyticsEvents_0).h3k = function () {
  return this.SCREEN_VIEW;
};
protoOf(AnalyticsEvents_0).i3k = function () {
  return this.PAGE_VIEW;
};
protoOf(AnalyticsEvents_0).j3k = function () {
  return this.SIGN_UP;
};
protoOf(AnalyticsEvents_0).k3k = function () {
  return this.LOGIN;
};
protoOf(AnalyticsEvents_0).l3k = function () {
  return this.REAUTH;
};
protoOf(AnalyticsEvents_0).m3k = function () {
  return this.ADD_TO_CART;
};
protoOf(AnalyticsEvents_0).n3k = function () {
  return this.BEGIN_CHECKOUT;
};
protoOf(AnalyticsEvents_0).o3k = function () {
  return this.ADD_PAYMENT_INFO;
};
protoOf(AnalyticsEvents_0).p3k = function () {
  return this.APP_UNLOCK;
};
protoOf(AnalyticsEvents_0).q3k = function () {
  return this.CTA_CLICK;
};
protoOf(AnalyticsEvents_0).r3k = function () {
  return this.CLICK_APPLY;
};
protoOf(AnalyticsEvents_0).s3k = function () {
  return this.NAV_CLICK;
};
protoOf(AnalyticsEvents_0).t3k = function () {
  return this.LINK_CLICK;
};
protoOf(AnalyticsEvents_0).u3k = function () {
  return this.FILTER_APPLY;
};
protoOf(AnalyticsEvents_0).v3k = function () {
  return this.DROPDOWN_SELECT;
};
protoOf(AnalyticsEvents_0).w3k = function () {
  return this.SWIPE;
};
protoOf(AnalyticsEvents_0).x3k = function () {
  return this.CONTENT_VIEW;
};
protoOf(AnalyticsEvents_0).y3k = function () {
  return this.FORM_START;
};
protoOf(AnalyticsEvents_0).z3k = function () {
  return this.FORM_SUBMIT;
};
protoOf(AnalyticsEvents_0).a3l = function () {
  return this.SELL_INITIATED;
};
protoOf(AnalyticsEvents_0).b3l = function () {
  return this.SELL_PENDING;
};
protoOf(AnalyticsEvents_0).c3l = function () {
  return this.TRANSACTION_CANCELLED;
};
var AnalyticsEvents_instance;
function AnalyticsEvents_getInstance() {
  return AnalyticsEvents_instance;
}
function AnalyticsFilterType_0() {
  this.CHART_TYPE = 'chart_type';
  this.TIME_RANGE = 'time_range';
  this.TRANSACTION_TYPE = 'transaction_type';
}
protoOf(AnalyticsFilterType_0).d3l = function () {
  return this.CHART_TYPE;
};
protoOf(AnalyticsFilterType_0).e3l = function () {
  return this.TIME_RANGE;
};
protoOf(AnalyticsFilterType_0).f3l = function () {
  return this.TRANSACTION_TYPE;
};
var AnalyticsFilterType_instance;
function AnalyticsFilterType_getInstance() {
  return AnalyticsFilterType_instance;
}
function AnalyticsFormId_0() {
  this.ADD_PASSKEY = 'add_passkey';
  this.BANK_FORM_1 = 'bank_form_1';
  this.BANK_FORM_2 = 'bank_form_2';
  this.PAYOUT_THRESHOLD = 'payout_threshold';
  this.REGISTRATION = 'registration';
  this.SHARE_CANCELLED_FEEDBACK_SURVEY = 'share_cancelled_feedback_survey';
  this.SHARE_RESERVED_FEEDBACK_SURVEY = 'share_reserved_feedback_survey';
  this.SUPPORT_ISSUE = 'support_issue';
}
protoOf(AnalyticsFormId_0).g3h = function () {
  return this.ADD_PASSKEY;
};
protoOf(AnalyticsFormId_0).g3l = function () {
  return this.BANK_FORM_1;
};
protoOf(AnalyticsFormId_0).h3l = function () {
  return this.BANK_FORM_2;
};
protoOf(AnalyticsFormId_0).i3l = function () {
  return this.PAYOUT_THRESHOLD;
};
protoOf(AnalyticsFormId_0).j3l = function () {
  return this.REGISTRATION;
};
protoOf(AnalyticsFormId_0).k3l = function () {
  return this.SHARE_CANCELLED_FEEDBACK_SURVEY;
};
protoOf(AnalyticsFormId_0).l3l = function () {
  return this.SHARE_RESERVED_FEEDBACK_SURVEY;
};
protoOf(AnalyticsFormId_0).m3l = function () {
  return this.SUPPORT_ISSUE;
};
var AnalyticsFormId_instance;
function AnalyticsFormId_getInstance() {
  return AnalyticsFormId_instance;
}
var AnalyticsFormOutcome_Success_instance;
function values_3() {
  return [AnalyticsFormOutcome_Success_getInstance()];
}
function valueOf_3(value) {
  if (value === 'Success')
    return AnalyticsFormOutcome_Success_getInstance();
  else {
    AnalyticsFormOutcome_initEntries();
    THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsFormOutcome.' + value);
  }
}
function get_entries_3() {
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_3());
  return $ENTRIES_3;
}
var AnalyticsFormOutcome_entriesInitialized;
function AnalyticsFormOutcome_initEntries() {
  if (AnalyticsFormOutcome_entriesInitialized)
    return Unit_instance;
  AnalyticsFormOutcome_entriesInitialized = true;
  AnalyticsFormOutcome_Success_instance = new AnalyticsFormOutcome('Success', 0, 'success');
}
var $ENTRIES_3;
function AnalyticsFormOutcome(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsFormOutcome).w = function () {
  return this.value;
};
protoOf(AnalyticsFormOutcome).toString = function () {
  return this.value;
};
function AnalyticsFormOutcome_Success_getInstance() {
  AnalyticsFormOutcome_initEntries();
  return AnalyticsFormOutcome_Success_instance;
}
function AnalyticsLinkId_0() {
  this.BLOG = 'blog';
  this.COOKIE_POLICY = 'cookie_policy';
  this.DISCLAIMER = 'disclaimer';
  this.END_USER_AGREEMENT = 'end_user_agreement';
  this.FAQS = 'faqs';
  this.HELP_CENTRE = 'help_centre';
  this.MAP = 'map';
  this.PRIVACY_POLICY = 'privacy_policy';
  this.SUBSCRIPTION_AGREEMENT = 'subscription_agreement';
  this.TERMS_CONDITIONS = 'terms_conditions';
}
protoOf(AnalyticsLinkId_0).o3j = function () {
  return this.BLOG;
};
protoOf(AnalyticsLinkId_0).p3j = function () {
  return this.COOKIE_POLICY;
};
protoOf(AnalyticsLinkId_0).r3j = function () {
  return this.DISCLAIMER;
};
protoOf(AnalyticsLinkId_0).s3j = function () {
  return this.END_USER_AGREEMENT;
};
protoOf(AnalyticsLinkId_0).t3j = function () {
  return this.FAQS;
};
protoOf(AnalyticsLinkId_0).u3j = function () {
  return this.HELP_CENTRE;
};
protoOf(AnalyticsLinkId_0).p3l = function () {
  return this.MAP;
};
protoOf(AnalyticsLinkId_0).y3j = function () {
  return this.PRIVACY_POLICY;
};
protoOf(AnalyticsLinkId_0).a3k = function () {
  return this.SUBSCRIPTION_AGREEMENT;
};
protoOf(AnalyticsLinkId_0).c3k = function () {
  return this.TERMS_CONDITIONS;
};
var AnalyticsLinkId_instance;
function AnalyticsLinkId_getInstance() {
  return AnalyticsLinkId_instance;
}
function AnalyticsNavLocation_0() {
  this.SIDE_MENU = 'side_menu';
  this.SUPPORT = 'support';
}
protoOf(AnalyticsNavLocation_0).q3l = function () {
  return this.SIDE_MENU;
};
protoOf(AnalyticsNavLocation_0).b3k = function () {
  return this.SUPPORT;
};
var AnalyticsNavLocation_instance;
function AnalyticsNavLocation_getInstance() {
  return AnalyticsNavLocation_instance;
}
function AnalyticsParams_0() {
  this.CLICK_ID = 'click_id';
  this.CONTENT_ID = 'content_id';
  this.CONTENT_TYPE = 'content_type';
  this.CTA_ID = 'cta_id';
  this.CURRENCY = 'currency';
  this.DESTINATION = 'destination';
  this.DROPDOWN_ID = 'dropdown_id';
  this.ERROR_CODE = 'error_code';
  this.FILTER_TYPE = 'filter_type';
  this.FILTER_VALUE = 'filter_value';
  this.FORM_ID = 'form_id';
  this.FUND_ID = 'fund_id';
  this.ITEMS = 'items';
  this.LINK_ID = 'link_id';
  this.METHOD = 'method';
  this.NAV_LOCATION = 'nav_location';
  this.NUM_SHARES = 'num_shares';
  this.OUTCOME = 'outcome';
  this.PAYMENT_TYPE = 'payment_type';
  this.SCREEN_NAME = 'screen_name';
  this.SHARE_PRICE = 'share_price';
  this.SLIDE_COUNT = 'slide_count';
  this.SLIDE_INDEX = 'slide_index';
  this.STAGE = 'stage';
  this.TRANSACTION_ID = 'transaction_id';
  this.TRANSACTION_TYPE = 'transaction_type';
  this.VALUE = 'value';
}
protoOf(AnalyticsParams_0).r3l = function () {
  return this.CLICK_ID;
};
protoOf(AnalyticsParams_0).s3l = function () {
  return this.CONTENT_ID;
};
protoOf(AnalyticsParams_0).t3l = function () {
  return this.CONTENT_TYPE;
};
protoOf(AnalyticsParams_0).u3l = function () {
  return this.CTA_ID;
};
protoOf(AnalyticsParams_0).v3l = function () {
  return this.CURRENCY;
};
protoOf(AnalyticsParams_0).w3l = function () {
  return this.DESTINATION;
};
protoOf(AnalyticsParams_0).x3l = function () {
  return this.DROPDOWN_ID;
};
protoOf(AnalyticsParams_0).y3l = function () {
  return this.ERROR_CODE;
};
protoOf(AnalyticsParams_0).z3l = function () {
  return this.FILTER_TYPE;
};
protoOf(AnalyticsParams_0).a3m = function () {
  return this.FILTER_VALUE;
};
protoOf(AnalyticsParams_0).b3m = function () {
  return this.FORM_ID;
};
protoOf(AnalyticsParams_0).c3m = function () {
  return this.FUND_ID;
};
protoOf(AnalyticsParams_0).d3m = function () {
  return this.ITEMS;
};
protoOf(AnalyticsParams_0).e3m = function () {
  return this.LINK_ID;
};
protoOf(AnalyticsParams_0).f3m = function () {
  return this.METHOD;
};
protoOf(AnalyticsParams_0).g3m = function () {
  return this.NAV_LOCATION;
};
protoOf(AnalyticsParams_0).h3m = function () {
  return this.NUM_SHARES;
};
protoOf(AnalyticsParams_0).i3m = function () {
  return this.OUTCOME;
};
protoOf(AnalyticsParams_0).j3m = function () {
  return this.PAYMENT_TYPE;
};
protoOf(AnalyticsParams_0).k3m = function () {
  return this.SCREEN_NAME;
};
protoOf(AnalyticsParams_0).l3m = function () {
  return this.SHARE_PRICE;
};
protoOf(AnalyticsParams_0).m3m = function () {
  return this.SLIDE_COUNT;
};
protoOf(AnalyticsParams_0).n3m = function () {
  return this.SLIDE_INDEX;
};
protoOf(AnalyticsParams_0).o3m = function () {
  return this.STAGE;
};
protoOf(AnalyticsParams_0).p3m = function () {
  return this.TRANSACTION_ID;
};
protoOf(AnalyticsParams_0).f3l = function () {
  return this.TRANSACTION_TYPE;
};
protoOf(AnalyticsParams_0).q3m = function () {
  return this.VALUE;
};
var AnalyticsParams_instance;
function AnalyticsParams_getInstance() {
  return AnalyticsParams_instance;
}
var AnalyticsPaymentType_BankTransfer_instance;
function values_4() {
  return [AnalyticsPaymentType_BankTransfer_getInstance()];
}
function valueOf_4(value) {
  if (value === 'BankTransfer')
    return AnalyticsPaymentType_BankTransfer_getInstance();
  else {
    AnalyticsPaymentType_initEntries();
    THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsPaymentType.' + value);
  }
}
function get_entries_4() {
  if ($ENTRIES_4 == null)
    $ENTRIES_4 = enumEntries(values_4());
  return $ENTRIES_4;
}
var AnalyticsPaymentType_entriesInitialized;
function AnalyticsPaymentType_initEntries() {
  if (AnalyticsPaymentType_entriesInitialized)
    return Unit_instance;
  AnalyticsPaymentType_entriesInitialized = true;
  AnalyticsPaymentType_BankTransfer_instance = new AnalyticsPaymentType('BankTransfer', 0, 'bank_transfer');
}
var $ENTRIES_4;
function AnalyticsPaymentType(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsPaymentType).w = function () {
  return this.value;
};
protoOf(AnalyticsPaymentType).toString = function () {
  return this.value;
};
function AnalyticsPaymentType_BankTransfer_getInstance() {
  AnalyticsPaymentType_initEntries();
  return AnalyticsPaymentType_BankTransfer_instance;
}
function AnalyticsScreenName_0() {
  this.ABOUT_PROPERTY = 'about_property';
  this.APP_LOCK = 'app_lock';
  this.BANK_FORM_1 = 'bank_form_1';
  this.BANK_FORM_2 = 'bank_form_2';
  this.CHANGE_PASSWORD = 'change_password';
  this.CREATE_SUPPORT_ISSUE = 'create_support_issue';
  this.DIVIDEND_HISTORY = 'dividend_history';
  this.FUNDS_AND_HOLDINGS = 'funds_and_holdings';
  this.FUND_DOCUMENTS = 'fund_documents';
  this.HOLDING = 'holding';
  this.HOLDINGS_IN_FUND = 'holdings_in_fund';
  this.HOLDING_DOCUMENTS = 'holding_documents';
  this.HOME = 'home';
  this.INVESTMENT_ACTIVITY = 'investment_activity';
  this.INVESTOR_STATEMENTS = 'investor_statements';
  this.KYC_DECLINED = 'kyc_declined';
  this.KYC_REVIEW = 'kyc_review';
  this.KYC_STATUS = 'kyc_status';
  this.LOGIN_EMAIL = 'login_email';
  this.LOGIN_MAGIC_LINK = 'login_magic_link';
  this.LOGIN_PASSKEY = 'login_passkey';
  this.LOGIN_PASSWORD = 'login_password';
  this.LOGIN_TOTP = 'login_totp';
  this.MENU = 'menu';
  this.MESSAGING_PREFERENCE = 'messaging_preference';
  this.MY_PORTFOLIO = 'my_portfolio';
  this.ONBOARDING = 'onboarding';
  this.PAYOUT_SETTINGS = 'payout_settings';
  this.PROFILE = 'profile';
  this.PROFILE_BANK_DETAILS = 'profile_bank_details';
  this.PROFILE_PERSONAL_DETAILS = 'profile_personal_details';
  this.PROPERTIES_MAP = 'properties_map';
  this.PROPERTY = 'property';
  this.PROPERTY_TOUR = 'property_tour';
  this.REAUTH_MAGIC_LINK = 'reauth_magic_link';
  this.REAUTH_PASSKEY = 'reauth_passkey';
  this.REAUTH_PASSWORD = 'reauth_password';
  this.REAUTH_TOTP = 'reauth_totp';
  this.REGISTRATION = 'registration';
  this.RESERVE_SHARES_1 = 'reserve_shares_1';
  this.RESERVE_SHARES_2 = 'reserve_shares_2';
  this.RESERVE_SHARES_3 = 'reserve_shares_3';
  this.RESERVE_SHARES_PENDING = 'reserve_shares_pending';
  this.SECURITY_SETTINGS = 'security_settings';
  this.SELL_ORDER_REVIEW = 'sell_order_review';
  this.SELL_SHARES = 'sell_shares';
  this.SELL_SHARES_REVIEW = 'sell_shares_review';
  this.SET_PASSWORD = 'set_password';
  this.SETUP_TOTP = 'setup_totp';
  this.SHARE_CANCELLED_FEEDBACK = 'share_cancelled_feedback';
  this.SHARE_RESERVED_FEEDBACK = 'share_reserved_feedback';
  this.SUPPORT = 'support';
  this.TRANSACTION_DETAILS = 'transaction_details';
  this.TRANSACTION_HISTORY = 'transaction_history';
  this.TRANSFER_GUIDE = 'transfer_guide';
  this.VERIFY_MAGIC_LINK = 'verify_magic_link';
}
protoOf(AnalyticsScreenName_0).t3m = function () {
  return this.ABOUT_PROPERTY;
};
protoOf(AnalyticsScreenName_0).i3h = function () {
  return this.APP_LOCK;
};
protoOf(AnalyticsScreenName_0).g3l = function () {
  return this.BANK_FORM_1;
};
protoOf(AnalyticsScreenName_0).h3l = function () {
  return this.BANK_FORM_2;
};
protoOf(AnalyticsScreenName_0).u3m = function () {
  return this.CHANGE_PASSWORD;
};
protoOf(AnalyticsScreenName_0).q3j = function () {
  return this.CREATE_SUPPORT_ISSUE;
};
protoOf(AnalyticsScreenName_0).e3k = function () {
  return this.DIVIDEND_HISTORY;
};
protoOf(AnalyticsScreenName_0).v3m = function () {
  return this.FUNDS_AND_HOLDINGS;
};
protoOf(AnalyticsScreenName_0).w3m = function () {
  return this.FUND_DOCUMENTS;
};
protoOf(AnalyticsScreenName_0).x3m = function () {
  return this.HOLDING;
};
protoOf(AnalyticsScreenName_0).y3m = function () {
  return this.HOLDINGS_IN_FUND;
};
protoOf(AnalyticsScreenName_0).z3m = function () {
  return this.HOLDING_DOCUMENTS;
};
protoOf(AnalyticsScreenName_0).v3j = function () {
  return this.HOME;
};
protoOf(AnalyticsScreenName_0).a3n = function () {
  return this.INVESTMENT_ACTIVITY;
};
protoOf(AnalyticsScreenName_0).b3n = function () {
  return this.INVESTOR_STATEMENTS;
};
protoOf(AnalyticsScreenName_0).c3n = function () {
  return this.KYC_DECLINED;
};
protoOf(AnalyticsScreenName_0).d3n = function () {
  return this.KYC_REVIEW;
};
protoOf(AnalyticsScreenName_0).e3n = function () {
  return this.KYC_STATUS;
};
protoOf(AnalyticsScreenName_0).f3n = function () {
  return this.LOGIN_EMAIL;
};
protoOf(AnalyticsScreenName_0).g3n = function () {
  return this.LOGIN_MAGIC_LINK;
};
protoOf(AnalyticsScreenName_0).h3n = function () {
  return this.LOGIN_PASSKEY;
};
protoOf(AnalyticsScreenName_0).i3n = function () {
  return this.LOGIN_PASSWORD;
};
protoOf(AnalyticsScreenName_0).j3n = function () {
  return this.LOGIN_TOTP;
};
protoOf(AnalyticsScreenName_0).w3j = function () {
  return this.MENU;
};
protoOf(AnalyticsScreenName_0).k3n = function () {
  return this.MESSAGING_PREFERENCE;
};
protoOf(AnalyticsScreenName_0).x3j = function () {
  return this.MY_PORTFOLIO;
};
protoOf(AnalyticsScreenName_0).l3n = function () {
  return this.ONBOARDING;
};
protoOf(AnalyticsScreenName_0).m3n = function () {
  return this.PAYOUT_SETTINGS;
};
protoOf(AnalyticsScreenName_0).z3j = function () {
  return this.PROFILE;
};
protoOf(AnalyticsScreenName_0).n3n = function () {
  return this.PROFILE_BANK_DETAILS;
};
protoOf(AnalyticsScreenName_0).o3n = function () {
  return this.PROFILE_PERSONAL_DETAILS;
};
protoOf(AnalyticsScreenName_0).p3n = function () {
  return this.PROPERTIES_MAP;
};
protoOf(AnalyticsScreenName_0).q3n = function () {
  return this.PROPERTY;
};
protoOf(AnalyticsScreenName_0).r3n = function () {
  return this.PROPERTY_TOUR;
};
protoOf(AnalyticsScreenName_0).s3n = function () {
  return this.REAUTH_MAGIC_LINK;
};
protoOf(AnalyticsScreenName_0).t3n = function () {
  return this.REAUTH_PASSKEY;
};
protoOf(AnalyticsScreenName_0).u3n = function () {
  return this.REAUTH_PASSWORD;
};
protoOf(AnalyticsScreenName_0).v3n = function () {
  return this.REAUTH_TOTP;
};
protoOf(AnalyticsScreenName_0).j3l = function () {
  return this.REGISTRATION;
};
protoOf(AnalyticsScreenName_0).w3n = function () {
  return this.RESERVE_SHARES_1;
};
protoOf(AnalyticsScreenName_0).x3n = function () {
  return this.RESERVE_SHARES_2;
};
protoOf(AnalyticsScreenName_0).y3n = function () {
  return this.RESERVE_SHARES_3;
};
protoOf(AnalyticsScreenName_0).z3n = function () {
  return this.RESERVE_SHARES_PENDING;
};
protoOf(AnalyticsScreenName_0).h3i = function () {
  return this.SECURITY_SETTINGS;
};
protoOf(AnalyticsScreenName_0).a3o = function () {
  return this.SELL_ORDER_REVIEW;
};
protoOf(AnalyticsScreenName_0).b3o = function () {
  return this.SELL_SHARES;
};
protoOf(AnalyticsScreenName_0).c3o = function () {
  return this.SELL_SHARES_REVIEW;
};
protoOf(AnalyticsScreenName_0).d3o = function () {
  return this.SET_PASSWORD;
};
protoOf(AnalyticsScreenName_0).e3o = function () {
  return this.SETUP_TOTP;
};
protoOf(AnalyticsScreenName_0).f3o = function () {
  return this.SHARE_CANCELLED_FEEDBACK;
};
protoOf(AnalyticsScreenName_0).g3o = function () {
  return this.SHARE_RESERVED_FEEDBACK;
};
protoOf(AnalyticsScreenName_0).b3k = function () {
  return this.SUPPORT;
};
protoOf(AnalyticsScreenName_0).h3o = function () {
  return this.TRANSACTION_DETAILS;
};
protoOf(AnalyticsScreenName_0).d3k = function () {
  return this.TRANSACTION_HISTORY;
};
protoOf(AnalyticsScreenName_0).i3o = function () {
  return this.TRANSFER_GUIDE;
};
protoOf(AnalyticsScreenName_0).j3o = function () {
  return this.VERIFY_MAGIC_LINK;
};
var AnalyticsScreenName_instance;
function AnalyticsScreenName_getInstance() {
  return AnalyticsScreenName_instance;
}
function AnalyticsTimeRange_0() {
  this.SIX_MONTHS = '6_months';
  this.ONE_YEAR = '1_year';
  this.THREE_YEARS = '3_years';
  this.ALL = 'all';
}
protoOf(AnalyticsTimeRange_0).k3o = function () {
  return this.SIX_MONTHS;
};
protoOf(AnalyticsTimeRange_0).l3o = function () {
  return this.ONE_YEAR;
};
protoOf(AnalyticsTimeRange_0).m3o = function () {
  return this.THREE_YEARS;
};
protoOf(AnalyticsTimeRange_0).n3o = function () {
  return this.ALL;
};
var AnalyticsTimeRange_instance;
function AnalyticsTimeRange_getInstance() {
  return AnalyticsTimeRange_instance;
}
var AnalyticsTransactionStage_Initiated_instance;
var AnalyticsTransactionStage_Reserved_instance;
var AnalyticsTransactionStage_Pending_instance;
function values_5() {
  return [AnalyticsTransactionStage_Initiated_getInstance(), AnalyticsTransactionStage_Reserved_getInstance(), AnalyticsTransactionStage_Pending_getInstance()];
}
function valueOf_5(value) {
  switch (value) {
    case 'Initiated':
      return AnalyticsTransactionStage_Initiated_getInstance();
    case 'Reserved':
      return AnalyticsTransactionStage_Reserved_getInstance();
    case 'Pending':
      return AnalyticsTransactionStage_Pending_getInstance();
    default:
      AnalyticsTransactionStage_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsTransactionStage.' + value);
      break;
  }
}
function get_entries_5() {
  if ($ENTRIES_5 == null)
    $ENTRIES_5 = enumEntries(values_5());
  return $ENTRIES_5;
}
var AnalyticsTransactionStage_entriesInitialized;
function AnalyticsTransactionStage_initEntries() {
  if (AnalyticsTransactionStage_entriesInitialized)
    return Unit_instance;
  AnalyticsTransactionStage_entriesInitialized = true;
  AnalyticsTransactionStage_Initiated_instance = new AnalyticsTransactionStage('Initiated', 0, 'initiated');
  AnalyticsTransactionStage_Reserved_instance = new AnalyticsTransactionStage('Reserved', 1, 'reserved');
  AnalyticsTransactionStage_Pending_instance = new AnalyticsTransactionStage('Pending', 2, 'pending');
}
var $ENTRIES_5;
function AnalyticsTransactionStage(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsTransactionStage).w = function () {
  return this.value;
};
protoOf(AnalyticsTransactionStage).toString = function () {
  return this.value;
};
function AnalyticsTransactionStage_Initiated_getInstance() {
  AnalyticsTransactionStage_initEntries();
  return AnalyticsTransactionStage_Initiated_instance;
}
function AnalyticsTransactionStage_Reserved_getInstance() {
  AnalyticsTransactionStage_initEntries();
  return AnalyticsTransactionStage_Reserved_instance;
}
function AnalyticsTransactionStage_Pending_getInstance() {
  AnalyticsTransactionStage_initEntries();
  return AnalyticsTransactionStage_Pending_instance;
}
var AnalyticsTransactionType_Buy_instance;
var AnalyticsTransactionType_Sell_instance;
function values_6() {
  return [AnalyticsTransactionType_Buy_getInstance(), AnalyticsTransactionType_Sell_getInstance()];
}
function valueOf_6(value) {
  switch (value) {
    case 'Buy':
      return AnalyticsTransactionType_Buy_getInstance();
    case 'Sell':
      return AnalyticsTransactionType_Sell_getInstance();
    default:
      AnalyticsTransactionType_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.analytics.AnalyticsTransactionType.' + value);
      break;
  }
}
function get_entries_6() {
  if ($ENTRIES_6 == null)
    $ENTRIES_6 = enumEntries(values_6());
  return $ENTRIES_6;
}
var AnalyticsTransactionType_entriesInitialized;
function AnalyticsTransactionType_initEntries() {
  if (AnalyticsTransactionType_entriesInitialized)
    return Unit_instance;
  AnalyticsTransactionType_entriesInitialized = true;
  AnalyticsTransactionType_Buy_instance = new AnalyticsTransactionType('Buy', 0, 'buy');
  AnalyticsTransactionType_Sell_instance = new AnalyticsTransactionType('Sell', 1, 'sell');
}
var $ENTRIES_6;
function AnalyticsTransactionType(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(AnalyticsTransactionType).w = function () {
  return this.value;
};
protoOf(AnalyticsTransactionType).toString = function () {
  return this.value;
};
function AnalyticsTransactionType_Buy_getInstance() {
  AnalyticsTransactionType_initEntries();
  return AnalyticsTransactionType_Buy_instance;
}
function AnalyticsTransactionType_Sell_getInstance() {
  AnalyticsTransactionType_initEntries();
  return AnalyticsTransactionType_Sell_instance;
}
function AnalyticsUserProperties_0() {
  this.COUNTRY = 'country';
  this.IS_INTERNAL = 'is_internal';
  this.KYC_STATUS = 'kyc_status';
  this.SIGNUP_COHORT = 'signup_cohort';
}
protoOf(AnalyticsUserProperties_0).s3o = function () {
  return this.COUNTRY;
};
protoOf(AnalyticsUserProperties_0).t3o = function () {
  return this.IS_INTERNAL;
};
protoOf(AnalyticsUserProperties_0).e3n = function () {
  return this.KYC_STATUS;
};
protoOf(AnalyticsUserProperties_0).u3o = function () {
  return this.SIGNUP_COHORT;
};
var AnalyticsUserProperties_instance;
function AnalyticsUserProperties_getInstance() {
  return AnalyticsUserProperties_instance;
}
function AnalyticsValue_0() {
  this.ENABLE = 'enable';
  this.DISABLE = 'disable';
  this.OPEN_SETTINGS = 'open_settings';
}
protoOf(AnalyticsValue_0).v3o = function () {
  return this.ENABLE;
};
protoOf(AnalyticsValue_0).w3o = function () {
  return this.DISABLE;
};
protoOf(AnalyticsValue_0).x3o = function () {
  return this.OPEN_SETTINGS;
};
var AnalyticsValue_instance;
function AnalyticsValue_getInstance() {
  return AnalyticsValue_instance;
}
function Companion() {
}
protoOf(Companion).o1c = function () {
  return $serializer_getInstance();
};
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.PasswordlessRequest', this, 4);
  tmp0_serialDesc.k10('email', false);
  tmp0_serialDesc.k10('url', false);
  tmp0_serialDesc.k10('force', true);
  tmp0_serialDesc.k10('sessionExp', true);
  this.y3o_1 = tmp0_serialDesc;
}
protoOf($serializer).z3o = function (encoder, value) {
  var tmp0_desc = this.y3o_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.email);
  tmp1_output.hu(tmp0_desc, 1, value.url);
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.force === false)) {
    tmp1_output.zt(tmp0_desc, 2, value.force);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.sessionExp == null)) {
    tmp1_output.lu(tmp0_desc, 3, LongSerializer_getInstance(), value.sessionExp);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer).gp = function (encoder, value) {
  return this.z3o(encoder, value instanceof PasswordlessRequest ? value : THROW_CCE());
};
protoOf($serializer).hp = function (decoder) {
  var tmp0_desc = this.y3o_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = false;
  var tmp7_local3 = null;
  var tmp8_input = decoder.ss(tmp0_desc);
  if (tmp8_input.it()) {
    tmp4_local0 = tmp8_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.us(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.gt(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.us(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.gt(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.ts(tmp0_desc);
  return PasswordlessRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer).fp = function () {
  return this.y3o_1;
};
protoOf($serializer).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function PasswordlessRequest_init_$Init$(seen0, email, url, force, sessionExp, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance().y3o_1);
  }
  $this.email = email;
  $this.url = url;
  if (0 === (seen0 & 4))
    $this.force = false;
  else
    $this.force = force;
  if (0 === (seen0 & 8))
    $this.sessionExp = null;
  else
    $this.sessionExp = sessionExp;
  return $this;
}
function PasswordlessRequest_init_$Create$(seen0, email, url, force, sessionExp, serializationConstructorMarker) {
  return PasswordlessRequest_init_$Init$(seen0, email, url, force, sessionExp, serializationConstructorMarker, objectCreate(protoOf(PasswordlessRequest)));
}
function PasswordlessRequest(email, url, force, sessionExp) {
  force = force === VOID ? false : force;
  sessionExp = sessionExp === VOID ? null : sessionExp;
  this.email = email;
  this.url = url;
  this.force = force;
  this.sessionExp = sessionExp;
}
protoOf(PasswordlessRequest).a3p = function () {
  return this.email;
};
protoOf(PasswordlessRequest).b3p = function () {
  return this.url;
};
protoOf(PasswordlessRequest).c3p = function () {
  return this.force;
};
protoOf(PasswordlessRequest).d3p = function () {
  return this.sessionExp;
};
protoOf(PasswordlessRequest).wf = function () {
  return this.email;
};
protoOf(PasswordlessRequest).xf = function () {
  return this.url;
};
protoOf(PasswordlessRequest).e3p = function () {
  return this.force;
};
protoOf(PasswordlessRequest).f3p = function () {
  return this.sessionExp;
};
protoOf(PasswordlessRequest).g3p = function (email, url, force, sessionExp) {
  return new PasswordlessRequest(email, url, force, sessionExp);
};
protoOf(PasswordlessRequest).copy = function (email, url, force, sessionExp, $super) {
  email = email === VOID ? this.email : email;
  url = url === VOID ? this.url : url;
  force = force === VOID ? this.force : force;
  sessionExp = sessionExp === VOID ? this.sessionExp : sessionExp;
  return $super === VOID ? this.g3p(email, url, force, sessionExp) : $super.g3p.call(this, email, url, force, sessionExp);
};
protoOf(PasswordlessRequest).toString = function () {
  return 'PasswordlessRequest(email=' + this.email + ', url=' + this.url + ', force=' + this.force + ', sessionExp=' + toString(this.sessionExp) + ')';
};
protoOf(PasswordlessRequest).hashCode = function () {
  var result = getStringHashCode(this.email);
  result = imul(result, 31) + getStringHashCode(this.url) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.force) | 0;
  result = imul(result, 31) + (this.sessionExp == null ? 0 : getBigIntHashCode(this.sessionExp)) | 0;
  return result;
};
protoOf(PasswordlessRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PasswordlessRequest))
    return false;
  if (!(this.email === other.email))
    return false;
  if (!(this.url === other.url))
    return false;
  if (!(this.force === other.force))
    return false;
  if (!(this.sessionExp == other.sessionExp))
    return false;
  return true;
};
function PasswordlessResponse$Companion$$childSerializers$_anonymous__nhkq97() {
  return new ArrayListSerializer(Companion_getInstance_18().o1c());
}
function Companion_0() {
  Companion_instance_0 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i3p_1 = [null, lazy(tmp_0, PasswordlessResponse$Companion$$childSerializers$_anonymous__nhkq97)];
}
protoOf(Companion_0).o1c = function () {
  return $serializer_getInstance_0();
};
var Companion_instance_0;
function Companion_getInstance_3() {
  if (Companion_instance_0 == null)
    new Companion_0();
  return Companion_instance_0;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.PasswordlessResponse', this, 2);
  tmp0_serialDesc.k10('sent', true);
  tmp0_serialDesc.k10('methods', true);
  this.j3p_1 = tmp0_serialDesc;
}
protoOf($serializer_0).k3p = function (encoder, value) {
  var tmp0_desc = this.j3p_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_3().i3p_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.sent === false)) {
    tmp1_output.zt(tmp0_desc, 0, value.sent);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !equals(value.methods, emptyList())) {
    tmp1_output.ju(tmp0_desc, 1, tmp2_cached[1].w(), value.methods);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_0).gp = function (encoder, value) {
  return this.k3p(encoder, value instanceof PasswordlessResponse ? value : THROW_CCE());
};
protoOf($serializer_0).hp = function (decoder) {
  var tmp0_desc = this.j3p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  var tmp7_cached = Companion_getInstance_3().i3p_1;
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.us(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.et(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.us(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.et(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return PasswordlessResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_0).fp = function () {
  return this.j3p_1;
};
protoOf($serializer_0).z10 = function () {
  var tmp0_cached = Companion_getInstance_3().i3p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance(), tmp0_cached[1].w()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function PasswordlessResponse_init_$Init$(seen0, sent, methods, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_0().j3p_1);
  }
  if (0 === (seen0 & 1))
    $this.sent = false;
  else
    $this.sent = sent;
  if (0 === (seen0 & 2))
    $this.methods = emptyList();
  else
    $this.methods = methods;
  return $this;
}
function PasswordlessResponse_init_$Create$(seen0, sent, methods, serializationConstructorMarker) {
  return PasswordlessResponse_init_$Init$(seen0, sent, methods, serializationConstructorMarker, objectCreate(protoOf(PasswordlessResponse)));
}
function PasswordlessResponse(sent, methods) {
  Companion_getInstance_3();
  sent = sent === VOID ? false : sent;
  methods = methods === VOID ? emptyList() : methods;
  this.sent = sent;
  this.methods = methods;
}
protoOf(PasswordlessResponse).l3p = function () {
  return this.sent;
};
protoOf(PasswordlessResponse).m3p = function () {
  return this.methods;
};
protoOf(PasswordlessResponse).wf = function () {
  return this.sent;
};
protoOf(PasswordlessResponse).xf = function () {
  return this.methods;
};
protoOf(PasswordlessResponse).n3p = function (sent, methods) {
  return new PasswordlessResponse(sent, methods);
};
protoOf(PasswordlessResponse).copy = function (sent, methods, $super) {
  sent = sent === VOID ? this.sent : sent;
  methods = methods === VOID ? this.methods : methods;
  return $super === VOID ? this.n3p(sent, methods) : $super.n3p.call(this, sent, methods);
};
protoOf(PasswordlessResponse).toString = function () {
  return 'PasswordlessResponse(sent=' + this.sent + ', methods=' + toString_0(this.methods) + ')';
};
protoOf(PasswordlessResponse).hashCode = function () {
  var result = getBooleanHashCode(this.sent);
  result = imul(result, 31) + hashCode(this.methods) | 0;
  return result;
};
protoOf(PasswordlessResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PasswordlessResponse))
    return false;
  if (!(this.sent === other.sent))
    return false;
  if (!equals(this.methods, other.methods))
    return false;
  return true;
};
function ProfileResponse$Companion$$childSerializers$_anonymous__c1u2cg() {
  return Companion_getInstance_13().o1c();
}
function ProfileResponse$Companion$$childSerializers$_anonymous__c1u2cg_0() {
  return Companion_getInstance_17().o1c();
}
function ProfileResponse$Companion$$childSerializers$_anonymous__c1u2cg_1() {
  return Companion_getInstance_14().o1c();
}
function Companion_1() {
  Companion_instance_1 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, ProfileResponse$Companion$$childSerializers$_anonymous__c1u2cg);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_3 = lazy(tmp_2, ProfileResponse$Companion$$childSerializers$_anonymous__c1u2cg_0);
  var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r3p_1 = [null, null, null, tmp_1, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, tmp_3, null, lazy(tmp_4, ProfileResponse$Companion$$childSerializers$_anonymous__c1u2cg_1), null, null, null];
}
protoOf(Companion_1).o1c = function () {
  return $serializer_getInstance_1();
};
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 == null)
    new Companion_1();
  return Companion_instance_1;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.ProfileResponse', this, 28);
  tmp0_serialDesc.k10('userId', true);
  tmp0_serialDesc.k10('email', true);
  tmp0_serialDesc.k10('accountCreateOn', true);
  tmp0_serialDesc.k10('accountStatus', true);
  tmp0_serialDesc.k10('firstName', true);
  tmp0_serialDesc.k10('lastName', true);
  tmp0_serialDesc.k10('fullName', true);
  tmp0_serialDesc.k10('dob', true);
  tmp0_serialDesc.k10('optIn', true);
  tmp0_serialDesc.k10('directContactable', true);
  tmp0_serialDesc.k10('password', true);
  tmp0_serialDesc.k10('twoFaSetup', true);
  tmp0_serialDesc.k10('webauthnSetup', true);
  tmp0_serialDesc.k10('phoneNumber', true);
  tmp0_serialDesc.k10('addressLine1', true);
  tmp0_serialDesc.k10('addressLine2', true);
  tmp0_serialDesc.k10('postalCode', true);
  tmp0_serialDesc.k10('city', true);
  tmp0_serialDesc.k10('state', true);
  tmp0_serialDesc.k10('country', true);
  tmp0_serialDesc.k10('nationality', true);
  tmp0_serialDesc.k10('role', true);
  tmp0_serialDesc.k10('investorTier', true);
  tmp0_serialDesc.k10('accreditedInvestorStatus', true);
  tmp0_serialDesc.k10('showFeedbackSurvey', true);
  tmp0_serialDesc.k10('tcAcceptanceTimestamp', true);
  tmp0_serialDesc.k10('threshold', true);
  tmp0_serialDesc.k10('pushNotificationsEnabled', true);
  this.s3p_1 = tmp0_serialDesc;
}
protoOf($serializer_1).t3p = function (encoder, value) {
  var tmp0_desc = this.s3p_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_4().r3p_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.userId == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.userId);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.email == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.email);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.accountCreateOn == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.accountCreateOn);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.accountStatus == null)) {
    tmp1_output.lu(tmp0_desc, 3, tmp2_cached[3].w(), value.accountStatus);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.firstName == null)) {
    tmp1_output.lu(tmp0_desc, 4, StringSerializer_getInstance(), value.firstName);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.lastName == null)) {
    tmp1_output.lu(tmp0_desc, 5, StringSerializer_getInstance(), value.lastName);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.fullName == null)) {
    tmp1_output.lu(tmp0_desc, 6, StringSerializer_getInstance(), value.fullName);
  }
  if (tmp1_output.pu(tmp0_desc, 7) ? true : !(value.dob == null)) {
    tmp1_output.lu(tmp0_desc, 7, StringSerializer_getInstance(), value.dob);
  }
  if (tmp1_output.pu(tmp0_desc, 8) ? true : !(value.optIn == null)) {
    tmp1_output.lu(tmp0_desc, 8, BooleanSerializer_getInstance(), value.optIn);
  }
  if (tmp1_output.pu(tmp0_desc, 9) ? true : !(value.directContactable == null)) {
    tmp1_output.lu(tmp0_desc, 9, BooleanSerializer_getInstance(), value.directContactable);
  }
  if (tmp1_output.pu(tmp0_desc, 10) ? true : !(value.password == null)) {
    tmp1_output.lu(tmp0_desc, 10, BooleanSerializer_getInstance(), value.password);
  }
  if (tmp1_output.pu(tmp0_desc, 11) ? true : !(value.twoFaSetup == null)) {
    tmp1_output.lu(tmp0_desc, 11, BooleanSerializer_getInstance(), value.twoFaSetup);
  }
  if (tmp1_output.pu(tmp0_desc, 12) ? true : !(value.webauthnSetup == null)) {
    tmp1_output.lu(tmp0_desc, 12, BooleanSerializer_getInstance(), value.webauthnSetup);
  }
  if (tmp1_output.pu(tmp0_desc, 13) ? true : !(value.phoneNumber == null)) {
    tmp1_output.lu(tmp0_desc, 13, StringSerializer_getInstance(), value.phoneNumber);
  }
  if (tmp1_output.pu(tmp0_desc, 14) ? true : !(value.addressLine1 == null)) {
    tmp1_output.lu(tmp0_desc, 14, StringSerializer_getInstance(), value.addressLine1);
  }
  if (tmp1_output.pu(tmp0_desc, 15) ? true : !(value.addressLine2 == null)) {
    tmp1_output.lu(tmp0_desc, 15, StringSerializer_getInstance(), value.addressLine2);
  }
  if (tmp1_output.pu(tmp0_desc, 16) ? true : !(value.postalCode == null)) {
    tmp1_output.lu(tmp0_desc, 16, StringSerializer_getInstance(), value.postalCode);
  }
  if (tmp1_output.pu(tmp0_desc, 17) ? true : !(value.city == null)) {
    tmp1_output.lu(tmp0_desc, 17, StringSerializer_getInstance(), value.city);
  }
  if (tmp1_output.pu(tmp0_desc, 18) ? true : !(value.state == null)) {
    tmp1_output.lu(tmp0_desc, 18, StringSerializer_getInstance(), value.state);
  }
  if (tmp1_output.pu(tmp0_desc, 19) ? true : !(value.country == null)) {
    tmp1_output.lu(tmp0_desc, 19, StringSerializer_getInstance(), value.country);
  }
  if (tmp1_output.pu(tmp0_desc, 20) ? true : !(value.nationality == null)) {
    tmp1_output.lu(tmp0_desc, 20, StringSerializer_getInstance(), value.nationality);
  }
  if (tmp1_output.pu(tmp0_desc, 21) ? true : !(value.role == null)) {
    tmp1_output.lu(tmp0_desc, 21, StringSerializer_getInstance(), value.role);
  }
  if (tmp1_output.pu(tmp0_desc, 22) ? true : !(value.investorTier == null)) {
    tmp1_output.lu(tmp0_desc, 22, tmp2_cached[22].w(), value.investorTier);
  }
  if (tmp1_output.pu(tmp0_desc, 23) ? true : !(value.accreditedInvestorStatus == null)) {
    tmp1_output.lu(tmp0_desc, 23, BooleanSerializer_getInstance(), value.accreditedInvestorStatus);
  }
  if (tmp1_output.pu(tmp0_desc, 24) ? true : !(value.showFeedbackSurvey == null)) {
    tmp1_output.lu(tmp0_desc, 24, tmp2_cached[24].w(), value.showFeedbackSurvey);
  }
  if (tmp1_output.pu(tmp0_desc, 25) ? true : !(value.tcAcceptanceTimestamp == null)) {
    tmp1_output.lu(tmp0_desc, 25, StringSerializer_getInstance(), value.tcAcceptanceTimestamp);
  }
  if (tmp1_output.pu(tmp0_desc, 26) ? true : !(value.threshold == null)) {
    tmp1_output.lu(tmp0_desc, 26, IntSerializer_getInstance(), value.threshold);
  }
  if (tmp1_output.pu(tmp0_desc, 27) ? true : !(value.pushNotificationsEnabled == null)) {
    tmp1_output.lu(tmp0_desc, 27, BooleanSerializer_getInstance(), value.pushNotificationsEnabled);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_1).gp = function (encoder, value) {
  return this.t3p(encoder, value instanceof ProfileResponse ? value : THROW_CCE());
};
protoOf($serializer_1).hp = function (decoder) {
  var tmp0_desc = this.s3p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_local12 = null;
  var tmp17_local13 = null;
  var tmp18_local14 = null;
  var tmp19_local15 = null;
  var tmp20_local16 = null;
  var tmp21_local17 = null;
  var tmp22_local18 = null;
  var tmp23_local19 = null;
  var tmp24_local20 = null;
  var tmp25_local21 = null;
  var tmp26_local22 = null;
  var tmp27_local23 = null;
  var tmp28_local24 = null;
  var tmp29_local25 = null;
  var tmp30_local26 = null;
  var tmp31_local27 = null;
  var tmp32_input = decoder.ss(tmp0_desc);
  var tmp33_cached = Companion_getInstance_4().r3p_1;
  if (tmp32_input.it()) {
    tmp4_local0 = tmp32_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp32_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp32_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp32_input.gt(tmp0_desc, 3, tmp33_cached[3].w(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp32_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp32_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp32_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp32_input.gt(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp32_input.gt(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp32_input.gt(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp32_input.gt(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp32_input.gt(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp32_input.gt(tmp0_desc, 12, BooleanSerializer_getInstance(), tmp16_local12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp32_input.gt(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp32_input.gt(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp32_input.gt(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp32_input.gt(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp21_local17 = tmp32_input.gt(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    tmp22_local18 = tmp32_input.gt(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
    tmp3_bitMask0 = tmp3_bitMask0 | 262144;
    tmp23_local19 = tmp32_input.gt(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
    tmp3_bitMask0 = tmp3_bitMask0 | 524288;
    tmp24_local20 = tmp32_input.gt(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
    tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    tmp25_local21 = tmp32_input.gt(tmp0_desc, 21, StringSerializer_getInstance(), tmp25_local21);
    tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    tmp26_local22 = tmp32_input.gt(tmp0_desc, 22, tmp33_cached[22].w(), tmp26_local22);
    tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    tmp27_local23 = tmp32_input.gt(tmp0_desc, 23, BooleanSerializer_getInstance(), tmp27_local23);
    tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    tmp28_local24 = tmp32_input.gt(tmp0_desc, 24, tmp33_cached[24].w(), tmp28_local24);
    tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
    tmp29_local25 = tmp32_input.gt(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
    tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
    tmp30_local26 = tmp32_input.gt(tmp0_desc, 26, IntSerializer_getInstance(), tmp30_local26);
    tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    tmp31_local27 = tmp32_input.gt(tmp0_desc, 27, BooleanSerializer_getInstance(), tmp31_local27);
    tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp32_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp32_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp32_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp32_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp32_input.gt(tmp0_desc, 3, tmp33_cached[3].w(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp32_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp32_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp32_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp32_input.gt(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp32_input.gt(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp32_input.gt(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp32_input.gt(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp32_input.gt(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp32_input.gt(tmp0_desc, 12, BooleanSerializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp32_input.gt(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp32_input.gt(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp32_input.gt(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp32_input.gt(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp21_local17 = tmp32_input.gt(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        case 18:
          tmp22_local18 = tmp32_input.gt(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          break;
        case 19:
          tmp23_local19 = tmp32_input.gt(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          break;
        case 20:
          tmp24_local20 = tmp32_input.gt(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          break;
        case 21:
          tmp25_local21 = tmp32_input.gt(tmp0_desc, 21, StringSerializer_getInstance(), tmp25_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          break;
        case 22:
          tmp26_local22 = tmp32_input.gt(tmp0_desc, 22, tmp33_cached[22].w(), tmp26_local22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          break;
        case 23:
          tmp27_local23 = tmp32_input.gt(tmp0_desc, 23, BooleanSerializer_getInstance(), tmp27_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          break;
        case 24:
          tmp28_local24 = tmp32_input.gt(tmp0_desc, 24, tmp33_cached[24].w(), tmp28_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          break;
        case 25:
          tmp29_local25 = tmp32_input.gt(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          break;
        case 26:
          tmp30_local26 = tmp32_input.gt(tmp0_desc, 26, IntSerializer_getInstance(), tmp30_local26);
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          break;
        case 27:
          tmp31_local27 = tmp32_input.gt(tmp0_desc, 27, BooleanSerializer_getInstance(), tmp31_local27);
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp32_input.ts(tmp0_desc);
  return ProfileResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, null);
};
protoOf($serializer_1).fp = function () {
  return this.s3p_1;
};
protoOf($serializer_1).z10 = function () {
  var tmp0_cached = Companion_getInstance_4().r3p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].w()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[22].w()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[24].w()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ProfileResponse_init_$Init$(seen0, userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_1().s3p_1);
  }
  if (0 === (seen0 & 1))
    $this.userId = null;
  else
    $this.userId = userId;
  if (0 === (seen0 & 2))
    $this.email = null;
  else
    $this.email = email;
  if (0 === (seen0 & 4))
    $this.accountCreateOn = null;
  else
    $this.accountCreateOn = accountCreateOn;
  if (0 === (seen0 & 8))
    $this.accountStatus = null;
  else
    $this.accountStatus = accountStatus;
  if (0 === (seen0 & 16))
    $this.firstName = null;
  else
    $this.firstName = firstName;
  if (0 === (seen0 & 32))
    $this.lastName = null;
  else
    $this.lastName = lastName;
  if (0 === (seen0 & 64))
    $this.fullName = null;
  else
    $this.fullName = fullName;
  if (0 === (seen0 & 128))
    $this.dob = null;
  else
    $this.dob = dob;
  if (0 === (seen0 & 256))
    $this.optIn = null;
  else
    $this.optIn = optIn;
  if (0 === (seen0 & 512))
    $this.directContactable = null;
  else
    $this.directContactable = directContactable;
  if (0 === (seen0 & 1024))
    $this.password = null;
  else
    $this.password = password;
  if (0 === (seen0 & 2048))
    $this.twoFaSetup = null;
  else
    $this.twoFaSetup = twoFaSetup;
  if (0 === (seen0 & 4096))
    $this.webauthnSetup = null;
  else
    $this.webauthnSetup = webauthnSetup;
  if (0 === (seen0 & 8192))
    $this.phoneNumber = null;
  else
    $this.phoneNumber = phoneNumber;
  if (0 === (seen0 & 16384))
    $this.addressLine1 = null;
  else
    $this.addressLine1 = addressLine1;
  if (0 === (seen0 & 32768))
    $this.addressLine2 = null;
  else
    $this.addressLine2 = addressLine2;
  if (0 === (seen0 & 65536))
    $this.postalCode = null;
  else
    $this.postalCode = postalCode;
  if (0 === (seen0 & 131072))
    $this.city = null;
  else
    $this.city = city;
  if (0 === (seen0 & 262144))
    $this.state = null;
  else
    $this.state = state;
  if (0 === (seen0 & 524288))
    $this.country = null;
  else
    $this.country = country;
  if (0 === (seen0 & 1048576))
    $this.nationality = null;
  else
    $this.nationality = nationality;
  if (0 === (seen0 & 2097152))
    $this.role = null;
  else
    $this.role = role;
  if (0 === (seen0 & 4194304))
    $this.investorTier = null;
  else
    $this.investorTier = investorTier;
  if (0 === (seen0 & 8388608))
    $this.accreditedInvestorStatus = null;
  else
    $this.accreditedInvestorStatus = accreditedInvestorStatus;
  if (0 === (seen0 & 16777216))
    $this.showFeedbackSurvey = null;
  else
    $this.showFeedbackSurvey = showFeedbackSurvey;
  if (0 === (seen0 & 33554432))
    $this.tcAcceptanceTimestamp = null;
  else
    $this.tcAcceptanceTimestamp = tcAcceptanceTimestamp;
  if (0 === (seen0 & 67108864))
    $this.threshold = null;
  else
    $this.threshold = threshold;
  if (0 === (seen0 & 134217728))
    $this.pushNotificationsEnabled = null;
  else
    $this.pushNotificationsEnabled = pushNotificationsEnabled;
  return $this;
}
function ProfileResponse_init_$Create$(seen0, userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled, serializationConstructorMarker) {
  return ProfileResponse_init_$Init$(seen0, userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled, serializationConstructorMarker, objectCreate(protoOf(ProfileResponse)));
}
function ProfileResponse(userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled) {
  Companion_getInstance_4();
  userId = userId === VOID ? null : userId;
  email = email === VOID ? null : email;
  accountCreateOn = accountCreateOn === VOID ? null : accountCreateOn;
  accountStatus = accountStatus === VOID ? null : accountStatus;
  firstName = firstName === VOID ? null : firstName;
  lastName = lastName === VOID ? null : lastName;
  fullName = fullName === VOID ? null : fullName;
  dob = dob === VOID ? null : dob;
  optIn = optIn === VOID ? null : optIn;
  directContactable = directContactable === VOID ? null : directContactable;
  password = password === VOID ? null : password;
  twoFaSetup = twoFaSetup === VOID ? null : twoFaSetup;
  webauthnSetup = webauthnSetup === VOID ? null : webauthnSetup;
  phoneNumber = phoneNumber === VOID ? null : phoneNumber;
  addressLine1 = addressLine1 === VOID ? null : addressLine1;
  addressLine2 = addressLine2 === VOID ? null : addressLine2;
  postalCode = postalCode === VOID ? null : postalCode;
  city = city === VOID ? null : city;
  state = state === VOID ? null : state;
  country = country === VOID ? null : country;
  nationality = nationality === VOID ? null : nationality;
  role = role === VOID ? null : role;
  investorTier = investorTier === VOID ? null : investorTier;
  accreditedInvestorStatus = accreditedInvestorStatus === VOID ? null : accreditedInvestorStatus;
  showFeedbackSurvey = showFeedbackSurvey === VOID ? null : showFeedbackSurvey;
  tcAcceptanceTimestamp = tcAcceptanceTimestamp === VOID ? null : tcAcceptanceTimestamp;
  threshold = threshold === VOID ? null : threshold;
  pushNotificationsEnabled = pushNotificationsEnabled === VOID ? null : pushNotificationsEnabled;
  this.userId = userId;
  this.email = email;
  this.accountCreateOn = accountCreateOn;
  this.accountStatus = accountStatus;
  this.firstName = firstName;
  this.lastName = lastName;
  this.fullName = fullName;
  this.dob = dob;
  this.optIn = optIn;
  this.directContactable = directContactable;
  this.password = password;
  this.twoFaSetup = twoFaSetup;
  this.webauthnSetup = webauthnSetup;
  this.phoneNumber = phoneNumber;
  this.addressLine1 = addressLine1;
  this.addressLine2 = addressLine2;
  this.postalCode = postalCode;
  this.city = city;
  this.state = state;
  this.country = country;
  this.nationality = nationality;
  this.role = role;
  this.investorTier = investorTier;
  this.accreditedInvestorStatus = accreditedInvestorStatus;
  this.showFeedbackSurvey = showFeedbackSurvey;
  this.tcAcceptanceTimestamp = tcAcceptanceTimestamp;
  this.threshold = threshold;
  this.pushNotificationsEnabled = pushNotificationsEnabled;
}
protoOf(ProfileResponse).u3p = function () {
  return this.userId;
};
protoOf(ProfileResponse).a3p = function () {
  return this.email;
};
protoOf(ProfileResponse).v3p = function () {
  return this.accountCreateOn;
};
protoOf(ProfileResponse).w3p = function () {
  return this.accountStatus;
};
protoOf(ProfileResponse).x3p = function () {
  return this.firstName;
};
protoOf(ProfileResponse).y3p = function () {
  return this.lastName;
};
protoOf(ProfileResponse).z3p = function () {
  return this.fullName;
};
protoOf(ProfileResponse).a3q = function () {
  return this.dob;
};
protoOf(ProfileResponse).b3q = function () {
  return this.optIn;
};
protoOf(ProfileResponse).c3q = function () {
  return this.directContactable;
};
protoOf(ProfileResponse).l3e = function () {
  return this.password;
};
protoOf(ProfileResponse).d3q = function () {
  return this.twoFaSetup;
};
protoOf(ProfileResponse).e3q = function () {
  return this.webauthnSetup;
};
protoOf(ProfileResponse).f3q = function () {
  return this.phoneNumber;
};
protoOf(ProfileResponse).g3q = function () {
  return this.addressLine1;
};
protoOf(ProfileResponse).h3q = function () {
  return this.addressLine2;
};
protoOf(ProfileResponse).i3q = function () {
  return this.postalCode;
};
protoOf(ProfileResponse).j3q = function () {
  return this.city;
};
protoOf(ProfileResponse).k3q = function () {
  return this.state;
};
protoOf(ProfileResponse).l3q = function () {
  return this.country;
};
protoOf(ProfileResponse).m3q = function () {
  return this.nationality;
};
protoOf(ProfileResponse).n3q = function () {
  return this.role;
};
protoOf(ProfileResponse).o3q = function () {
  return this.investorTier;
};
protoOf(ProfileResponse).p3q = function () {
  return this.accreditedInvestorStatus;
};
protoOf(ProfileResponse).q3q = function () {
  return this.showFeedbackSurvey;
};
protoOf(ProfileResponse).r3q = function () {
  return this.tcAcceptanceTimestamp;
};
protoOf(ProfileResponse).s3q = function () {
  return this.threshold;
};
protoOf(ProfileResponse).t3q = function () {
  return this.pushNotificationsEnabled;
};
protoOf(ProfileResponse).wf = function () {
  return this.userId;
};
protoOf(ProfileResponse).xf = function () {
  return this.email;
};
protoOf(ProfileResponse).e3p = function () {
  return this.accountCreateOn;
};
protoOf(ProfileResponse).f3p = function () {
  return this.accountStatus;
};
protoOf(ProfileResponse).u3q = function () {
  return this.firstName;
};
protoOf(ProfileResponse).v3q = function () {
  return this.lastName;
};
protoOf(ProfileResponse).w3q = function () {
  return this.fullName;
};
protoOf(ProfileResponse).x3q = function () {
  return this.dob;
};
protoOf(ProfileResponse).y3q = function () {
  return this.optIn;
};
protoOf(ProfileResponse).z3q = function () {
  return this.directContactable;
};
protoOf(ProfileResponse).a3r = function () {
  return this.password;
};
protoOf(ProfileResponse).b3r = function () {
  return this.twoFaSetup;
};
protoOf(ProfileResponse).c3r = function () {
  return this.webauthnSetup;
};
protoOf(ProfileResponse).d3r = function () {
  return this.phoneNumber;
};
protoOf(ProfileResponse).e3r = function () {
  return this.addressLine1;
};
protoOf(ProfileResponse).f3r = function () {
  return this.addressLine2;
};
protoOf(ProfileResponse).g3r = function () {
  return this.postalCode;
};
protoOf(ProfileResponse).h3r = function () {
  return this.city;
};
protoOf(ProfileResponse).i3r = function () {
  return this.state;
};
protoOf(ProfileResponse).j3r = function () {
  return this.country;
};
protoOf(ProfileResponse).k3r = function () {
  return this.nationality;
};
protoOf(ProfileResponse).l3r = function () {
  return this.role;
};
protoOf(ProfileResponse).m3r = function () {
  return this.investorTier;
};
protoOf(ProfileResponse).n3r = function () {
  return this.accreditedInvestorStatus;
};
protoOf(ProfileResponse).o3r = function () {
  return this.showFeedbackSurvey;
};
protoOf(ProfileResponse).p3r = function () {
  return this.tcAcceptanceTimestamp;
};
protoOf(ProfileResponse).q3r = function () {
  return this.threshold;
};
protoOf(ProfileResponse).r3r = function () {
  return this.pushNotificationsEnabled;
};
protoOf(ProfileResponse).s3r = function (userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled) {
  return new ProfileResponse(userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled);
};
protoOf(ProfileResponse).copy = function (userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled, $super) {
  userId = userId === VOID ? this.userId : userId;
  email = email === VOID ? this.email : email;
  accountCreateOn = accountCreateOn === VOID ? this.accountCreateOn : accountCreateOn;
  accountStatus = accountStatus === VOID ? this.accountStatus : accountStatus;
  firstName = firstName === VOID ? this.firstName : firstName;
  lastName = lastName === VOID ? this.lastName : lastName;
  fullName = fullName === VOID ? this.fullName : fullName;
  dob = dob === VOID ? this.dob : dob;
  optIn = optIn === VOID ? this.optIn : optIn;
  directContactable = directContactable === VOID ? this.directContactable : directContactable;
  password = password === VOID ? this.password : password;
  twoFaSetup = twoFaSetup === VOID ? this.twoFaSetup : twoFaSetup;
  webauthnSetup = webauthnSetup === VOID ? this.webauthnSetup : webauthnSetup;
  phoneNumber = phoneNumber === VOID ? this.phoneNumber : phoneNumber;
  addressLine1 = addressLine1 === VOID ? this.addressLine1 : addressLine1;
  addressLine2 = addressLine2 === VOID ? this.addressLine2 : addressLine2;
  postalCode = postalCode === VOID ? this.postalCode : postalCode;
  city = city === VOID ? this.city : city;
  state = state === VOID ? this.state : state;
  country = country === VOID ? this.country : country;
  nationality = nationality === VOID ? this.nationality : nationality;
  role = role === VOID ? this.role : role;
  investorTier = investorTier === VOID ? this.investorTier : investorTier;
  accreditedInvestorStatus = accreditedInvestorStatus === VOID ? this.accreditedInvestorStatus : accreditedInvestorStatus;
  showFeedbackSurvey = showFeedbackSurvey === VOID ? this.showFeedbackSurvey : showFeedbackSurvey;
  tcAcceptanceTimestamp = tcAcceptanceTimestamp === VOID ? this.tcAcceptanceTimestamp : tcAcceptanceTimestamp;
  threshold = threshold === VOID ? this.threshold : threshold;
  pushNotificationsEnabled = pushNotificationsEnabled === VOID ? this.pushNotificationsEnabled : pushNotificationsEnabled;
  return $super === VOID ? this.s3r(userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled) : $super.s3r.call(this, userId, email, accountCreateOn, accountStatus, firstName, lastName, fullName, dob, optIn, directContactable, password, twoFaSetup, webauthnSetup, phoneNumber, addressLine1, addressLine2, postalCode, city, state, country, nationality, role, investorTier, accreditedInvestorStatus, showFeedbackSurvey, tcAcceptanceTimestamp, threshold, pushNotificationsEnabled);
};
protoOf(ProfileResponse).toString = function () {
  return 'ProfileResponse(userId=' + this.userId + ', email=' + this.email + ', accountCreateOn=' + this.accountCreateOn + ', accountStatus=' + toString(this.accountStatus) + ', firstName=' + this.firstName + ', lastName=' + this.lastName + ', fullName=' + this.fullName + ', dob=' + this.dob + ', optIn=' + this.optIn + ', directContactable=' + this.directContactable + ', password=' + this.password + ', twoFaSetup=' + this.twoFaSetup + ', webauthnSetup=' + this.webauthnSetup + ', phoneNumber=' + this.phoneNumber + ', addressLine1=' + this.addressLine1 + ', addressLine2=' + this.addressLine2 + ', postalCode=' + this.postalCode + ', city=' + this.city + ', state=' + this.state + ', country=' + this.country + ', nationality=' + this.nationality + ', role=' + this.role + ', investorTier=' + toString(this.investorTier) + ', accreditedInvestorStatus=' + this.accreditedInvestorStatus + ', showFeedbackSurvey=' + toString(this.showFeedbackSurvey) + ', tcAcceptanceTimestamp=' + this.tcAcceptanceTimestamp + ', threshold=' + this.threshold + ', pushNotificationsEnabled=' + this.pushNotificationsEnabled + ')';
};
protoOf(ProfileResponse).hashCode = function () {
  var result = this.userId == null ? 0 : getStringHashCode(this.userId);
  result = imul(result, 31) + (this.email == null ? 0 : getStringHashCode(this.email)) | 0;
  result = imul(result, 31) + (this.accountCreateOn == null ? 0 : getStringHashCode(this.accountCreateOn)) | 0;
  result = imul(result, 31) + (this.accountStatus == null ? 0 : this.accountStatus.hashCode()) | 0;
  result = imul(result, 31) + (this.firstName == null ? 0 : getStringHashCode(this.firstName)) | 0;
  result = imul(result, 31) + (this.lastName == null ? 0 : getStringHashCode(this.lastName)) | 0;
  result = imul(result, 31) + (this.fullName == null ? 0 : getStringHashCode(this.fullName)) | 0;
  result = imul(result, 31) + (this.dob == null ? 0 : getStringHashCode(this.dob)) | 0;
  result = imul(result, 31) + (this.optIn == null ? 0 : getBooleanHashCode(this.optIn)) | 0;
  result = imul(result, 31) + (this.directContactable == null ? 0 : getBooleanHashCode(this.directContactable)) | 0;
  result = imul(result, 31) + (this.password == null ? 0 : getBooleanHashCode(this.password)) | 0;
  result = imul(result, 31) + (this.twoFaSetup == null ? 0 : getBooleanHashCode(this.twoFaSetup)) | 0;
  result = imul(result, 31) + (this.webauthnSetup == null ? 0 : getBooleanHashCode(this.webauthnSetup)) | 0;
  result = imul(result, 31) + (this.phoneNumber == null ? 0 : getStringHashCode(this.phoneNumber)) | 0;
  result = imul(result, 31) + (this.addressLine1 == null ? 0 : getStringHashCode(this.addressLine1)) | 0;
  result = imul(result, 31) + (this.addressLine2 == null ? 0 : getStringHashCode(this.addressLine2)) | 0;
  result = imul(result, 31) + (this.postalCode == null ? 0 : getStringHashCode(this.postalCode)) | 0;
  result = imul(result, 31) + (this.city == null ? 0 : getStringHashCode(this.city)) | 0;
  result = imul(result, 31) + (this.state == null ? 0 : getStringHashCode(this.state)) | 0;
  result = imul(result, 31) + (this.country == null ? 0 : getStringHashCode(this.country)) | 0;
  result = imul(result, 31) + (this.nationality == null ? 0 : getStringHashCode(this.nationality)) | 0;
  result = imul(result, 31) + (this.role == null ? 0 : getStringHashCode(this.role)) | 0;
  result = imul(result, 31) + (this.investorTier == null ? 0 : this.investorTier.hashCode()) | 0;
  result = imul(result, 31) + (this.accreditedInvestorStatus == null ? 0 : getBooleanHashCode(this.accreditedInvestorStatus)) | 0;
  result = imul(result, 31) + (this.showFeedbackSurvey == null ? 0 : this.showFeedbackSurvey.hashCode()) | 0;
  result = imul(result, 31) + (this.tcAcceptanceTimestamp == null ? 0 : getStringHashCode(this.tcAcceptanceTimestamp)) | 0;
  result = imul(result, 31) + (this.threshold == null ? 0 : this.threshold) | 0;
  result = imul(result, 31) + (this.pushNotificationsEnabled == null ? 0 : getBooleanHashCode(this.pushNotificationsEnabled)) | 0;
  return result;
};
protoOf(ProfileResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProfileResponse))
    return false;
  if (!(this.userId == other.userId))
    return false;
  if (!(this.email == other.email))
    return false;
  if (!(this.accountCreateOn == other.accountCreateOn))
    return false;
  if (!equals(this.accountStatus, other.accountStatus))
    return false;
  if (!(this.firstName == other.firstName))
    return false;
  if (!(this.lastName == other.lastName))
    return false;
  if (!(this.fullName == other.fullName))
    return false;
  if (!(this.dob == other.dob))
    return false;
  if (!(this.optIn == other.optIn))
    return false;
  if (!(this.directContactable == other.directContactable))
    return false;
  if (!(this.password == other.password))
    return false;
  if (!(this.twoFaSetup == other.twoFaSetup))
    return false;
  if (!(this.webauthnSetup == other.webauthnSetup))
    return false;
  if (!(this.phoneNumber == other.phoneNumber))
    return false;
  if (!(this.addressLine1 == other.addressLine1))
    return false;
  if (!(this.addressLine2 == other.addressLine2))
    return false;
  if (!(this.postalCode == other.postalCode))
    return false;
  if (!(this.city == other.city))
    return false;
  if (!(this.state == other.state))
    return false;
  if (!(this.country == other.country))
    return false;
  if (!(this.nationality == other.nationality))
    return false;
  if (!(this.role == other.role))
    return false;
  if (!equals(this.investorTier, other.investorTier))
    return false;
  if (!(this.accreditedInvestorStatus == other.accreditedInvestorStatus))
    return false;
  if (!equals(this.showFeedbackSurvey, other.showFeedbackSurvey))
    return false;
  if (!(this.tcAcceptanceTimestamp == other.tcAcceptanceTimestamp))
    return false;
  if (!(this.threshold == other.threshold))
    return false;
  if (!(this.pushNotificationsEnabled == other.pushNotificationsEnabled))
    return false;
  return true;
};
function RenewJWTRequest$Companion$$childSerializers$_anonymous__nzmz3p() {
  return new ArrayListSerializer(Companion_getInstance_19().o1c());
}
function Companion_2() {
  Companion_instance_2 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.u3r_1 = [lazy(tmp_0, RenewJWTRequest$Companion$$childSerializers$_anonymous__nzmz3p), null];
}
protoOf(Companion_2).o1c = function () {
  return $serializer_getInstance_2();
};
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 == null)
    new Companion_2();
  return Companion_instance_2;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.RenewJWTRequest', this, 2);
  tmp0_serialDesc.k10('scopes', true);
  tmp0_serialDesc.k10('expiresTime', true);
  this.v3r_1 = tmp0_serialDesc;
}
protoOf($serializer_2).w3r = function (encoder, value) {
  var tmp0_desc = this.v3r_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_5().u3r_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.scopes, listOf(PermissionScope_basic_getInstance()))) {
    tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.scopes);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.expiresTime == null)) {
    tmp1_output.lu(tmp0_desc, 1, LongSerializer_getInstance(), value.expiresTime);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_2).gp = function (encoder, value) {
  return this.w3r(encoder, value instanceof RenewJWTRequest ? value : THROW_CCE());
};
protoOf($serializer_2).hp = function (decoder) {
  var tmp0_desc = this.v3r_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  var tmp7_cached = Companion_getInstance_5().u3r_1;
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, tmp7_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, tmp7_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return RenewJWTRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_2).fp = function () {
  return this.v3r_1;
};
protoOf($serializer_2).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_5().u3r_1[0].w(), get_nullable(LongSerializer_getInstance())];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function RenewJWTRequest_init_$Init$(seen0, scopes, expiresTime, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_2().v3r_1);
  }
  if (0 === (seen0 & 1))
    $this.scopes = listOf(PermissionScope_basic_getInstance());
  else
    $this.scopes = scopes;
  if (0 === (seen0 & 2))
    $this.expiresTime = null;
  else
    $this.expiresTime = expiresTime;
  return $this;
}
function RenewJWTRequest_init_$Create$(seen0, scopes, expiresTime, serializationConstructorMarker) {
  return RenewJWTRequest_init_$Init$(seen0, scopes, expiresTime, serializationConstructorMarker, objectCreate(protoOf(RenewJWTRequest)));
}
function RenewJWTRequest(scopes, expiresTime) {
  Companion_getInstance_5();
  scopes = scopes === VOID ? listOf(PermissionScope_basic_getInstance()) : scopes;
  expiresTime = expiresTime === VOID ? null : expiresTime;
  this.scopes = scopes;
  this.expiresTime = expiresTime;
}
protoOf(RenewJWTRequest).x3r = function () {
  return this.scopes;
};
protoOf(RenewJWTRequest).y3r = function () {
  return this.expiresTime;
};
protoOf(RenewJWTRequest).wf = function () {
  return this.scopes;
};
protoOf(RenewJWTRequest).xf = function () {
  return this.expiresTime;
};
protoOf(RenewJWTRequest).z3r = function (scopes, expiresTime) {
  return new RenewJWTRequest(scopes, expiresTime);
};
protoOf(RenewJWTRequest).copy = function (scopes, expiresTime, $super) {
  scopes = scopes === VOID ? this.scopes : scopes;
  expiresTime = expiresTime === VOID ? this.expiresTime : expiresTime;
  return $super === VOID ? this.z3r(scopes, expiresTime) : $super.z3r.call(this, scopes, expiresTime);
};
protoOf(RenewJWTRequest).toString = function () {
  return 'RenewJWTRequest(scopes=' + toString_0(this.scopes) + ', expiresTime=' + toString(this.expiresTime) + ')';
};
protoOf(RenewJWTRequest).hashCode = function () {
  var result = hashCode(this.scopes);
  result = imul(result, 31) + (this.expiresTime == null ? 0 : getBigIntHashCode(this.expiresTime)) | 0;
  return result;
};
protoOf(RenewJWTRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RenewJWTRequest))
    return false;
  if (!equals(this.scopes, other.scopes))
    return false;
  if (!(this.expiresTime == other.expiresTime))
    return false;
  return true;
};
function Companion_3() {
}
protoOf(Companion_3).o1c = function () {
  return $serializer_getInstance_3();
};
var Companion_instance_3;
function Companion_getInstance_6() {
  return Companion_instance_3;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.TokenResponse', this, 1);
  tmp0_serialDesc.k10('accessToken', true);
  this.a3s_1 = tmp0_serialDesc;
}
protoOf($serializer_3).b3s = function (encoder, value) {
  var tmp0_desc = this.a3s_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.accessToken == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.accessToken);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_3).gp = function (encoder, value) {
  return this.b3s(encoder, value instanceof TokenResponse ? value : THROW_CCE());
};
protoOf($serializer_3).hp = function (decoder) {
  var tmp0_desc = this.a3s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return TokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_3).fp = function () {
  return this.a3s_1;
};
protoOf($serializer_3).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function TokenResponse_init_$Init$(seen0, accessToken, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_3().a3s_1);
  }
  if (0 === (seen0 & 1))
    $this.accessToken = null;
  else
    $this.accessToken = accessToken;
  return $this;
}
function TokenResponse_init_$Create$(seen0, accessToken, serializationConstructorMarker) {
  return TokenResponse_init_$Init$(seen0, accessToken, serializationConstructorMarker, objectCreate(protoOf(TokenResponse)));
}
function TokenResponse(accessToken) {
  accessToken = accessToken === VOID ? null : accessToken;
  this.accessToken = accessToken;
}
protoOf(TokenResponse).c3s = function () {
  return this.accessToken;
};
protoOf(TokenResponse).wf = function () {
  return this.accessToken;
};
protoOf(TokenResponse).d3s = function (accessToken) {
  return new TokenResponse(accessToken);
};
protoOf(TokenResponse).copy = function (accessToken, $super) {
  accessToken = accessToken === VOID ? this.accessToken : accessToken;
  return $super === VOID ? this.d3s(accessToken) : $super.d3s.call(this, accessToken);
};
protoOf(TokenResponse).toString = function () {
  return 'TokenResponse(accessToken=' + this.accessToken + ')';
};
protoOf(TokenResponse).hashCode = function () {
  return this.accessToken == null ? 0 : getStringHashCode(this.accessToken);
};
protoOf(TokenResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TokenResponse))
    return false;
  if (!(this.accessToken == other.accessToken))
    return false;
  return true;
};
function VerifyAuthRequest$Companion$$childSerializers$_anonymous__mae6uc() {
  return Companion_getInstance_20().o1c();
}
function VerifyAuthRequest$Companion$$childSerializers$_anonymous__mae6uc_0() {
  return new ArrayListSerializer(Companion_getInstance_19().o1c());
}
function Companion_4() {
  Companion_instance_4 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, VerifyAuthRequest$Companion$$childSerializers$_anonymous__mae6uc);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.f3s_1 = [null, tmp_1, null, lazy(tmp_2, VerifyAuthRequest$Companion$$childSerializers$_anonymous__mae6uc_0), null];
}
protoOf(Companion_4).o1c = function () {
  return $serializer_getInstance_4();
};
var Companion_instance_4;
function Companion_getInstance_7() {
  if (Companion_instance_4 == null)
    new Companion_4();
  return Companion_instance_4;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.VerifyAuthRequest', this, 5);
  tmp0_serialDesc.k10('email', true);
  tmp0_serialDesc.k10('secretType', false);
  tmp0_serialDesc.k10('secret', true);
  tmp0_serialDesc.k10('scopes', true);
  tmp0_serialDesc.k10('expiresTime', true);
  this.g3s_1 = tmp0_serialDesc;
}
protoOf($serializer_4).h3s = function (encoder, value) {
  var tmp0_desc = this.g3s_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_7().f3s_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.email == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.email);
  }
  tmp1_output.ju(tmp0_desc, 1, tmp2_cached[1].w(), value.secretType);
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.secret == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.secret);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !equals(value.scopes, listOf(PermissionScope_basic_getInstance()))) {
    tmp1_output.ju(tmp0_desc, 3, tmp2_cached[3].w(), value.scopes);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.expiresTime == null)) {
    tmp1_output.lu(tmp0_desc, 4, LongSerializer_getInstance(), value.expiresTime);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_4).gp = function (encoder, value) {
  return this.h3s(encoder, value instanceof VerifyAuthRequest ? value : THROW_CCE());
};
protoOf($serializer_4).hp = function (decoder) {
  var tmp0_desc = this.g3s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.ss(tmp0_desc);
  var tmp10_cached = Companion_getInstance_7().f3s_1;
  if (tmp9_input.it()) {
    tmp4_local0 = tmp9_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.et(tmp0_desc, 1, tmp10_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.et(tmp0_desc, 3, tmp10_cached[3].w(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.et(tmp0_desc, 1, tmp10_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.et(tmp0_desc, 3, tmp10_cached[3].w(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.ts(tmp0_desc);
  return VerifyAuthRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_4).fp = function () {
  return this.g3s_1;
};
protoOf($serializer_4).z10 = function () {
  var tmp0_cached = Companion_getInstance_7().f3s_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), tmp0_cached[1].w(), get_nullable(StringSerializer_getInstance()), tmp0_cached[3].w(), get_nullable(LongSerializer_getInstance())];
};
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function VerifyAuthRequest_init_$Init$(seen0, email, secretType, secret, scopes, expiresTime, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_4().g3s_1);
  }
  if (0 === (seen0 & 1))
    $this.email = null;
  else
    $this.email = email;
  $this.secretType = secretType;
  if (0 === (seen0 & 4))
    $this.secret = null;
  else
    $this.secret = secret;
  if (0 === (seen0 & 8))
    $this.scopes = listOf(PermissionScope_basic_getInstance());
  else
    $this.scopes = scopes;
  if (0 === (seen0 & 16))
    $this.expiresTime = null;
  else
    $this.expiresTime = expiresTime;
  return $this;
}
function VerifyAuthRequest_init_$Create$(seen0, email, secretType, secret, scopes, expiresTime, serializationConstructorMarker) {
  return VerifyAuthRequest_init_$Init$(seen0, email, secretType, secret, scopes, expiresTime, serializationConstructorMarker, objectCreate(protoOf(VerifyAuthRequest)));
}
function VerifyAuthRequest(email, secretType, secret, scopes, expiresTime) {
  Companion_getInstance_7();
  email = email === VOID ? null : email;
  secret = secret === VOID ? null : secret;
  scopes = scopes === VOID ? listOf(PermissionScope_basic_getInstance()) : scopes;
  expiresTime = expiresTime === VOID ? null : expiresTime;
  this.email = email;
  this.secretType = secretType;
  this.secret = secret;
  this.scopes = scopes;
  this.expiresTime = expiresTime;
}
protoOf(VerifyAuthRequest).a3p = function () {
  return this.email;
};
protoOf(VerifyAuthRequest).i3s = function () {
  return this.secretType;
};
protoOf(VerifyAuthRequest).j3s = function () {
  return this.secret;
};
protoOf(VerifyAuthRequest).x3r = function () {
  return this.scopes;
};
protoOf(VerifyAuthRequest).y3r = function () {
  return this.expiresTime;
};
protoOf(VerifyAuthRequest).wf = function () {
  return this.email;
};
protoOf(VerifyAuthRequest).xf = function () {
  return this.secretType;
};
protoOf(VerifyAuthRequest).e3p = function () {
  return this.secret;
};
protoOf(VerifyAuthRequest).f3p = function () {
  return this.scopes;
};
protoOf(VerifyAuthRequest).u3q = function () {
  return this.expiresTime;
};
protoOf(VerifyAuthRequest).k3s = function (email, secretType, secret, scopes, expiresTime) {
  return new VerifyAuthRequest(email, secretType, secret, scopes, expiresTime);
};
protoOf(VerifyAuthRequest).copy = function (email, secretType, secret, scopes, expiresTime, $super) {
  email = email === VOID ? this.email : email;
  secretType = secretType === VOID ? this.secretType : secretType;
  secret = secret === VOID ? this.secret : secret;
  scopes = scopes === VOID ? this.scopes : scopes;
  expiresTime = expiresTime === VOID ? this.expiresTime : expiresTime;
  return $super === VOID ? this.k3s(email, secretType, secret, scopes, expiresTime) : $super.k3s.call(this, email, secretType, secret, scopes, expiresTime);
};
protoOf(VerifyAuthRequest).toString = function () {
  return 'VerifyAuthRequest(email=' + this.email + ', secretType=' + this.secretType.toString() + ', secret=' + this.secret + ', scopes=' + toString_0(this.scopes) + ', expiresTime=' + toString(this.expiresTime) + ')';
};
protoOf(VerifyAuthRequest).hashCode = function () {
  var result = this.email == null ? 0 : getStringHashCode(this.email);
  result = imul(result, 31) + this.secretType.hashCode() | 0;
  result = imul(result, 31) + (this.secret == null ? 0 : getStringHashCode(this.secret)) | 0;
  result = imul(result, 31) + hashCode(this.scopes) | 0;
  result = imul(result, 31) + (this.expiresTime == null ? 0 : getBigIntHashCode(this.expiresTime)) | 0;
  return result;
};
protoOf(VerifyAuthRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VerifyAuthRequest))
    return false;
  if (!(this.email == other.email))
    return false;
  if (!this.secretType.equals(other.secretType))
    return false;
  if (!(this.secret == other.secret))
    return false;
  if (!equals(this.scopes, other.scopes))
    return false;
  if (!(this.expiresTime == other.expiresTime))
    return false;
  return true;
};
function VerifyAuthResponse$Companion$$childSerializers$_anonymous__3a2n7s() {
  return Companion_getInstance_23().o1c();
}
function Companion_5() {
  Companion_instance_5 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.m3s_1 = [null, lazy(tmp_0, VerifyAuthResponse$Companion$$childSerializers$_anonymous__3a2n7s), null];
}
protoOf(Companion_5).o1c = function () {
  return $serializer_getInstance_5();
};
var Companion_instance_5;
function Companion_getInstance_8() {
  if (Companion_instance_5 == null)
    new Companion_5();
  return Companion_instance_5;
}
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.VerifyAuthResponse', this, 3);
  tmp0_serialDesc.k10('accessToken', true);
  tmp0_serialDesc.k10('twoFactorRequired', true);
  tmp0_serialDesc.k10('requestChallengeResponse', true);
  this.n3s_1 = tmp0_serialDesc;
}
protoOf($serializer_5).o3s = function (encoder, value) {
  var tmp0_desc = this.n3s_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_8().m3s_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.accessToken == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.accessToken);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.twoFactorRequired == null)) {
    tmp1_output.lu(tmp0_desc, 1, tmp2_cached[1].w(), value.twoFactorRequired);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.requestChallengeResponse == null)) {
    tmp1_output.lu(tmp0_desc, 2, $serializer_getInstance_6(), value.requestChallengeResponse);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_5).gp = function (encoder, value) {
  return this.o3s(encoder, value instanceof VerifyAuthResponse ? value : THROW_CCE());
};
protoOf($serializer_5).hp = function (decoder) {
  var tmp0_desc = this.n3s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  var tmp8_cached = Companion_getInstance_8().m3s_1;
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, tmp8_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, tmp8_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return VerifyAuthResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_5).fp = function () {
  return this.n3s_1;
};
protoOf($serializer_5).z10 = function () {
  var tmp0_cached = Companion_getInstance_8().m3s_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[1].w()), get_nullable($serializer_getInstance_6())];
};
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function VerifyAuthResponse_init_$Init$(seen0, accessToken, twoFactorRequired, requestChallengeResponse, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_5().n3s_1);
  }
  if (0 === (seen0 & 1))
    $this.accessToken = null;
  else
    $this.accessToken = accessToken;
  if (0 === (seen0 & 2))
    $this.twoFactorRequired = null;
  else
    $this.twoFactorRequired = twoFactorRequired;
  if (0 === (seen0 & 4))
    $this.requestChallengeResponse = null;
  else
    $this.requestChallengeResponse = requestChallengeResponse;
  return $this;
}
function VerifyAuthResponse_init_$Create$(seen0, accessToken, twoFactorRequired, requestChallengeResponse, serializationConstructorMarker) {
  return VerifyAuthResponse_init_$Init$(seen0, accessToken, twoFactorRequired, requestChallengeResponse, serializationConstructorMarker, objectCreate(protoOf(VerifyAuthResponse)));
}
function VerifyAuthResponse(accessToken, twoFactorRequired, requestChallengeResponse) {
  Companion_getInstance_8();
  accessToken = accessToken === VOID ? null : accessToken;
  twoFactorRequired = twoFactorRequired === VOID ? null : twoFactorRequired;
  requestChallengeResponse = requestChallengeResponse === VOID ? null : requestChallengeResponse;
  this.accessToken = accessToken;
  this.twoFactorRequired = twoFactorRequired;
  this.requestChallengeResponse = requestChallengeResponse;
}
protoOf(VerifyAuthResponse).c3s = function () {
  return this.accessToken;
};
protoOf(VerifyAuthResponse).p3s = function () {
  return this.twoFactorRequired;
};
protoOf(VerifyAuthResponse).q3s = function () {
  return this.requestChallengeResponse;
};
protoOf(VerifyAuthResponse).wf = function () {
  return this.accessToken;
};
protoOf(VerifyAuthResponse).xf = function () {
  return this.twoFactorRequired;
};
protoOf(VerifyAuthResponse).e3p = function () {
  return this.requestChallengeResponse;
};
protoOf(VerifyAuthResponse).r3s = function (accessToken, twoFactorRequired, requestChallengeResponse) {
  return new VerifyAuthResponse(accessToken, twoFactorRequired, requestChallengeResponse);
};
protoOf(VerifyAuthResponse).copy = function (accessToken, twoFactorRequired, requestChallengeResponse, $super) {
  accessToken = accessToken === VOID ? this.accessToken : accessToken;
  twoFactorRequired = twoFactorRequired === VOID ? this.twoFactorRequired : twoFactorRequired;
  requestChallengeResponse = requestChallengeResponse === VOID ? this.requestChallengeResponse : requestChallengeResponse;
  return $super === VOID ? this.r3s(accessToken, twoFactorRequired, requestChallengeResponse) : $super.r3s.call(this, accessToken, twoFactorRequired, requestChallengeResponse);
};
protoOf(VerifyAuthResponse).toString = function () {
  return 'VerifyAuthResponse(accessToken=' + this.accessToken + ', twoFactorRequired=' + toString(this.twoFactorRequired) + ', requestChallengeResponse=' + toString(this.requestChallengeResponse) + ')';
};
protoOf(VerifyAuthResponse).hashCode = function () {
  var result = this.accessToken == null ? 0 : getStringHashCode(this.accessToken);
  result = imul(result, 31) + (this.twoFactorRequired == null ? 0 : this.twoFactorRequired.hashCode()) | 0;
  result = imul(result, 31) + (this.requestChallengeResponse == null ? 0 : this.requestChallengeResponse.hashCode()) | 0;
  return result;
};
protoOf(VerifyAuthResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VerifyAuthResponse))
    return false;
  if (!(this.accessToken == other.accessToken))
    return false;
  if (!equals(this.twoFactorRequired, other.twoFactorRequired))
    return false;
  if (!equals(this.requestChallengeResponse, other.requestChallengeResponse))
    return false;
  return true;
};
function Companion_6() {
}
protoOf(Companion_6).o1c = function () {
  return $serializer_getInstance_6();
};
var Companion_instance_6;
function Companion_getInstance_9() {
  return Companion_instance_6;
}
function $serializer_6() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.RequestChallengeResponse', this, 1);
  tmp0_serialDesc.k10('publicKey', true);
  this.s3s_1 = tmp0_serialDesc;
}
protoOf($serializer_6).t3s = function (encoder, value) {
  var tmp0_desc = this.s3s_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.publicKey == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_7(), value.publicKey);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_6).gp = function (encoder, value) {
  return this.t3s(encoder, value instanceof RequestChallengeResponse ? value : THROW_CCE());
};
protoOf($serializer_6).hp = function (decoder) {
  var tmp0_desc = this.s3s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return RequestChallengeResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_6).fp = function () {
  return this.s3s_1;
};
protoOf($serializer_6).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_7())];
};
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 == null)
    new $serializer_6();
  return $serializer_instance_6;
}
function RequestChallengeResponse_init_$Init$(seen0, publicKey, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_6().s3s_1);
  }
  if (0 === (seen0 & 1))
    $this.publicKey = null;
  else
    $this.publicKey = publicKey;
  return $this;
}
function RequestChallengeResponse_init_$Create$(seen0, publicKey, serializationConstructorMarker) {
  return RequestChallengeResponse_init_$Init$(seen0, publicKey, serializationConstructorMarker, objectCreate(protoOf(RequestChallengeResponse)));
}
function RequestChallengeResponse(publicKey) {
  publicKey = publicKey === VOID ? null : publicKey;
  this.publicKey = publicKey;
}
protoOf(RequestChallengeResponse).u3s = function () {
  return this.publicKey;
};
protoOf(RequestChallengeResponse).wf = function () {
  return this.publicKey;
};
protoOf(RequestChallengeResponse).v3s = function (publicKey) {
  return new RequestChallengeResponse(publicKey);
};
protoOf(RequestChallengeResponse).copy = function (publicKey, $super) {
  publicKey = publicKey === VOID ? this.publicKey : publicKey;
  return $super === VOID ? this.v3s(publicKey) : $super.v3s.call(this, publicKey);
};
protoOf(RequestChallengeResponse).toString = function () {
  return 'RequestChallengeResponse(publicKey=' + toString(this.publicKey) + ')';
};
protoOf(RequestChallengeResponse).hashCode = function () {
  return this.publicKey == null ? 0 : this.publicKey.hashCode();
};
protoOf(RequestChallengeResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RequestChallengeResponse))
    return false;
  if (!equals(this.publicKey, other.publicKey))
    return false;
  return true;
};
function RequestChallengeResponsePublicKey$Companion$$childSerializers$_anonymous__9b1mjb() {
  return new ArrayListSerializer($serializer_getInstance_8());
}
function Companion_7() {
  Companion_instance_7 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.w3s_1 = [null, null, null, null, lazy(tmp_0, RequestChallengeResponsePublicKey$Companion$$childSerializers$_anonymous__9b1mjb)];
}
protoOf(Companion_7).o1c = function () {
  return $serializer_getInstance_7();
};
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 == null)
    new Companion_7();
  return Companion_instance_7;
}
function $serializer_7() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.RequestChallengeResponsePublicKey', this, 5);
  tmp0_serialDesc.k10('rpId', true);
  tmp0_serialDesc.k10('challenge', true);
  tmp0_serialDesc.k10('timeout', true);
  tmp0_serialDesc.k10('userVerification', true);
  tmp0_serialDesc.k10('allowCredentials', true);
  this.x3s_1 = tmp0_serialDesc;
}
protoOf($serializer_7).y3s = function (encoder, value) {
  var tmp0_desc = this.x3s_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_10().w3s_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.rpId == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.rpId);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.challenge == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.challenge);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.timeout == null)) {
    tmp1_output.lu(tmp0_desc, 2, IntSerializer_getInstance(), value.timeout);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.userVerification == null)) {
    tmp1_output.lu(tmp0_desc, 3, StringSerializer_getInstance(), value.userVerification);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.allowCredentials == null)) {
    tmp1_output.lu(tmp0_desc, 4, tmp2_cached[4].w(), value.allowCredentials);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_7).gp = function (encoder, value) {
  return this.y3s(encoder, value instanceof RequestChallengeResponsePublicKey ? value : THROW_CCE());
};
protoOf($serializer_7).hp = function (decoder) {
  var tmp0_desc = this.x3s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.ss(tmp0_desc);
  var tmp10_cached = Companion_getInstance_10().w3s_1;
  if (tmp9_input.it()) {
    tmp4_local0 = tmp9_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.gt(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, tmp10_cached[4].w(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.gt(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, tmp10_cached[4].w(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.ts(tmp0_desc);
  return RequestChallengeResponsePublicKey_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_7).fp = function () {
  return this.x3s_1;
};
protoOf($serializer_7).z10 = function () {
  var tmp0_cached = Companion_getInstance_10().w3s_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[4].w())];
};
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 == null)
    new $serializer_7();
  return $serializer_instance_7;
}
function RequestChallengeResponsePublicKey_init_$Init$(seen0, rpId, challenge, timeout, userVerification, allowCredentials, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_7().x3s_1);
  }
  if (0 === (seen0 & 1))
    $this.rpId = null;
  else
    $this.rpId = rpId;
  if (0 === (seen0 & 2))
    $this.challenge = null;
  else
    $this.challenge = challenge;
  if (0 === (seen0 & 4))
    $this.timeout = null;
  else
    $this.timeout = timeout;
  if (0 === (seen0 & 8))
    $this.userVerification = null;
  else
    $this.userVerification = userVerification;
  if (0 === (seen0 & 16))
    $this.allowCredentials = null;
  else
    $this.allowCredentials = allowCredentials;
  return $this;
}
function RequestChallengeResponsePublicKey_init_$Create$(seen0, rpId, challenge, timeout, userVerification, allowCredentials, serializationConstructorMarker) {
  return RequestChallengeResponsePublicKey_init_$Init$(seen0, rpId, challenge, timeout, userVerification, allowCredentials, serializationConstructorMarker, objectCreate(protoOf(RequestChallengeResponsePublicKey)));
}
function RequestChallengeResponsePublicKey(rpId, challenge, timeout, userVerification, allowCredentials) {
  Companion_getInstance_10();
  rpId = rpId === VOID ? null : rpId;
  challenge = challenge === VOID ? null : challenge;
  timeout = timeout === VOID ? null : timeout;
  userVerification = userVerification === VOID ? null : userVerification;
  allowCredentials = allowCredentials === VOID ? null : allowCredentials;
  this.rpId = rpId;
  this.challenge = challenge;
  this.timeout = timeout;
  this.userVerification = userVerification;
  this.allowCredentials = allowCredentials;
}
protoOf(RequestChallengeResponsePublicKey).z3s = function () {
  return this.rpId;
};
protoOf(RequestChallengeResponsePublicKey).a3t = function (_set____db54di) {
  this.challenge = _set____db54di;
};
protoOf(RequestChallengeResponsePublicKey).b3t = function () {
  return this.challenge;
};
protoOf(RequestChallengeResponsePublicKey).c3t = function () {
  return this.timeout;
};
protoOf(RequestChallengeResponsePublicKey).d3t = function (_set____db54di) {
  this.userVerification = _set____db54di;
};
protoOf(RequestChallengeResponsePublicKey).e3t = function () {
  return this.userVerification;
};
protoOf(RequestChallengeResponsePublicKey).f3t = function (_set____db54di) {
  this.allowCredentials = _set____db54di;
};
protoOf(RequestChallengeResponsePublicKey).g3t = function () {
  return this.allowCredentials;
};
protoOf(RequestChallengeResponsePublicKey).wf = function () {
  return this.rpId;
};
protoOf(RequestChallengeResponsePublicKey).xf = function () {
  return this.challenge;
};
protoOf(RequestChallengeResponsePublicKey).e3p = function () {
  return this.timeout;
};
protoOf(RequestChallengeResponsePublicKey).f3p = function () {
  return this.userVerification;
};
protoOf(RequestChallengeResponsePublicKey).u3q = function () {
  return this.allowCredentials;
};
protoOf(RequestChallengeResponsePublicKey).h3t = function (rpId, challenge, timeout, userVerification, allowCredentials) {
  return new RequestChallengeResponsePublicKey(rpId, challenge, timeout, userVerification, allowCredentials);
};
protoOf(RequestChallengeResponsePublicKey).copy = function (rpId, challenge, timeout, userVerification, allowCredentials, $super) {
  rpId = rpId === VOID ? this.rpId : rpId;
  challenge = challenge === VOID ? this.challenge : challenge;
  timeout = timeout === VOID ? this.timeout : timeout;
  userVerification = userVerification === VOID ? this.userVerification : userVerification;
  allowCredentials = allowCredentials === VOID ? this.allowCredentials : allowCredentials;
  return $super === VOID ? this.h3t(rpId, challenge, timeout, userVerification, allowCredentials) : $super.h3t.call(this, rpId, challenge, timeout, userVerification, allowCredentials);
};
protoOf(RequestChallengeResponsePublicKey).toString = function () {
  return 'RequestChallengeResponsePublicKey(rpId=' + this.rpId + ', challenge=' + this.challenge + ', timeout=' + this.timeout + ', userVerification=' + this.userVerification + ', allowCredentials=' + toString(this.allowCredentials) + ')';
};
protoOf(RequestChallengeResponsePublicKey).hashCode = function () {
  var result = this.rpId == null ? 0 : getStringHashCode(this.rpId);
  result = imul(result, 31) + (this.challenge == null ? 0 : getStringHashCode(this.challenge)) | 0;
  result = imul(result, 31) + (this.timeout == null ? 0 : this.timeout) | 0;
  result = imul(result, 31) + (this.userVerification == null ? 0 : getStringHashCode(this.userVerification)) | 0;
  result = imul(result, 31) + (this.allowCredentials == null ? 0 : hashCode(this.allowCredentials)) | 0;
  return result;
};
protoOf(RequestChallengeResponsePublicKey).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RequestChallengeResponsePublicKey))
    return false;
  if (!(this.rpId == other.rpId))
    return false;
  if (!(this.challenge == other.challenge))
    return false;
  if (!(this.timeout == other.timeout))
    return false;
  if (!(this.userVerification == other.userVerification))
    return false;
  if (!equals(this.allowCredentials, other.allowCredentials))
    return false;
  return true;
};
function RequestChallengeResponseAllowCredential$Companion$$childSerializers$_anonymous__l1qjj5() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function Companion_8() {
  Companion_instance_8 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i3t_1 = [null, null, lazy(tmp_0, RequestChallengeResponseAllowCredential$Companion$$childSerializers$_anonymous__l1qjj5)];
}
protoOf(Companion_8).o1c = function () {
  return $serializer_getInstance_8();
};
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 == null)
    new Companion_8();
  return Companion_instance_8;
}
function $serializer_8() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.auth.RequestChallengeResponseAllowCredential', this, 3);
  tmp0_serialDesc.k10('id', true);
  tmp0_serialDesc.k10('type', true);
  tmp0_serialDesc.k10('transports', true);
  this.j3t_1 = tmp0_serialDesc;
}
protoOf($serializer_8).k3t = function (encoder, value) {
  var tmp0_desc = this.j3t_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_11().i3t_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.id == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.id);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.type == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.transports == null)) {
    tmp1_output.lu(tmp0_desc, 2, tmp2_cached[2].w(), value.transports);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_8).gp = function (encoder, value) {
  return this.k3t(encoder, value instanceof RequestChallengeResponseAllowCredential ? value : THROW_CCE());
};
protoOf($serializer_8).hp = function (decoder) {
  var tmp0_desc = this.j3t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  var tmp8_cached = Companion_getInstance_11().i3t_1;
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, tmp8_cached[2].w(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, tmp8_cached[2].w(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return RequestChallengeResponseAllowCredential_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_8).fp = function () {
  return this.j3t_1;
};
protoOf($serializer_8).z10 = function () {
  var tmp0_cached = Companion_getInstance_11().i3t_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[2].w())];
};
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 == null)
    new $serializer_8();
  return $serializer_instance_8;
}
function RequestChallengeResponseAllowCredential_init_$Init$(seen0, id, type, transports, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_8().j3t_1);
  }
  if (0 === (seen0 & 1))
    $this.id = null;
  else
    $this.id = id;
  if (0 === (seen0 & 2))
    $this.type = null;
  else
    $this.type = type;
  if (0 === (seen0 & 4))
    $this.transports = null;
  else
    $this.transports = transports;
  return $this;
}
function RequestChallengeResponseAllowCredential_init_$Create$(seen0, id, type, transports, serializationConstructorMarker) {
  return RequestChallengeResponseAllowCredential_init_$Init$(seen0, id, type, transports, serializationConstructorMarker, objectCreate(protoOf(RequestChallengeResponseAllowCredential)));
}
function RequestChallengeResponseAllowCredential(id, type, transports) {
  Companion_getInstance_11();
  id = id === VOID ? null : id;
  type = type === VOID ? null : type;
  transports = transports === VOID ? null : transports;
  this.id = id;
  this.type = type;
  this.transports = transports;
}
protoOf(RequestChallengeResponseAllowCredential).l3t = function () {
  return this.id;
};
protoOf(RequestChallengeResponseAllowCredential).m3t = function () {
  return this.type;
};
protoOf(RequestChallengeResponseAllowCredential).n3t = function () {
  return this.transports;
};
protoOf(RequestChallengeResponseAllowCredential).wf = function () {
  return this.id;
};
protoOf(RequestChallengeResponseAllowCredential).xf = function () {
  return this.type;
};
protoOf(RequestChallengeResponseAllowCredential).e3p = function () {
  return this.transports;
};
protoOf(RequestChallengeResponseAllowCredential).o3t = function (id, type, transports) {
  return new RequestChallengeResponseAllowCredential(id, type, transports);
};
protoOf(RequestChallengeResponseAllowCredential).copy = function (id, type, transports, $super) {
  id = id === VOID ? this.id : id;
  type = type === VOID ? this.type : type;
  transports = transports === VOID ? this.transports : transports;
  return $super === VOID ? this.o3t(id, type, transports) : $super.o3t.call(this, id, type, transports);
};
protoOf(RequestChallengeResponseAllowCredential).toString = function () {
  return 'RequestChallengeResponseAllowCredential(id=' + this.id + ', type=' + this.type + ', transports=' + toString(this.transports) + ')';
};
protoOf(RequestChallengeResponseAllowCredential).hashCode = function () {
  var result = this.id == null ? 0 : getStringHashCode(this.id);
  result = imul(result, 31) + (this.type == null ? 0 : getStringHashCode(this.type)) | 0;
  result = imul(result, 31) + (this.transports == null ? 0 : hashCode(this.transports)) | 0;
  return result;
};
protoOf(RequestChallengeResponseAllowCredential).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RequestChallengeResponseAllowCredential))
    return false;
  if (!(this.id == other.id))
    return false;
  if (!(this.type == other.type))
    return false;
  if (!equals(this.transports, other.transports))
    return false;
  return true;
};
function Companion_9() {
}
protoOf(Companion_9).o1c = function () {
  return $serializer_getInstance_9();
};
var Companion_instance_9;
function Companion_getInstance_12() {
  return Companion_instance_9;
}
function $serializer_9() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.common.VersionResponse', this, 1);
  tmp0_serialDesc.k10('version', false);
  this.p3t_1 = tmp0_serialDesc;
}
protoOf($serializer_9).q3t = function (encoder, value) {
  var tmp0_desc = this.p3t_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.version);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_9).gp = function (encoder, value) {
  return this.q3t(encoder, value instanceof VersionResponse ? value : THROW_CCE());
};
protoOf($serializer_9).hp = function (decoder) {
  var tmp0_desc = this.p3t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return VersionResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_9).fp = function () {
  return this.p3t_1;
};
protoOf($serializer_9).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 == null)
    new $serializer_9();
  return $serializer_instance_9;
}
function VersionResponse_init_$Init$(seen0, version, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_9().p3t_1);
  }
  $this.version = version;
  return $this;
}
function VersionResponse_init_$Create$(seen0, version, serializationConstructorMarker) {
  return VersionResponse_init_$Init$(seen0, version, serializationConstructorMarker, objectCreate(protoOf(VersionResponse)));
}
function VersionResponse(version) {
  this.version = version;
}
protoOf(VersionResponse).r3t = function () {
  return this.version;
};
protoOf(VersionResponse).wf = function () {
  return this.version;
};
protoOf(VersionResponse).s3t = function (version) {
  return new VersionResponse(version);
};
protoOf(VersionResponse).copy = function (version, $super) {
  version = version === VOID ? this.version : version;
  return $super === VOID ? this.s3t(version) : $super.s3t.call(this, version);
};
protoOf(VersionResponse).toString = function () {
  return 'VersionResponse(version=' + this.version + ')';
};
protoOf(VersionResponse).hashCode = function () {
  return getStringHashCode(this.version);
};
protoOf(VersionResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VersionResponse))
    return false;
  if (!(this.version === other.version))
    return false;
  return true;
};
function _get_$cachedSerializer__te6jhj($this) {
  return $this.o3p_1.w();
}
function AccountStatus$Companion$_anonymous__155k6o() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.AccountStatus', values_7());
}
var AccountStatus_None_instance;
var AccountStatus_Pending_instance;
var AccountStatus_KycDeclined_instance;
var AccountStatus_KycVerified_instance;
var AccountStatus_Complete_instance;
function values_7() {
  return [AccountStatus_None_getInstance(), AccountStatus_Pending_getInstance(), AccountStatus_KycDeclined_getInstance(), AccountStatus_KycVerified_getInstance(), AccountStatus_Complete_getInstance()];
}
function valueOf_7(value) {
  switch (value) {
    case 'None':
      return AccountStatus_None_getInstance();
    case 'Pending':
      return AccountStatus_Pending_getInstance();
    case 'KycDeclined':
      return AccountStatus_KycDeclined_getInstance();
    case 'KycVerified':
      return AccountStatus_KycVerified_getInstance();
    case 'Complete':
      return AccountStatus_Complete_getInstance();
    default:
      AccountStatus_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.AccountStatus.' + value);
      break;
  }
}
function Companion_10() {
  Companion_instance_10 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.o3p_1 = lazy(tmp_0, AccountStatus$Companion$_anonymous__155k6o);
}
protoOf(Companion_10).o1c = function () {
  return _get_$cachedSerializer__te6jhj(this);
};
protoOf(Companion_10).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_10;
function Companion_getInstance_13() {
  AccountStatus_initEntries();
  if (Companion_instance_10 == null)
    new Companion_10();
  return Companion_instance_10;
}
var AccountStatus_entriesInitialized;
function AccountStatus_initEntries() {
  if (AccountStatus_entriesInitialized)
    return Unit_instance;
  AccountStatus_entriesInitialized = true;
  AccountStatus_None_instance = new AccountStatus('None', 0);
  AccountStatus_Pending_instance = new AccountStatus('Pending', 1);
  AccountStatus_KycDeclined_instance = new AccountStatus('KycDeclined', 2);
  AccountStatus_KycVerified_instance = new AccountStatus('KycVerified', 3);
  AccountStatus_Complete_instance = new AccountStatus('Complete', 4);
  Companion_getInstance_13();
}
function AccountStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(AccountStatus).toAnalyticsValue = function () {
  var tmp;
  switch (this.j2_1) {
    case 0:
      tmp = 'none';
      break;
    case 1:
      tmp = 'pending';
      break;
    case 2:
      tmp = 'rejected';
      break;
    case 3:
      tmp = 'verified';
      break;
    case 4:
      tmp = 'complete';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
function AccountStatus_None_getInstance() {
  AccountStatus_initEntries();
  return AccountStatus_None_instance;
}
function AccountStatus_Pending_getInstance() {
  AccountStatus_initEntries();
  return AccountStatus_Pending_instance;
}
function AccountStatus_KycDeclined_getInstance() {
  AccountStatus_initEntries();
  return AccountStatus_KycDeclined_instance;
}
function AccountStatus_KycVerified_getInstance() {
  AccountStatus_initEntries();
  return AccountStatus_KycVerified_instance;
}
function AccountStatus_Complete_getInstance() {
  AccountStatus_initEntries();
  return AccountStatus_Complete_instance;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.q3p_1.w();
}
function ApiFeedbackSurveyTypeEnum$Companion$_anonymous__zbgexx() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.ApiFeedbackSurveyTypeEnum', values_8());
}
var ApiFeedbackSurveyTypeEnum_none_instance;
var ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_instance;
var ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_instance;
function values_8() {
  return [ApiFeedbackSurveyTypeEnum_none_getInstance(), ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_getInstance(), ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_getInstance()];
}
function valueOf_8(value) {
  switch (value) {
    case 'none':
      return ApiFeedbackSurveyTypeEnum_none_getInstance();
    case 'firstCompletedTransaction':
      return ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_getInstance();
    case 'firstCancelledTransaction':
      return ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_getInstance();
    default:
      ApiFeedbackSurveyTypeEnum_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.ApiFeedbackSurveyTypeEnum.' + value);
      break;
  }
}
function Companion_11() {
  Companion_instance_11 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.q3p_1 = lazy(tmp_0, ApiFeedbackSurveyTypeEnum$Companion$_anonymous__zbgexx);
}
protoOf(Companion_11).o1c = function () {
  return _get_$cachedSerializer__te6jhj_0(this);
};
protoOf(Companion_11).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_11;
function Companion_getInstance_14() {
  ApiFeedbackSurveyTypeEnum_initEntries();
  if (Companion_instance_11 == null)
    new Companion_11();
  return Companion_instance_11;
}
var ApiFeedbackSurveyTypeEnum_entriesInitialized;
function ApiFeedbackSurveyTypeEnum_initEntries() {
  if (ApiFeedbackSurveyTypeEnum_entriesInitialized)
    return Unit_instance;
  ApiFeedbackSurveyTypeEnum_entriesInitialized = true;
  ApiFeedbackSurveyTypeEnum_none_instance = new ApiFeedbackSurveyTypeEnum('none', 0);
  ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_instance = new ApiFeedbackSurveyTypeEnum('firstCompletedTransaction', 1);
  ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_instance = new ApiFeedbackSurveyTypeEnum('firstCancelledTransaction', 2);
  Companion_getInstance_14();
}
function ApiFeedbackSurveyTypeEnum(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ApiFeedbackSurveyTypeEnum_none_getInstance() {
  ApiFeedbackSurveyTypeEnum_initEntries();
  return ApiFeedbackSurveyTypeEnum_none_instance;
}
function ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_getInstance() {
  ApiFeedbackSurveyTypeEnum_initEntries();
  return ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_instance;
}
function ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_getInstance() {
  ApiFeedbackSurveyTypeEnum_initEntries();
  return ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_instance;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.x3t_1.w();
}
function DevicePlatformEnum$Companion$_anonymous__8b5q4l() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.DevicePlatformEnum', values_9());
}
var DevicePlatformEnum_Android_instance;
var DevicePlatformEnum_Ios_instance;
var DevicePlatformEnum_Web_instance;
function values_9() {
  return [DevicePlatformEnum_Android_getInstance(), DevicePlatformEnum_Ios_getInstance(), DevicePlatformEnum_Web_getInstance()];
}
function valueOf_9(value) {
  switch (value) {
    case 'Android':
      return DevicePlatformEnum_Android_getInstance();
    case 'Ios':
      return DevicePlatformEnum_Ios_getInstance();
    case 'Web':
      return DevicePlatformEnum_Web_getInstance();
    default:
      DevicePlatformEnum_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.DevicePlatformEnum.' + value);
      break;
  }
}
function Companion_12() {
  Companion_instance_12 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.x3t_1 = lazy(tmp_0, DevicePlatformEnum$Companion$_anonymous__8b5q4l);
}
protoOf(Companion_12).o1c = function () {
  return _get_$cachedSerializer__te6jhj_1(this);
};
protoOf(Companion_12).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_12;
function Companion_getInstance_15() {
  DevicePlatformEnum_initEntries();
  if (Companion_instance_12 == null)
    new Companion_12();
  return Companion_instance_12;
}
var DevicePlatformEnum_entriesInitialized;
function DevicePlatformEnum_initEntries() {
  if (DevicePlatformEnum_entriesInitialized)
    return Unit_instance;
  DevicePlatformEnum_entriesInitialized = true;
  DevicePlatformEnum_Android_instance = new DevicePlatformEnum('Android', 0);
  DevicePlatformEnum_Ios_instance = new DevicePlatformEnum('Ios', 1);
  DevicePlatformEnum_Web_instance = new DevicePlatformEnum('Web', 2);
  Companion_getInstance_15();
}
function DevicePlatformEnum(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function DevicePlatformEnum_Android_getInstance() {
  DevicePlatformEnum_initEntries();
  return DevicePlatformEnum_Android_instance;
}
function DevicePlatformEnum_Ios_getInstance() {
  DevicePlatformEnum_initEntries();
  return DevicePlatformEnum_Ios_instance;
}
function DevicePlatformEnum_Web_getInstance() {
  DevicePlatformEnum_initEntries();
  return DevicePlatformEnum_Web_instance;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.a3u_1.w();
}
function FeedbackSurveyStatusEnum$Companion$_anonymous__ryshgd() {
  var tmp = values_10();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = ['none', 'show', 'done'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null, null];
  return createAnnotatedEnumSerializer('com.moreharvest.shared.enums.FeedbackSurveyStatusEnum', tmp, tmp_0, tmp$ret$5, null);
}
var FeedbackSurveyStatusEnum_None_instance;
var FeedbackSurveyStatusEnum_Show_instance;
var FeedbackSurveyStatusEnum_Done_instance;
function values_10() {
  return [FeedbackSurveyStatusEnum_None_getInstance(), FeedbackSurveyStatusEnum_Show_getInstance(), FeedbackSurveyStatusEnum_Done_getInstance()];
}
function valueOf_10(value) {
  switch (value) {
    case 'None':
      return FeedbackSurveyStatusEnum_None_getInstance();
    case 'Show':
      return FeedbackSurveyStatusEnum_Show_getInstance();
    case 'Done':
      return FeedbackSurveyStatusEnum_Done_getInstance();
    default:
      FeedbackSurveyStatusEnum_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.FeedbackSurveyStatusEnum.' + value);
      break;
  }
}
function Companion_13() {
  Companion_instance_13 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.a3u_1 = lazy(tmp_0, FeedbackSurveyStatusEnum$Companion$_anonymous__ryshgd);
}
protoOf(Companion_13).o1c = function () {
  return _get_$cachedSerializer__te6jhj_2(this);
};
protoOf(Companion_13).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_13;
function Companion_getInstance_16() {
  FeedbackSurveyStatusEnum_initEntries();
  if (Companion_instance_13 == null)
    new Companion_13();
  return Companion_instance_13;
}
var FeedbackSurveyStatusEnum_entriesInitialized;
function FeedbackSurveyStatusEnum_initEntries() {
  if (FeedbackSurveyStatusEnum_entriesInitialized)
    return Unit_instance;
  FeedbackSurveyStatusEnum_entriesInitialized = true;
  FeedbackSurveyStatusEnum_None_instance = new FeedbackSurveyStatusEnum('None', 0);
  FeedbackSurveyStatusEnum_Show_instance = new FeedbackSurveyStatusEnum('Show', 1);
  FeedbackSurveyStatusEnum_Done_instance = new FeedbackSurveyStatusEnum('Done', 2);
  Companion_getInstance_16();
}
function FeedbackSurveyStatusEnum(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function FeedbackSurveyStatusEnum_None_getInstance() {
  FeedbackSurveyStatusEnum_initEntries();
  return FeedbackSurveyStatusEnum_None_instance;
}
function FeedbackSurveyStatusEnum_Show_getInstance() {
  FeedbackSurveyStatusEnum_initEntries();
  return FeedbackSurveyStatusEnum_Show_instance;
}
function FeedbackSurveyStatusEnum_Done_getInstance() {
  FeedbackSurveyStatusEnum_initEntries();
  return FeedbackSurveyStatusEnum_Done_instance;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.p3p_1.w();
}
function InvestorTierEnum$Companion$_anonymous__ep5no4() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.InvestorTierEnum', values_11());
}
var InvestorTierEnum_Enthusiast_instance;
var InvestorTierEnum_Insider_instance;
var InvestorTierEnum_Trailblazer_instance;
var InvestorTierEnum_Connoisseur_instance;
var InvestorTierEnum_Visionary_instance;
function Companion_14() {
  Companion_instance_14 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.p3p_1 = lazy(tmp_0, InvestorTierEnum$Companion$_anonymous__ep5no4);
}
protoOf(Companion_14).calculateInvestorTier = function (shares) {
  return (0 <= shares ? shares <= 9 : false) ? InvestorTierEnum_Enthusiast_getInstance() : (10 <= shares ? shares <= 49 : false) ? InvestorTierEnum_Insider_getInstance() : (50 <= shares ? shares <= 99 : false) ? InvestorTierEnum_Trailblazer_getInstance() : (100 <= shares ? shares <= 199 : false) ? InvestorTierEnum_Connoisseur_getInstance() : InvestorTierEnum_Visionary_getInstance();
};
protoOf(Companion_14).fromInt = function (value) {
  var tmp0 = get_entries_7();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (element.tier === value) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
protoOf(Companion_14).o1c = function () {
  return _get_$cachedSerializer__te6jhj_3(this);
};
protoOf(Companion_14).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_14;
function Companion_getInstance_17() {
  InvestorTierEnum_initEntries();
  if (Companion_instance_14 == null)
    new Companion_14();
  return Companion_instance_14;
}
function values_11() {
  return [InvestorTierEnum_Enthusiast_getInstance(), InvestorTierEnum_Insider_getInstance(), InvestorTierEnum_Trailblazer_getInstance(), InvestorTierEnum_Connoisseur_getInstance(), InvestorTierEnum_Visionary_getInstance()];
}
function valueOf_11(value) {
  switch (value) {
    case 'Enthusiast':
      return InvestorTierEnum_Enthusiast_getInstance();
    case 'Insider':
      return InvestorTierEnum_Insider_getInstance();
    case 'Trailblazer':
      return InvestorTierEnum_Trailblazer_getInstance();
    case 'Connoisseur':
      return InvestorTierEnum_Connoisseur_getInstance();
    case 'Visionary':
      return InvestorTierEnum_Visionary_getInstance();
    default:
      InvestorTierEnum_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.InvestorTierEnum.' + value);
      break;
  }
}
function get_entries_7() {
  if ($ENTRIES_7 == null)
    $ENTRIES_7 = enumEntries(values_11());
  return $ENTRIES_7;
}
var InvestorTierEnum_entriesInitialized;
function InvestorTierEnum_initEntries() {
  if (InvestorTierEnum_entriesInitialized)
    return Unit_instance;
  InvestorTierEnum_entriesInitialized = true;
  InvestorTierEnum_Enthusiast_instance = new InvestorTierEnum('Enthusiast', 0, 0);
  InvestorTierEnum_Insider_instance = new InvestorTierEnum('Insider', 1, 1);
  InvestorTierEnum_Trailblazer_instance = new InvestorTierEnum('Trailblazer', 2, 2);
  InvestorTierEnum_Connoisseur_instance = new InvestorTierEnum('Connoisseur', 3, 3);
  InvestorTierEnum_Visionary_instance = new InvestorTierEnum('Visionary', 4, 4);
  Companion_getInstance_17();
}
var $ENTRIES_7;
function InvestorTierEnum(name, ordinal, tier) {
  Enum.call(this, name, ordinal);
  this.tier = tier;
}
protoOf(InvestorTierEnum).f3u = function () {
  return this.tier;
};
function InvestorTierEnum_Enthusiast_getInstance() {
  InvestorTierEnum_initEntries();
  return InvestorTierEnum_Enthusiast_instance;
}
function InvestorTierEnum_Insider_getInstance() {
  InvestorTierEnum_initEntries();
  return InvestorTierEnum_Insider_instance;
}
function InvestorTierEnum_Trailblazer_getInstance() {
  InvestorTierEnum_initEntries();
  return InvestorTierEnum_Trailblazer_instance;
}
function InvestorTierEnum_Connoisseur_getInstance() {
  InvestorTierEnum_initEntries();
  return InvestorTierEnum_Connoisseur_instance;
}
function InvestorTierEnum_Visionary_getInstance() {
  InvestorTierEnum_initEntries();
  return InvestorTierEnum_Visionary_instance;
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.h3p_1.w();
}
function LoginMethod$Companion$_anonymous__y7fk4l() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.LoginMethod', values_12());
}
var LoginMethod_magicLink_instance;
var LoginMethod_password_instance;
var LoginMethod_webauthn_instance;
function values_12() {
  return [LoginMethod_magicLink_getInstance(), LoginMethod_password_getInstance(), LoginMethod_webauthn_getInstance()];
}
function valueOf_12(value) {
  switch (value) {
    case 'magicLink':
      return LoginMethod_magicLink_getInstance();
    case 'password':
      return LoginMethod_password_getInstance();
    case 'webauthn':
      return LoginMethod_webauthn_getInstance();
    default:
      LoginMethod_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.LoginMethod.' + value);
      break;
  }
}
function Companion_15() {
  Companion_instance_15 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.h3p_1 = lazy(tmp_0, LoginMethod$Companion$_anonymous__y7fk4l);
}
protoOf(Companion_15).o1c = function () {
  return _get_$cachedSerializer__te6jhj_4(this);
};
protoOf(Companion_15).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_15;
function Companion_getInstance_18() {
  LoginMethod_initEntries();
  if (Companion_instance_15 == null)
    new Companion_15();
  return Companion_instance_15;
}
var LoginMethod_entriesInitialized;
function LoginMethod_initEntries() {
  if (LoginMethod_entriesInitialized)
    return Unit_instance;
  LoginMethod_entriesInitialized = true;
  LoginMethod_magicLink_instance = new LoginMethod('magicLink', 0);
  LoginMethod_password_instance = new LoginMethod('password', 1);
  LoginMethod_webauthn_instance = new LoginMethod('webauthn', 2);
  Companion_getInstance_18();
}
function LoginMethod(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function LoginMethod_magicLink_getInstance() {
  LoginMethod_initEntries();
  return LoginMethod_magicLink_instance;
}
function LoginMethod_password_getInstance() {
  LoginMethod_initEntries();
  return LoginMethod_password_instance;
}
function LoginMethod_webauthn_getInstance() {
  LoginMethod_initEntries();
  return LoginMethod_webauthn_instance;
}
function _get_$cachedSerializer__te6jhj_5($this) {
  return $this.t3r_1.w();
}
function PermissionScope$Companion$_anonymous__opyw96() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.PermissionScope', values_13());
}
var PermissionScope_basic_instance;
var PermissionScope_security_instance;
function Companion_16() {
  Companion_instance_16 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.t3r_1 = lazy(tmp_0, PermissionScope$Companion$_anonymous__opyw96);
}
protoOf(Companion_16).fromString = function (s) {
  var tmp0 = get_entries_8();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (element.value === s) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
protoOf(Companion_16).o1c = function () {
  return _get_$cachedSerializer__te6jhj_5(this);
};
protoOf(Companion_16).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_16;
function Companion_getInstance_19() {
  PermissionScope_initEntries();
  if (Companion_instance_16 == null)
    new Companion_16();
  return Companion_instance_16;
}
function values_13() {
  return [PermissionScope_basic_getInstance(), PermissionScope_security_getInstance()];
}
function valueOf_13(value) {
  switch (value) {
    case 'basic':
      return PermissionScope_basic_getInstance();
    case 'security':
      return PermissionScope_security_getInstance();
    default:
      PermissionScope_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.PermissionScope.' + value);
      break;
  }
}
function get_entries_8() {
  if ($ENTRIES_8 == null)
    $ENTRIES_8 = enumEntries(values_13());
  return $ENTRIES_8;
}
var PermissionScope_entriesInitialized;
function PermissionScope_initEntries() {
  if (PermissionScope_entriesInitialized)
    return Unit_instance;
  PermissionScope_entriesInitialized = true;
  PermissionScope_basic_instance = new PermissionScope('basic', 0, 'basic');
  PermissionScope_security_instance = new PermissionScope('security', 1, 'security');
  Companion_getInstance_19();
}
var $ENTRIES_8;
function PermissionScope(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(PermissionScope).w = function () {
  return this.value;
};
function PermissionScope_basic_getInstance() {
  PermissionScope_initEntries();
  return PermissionScope_basic_instance;
}
function PermissionScope_security_getInstance() {
  PermissionScope_initEntries();
  return PermissionScope_security_instance;
}
function _get_$cachedSerializer__te6jhj_6($this) {
  return $this.e3s_1.w();
}
function SecretType$Companion$_anonymous__yi8yd7() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.SecretType', values_14());
}
var SecretType_password_instance;
var SecretType_magicLink_instance;
var SecretType_totp_instance;
var SecretType_webauthn_instance;
function values_14() {
  return [SecretType_password_getInstance(), SecretType_magicLink_getInstance(), SecretType_totp_getInstance(), SecretType_webauthn_getInstance()];
}
function valueOf_14(value) {
  switch (value) {
    case 'password':
      return SecretType_password_getInstance();
    case 'magicLink':
      return SecretType_magicLink_getInstance();
    case 'totp':
      return SecretType_totp_getInstance();
    case 'webauthn':
      return SecretType_webauthn_getInstance();
    default:
      SecretType_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.SecretType.' + value);
      break;
  }
}
function Companion_17() {
  Companion_instance_17 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.e3s_1 = lazy(tmp_0, SecretType$Companion$_anonymous__yi8yd7);
}
protoOf(Companion_17).o1c = function () {
  return _get_$cachedSerializer__te6jhj_6(this);
};
protoOf(Companion_17).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_17;
function Companion_getInstance_20() {
  SecretType_initEntries();
  if (Companion_instance_17 == null)
    new Companion_17();
  return Companion_instance_17;
}
var SecretType_entriesInitialized;
function SecretType_initEntries() {
  if (SecretType_entriesInitialized)
    return Unit_instance;
  SecretType_entriesInitialized = true;
  SecretType_password_instance = new SecretType('password', 0);
  SecretType_magicLink_instance = new SecretType('magicLink', 1);
  SecretType_totp_instance = new SecretType('totp', 2);
  SecretType_webauthn_instance = new SecretType('webauthn', 3);
  Companion_getInstance_20();
}
function SecretType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function SecretType_password_getInstance() {
  SecretType_initEntries();
  return SecretType_password_instance;
}
function SecretType_magicLink_getInstance() {
  SecretType_initEntries();
  return SecretType_magicLink_instance;
}
function SecretType_totp_getInstance() {
  SecretType_initEntries();
  return SecretType_totp_instance;
}
function SecretType_webauthn_getInstance() {
  SecretType_initEntries();
  return SecretType_webauthn_instance;
}
function _get_$cachedSerializer__te6jhj_7($this) {
  return $this.m3u_1.w();
}
function TransactionTypeEnum$Companion$_anonymous__xnpfee() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.TransactionTypeEnum', values_15());
}
var TransactionTypeEnum_buy_instance;
var TransactionTypeEnum_sell_instance;
function values_15() {
  return [TransactionTypeEnum_buy_getInstance(), TransactionTypeEnum_sell_getInstance()];
}
function valueOf_15(value) {
  switch (value) {
    case 'buy':
      return TransactionTypeEnum_buy_getInstance();
    case 'sell':
      return TransactionTypeEnum_sell_getInstance();
    default:
      TransactionTypeEnum_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.TransactionTypeEnum.' + value);
      break;
  }
}
function Companion_18() {
  Companion_instance_18 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.m3u_1 = lazy(tmp_0, TransactionTypeEnum$Companion$_anonymous__xnpfee);
}
protoOf(Companion_18).o1c = function () {
  return _get_$cachedSerializer__te6jhj_7(this);
};
protoOf(Companion_18).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_18;
function Companion_getInstance_21() {
  TransactionTypeEnum_initEntries();
  if (Companion_instance_18 == null)
    new Companion_18();
  return Companion_instance_18;
}
var TransactionTypeEnum_entriesInitialized;
function TransactionTypeEnum_initEntries() {
  if (TransactionTypeEnum_entriesInitialized)
    return Unit_instance;
  TransactionTypeEnum_entriesInitialized = true;
  TransactionTypeEnum_buy_instance = new TransactionTypeEnum('buy', 0);
  TransactionTypeEnum_sell_instance = new TransactionTypeEnum('sell', 1);
  Companion_getInstance_21();
}
function TransactionTypeEnum(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(TransactionTypeEnum).checkStatus = function (status) {
  var tmp;
  switch (this.j2_1) {
    case 0:
      tmp = true;
      break;
    case 1:
      tmp = !status.equals(TransactionStatusEnum_reserved_getInstance());
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
function _get_$cachedSerializer__te6jhj_8($this) {
  return $this.p3u_1.w();
}
function TransactionStatusEnum$Companion$_anonymous__hvsb26() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.TransactionStatusEnum', values_16());
}
var TransactionStatusEnum_completed_instance;
var TransactionStatusEnum_cancelled_instance;
var TransactionStatusEnum_reserved_instance;
var TransactionStatusEnum_pending_instance;
var TransactionStatusEnum_custom_instance;
function values_16() {
  return [TransactionStatusEnum_completed_getInstance(), TransactionStatusEnum_cancelled_getInstance(), TransactionStatusEnum_reserved_getInstance(), TransactionStatusEnum_pending_getInstance(), TransactionStatusEnum_custom_getInstance()];
}
function valueOf_16(value) {
  switch (value) {
    case 'completed':
      return TransactionStatusEnum_completed_getInstance();
    case 'cancelled':
      return TransactionStatusEnum_cancelled_getInstance();
    case 'reserved':
      return TransactionStatusEnum_reserved_getInstance();
    case 'pending':
      return TransactionStatusEnum_pending_getInstance();
    case 'custom':
      return TransactionStatusEnum_custom_getInstance();
    default:
      TransactionStatusEnum_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.TransactionStatusEnum.' + value);
      break;
  }
}
function Companion_19() {
  Companion_instance_19 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.p3u_1 = lazy(tmp_0, TransactionStatusEnum$Companion$_anonymous__hvsb26);
}
protoOf(Companion_19).o1c = function () {
  return _get_$cachedSerializer__te6jhj_8(this);
};
protoOf(Companion_19).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_19;
function Companion_getInstance_22() {
  TransactionStatusEnum_initEntries();
  if (Companion_instance_19 == null)
    new Companion_19();
  return Companion_instance_19;
}
var TransactionStatusEnum_entriesInitialized;
function TransactionStatusEnum_initEntries() {
  if (TransactionStatusEnum_entriesInitialized)
    return Unit_instance;
  TransactionStatusEnum_entriesInitialized = true;
  TransactionStatusEnum_completed_instance = new TransactionStatusEnum('completed', 0);
  TransactionStatusEnum_cancelled_instance = new TransactionStatusEnum('cancelled', 1);
  TransactionStatusEnum_reserved_instance = new TransactionStatusEnum('reserved', 2);
  TransactionStatusEnum_pending_instance = new TransactionStatusEnum('pending', 3);
  TransactionStatusEnum_custom_instance = new TransactionStatusEnum('custom', 4);
  Companion_getInstance_22();
}
function TransactionStatusEnum(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TransactionTypeEnum_buy_getInstance() {
  TransactionTypeEnum_initEntries();
  return TransactionTypeEnum_buy_instance;
}
function TransactionTypeEnum_sell_getInstance() {
  TransactionTypeEnum_initEntries();
  return TransactionTypeEnum_sell_instance;
}
function TransactionStatusEnum_completed_getInstance() {
  TransactionStatusEnum_initEntries();
  return TransactionStatusEnum_completed_instance;
}
function TransactionStatusEnum_cancelled_getInstance() {
  TransactionStatusEnum_initEntries();
  return TransactionStatusEnum_cancelled_instance;
}
function TransactionStatusEnum_reserved_getInstance() {
  TransactionStatusEnum_initEntries();
  return TransactionStatusEnum_reserved_instance;
}
function TransactionStatusEnum_pending_getInstance() {
  TransactionStatusEnum_initEntries();
  return TransactionStatusEnum_pending_instance;
}
function TransactionStatusEnum_custom_getInstance() {
  TransactionStatusEnum_initEntries();
  return TransactionStatusEnum_custom_instance;
}
function _get_$cachedSerializer__te6jhj_9($this) {
  return $this.l3s_1.w();
}
function TwoFactor$Companion$_anonymous__ssqu98() {
  return createSimpleEnumSerializer('com.moreharvest.shared.enums.TwoFactor', values_17());
}
var TwoFactor_totp_instance;
var TwoFactor_webauthn_instance;
function values_17() {
  return [TwoFactor_totp_getInstance(), TwoFactor_webauthn_getInstance()];
}
function valueOf_17(value) {
  switch (value) {
    case 'totp':
      return TwoFactor_totp_getInstance();
    case 'webauthn':
      return TwoFactor_webauthn_getInstance();
    default:
      TwoFactor_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.enums.TwoFactor.' + value);
      break;
  }
}
function Companion_20() {
  Companion_instance_20 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.l3s_1 = lazy(tmp_0, TwoFactor$Companion$_anonymous__ssqu98);
}
protoOf(Companion_20).o1c = function () {
  return _get_$cachedSerializer__te6jhj_9(this);
};
protoOf(Companion_20).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_20;
function Companion_getInstance_23() {
  TwoFactor_initEntries();
  if (Companion_instance_20 == null)
    new Companion_20();
  return Companion_instance_20;
}
var TwoFactor_entriesInitialized;
function TwoFactor_initEntries() {
  if (TwoFactor_entriesInitialized)
    return Unit_instance;
  TwoFactor_entriesInitialized = true;
  TwoFactor_totp_instance = new TwoFactor('totp', 0);
  TwoFactor_webauthn_instance = new TwoFactor('webauthn', 1);
  Companion_getInstance_23();
}
function TwoFactor(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TwoFactor_totp_getInstance() {
  TwoFactor_initEntries();
  return TwoFactor_totp_instance;
}
function TwoFactor_webauthn_getInstance() {
  TwoFactor_initEntries();
  return TwoFactor_webauthn_instance;
}
var ErrorCode_InvalidEmail_instance;
var ErrorCode_InvalidPassword_instance;
var ErrorCode_InvalidBearerToken_instance;
var ErrorCode_InvalidTotpCode_instance;
var ErrorCode_PasswordTooShort_instance;
var ErrorCode_DuplicateLabel_instance;
var ErrorCode_SessionExpired_instance;
var ErrorCode_InvalidSession_instance;
var ErrorCode_InvalidSecret_instance;
var ErrorCode_MissingIPAddress_instance;
var ErrorCode_WebauthnNotEnabled_instance;
var ErrorCode_WebauthnIdError_instance;
var ErrorCode_WebauthnPasskeyRegistrationError_instance;
var ErrorCode_SecurityLevelRequired_instance;
var ErrorCode_BasicLevelRequired_instance;
var ErrorCode_InvalidPasswordStrength_instance;
var ErrorCode_PermissionDenied_instance;
var ErrorCode_InvalidUserId_instance;
var ErrorCode_UserProfileNotFound_instance;
var ErrorCode_AccountClosed_instance;
var ErrorCode_UploadFail_instance;
var ErrorCode_InvalidPropertyId_instance;
var ErrorCode_InvalidStatus_instance;
var ErrorCode_InvalidTarget_instance;
var ErrorCode_MissSessionToken_instance;
var ErrorCode_ExpireSession_instance;
var ErrorCode_InvalidSessionIdFormat_instance;
var ErrorCode_SessionIdUnavailable_instance;
var ErrorCode_RoleNotFound_instance;
var ErrorCode_InvalidShares_instance;
var ErrorCode_NotEnoughShares_instance;
var ErrorCode_UnauthorizedAction_instance;
var ErrorCode_TransactionNotFound_instance;
var ErrorCode_CalendarNotFound_instance;
var ErrorCode_TransactionInProgress_instance;
var ErrorCode_InvalidTransactionType_instance;
var ErrorCode_UnverifiedBankAccount_instance;
var ErrorCode_ParseError_instance;
var ErrorCode_ShuftiKeyConfigurationError_instance;
var ErrorCode_CalculationOverflow_instance;
var ErrorCode_UnauthorizedTransactionDueToKyc_instance;
var ErrorCode_KycAlreadyInProgress_instance;
var ErrorCode_UserNotFound_instance;
var ErrorCode_InvalidDividendPayoutRecordId_instance;
var ErrorCode_NotFoundPayoutRecord_instance;
var ErrorCode_FileSaveError_instance;
var ErrorCode_FileReadError_instance;
var ErrorCode_FileUploadError_instance;
var ErrorCode_TokenExpired_instance;
var ErrorCode_NoWebauthnDevice_instance;
var ErrorCode_MissingEnvironmentVariable_instance;
var ErrorCode_TokenPasswordInvalid_instance;
var ErrorCode_NotEnoughMaturedShares_instance;
var ErrorCode_TransactionAlreadyCompleted_instance;
var ErrorCode_TransactionAlreadyCancelled_instance;
var ErrorCode_InvalidThreshold_instance;
var ErrorCode_FcmInvalidToken_instance;
var ErrorCode_CannotDeleteSelf_instance;
var ErrorCode_LastSuperAdmin_instance;
var ErrorCode_DatabaseError_instance;
var ErrorCode_WebauthnProcessError_instance;
var ErrorCode_WrongOrigin_instance;
var ErrorCode_PasswordCryptoError_instance;
var ErrorCode_TotpError_instance;
var ErrorCode_PasswordStrengthError_instance;
var ErrorCode_TokenParseError_instance;
var ErrorCode_InvalidUuidFormat_instance;
var ErrorCode_InvalidDateFormat_instance;
var ErrorCode_PasskeyVerificationError_instance;
var ErrorCode_PasskeyRegistrationError_instance;
var ErrorCode_PostmarkError_instance;
var ErrorCode_StrapiError_instance;
var ErrorCode_ShuftiVerificationFailed_instance;
var ErrorCode_ShuftiRequestError_instance;
var ErrorCode_ShuftiResponseError_instance;
var ErrorCode_ZendeskRequestError_instance;
var ErrorCode_ZendeskResponseError_instance;
var ErrorCode_ZendeskTokenError_instance;
var ErrorCode_StrapiUnexpectedContentType_instance;
var ErrorCode_StrapiUnavailable_instance;
var ErrorCode_UnknownError_instance;
function Companion_21() {
}
protoOf(Companion_21).fromCode = function (code) {
  var tmp0 = get_entries_9();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (element.code === code) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  return tmp0_elvis_lhs == null ? ErrorCode_UnknownError_getInstance() : tmp0_elvis_lhs;
};
protoOf(Companion_21).o1c = function () {
  return ErrorCodeSerializer_getInstance();
};
protoOf(Companion_21).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_21;
function Companion_getInstance_24() {
  return Companion_instance_21;
}
function values_18() {
  return [ErrorCode_InvalidEmail_getInstance(), ErrorCode_InvalidPassword_getInstance(), ErrorCode_InvalidBearerToken_getInstance(), ErrorCode_InvalidTotpCode_getInstance(), ErrorCode_PasswordTooShort_getInstance(), ErrorCode_DuplicateLabel_getInstance(), ErrorCode_SessionExpired_getInstance(), ErrorCode_InvalidSession_getInstance(), ErrorCode_InvalidSecret_getInstance(), ErrorCode_MissingIPAddress_getInstance(), ErrorCode_WebauthnNotEnabled_getInstance(), ErrorCode_WebauthnIdError_getInstance(), ErrorCode_WebauthnPasskeyRegistrationError_getInstance(), ErrorCode_SecurityLevelRequired_getInstance(), ErrorCode_BasicLevelRequired_getInstance(), ErrorCode_InvalidPasswordStrength_getInstance(), ErrorCode_PermissionDenied_getInstance(), ErrorCode_InvalidUserId_getInstance(), ErrorCode_UserProfileNotFound_getInstance(), ErrorCode_AccountClosed_getInstance(), ErrorCode_UploadFail_getInstance(), ErrorCode_InvalidPropertyId_getInstance(), ErrorCode_InvalidStatus_getInstance(), ErrorCode_InvalidTarget_getInstance(), ErrorCode_MissSessionToken_getInstance(), ErrorCode_ExpireSession_getInstance(), ErrorCode_InvalidSessionIdFormat_getInstance(), ErrorCode_SessionIdUnavailable_getInstance(), ErrorCode_RoleNotFound_getInstance(), ErrorCode_InvalidShares_getInstance(), ErrorCode_NotEnoughShares_getInstance(), ErrorCode_UnauthorizedAction_getInstance(), ErrorCode_TransactionNotFound_getInstance(), ErrorCode_CalendarNotFound_getInstance(), ErrorCode_TransactionInProgress_getInstance(), ErrorCode_InvalidTransactionType_getInstance(), ErrorCode_UnverifiedBankAccount_getInstance(), ErrorCode_ParseError_getInstance(), ErrorCode_ShuftiKeyConfigurationError_getInstance(), ErrorCode_CalculationOverflow_getInstance(), ErrorCode_UnauthorizedTransactionDueToKyc_getInstance(), ErrorCode_KycAlreadyInProgress_getInstance(), ErrorCode_UserNotFound_getInstance(), ErrorCode_InvalidDividendPayoutRecordId_getInstance(), ErrorCode_NotFoundPayoutRecord_getInstance(), ErrorCode_FileSaveError_getInstance(), ErrorCode_FileReadError_getInstance(), ErrorCode_FileUploadError_getInstance(), ErrorCode_TokenExpired_getInstance(), ErrorCode_NoWebauthnDevice_getInstance(), ErrorCode_MissingEnvironmentVariable_getInstance(), ErrorCode_TokenPasswordInvalid_getInstance(), ErrorCode_NotEnoughMaturedShares_getInstance(), ErrorCode_TransactionAlreadyCompleted_getInstance(), ErrorCode_TransactionAlreadyCancelled_getInstance(), ErrorCode_InvalidThreshold_getInstance(), ErrorCode_FcmInvalidToken_getInstance(), ErrorCode_CannotDeleteSelf_getInstance(), ErrorCode_LastSuperAdmin_getInstance(), ErrorCode_DatabaseError_getInstance(), ErrorCode_WebauthnProcessError_getInstance(), ErrorCode_WrongOrigin_getInstance(), ErrorCode_PasswordCryptoError_getInstance(), ErrorCode_TotpError_getInstance(), ErrorCode_PasswordStrengthError_getInstance(), ErrorCode_TokenParseError_getInstance(), ErrorCode_InvalidUuidFormat_getInstance(), ErrorCode_InvalidDateFormat_getInstance(), ErrorCode_PasskeyVerificationError_getInstance(), ErrorCode_PasskeyRegistrationError_getInstance(), ErrorCode_PostmarkError_getInstance(), ErrorCode_StrapiError_getInstance(), ErrorCode_ShuftiVerificationFailed_getInstance(), ErrorCode_ShuftiRequestError_getInstance(), ErrorCode_ShuftiResponseError_getInstance(), ErrorCode_ZendeskRequestError_getInstance(), ErrorCode_ZendeskResponseError_getInstance(), ErrorCode_ZendeskTokenError_getInstance(), ErrorCode_StrapiUnexpectedContentType_getInstance(), ErrorCode_StrapiUnavailable_getInstance(), ErrorCode_UnknownError_getInstance()];
}
function valueOf_18(value) {
  switch (value) {
    case 'InvalidEmail':
      return ErrorCode_InvalidEmail_getInstance();
    case 'InvalidPassword':
      return ErrorCode_InvalidPassword_getInstance();
    case 'InvalidBearerToken':
      return ErrorCode_InvalidBearerToken_getInstance();
    case 'InvalidTotpCode':
      return ErrorCode_InvalidTotpCode_getInstance();
    case 'PasswordTooShort':
      return ErrorCode_PasswordTooShort_getInstance();
    case 'DuplicateLabel':
      return ErrorCode_DuplicateLabel_getInstance();
    case 'SessionExpired':
      return ErrorCode_SessionExpired_getInstance();
    case 'InvalidSession':
      return ErrorCode_InvalidSession_getInstance();
    case 'InvalidSecret':
      return ErrorCode_InvalidSecret_getInstance();
    case 'MissingIPAddress':
      return ErrorCode_MissingIPAddress_getInstance();
    case 'WebauthnNotEnabled':
      return ErrorCode_WebauthnNotEnabled_getInstance();
    case 'WebauthnIdError':
      return ErrorCode_WebauthnIdError_getInstance();
    case 'WebauthnPasskeyRegistrationError':
      return ErrorCode_WebauthnPasskeyRegistrationError_getInstance();
    case 'SecurityLevelRequired':
      return ErrorCode_SecurityLevelRequired_getInstance();
    case 'BasicLevelRequired':
      return ErrorCode_BasicLevelRequired_getInstance();
    case 'InvalidPasswordStrength':
      return ErrorCode_InvalidPasswordStrength_getInstance();
    case 'PermissionDenied':
      return ErrorCode_PermissionDenied_getInstance();
    case 'InvalidUserId':
      return ErrorCode_InvalidUserId_getInstance();
    case 'UserProfileNotFound':
      return ErrorCode_UserProfileNotFound_getInstance();
    case 'AccountClosed':
      return ErrorCode_AccountClosed_getInstance();
    case 'UploadFail':
      return ErrorCode_UploadFail_getInstance();
    case 'InvalidPropertyId':
      return ErrorCode_InvalidPropertyId_getInstance();
    case 'InvalidStatus':
      return ErrorCode_InvalidStatus_getInstance();
    case 'InvalidTarget':
      return ErrorCode_InvalidTarget_getInstance();
    case 'MissSessionToken':
      return ErrorCode_MissSessionToken_getInstance();
    case 'ExpireSession':
      return ErrorCode_ExpireSession_getInstance();
    case 'InvalidSessionIdFormat':
      return ErrorCode_InvalidSessionIdFormat_getInstance();
    case 'SessionIdUnavailable':
      return ErrorCode_SessionIdUnavailable_getInstance();
    case 'RoleNotFound':
      return ErrorCode_RoleNotFound_getInstance();
    case 'InvalidShares':
      return ErrorCode_InvalidShares_getInstance();
    case 'NotEnoughShares':
      return ErrorCode_NotEnoughShares_getInstance();
    case 'UnauthorizedAction':
      return ErrorCode_UnauthorizedAction_getInstance();
    case 'TransactionNotFound':
      return ErrorCode_TransactionNotFound_getInstance();
    case 'CalendarNotFound':
      return ErrorCode_CalendarNotFound_getInstance();
    case 'TransactionInProgress':
      return ErrorCode_TransactionInProgress_getInstance();
    case 'InvalidTransactionType':
      return ErrorCode_InvalidTransactionType_getInstance();
    case 'UnverifiedBankAccount':
      return ErrorCode_UnverifiedBankAccount_getInstance();
    case 'ParseError':
      return ErrorCode_ParseError_getInstance();
    case 'ShuftiKeyConfigurationError':
      return ErrorCode_ShuftiKeyConfigurationError_getInstance();
    case 'CalculationOverflow':
      return ErrorCode_CalculationOverflow_getInstance();
    case 'UnauthorizedTransactionDueToKyc':
      return ErrorCode_UnauthorizedTransactionDueToKyc_getInstance();
    case 'KycAlreadyInProgress':
      return ErrorCode_KycAlreadyInProgress_getInstance();
    case 'UserNotFound':
      return ErrorCode_UserNotFound_getInstance();
    case 'InvalidDividendPayoutRecordId':
      return ErrorCode_InvalidDividendPayoutRecordId_getInstance();
    case 'NotFoundPayoutRecord':
      return ErrorCode_NotFoundPayoutRecord_getInstance();
    case 'FileSaveError':
      return ErrorCode_FileSaveError_getInstance();
    case 'FileReadError':
      return ErrorCode_FileReadError_getInstance();
    case 'FileUploadError':
      return ErrorCode_FileUploadError_getInstance();
    case 'TokenExpired':
      return ErrorCode_TokenExpired_getInstance();
    case 'NoWebauthnDevice':
      return ErrorCode_NoWebauthnDevice_getInstance();
    case 'MissingEnvironmentVariable':
      return ErrorCode_MissingEnvironmentVariable_getInstance();
    case 'TokenPasswordInvalid':
      return ErrorCode_TokenPasswordInvalid_getInstance();
    case 'NotEnoughMaturedShares':
      return ErrorCode_NotEnoughMaturedShares_getInstance();
    case 'TransactionAlreadyCompleted':
      return ErrorCode_TransactionAlreadyCompleted_getInstance();
    case 'TransactionAlreadyCancelled':
      return ErrorCode_TransactionAlreadyCancelled_getInstance();
    case 'InvalidThreshold':
      return ErrorCode_InvalidThreshold_getInstance();
    case 'FcmInvalidToken':
      return ErrorCode_FcmInvalidToken_getInstance();
    case 'CannotDeleteSelf':
      return ErrorCode_CannotDeleteSelf_getInstance();
    case 'LastSuperAdmin':
      return ErrorCode_LastSuperAdmin_getInstance();
    case 'DatabaseError':
      return ErrorCode_DatabaseError_getInstance();
    case 'WebauthnProcessError':
      return ErrorCode_WebauthnProcessError_getInstance();
    case 'WrongOrigin':
      return ErrorCode_WrongOrigin_getInstance();
    case 'PasswordCryptoError':
      return ErrorCode_PasswordCryptoError_getInstance();
    case 'TotpError':
      return ErrorCode_TotpError_getInstance();
    case 'PasswordStrengthError':
      return ErrorCode_PasswordStrengthError_getInstance();
    case 'TokenParseError':
      return ErrorCode_TokenParseError_getInstance();
    case 'InvalidUuidFormat':
      return ErrorCode_InvalidUuidFormat_getInstance();
    case 'InvalidDateFormat':
      return ErrorCode_InvalidDateFormat_getInstance();
    case 'PasskeyVerificationError':
      return ErrorCode_PasskeyVerificationError_getInstance();
    case 'PasskeyRegistrationError':
      return ErrorCode_PasskeyRegistrationError_getInstance();
    case 'PostmarkError':
      return ErrorCode_PostmarkError_getInstance();
    case 'StrapiError':
      return ErrorCode_StrapiError_getInstance();
    case 'ShuftiVerificationFailed':
      return ErrorCode_ShuftiVerificationFailed_getInstance();
    case 'ShuftiRequestError':
      return ErrorCode_ShuftiRequestError_getInstance();
    case 'ShuftiResponseError':
      return ErrorCode_ShuftiResponseError_getInstance();
    case 'ZendeskRequestError':
      return ErrorCode_ZendeskRequestError_getInstance();
    case 'ZendeskResponseError':
      return ErrorCode_ZendeskResponseError_getInstance();
    case 'ZendeskTokenError':
      return ErrorCode_ZendeskTokenError_getInstance();
    case 'StrapiUnexpectedContentType':
      return ErrorCode_StrapiUnexpectedContentType_getInstance();
    case 'StrapiUnavailable':
      return ErrorCode_StrapiUnavailable_getInstance();
    case 'UnknownError':
      return ErrorCode_UnknownError_getInstance();
    default:
      ErrorCode_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.error.ErrorCode.' + value);
      break;
  }
}
function get_entries_9() {
  if ($ENTRIES_9 == null)
    $ENTRIES_9 = enumEntries(values_18());
  return $ENTRIES_9;
}
var ErrorCode_entriesInitialized;
function ErrorCode_initEntries() {
  if (ErrorCode_entriesInitialized)
    return Unit_instance;
  ErrorCode_entriesInitialized = true;
  ErrorCode_InvalidEmail_instance = new ErrorCode('InvalidEmail', 0, 100, 'Invalid email address');
  ErrorCode_InvalidPassword_instance = new ErrorCode('InvalidPassword', 1, 101, 'Invalid password');
  ErrorCode_InvalidBearerToken_instance = new ErrorCode('InvalidBearerToken', 2, 102, 'Invalid or expired token');
  ErrorCode_InvalidTotpCode_instance = new ErrorCode('InvalidTotpCode', 3, 103, 'Invalid verification code');
  ErrorCode_PasswordTooShort_instance = new ErrorCode('PasswordTooShort', 4, 104, 'Password is too short');
  ErrorCode_DuplicateLabel_instance = new ErrorCode('DuplicateLabel', 5, 108, 'This label already exists');
  ErrorCode_SessionExpired_instance = new ErrorCode('SessionExpired', 6, 109, 'Your session has expired');
  ErrorCode_InvalidSession_instance = new ErrorCode('InvalidSession', 7, 110, 'Invalid session');
  ErrorCode_InvalidSecret_instance = new ErrorCode('InvalidSecret', 8, 111, 'Invalid secret');
  ErrorCode_MissingIPAddress_instance = new ErrorCode('MissingIPAddress', 9, 112, 'Request could not be processed');
  ErrorCode_WebauthnNotEnabled_instance = new ErrorCode('WebauthnNotEnabled', 10, 113, 'Passkey authentication is not enabled');
  ErrorCode_WebauthnIdError_instance = new ErrorCode('WebauthnIdError', 11, 114, 'Passkey identification error');
  ErrorCode_WebauthnPasskeyRegistrationError_instance = new ErrorCode('WebauthnPasskeyRegistrationError', 12, 115, 'Failed to register passkey');
  ErrorCode_SecurityLevelRequired_instance = new ErrorCode('SecurityLevelRequired', 13, 116, 'Higher security level required');
  ErrorCode_BasicLevelRequired_instance = new ErrorCode('BasicLevelRequired', 14, 117, 'Basic verification required');
  ErrorCode_InvalidPasswordStrength_instance = new ErrorCode('InvalidPasswordStrength', 15, 118, 'Password does not meet strength requirements');
  ErrorCode_PermissionDenied_instance = new ErrorCode('PermissionDenied', 16, 119, 'Permission denied');
  ErrorCode_InvalidUserId_instance = new ErrorCode('InvalidUserId', 17, 120, 'Invalid user ID');
  ErrorCode_UserProfileNotFound_instance = new ErrorCode('UserProfileNotFound', 18, 121, 'User profile not found');
  ErrorCode_AccountClosed_instance = new ErrorCode('AccountClosed', 19, 122, 'This account has been closed');
  ErrorCode_UploadFail_instance = new ErrorCode('UploadFail', 20, 123, 'File upload failed');
  ErrorCode_InvalidPropertyId_instance = new ErrorCode('InvalidPropertyId', 21, 124, 'Invalid property ID');
  ErrorCode_InvalidStatus_instance = new ErrorCode('InvalidStatus', 22, 125, 'Invalid status');
  ErrorCode_InvalidTarget_instance = new ErrorCode('InvalidTarget', 23, 126, 'Invalid target');
  ErrorCode_MissSessionToken_instance = new ErrorCode('MissSessionToken', 24, 127, 'Missing session token');
  ErrorCode_ExpireSession_instance = new ErrorCode('ExpireSession', 25, 128, 'Your session has expired');
  ErrorCode_InvalidSessionIdFormat_instance = new ErrorCode('InvalidSessionIdFormat', 26, 129, 'Invalid session');
  ErrorCode_SessionIdUnavailable_instance = new ErrorCode('SessionIdUnavailable', 27, 130, 'An unexpected error occurred');
  ErrorCode_RoleNotFound_instance = new ErrorCode('RoleNotFound', 28, 131, 'Role not found');
  ErrorCode_InvalidShares_instance = new ErrorCode('InvalidShares', 29, 132, 'Invalid share amount');
  ErrorCode_NotEnoughShares_instance = new ErrorCode('NotEnoughShares', 30, 133, 'Not enough shares available');
  ErrorCode_UnauthorizedAction_instance = new ErrorCode('UnauthorizedAction', 31, 134, 'You are not authorized to perform this action');
  ErrorCode_TransactionNotFound_instance = new ErrorCode('TransactionNotFound', 32, 135, 'Transaction not found');
  ErrorCode_CalendarNotFound_instance = new ErrorCode('CalendarNotFound', 33, 136, 'Calendar not found');
  ErrorCode_TransactionInProgress_instance = new ErrorCode('TransactionInProgress', 34, 139, 'A transaction is already in progress');
  ErrorCode_InvalidTransactionType_instance = new ErrorCode('InvalidTransactionType', 35, 140, 'Invalid transaction type');
  ErrorCode_UnverifiedBankAccount_instance = new ErrorCode('UnverifiedBankAccount', 36, 141, 'Bank account is not verified');
  ErrorCode_ParseError_instance = new ErrorCode('ParseError', 37, 142, 'Invalid input format');
  ErrorCode_ShuftiKeyConfigurationError_instance = new ErrorCode('ShuftiKeyConfigurationError', 38, 143, 'Service configuration error');
  ErrorCode_CalculationOverflow_instance = new ErrorCode('CalculationOverflow', 39, 144, 'An unexpected error occurred');
  ErrorCode_UnauthorizedTransactionDueToKyc_instance = new ErrorCode('UnauthorizedTransactionDueToKyc', 40, 145, 'Identity verification required to proceed');
  ErrorCode_KycAlreadyInProgress_instance = new ErrorCode('KycAlreadyInProgress', 41, 146, 'Identity verification is already in progress');
  ErrorCode_UserNotFound_instance = new ErrorCode('UserNotFound', 42, 147, 'User not found');
  ErrorCode_InvalidDividendPayoutRecordId_instance = new ErrorCode('InvalidDividendPayoutRecordId', 43, 148, 'Invalid payout record ID');
  ErrorCode_NotFoundPayoutRecord_instance = new ErrorCode('NotFoundPayoutRecord', 44, 149, 'Payout record not found');
  ErrorCode_FileSaveError_instance = new ErrorCode('FileSaveError', 45, 150, 'Failed to save file');
  ErrorCode_FileReadError_instance = new ErrorCode('FileReadError', 46, 151, 'Failed to read file');
  ErrorCode_FileUploadError_instance = new ErrorCode('FileUploadError', 47, 152, 'Failed to upload file');
  ErrorCode_TokenExpired_instance = new ErrorCode('TokenExpired', 48, 153, 'Token has expired');
  ErrorCode_NoWebauthnDevice_instance = new ErrorCode('NoWebauthnDevice', 49, 154, 'No passkey device registered');
  ErrorCode_MissingEnvironmentVariable_instance = new ErrorCode('MissingEnvironmentVariable', 50, 155, 'Server configuration error');
  ErrorCode_TokenPasswordInvalid_instance = new ErrorCode('TokenPasswordInvalid', 51, 156, 'Invalid token or password');
  ErrorCode_NotEnoughMaturedShares_instance = new ErrorCode('NotEnoughMaturedShares', 52, 157, 'Not enough matured shares available');
  ErrorCode_TransactionAlreadyCompleted_instance = new ErrorCode('TransactionAlreadyCompleted', 53, 158, 'Transaction has already been completed');
  ErrorCode_TransactionAlreadyCancelled_instance = new ErrorCode('TransactionAlreadyCancelled', 54, 159, 'Transaction has already been cancelled');
  ErrorCode_InvalidThreshold_instance = new ErrorCode('InvalidThreshold', 55, 160, 'Invalid threshold value');
  ErrorCode_FcmInvalidToken_instance = new ErrorCode('FcmInvalidToken', 56, 161, 'Invalid FCM token');
  ErrorCode_CannotDeleteSelf_instance = new ErrorCode('CannotDeleteSelf', 57, 162, 'You cannot remove your own admin access');
  ErrorCode_LastSuperAdmin_instance = new ErrorCode('LastSuperAdmin', 58, 163, 'Cannot remove the last super admin');
  ErrorCode_DatabaseError_instance = new ErrorCode('DatabaseError', 59, 201, 'An unexpected error occurred');
  ErrorCode_WebauthnProcessError_instance = new ErrorCode('WebauthnProcessError', 60, 202, 'Passkey processing error');
  ErrorCode_WrongOrigin_instance = new ErrorCode('WrongOrigin', 61, 204, 'Request origin is not allowed');
  ErrorCode_PasswordCryptoError_instance = new ErrorCode('PasswordCryptoError', 62, 205, 'An unexpected error occurred');
  ErrorCode_TotpError_instance = new ErrorCode('TotpError', 63, 206, 'An unexpected error occurred');
  ErrorCode_PasswordStrengthError_instance = new ErrorCode('PasswordStrengthError', 64, 207, 'Password does not meet requirements');
  ErrorCode_TokenParseError_instance = new ErrorCode('TokenParseError', 65, 208, 'Invalid token');
  ErrorCode_InvalidUuidFormat_instance = new ErrorCode('InvalidUuidFormat', 66, 209, 'Invalid ID format');
  ErrorCode_InvalidDateFormat_instance = new ErrorCode('InvalidDateFormat', 67, 210, 'Invalid date format');
  ErrorCode_PasskeyVerificationError_instance = new ErrorCode('PasskeyVerificationError', 68, 211, 'Passkey verification failed');
  ErrorCode_PasskeyRegistrationError_instance = new ErrorCode('PasskeyRegistrationError', 69, 212, 'Passkey registration failed');
  ErrorCode_PostmarkError_instance = new ErrorCode('PostmarkError', 70, 301, 'Email service error');
  ErrorCode_StrapiError_instance = new ErrorCode('StrapiError', 71, 302, 'Content service error');
  ErrorCode_ShuftiVerificationFailed_instance = new ErrorCode('ShuftiVerificationFailed', 72, 303, 'Identity verification failed');
  ErrorCode_ShuftiRequestError_instance = new ErrorCode('ShuftiRequestError', 73, 304, 'Identity verification service unavailable');
  ErrorCode_ShuftiResponseError_instance = new ErrorCode('ShuftiResponseError', 74, 305, 'Identity verification service error');
  ErrorCode_ZendeskRequestError_instance = new ErrorCode('ZendeskRequestError', 75, 306, 'Support service unavailable');
  ErrorCode_ZendeskResponseError_instance = new ErrorCode('ZendeskResponseError', 76, 307, 'Support service error');
  ErrorCode_ZendeskTokenError_instance = new ErrorCode('ZendeskTokenError', 77, 308, 'Support service authentication error');
  ErrorCode_StrapiUnexpectedContentType_instance = new ErrorCode('StrapiUnexpectedContentType', 78, 309, 'Content service error');
  ErrorCode_StrapiUnavailable_instance = new ErrorCode('StrapiUnavailable', 79, 310, 'Content service is temporarily unavailable');
  ErrorCode_UnknownError_instance = new ErrorCode('UnknownError', 80, 999, 'An unexpected error occurred');
}
var $ENTRIES_9;
function ErrorCode(name, ordinal, code, defaultMessage) {
  defaultMessage = defaultMessage === VOID ? 'An unexpected error occurred' : defaultMessage;
  Enum.call(this, name, ordinal);
  this.code = code;
  this.defaultMessage = defaultMessage;
}
protoOf(ErrorCode).w3u = function () {
  return this.code;
};
protoOf(ErrorCode).x3u = function () {
  return this.defaultMessage;
};
function ErrorCodeSerializer() {
  ErrorCodeSerializer_instance = this;
  this.y3u_1 = PrimitiveSerialDescriptor('ErrorCode', INT_getInstance());
}
protoOf(ErrorCodeSerializer).fp = function () {
  return this.y3u_1;
};
protoOf(ErrorCodeSerializer).z3u = function (encoder, value) {
  encoder.rt(value.code);
};
protoOf(ErrorCodeSerializer).gp = function (encoder, value) {
  return this.z3u(encoder, value instanceof ErrorCode ? value : THROW_CCE());
};
protoOf(ErrorCodeSerializer).hp = function (decoder) {
  var code = decoder.is();
  return Companion_instance_21.fromCode(code);
};
var ErrorCodeSerializer_instance;
function ErrorCodeSerializer_getInstance() {
  if (ErrorCodeSerializer_instance == null)
    new ErrorCodeSerializer();
  return ErrorCodeSerializer_instance;
}
function ErrorCode_InvalidEmail_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidEmail_instance;
}
function ErrorCode_InvalidPassword_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidPassword_instance;
}
function ErrorCode_InvalidBearerToken_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidBearerToken_instance;
}
function ErrorCode_InvalidTotpCode_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidTotpCode_instance;
}
function ErrorCode_PasswordTooShort_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PasswordTooShort_instance;
}
function ErrorCode_DuplicateLabel_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_DuplicateLabel_instance;
}
function ErrorCode_SessionExpired_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_SessionExpired_instance;
}
function ErrorCode_InvalidSession_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidSession_instance;
}
function ErrorCode_InvalidSecret_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidSecret_instance;
}
function ErrorCode_MissingIPAddress_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_MissingIPAddress_instance;
}
function ErrorCode_WebauthnNotEnabled_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_WebauthnNotEnabled_instance;
}
function ErrorCode_WebauthnIdError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_WebauthnIdError_instance;
}
function ErrorCode_WebauthnPasskeyRegistrationError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_WebauthnPasskeyRegistrationError_instance;
}
function ErrorCode_SecurityLevelRequired_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_SecurityLevelRequired_instance;
}
function ErrorCode_BasicLevelRequired_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_BasicLevelRequired_instance;
}
function ErrorCode_InvalidPasswordStrength_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidPasswordStrength_instance;
}
function ErrorCode_PermissionDenied_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PermissionDenied_instance;
}
function ErrorCode_InvalidUserId_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidUserId_instance;
}
function ErrorCode_UserProfileNotFound_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UserProfileNotFound_instance;
}
function ErrorCode_AccountClosed_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_AccountClosed_instance;
}
function ErrorCode_UploadFail_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UploadFail_instance;
}
function ErrorCode_InvalidPropertyId_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidPropertyId_instance;
}
function ErrorCode_InvalidStatus_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidStatus_instance;
}
function ErrorCode_InvalidTarget_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidTarget_instance;
}
function ErrorCode_MissSessionToken_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_MissSessionToken_instance;
}
function ErrorCode_ExpireSession_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ExpireSession_instance;
}
function ErrorCode_InvalidSessionIdFormat_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidSessionIdFormat_instance;
}
function ErrorCode_SessionIdUnavailable_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_SessionIdUnavailable_instance;
}
function ErrorCode_RoleNotFound_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_RoleNotFound_instance;
}
function ErrorCode_InvalidShares_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidShares_instance;
}
function ErrorCode_NotEnoughShares_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_NotEnoughShares_instance;
}
function ErrorCode_UnauthorizedAction_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UnauthorizedAction_instance;
}
function ErrorCode_TransactionNotFound_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TransactionNotFound_instance;
}
function ErrorCode_CalendarNotFound_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_CalendarNotFound_instance;
}
function ErrorCode_TransactionInProgress_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TransactionInProgress_instance;
}
function ErrorCode_InvalidTransactionType_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidTransactionType_instance;
}
function ErrorCode_UnverifiedBankAccount_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UnverifiedBankAccount_instance;
}
function ErrorCode_ParseError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ParseError_instance;
}
function ErrorCode_ShuftiKeyConfigurationError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ShuftiKeyConfigurationError_instance;
}
function ErrorCode_CalculationOverflow_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_CalculationOverflow_instance;
}
function ErrorCode_UnauthorizedTransactionDueToKyc_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UnauthorizedTransactionDueToKyc_instance;
}
function ErrorCode_KycAlreadyInProgress_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_KycAlreadyInProgress_instance;
}
function ErrorCode_UserNotFound_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UserNotFound_instance;
}
function ErrorCode_InvalidDividendPayoutRecordId_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidDividendPayoutRecordId_instance;
}
function ErrorCode_NotFoundPayoutRecord_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_NotFoundPayoutRecord_instance;
}
function ErrorCode_FileSaveError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_FileSaveError_instance;
}
function ErrorCode_FileReadError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_FileReadError_instance;
}
function ErrorCode_FileUploadError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_FileUploadError_instance;
}
function ErrorCode_TokenExpired_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TokenExpired_instance;
}
function ErrorCode_NoWebauthnDevice_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_NoWebauthnDevice_instance;
}
function ErrorCode_MissingEnvironmentVariable_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_MissingEnvironmentVariable_instance;
}
function ErrorCode_TokenPasswordInvalid_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TokenPasswordInvalid_instance;
}
function ErrorCode_NotEnoughMaturedShares_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_NotEnoughMaturedShares_instance;
}
function ErrorCode_TransactionAlreadyCompleted_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TransactionAlreadyCompleted_instance;
}
function ErrorCode_TransactionAlreadyCancelled_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TransactionAlreadyCancelled_instance;
}
function ErrorCode_InvalidThreshold_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidThreshold_instance;
}
function ErrorCode_FcmInvalidToken_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_FcmInvalidToken_instance;
}
function ErrorCode_CannotDeleteSelf_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_CannotDeleteSelf_instance;
}
function ErrorCode_LastSuperAdmin_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_LastSuperAdmin_instance;
}
function ErrorCode_DatabaseError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_DatabaseError_instance;
}
function ErrorCode_WebauthnProcessError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_WebauthnProcessError_instance;
}
function ErrorCode_WrongOrigin_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_WrongOrigin_instance;
}
function ErrorCode_PasswordCryptoError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PasswordCryptoError_instance;
}
function ErrorCode_TotpError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TotpError_instance;
}
function ErrorCode_PasswordStrengthError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PasswordStrengthError_instance;
}
function ErrorCode_TokenParseError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_TokenParseError_instance;
}
function ErrorCode_InvalidUuidFormat_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidUuidFormat_instance;
}
function ErrorCode_InvalidDateFormat_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_InvalidDateFormat_instance;
}
function ErrorCode_PasskeyVerificationError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PasskeyVerificationError_instance;
}
function ErrorCode_PasskeyRegistrationError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PasskeyRegistrationError_instance;
}
function ErrorCode_PostmarkError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_PostmarkError_instance;
}
function ErrorCode_StrapiError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_StrapiError_instance;
}
function ErrorCode_ShuftiVerificationFailed_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ShuftiVerificationFailed_instance;
}
function ErrorCode_ShuftiRequestError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ShuftiRequestError_instance;
}
function ErrorCode_ShuftiResponseError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ShuftiResponseError_instance;
}
function ErrorCode_ZendeskRequestError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ZendeskRequestError_instance;
}
function ErrorCode_ZendeskResponseError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ZendeskResponseError_instance;
}
function ErrorCode_ZendeskTokenError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_ZendeskTokenError_instance;
}
function ErrorCode_StrapiUnexpectedContentType_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_StrapiUnexpectedContentType_instance;
}
function ErrorCode_StrapiUnavailable_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_StrapiUnavailable_instance;
}
function ErrorCode_UnknownError_getInstance() {
  ErrorCode_initEntries();
  return ErrorCode_UnknownError_instance;
}
function Companion_22() {
}
protoOf(Companion_22).o1c = function () {
  return $serializer_getInstance_10();
};
var Companion_instance_22;
function Companion_getInstance_25() {
  return Companion_instance_22;
}
function $serializer_10() {
  $serializer_instance_10 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.error.MohaApiError', this, 2);
  tmp0_serialDesc.k10('errorCode', false);
  tmp0_serialDesc.k10('errorMessage', true);
  this.a3v_1 = tmp0_serialDesc;
}
protoOf($serializer_10).b3v = function (encoder, value) {
  var tmp0_desc = this.a3v_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, ErrorCodeSerializer_getInstance(), value.code);
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.message == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.message);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_10).gp = function (encoder, value) {
  return this.b3v(encoder, value instanceof MohaApiError ? value : THROW_CCE());
};
protoOf($serializer_10).hp = function (decoder) {
  var tmp0_desc = this.a3v_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, ErrorCodeSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, ErrorCodeSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return MohaApiError_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_10).fp = function () {
  return this.a3v_1;
};
protoOf($serializer_10).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [ErrorCodeSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 == null)
    new $serializer_10();
  return $serializer_instance_10;
}
function MohaApiError_init_$Init$(seen0, code, message, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_10().a3v_1);
  }
  $this.code = code;
  if (0 === (seen0 & 2))
    $this.message = null;
  else
    $this.message = message;
  return $this;
}
function MohaApiError_init_$Create$(seen0, code, message, serializationConstructorMarker) {
  return MohaApiError_init_$Init$(seen0, code, message, serializationConstructorMarker, objectCreate(protoOf(MohaApiError)));
}
function MohaApiError(code, message) {
  message = message === VOID ? null : message;
  this.code = code;
  this.message = message;
}
protoOf(MohaApiError).w3u = function () {
  return this.code;
};
protoOf(MohaApiError).e = function () {
  return this.message;
};
protoOf(MohaApiError).wf = function () {
  return this.code;
};
protoOf(MohaApiError).xf = function () {
  return this.message;
};
protoOf(MohaApiError).c3v = function (code, message) {
  return new MohaApiError(code, message);
};
protoOf(MohaApiError).copy = function (code, message, $super) {
  code = code === VOID ? this.code : code;
  message = message === VOID ? this.message : message;
  return $super === VOID ? this.c3v(code, message) : $super.c3v.call(this, code, message);
};
protoOf(MohaApiError).toString = function () {
  return 'MohaApiError(code=' + this.code.toString() + ', message=' + this.message + ')';
};
protoOf(MohaApiError).hashCode = function () {
  var result = this.code.hashCode();
  result = imul(result, 31) + (this.message == null ? 0 : getStringHashCode(this.message)) | 0;
  return result;
};
protoOf(MohaApiError).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MohaApiError))
    return false;
  if (!this.code.equals(other.code))
    return false;
  if (!(this.message == other.message))
    return false;
  return true;
};
function Companion_23() {
}
protoOf(Companion_23).empty = function () {
  return new Dividend('', toUuidString(Companion_getInstance().in('00000000-0000-0000-0000-000000000000')), toIsoTimestamp(Companion_getInstance_0().am()), toIsoTimestamp(Companion_getInstance_0().am()), toIsoTimestamp(Companion_getInstance_0().am()), toIsoTimestamp(Companion_getInstance_0().am()), toIsoTimestamp(Companion_getInstance_0().am()), 0.0, 0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, '', 0.0);
};
protoOf(Companion_23).o1c = function () {
  return $serializer_getInstance_11();
};
var Companion_instance_23;
function Companion_getInstance_26() {
  return Companion_instance_23;
}
function $serializer_11() {
  $serializer_instance_11 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.funds.Dividend', this, 18);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('divId', false);
  tmp0_serialDesc.k10('announceDate', false);
  tmp0_serialDesc.k10('exDate', false);
  tmp0_serialDesc.k10('divStart', false);
  tmp0_serialDesc.k10('recordDate', false);
  tmp0_serialDesc.k10('payoutDate', false);
  tmp0_serialDesc.k10('totalDividend', false);
  tmp0_serialDesc.k10('totalShares', false);
  tmp0_serialDesc.k10('valuePerShare', false);
  tmp0_serialDesc.k10('totalPayout', false);
  tmp0_serialDesc.k10('estimatedDividend', false);
  tmp0_serialDesc.k10('estimatedDividendLow', false);
  tmp0_serialDesc.k10('estimatedDividendHigh', false);
  tmp0_serialDesc.k10('actualDividend', false);
  tmp0_serialDesc.k10('yieldToDate', false);
  tmp0_serialDesc.k10('divStatus', false);
  tmp0_serialDesc.k10('dividendBankTransferFee', false);
  this.d3v_1 = tmp0_serialDesc;
}
protoOf($serializer_11).e3v = function (encoder, value) {
  var tmp0_desc = this.d3v_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.ticker);
  tmp1_output.ju(tmp0_desc, 1, UuidStringSerializer_getInstance(), value.id);
  tmp1_output.ju(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), value.announceDate);
  tmp1_output.ju(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), value.exDate);
  tmp1_output.ju(tmp0_desc, 4, IsoTimestampSerializer_getInstance(), value.divStart);
  tmp1_output.ju(tmp0_desc, 5, IsoTimestampSerializer_getInstance(), value.recordDate);
  tmp1_output.ju(tmp0_desc, 6, IsoTimestampSerializer_getInstance(), value.payoutDate);
  tmp1_output.eu(tmp0_desc, 7, value.totalDividend);
  tmp1_output.cu(tmp0_desc, 8, value.totalShares);
  tmp1_output.eu(tmp0_desc, 9, value.valuePerShare);
  tmp1_output.eu(tmp0_desc, 10, value.totalPayout);
  tmp1_output.eu(tmp0_desc, 11, value.estimatedDividend);
  tmp1_output.eu(tmp0_desc, 12, value.estimatedDividendLow);
  tmp1_output.eu(tmp0_desc, 13, value.estimatedDividendHigh);
  tmp1_output.eu(tmp0_desc, 14, value.actualDividend);
  tmp1_output.eu(tmp0_desc, 15, value.yieldToDate);
  tmp1_output.hu(tmp0_desc, 16, value.divStatus);
  tmp1_output.eu(tmp0_desc, 17, value.dividendBankTransferFee);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_11).gp = function (encoder, value) {
  return this.e3v(encoder, value instanceof Dividend ? value : THROW_CCE());
};
protoOf($serializer_11).hp = function (decoder) {
  var tmp0_desc = this.d3v_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = 0.0;
  var tmp12_local8 = 0;
  var tmp13_local9 = 0.0;
  var tmp14_local10 = 0.0;
  var tmp15_local11 = 0.0;
  var tmp16_local12 = 0.0;
  var tmp17_local13 = 0.0;
  var tmp18_local14 = 0.0;
  var tmp19_local15 = 0.0;
  var tmp20_local16 = null;
  var tmp21_local17 = 0.0;
  var tmp22_input = decoder.ss(tmp0_desc);
  if (tmp22_input.it()) {
    tmp4_local0 = tmp22_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp22_input.et(tmp0_desc, 1, UuidStringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp22_input.et(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp22_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp22_input.et(tmp0_desc, 4, IsoTimestampSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp22_input.et(tmp0_desc, 5, IsoTimestampSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp22_input.et(tmp0_desc, 6, IsoTimestampSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp22_input.zs(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp22_input.xs(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp22_input.zs(tmp0_desc, 9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp22_input.zs(tmp0_desc, 10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp22_input.zs(tmp0_desc, 11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp22_input.zs(tmp0_desc, 12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp22_input.zs(tmp0_desc, 13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp22_input.zs(tmp0_desc, 14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp22_input.zs(tmp0_desc, 15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp22_input.ct(tmp0_desc, 16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp21_local17 = tmp22_input.zs(tmp0_desc, 17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp22_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp22_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp22_input.et(tmp0_desc, 1, UuidStringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp22_input.et(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp22_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp22_input.et(tmp0_desc, 4, IsoTimestampSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp22_input.et(tmp0_desc, 5, IsoTimestampSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp22_input.et(tmp0_desc, 6, IsoTimestampSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp22_input.zs(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp22_input.xs(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp22_input.zs(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp22_input.zs(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp22_input.zs(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp22_input.zs(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp22_input.zs(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp22_input.zs(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp22_input.zs(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp22_input.ct(tmp0_desc, 16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp21_local17 = tmp22_input.zs(tmp0_desc, 17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp22_input.ts(tmp0_desc);
  return Dividend_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, null);
};
protoOf($serializer_11).fp = function () {
  return this.d3v_1;
};
protoOf($serializer_11).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), UuidStringSerializer_getInstance(), IsoTimestampSerializer_getInstance(), IsoTimestampSerializer_getInstance(), IsoTimestampSerializer_getInstance(), IsoTimestampSerializer_getInstance(), IsoTimestampSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), StringSerializer_getInstance(), FloatSerializer_getInstance()];
};
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 == null)
    new $serializer_11();
  return $serializer_instance_11;
}
function Dividend_init_$Init$(seen0, ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee, serializationConstructorMarker, $this) {
  if (!(262143 === (262143 & seen0))) {
    throwMissingFieldException(seen0, 262143, $serializer_getInstance_11().d3v_1);
  }
  $this.ticker = ticker;
  $this.id = id;
  $this.announceDate = announceDate;
  $this.exDate = exDate;
  $this.divStart = divStart;
  $this.recordDate = recordDate;
  $this.payoutDate = payoutDate;
  $this.totalDividend = totalDividend;
  $this.totalShares = totalShares;
  $this.valuePerShare = valuePerShare;
  $this.totalPayout = totalPayout;
  $this.estimatedDividend = estimatedDividend;
  $this.estimatedDividendLow = estimatedDividendLow;
  $this.estimatedDividendHigh = estimatedDividendHigh;
  $this.actualDividend = actualDividend;
  $this.yieldToDate = yieldToDate;
  $this.divStatus = divStatus;
  $this.dividendBankTransferFee = dividendBankTransferFee;
  return $this;
}
function Dividend_init_$Create$(seen0, ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee, serializationConstructorMarker) {
  return Dividend_init_$Init$(seen0, ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee, serializationConstructorMarker, objectCreate(protoOf(Dividend)));
}
function Dividend(ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee) {
  this.ticker = ticker;
  this.id = id;
  this.announceDate = announceDate;
  this.exDate = exDate;
  this.divStart = divStart;
  this.recordDate = recordDate;
  this.payoutDate = payoutDate;
  this.totalDividend = totalDividend;
  this.totalShares = totalShares;
  this.valuePerShare = valuePerShare;
  this.totalPayout = totalPayout;
  this.estimatedDividend = estimatedDividend;
  this.estimatedDividendLow = estimatedDividendLow;
  this.estimatedDividendHigh = estimatedDividendHigh;
  this.actualDividend = actualDividend;
  this.yieldToDate = yieldToDate;
  this.divStatus = divStatus;
  this.dividendBankTransferFee = dividendBankTransferFee;
}
protoOf(Dividend).f3v = function () {
  return this.ticker;
};
protoOf(Dividend).l3t = function () {
  return this.id;
};
protoOf(Dividend).g3v = function () {
  return this.announceDate;
};
protoOf(Dividend).h3v = function () {
  return this.exDate;
};
protoOf(Dividend).i3v = function () {
  return this.divStart;
};
protoOf(Dividend).j3v = function () {
  return this.recordDate;
};
protoOf(Dividend).k3v = function () {
  return this.payoutDate;
};
protoOf(Dividend).l3v = function () {
  return this.totalDividend;
};
protoOf(Dividend).m3v = function () {
  return this.totalShares;
};
protoOf(Dividend).n3v = function () {
  return this.valuePerShare;
};
protoOf(Dividend).o3v = function () {
  return this.totalPayout;
};
protoOf(Dividend).p3v = function () {
  return this.estimatedDividend;
};
protoOf(Dividend).q3v = function () {
  return this.estimatedDividendLow;
};
protoOf(Dividend).r3v = function () {
  return this.estimatedDividendHigh;
};
protoOf(Dividend).s3v = function () {
  return this.actualDividend;
};
protoOf(Dividend).t3v = function () {
  return this.yieldToDate;
};
protoOf(Dividend).u3v = function () {
  return this.divStatus;
};
protoOf(Dividend).v3v = function () {
  return this.dividendBankTransferFee;
};
protoOf(Dividend).wf = function () {
  return this.ticker;
};
protoOf(Dividend).xf = function () {
  return this.id;
};
protoOf(Dividend).e3p = function () {
  return this.announceDate;
};
protoOf(Dividend).f3p = function () {
  return this.exDate;
};
protoOf(Dividend).u3q = function () {
  return this.divStart;
};
protoOf(Dividend).v3q = function () {
  return this.recordDate;
};
protoOf(Dividend).w3q = function () {
  return this.payoutDate;
};
protoOf(Dividend).x3q = function () {
  return this.totalDividend;
};
protoOf(Dividend).y3q = function () {
  return this.totalShares;
};
protoOf(Dividend).z3q = function () {
  return this.valuePerShare;
};
protoOf(Dividend).a3r = function () {
  return this.totalPayout;
};
protoOf(Dividend).b3r = function () {
  return this.estimatedDividend;
};
protoOf(Dividend).c3r = function () {
  return this.estimatedDividendLow;
};
protoOf(Dividend).d3r = function () {
  return this.estimatedDividendHigh;
};
protoOf(Dividend).e3r = function () {
  return this.actualDividend;
};
protoOf(Dividend).f3r = function () {
  return this.yieldToDate;
};
protoOf(Dividend).g3r = function () {
  return this.divStatus;
};
protoOf(Dividend).h3r = function () {
  return this.dividendBankTransferFee;
};
protoOf(Dividend).w3v = function (ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee) {
  return new Dividend(ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee);
};
protoOf(Dividend).copy = function (ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee, $super) {
  ticker = ticker === VOID ? this.ticker : ticker;
  id = id === VOID ? this.id : id;
  announceDate = announceDate === VOID ? this.announceDate : announceDate;
  exDate = exDate === VOID ? this.exDate : exDate;
  divStart = divStart === VOID ? this.divStart : divStart;
  recordDate = recordDate === VOID ? this.recordDate : recordDate;
  payoutDate = payoutDate === VOID ? this.payoutDate : payoutDate;
  totalDividend = totalDividend === VOID ? this.totalDividend : totalDividend;
  totalShares = totalShares === VOID ? this.totalShares : totalShares;
  valuePerShare = valuePerShare === VOID ? this.valuePerShare : valuePerShare;
  totalPayout = totalPayout === VOID ? this.totalPayout : totalPayout;
  estimatedDividend = estimatedDividend === VOID ? this.estimatedDividend : estimatedDividend;
  estimatedDividendLow = estimatedDividendLow === VOID ? this.estimatedDividendLow : estimatedDividendLow;
  estimatedDividendHigh = estimatedDividendHigh === VOID ? this.estimatedDividendHigh : estimatedDividendHigh;
  actualDividend = actualDividend === VOID ? this.actualDividend : actualDividend;
  yieldToDate = yieldToDate === VOID ? this.yieldToDate : yieldToDate;
  divStatus = divStatus === VOID ? this.divStatus : divStatus;
  dividendBankTransferFee = dividendBankTransferFee === VOID ? this.dividendBankTransferFee : dividendBankTransferFee;
  return $super === VOID ? this.w3v(ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee) : $super.w3v.call(this, ticker, id, announceDate, exDate, divStart, recordDate, payoutDate, totalDividend, totalShares, valuePerShare, totalPayout, estimatedDividend, estimatedDividendLow, estimatedDividendHigh, actualDividend, yieldToDate, divStatus, dividendBankTransferFee);
};
protoOf(Dividend).toString = function () {
  return 'Dividend(ticker=' + this.ticker + ', id=' + this.id.toString() + ', announceDate=' + this.announceDate.toString() + ', exDate=' + this.exDate.toString() + ', divStart=' + this.divStart.toString() + ', recordDate=' + this.recordDate.toString() + ', payoutDate=' + this.payoutDate.toString() + ', totalDividend=' + this.totalDividend + ', totalShares=' + this.totalShares + ', valuePerShare=' + this.valuePerShare + ', totalPayout=' + this.totalPayout + ', estimatedDividend=' + this.estimatedDividend + ', estimatedDividendLow=' + this.estimatedDividendLow + ', estimatedDividendHigh=' + this.estimatedDividendHigh + ', actualDividend=' + this.actualDividend + ', yieldToDate=' + this.yieldToDate + ', divStatus=' + this.divStatus + ', dividendBankTransferFee=' + this.dividendBankTransferFee + ')';
};
protoOf(Dividend).hashCode = function () {
  var result = getStringHashCode(this.ticker);
  result = imul(result, 31) + this.id.hashCode() | 0;
  result = imul(result, 31) + this.announceDate.hashCode() | 0;
  result = imul(result, 31) + this.exDate.hashCode() | 0;
  result = imul(result, 31) + this.divStart.hashCode() | 0;
  result = imul(result, 31) + this.recordDate.hashCode() | 0;
  result = imul(result, 31) + this.payoutDate.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.totalDividend) | 0;
  result = imul(result, 31) + this.totalShares | 0;
  result = imul(result, 31) + getNumberHashCode(this.valuePerShare) | 0;
  result = imul(result, 31) + getNumberHashCode(this.totalPayout) | 0;
  result = imul(result, 31) + getNumberHashCode(this.estimatedDividend) | 0;
  result = imul(result, 31) + getNumberHashCode(this.estimatedDividendLow) | 0;
  result = imul(result, 31) + getNumberHashCode(this.estimatedDividendHigh) | 0;
  result = imul(result, 31) + getNumberHashCode(this.actualDividend) | 0;
  result = imul(result, 31) + getNumberHashCode(this.yieldToDate) | 0;
  result = imul(result, 31) + getStringHashCode(this.divStatus) | 0;
  result = imul(result, 31) + getNumberHashCode(this.dividendBankTransferFee) | 0;
  return result;
};
protoOf(Dividend).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Dividend))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!this.id.equals(other.id))
    return false;
  if (!this.announceDate.equals(other.announceDate))
    return false;
  if (!this.exDate.equals(other.exDate))
    return false;
  if (!this.divStart.equals(other.divStart))
    return false;
  if (!this.recordDate.equals(other.recordDate))
    return false;
  if (!this.payoutDate.equals(other.payoutDate))
    return false;
  if (!equals(this.totalDividend, other.totalDividend))
    return false;
  if (!(this.totalShares === other.totalShares))
    return false;
  if (!equals(this.valuePerShare, other.valuePerShare))
    return false;
  if (!equals(this.totalPayout, other.totalPayout))
    return false;
  if (!equals(this.estimatedDividend, other.estimatedDividend))
    return false;
  if (!equals(this.estimatedDividendLow, other.estimatedDividendLow))
    return false;
  if (!equals(this.estimatedDividendHigh, other.estimatedDividendHigh))
    return false;
  if (!equals(this.actualDividend, other.actualDividend))
    return false;
  if (!equals(this.yieldToDate, other.yieldToDate))
    return false;
  if (!(this.divStatus === other.divStatus))
    return false;
  if (!equals(this.dividendBankTransferFee, other.dividendBankTransferFee))
    return false;
  return true;
};
function _get_$cachedSerializer__te6jhj_10($this) {
  return $this.x3v_1.w();
}
function DividendPeriodStatus$Companion$_anonymous__xw8j8t() {
  return createSimpleEnumSerializer('com.moreharvest.shared.funds.DividendPeriodStatus', values_19());
}
var DividendPeriodStatus_paid_instance;
var DividendPeriodStatus_partially_paid_instance;
var DividendPeriodStatus_pending_instance;
function values_19() {
  return [DividendPeriodStatus_paid_getInstance(), DividendPeriodStatus_partially_paid_getInstance(), DividendPeriodStatus_pending_getInstance()];
}
function valueOf_19(value) {
  switch (value) {
    case 'paid':
      return DividendPeriodStatus_paid_getInstance();
    case 'partially_paid':
      return DividendPeriodStatus_partially_paid_getInstance();
    case 'pending':
      return DividendPeriodStatus_pending_getInstance();
    default:
      DividendPeriodStatus_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.funds.DividendPeriodStatus.' + value);
      break;
  }
}
function Companion_24() {
  Companion_instance_24 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.x3v_1 = lazy(tmp_0, DividendPeriodStatus$Companion$_anonymous__xw8j8t);
}
protoOf(Companion_24).o1c = function () {
  return _get_$cachedSerializer__te6jhj_10(this);
};
protoOf(Companion_24).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_24;
function Companion_getInstance_27() {
  DividendPeriodStatus_initEntries();
  if (Companion_instance_24 == null)
    new Companion_24();
  return Companion_instance_24;
}
var DividendPeriodStatus_entriesInitialized;
function DividendPeriodStatus_initEntries() {
  if (DividendPeriodStatus_entriesInitialized)
    return Unit_instance;
  DividendPeriodStatus_entriesInitialized = true;
  DividendPeriodStatus_paid_instance = new DividendPeriodStatus('paid', 0);
  DividendPeriodStatus_partially_paid_instance = new DividendPeriodStatus('partially_paid', 1);
  DividendPeriodStatus_pending_instance = new DividendPeriodStatus('pending', 2);
  Companion_getInstance_27();
}
function DividendPeriodStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function _get_$cachedSerializer__te6jhj_11($this) {
  return $this.a3w_1.w();
}
function PayoutStatus$Companion$_anonymous__gf9m09() {
  return createSimpleEnumSerializer('com.moreharvest.shared.funds.PayoutStatus', values_20());
}
var PayoutStatus_paid_instance;
var PayoutStatus_pending_instance;
function values_20() {
  return [PayoutStatus_paid_getInstance(), PayoutStatus_pending_getInstance()];
}
function valueOf_20(value) {
  switch (value) {
    case 'paid':
      return PayoutStatus_paid_getInstance();
    case 'pending':
      return PayoutStatus_pending_getInstance();
    default:
      PayoutStatus_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.funds.PayoutStatus.' + value);
      break;
  }
}
function Companion_25() {
  Companion_instance_25 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.a3w_1 = lazy(tmp_0, PayoutStatus$Companion$_anonymous__gf9m09);
}
protoOf(Companion_25).o1c = function () {
  return _get_$cachedSerializer__te6jhj_11(this);
};
protoOf(Companion_25).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_25;
function Companion_getInstance_28() {
  PayoutStatus_initEntries();
  if (Companion_instance_25 == null)
    new Companion_25();
  return Companion_instance_25;
}
var PayoutStatus_entriesInitialized;
function PayoutStatus_initEntries() {
  if (PayoutStatus_entriesInitialized)
    return Unit_instance;
  PayoutStatus_entriesInitialized = true;
  PayoutStatus_paid_instance = new PayoutStatus('paid', 0);
  PayoutStatus_pending_instance = new PayoutStatus('pending', 1);
  Companion_getInstance_28();
}
function PayoutStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function _get_$cachedSerializer__te6jhj_12($this) {
  return $this.d3w_1.w();
}
function DivEarningsBreakdownType$Companion$_anonymous__ymi0z6() {
  return createSimpleEnumSerializer('com.moreharvest.shared.funds.DivEarningsBreakdownType', values_21());
}
var DivEarningsBreakdownType_paid_instance;
var DivEarningsBreakdownType_projected_instance;
var DivEarningsBreakdownType_fee_instance;
function values_21() {
  return [DivEarningsBreakdownType_paid_getInstance(), DivEarningsBreakdownType_projected_getInstance(), DivEarningsBreakdownType_fee_getInstance()];
}
function valueOf_21(value) {
  switch (value) {
    case 'paid':
      return DivEarningsBreakdownType_paid_getInstance();
    case 'projected':
      return DivEarningsBreakdownType_projected_getInstance();
    case 'fee':
      return DivEarningsBreakdownType_fee_getInstance();
    default:
      DivEarningsBreakdownType_initEntries();
      THROW_IAE('No enum constant com.moreharvest.shared.funds.DivEarningsBreakdownType.' + value);
      break;
  }
}
function Companion_26() {
  Companion_instance_26 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.d3w_1 = lazy(tmp_0, DivEarningsBreakdownType$Companion$_anonymous__ymi0z6);
}
protoOf(Companion_26).o1c = function () {
  return _get_$cachedSerializer__te6jhj_12(this);
};
protoOf(Companion_26).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var Companion_instance_26;
function Companion_getInstance_29() {
  DivEarningsBreakdownType_initEntries();
  if (Companion_instance_26 == null)
    new Companion_26();
  return Companion_instance_26;
}
var DivEarningsBreakdownType_entriesInitialized;
function DivEarningsBreakdownType_initEntries() {
  if (DivEarningsBreakdownType_entriesInitialized)
    return Unit_instance;
  DivEarningsBreakdownType_entriesInitialized = true;
  DivEarningsBreakdownType_paid_instance = new DivEarningsBreakdownType('paid', 0);
  DivEarningsBreakdownType_projected_instance = new DivEarningsBreakdownType('projected', 1);
  DivEarningsBreakdownType_fee_instance = new DivEarningsBreakdownType('fee', 2);
  Companion_getInstance_29();
}
function DivEarningsBreakdownType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function DivEarningsBreakdown$Companion$$childSerializers$_anonymous__5upj5v() {
  return Companion_getInstance_29().o1c();
}
function Companion_27() {
  Companion_instance_27 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g3w_1 = [lazy(tmp_0, DivEarningsBreakdown$Companion$$childSerializers$_anonymous__5upj5v), null];
}
protoOf(Companion_27).o1c = function () {
  return $serializer_getInstance_12();
};
var Companion_instance_27;
function Companion_getInstance_30() {
  if (Companion_instance_27 == null)
    new Companion_27();
  return Companion_instance_27;
}
function $serializer_12() {
  $serializer_instance_12 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.funds.DivEarningsBreakdown', this, 2);
  tmp0_serialDesc.k10('type', false);
  tmp0_serialDesc.k10('amount', false);
  this.h3w_1 = tmp0_serialDesc;
}
protoOf($serializer_12).i3w = function (encoder, value) {
  var tmp0_desc = this.h3w_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_30().g3w_1;
  tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.type);
  tmp1_output.eu(tmp0_desc, 1, value.amount);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_12).gp = function (encoder, value) {
  return this.i3w(encoder, value instanceof DivEarningsBreakdown ? value : THROW_CCE());
};
protoOf($serializer_12).hp = function (decoder) {
  var tmp0_desc = this.h3w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0.0;
  var tmp6_input = decoder.ss(tmp0_desc);
  var tmp7_cached = Companion_getInstance_30().g3w_1;
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, tmp7_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, tmp7_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return DivEarningsBreakdown_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_12).fp = function () {
  return this.h3w_1;
};
protoOf($serializer_12).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_30().g3w_1[0].w(), FloatSerializer_getInstance()];
};
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 == null)
    new $serializer_12();
  return $serializer_instance_12;
}
function DivEarningsBreakdown_init_$Init$(seen0, type, amount, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_12().h3w_1);
  }
  $this.type = type;
  $this.amount = amount;
  return $this;
}
function DivEarningsBreakdown_init_$Create$(seen0, type, amount, serializationConstructorMarker) {
  return DivEarningsBreakdown_init_$Init$(seen0, type, amount, serializationConstructorMarker, objectCreate(protoOf(DivEarningsBreakdown)));
}
function DivEarningsBreakdown(type, amount) {
  Companion_getInstance_30();
  this.type = type;
  this.amount = amount;
}
protoOf(DivEarningsBreakdown).m3t = function () {
  return this.type;
};
protoOf(DivEarningsBreakdown).j3w = function () {
  return this.amount;
};
protoOf(DivEarningsBreakdown).wf = function () {
  return this.type;
};
protoOf(DivEarningsBreakdown).xf = function () {
  return this.amount;
};
protoOf(DivEarningsBreakdown).k3w = function (type, amount) {
  return new DivEarningsBreakdown(type, amount);
};
protoOf(DivEarningsBreakdown).copy = function (type, amount, $super) {
  type = type === VOID ? this.type : type;
  amount = amount === VOID ? this.amount : amount;
  return $super === VOID ? this.k3w(type, amount) : $super.k3w.call(this, type, amount);
};
protoOf(DivEarningsBreakdown).toString = function () {
  return 'DivEarningsBreakdown(type=' + this.type.toString() + ', amount=' + this.amount + ')';
};
protoOf(DivEarningsBreakdown).hashCode = function () {
  var result = this.type.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.amount) | 0;
  return result;
};
protoOf(DivEarningsBreakdown).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DivEarningsBreakdown))
    return false;
  if (!this.type.equals(other.type))
    return false;
  if (!equals(this.amount, other.amount))
    return false;
  return true;
};
function DividendPeriodPayout$Companion$$childSerializers$_anonymous__crxzxo() {
  return Companion_getInstance_28().o1c();
}
function Companion_28() {
  Companion_instance_28 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.l3w_1 = [null, null, null, null, lazy(tmp_0, DividendPeriodPayout$Companion$$childSerializers$_anonymous__crxzxo), null, null, null, null];
}
protoOf(Companion_28).o1c = function () {
  return $serializer_getInstance_13();
};
var Companion_instance_28;
function Companion_getInstance_31() {
  if (Companion_instance_28 == null)
    new Companion_28();
  return Companion_instance_28;
}
function $serializer_13() {
  $serializer_instance_13 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.funds.DividendPeriodPayout', this, 9);
  tmp0_serialDesc.k10('payoutDate', false);
  tmp0_serialDesc.k10('earned', false);
  tmp0_serialDesc.k10('fee', false);
  tmp0_serialDesc.k10('received', false);
  tmp0_serialDesc.k10('status', false);
  tmp0_serialDesc.k10('maturationDate', false);
  tmp0_serialDesc.k10('paidOn', true);
  tmp0_serialDesc.k10('purchaseDate', true);
  tmp0_serialDesc.k10('dividendStartDate', true);
  this.m3w_1 = tmp0_serialDesc;
}
protoOf($serializer_13).n3w = function (encoder, value) {
  var tmp0_desc = this.m3w_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_31().l3w_1;
  tmp1_output.ju(tmp0_desc, 0, IsoTimestampSerializer_getInstance(), value.payoutDate);
  tmp1_output.eu(tmp0_desc, 1, value.earned);
  tmp1_output.eu(tmp0_desc, 2, value.fee);
  tmp1_output.eu(tmp0_desc, 3, value.received);
  tmp1_output.ju(tmp0_desc, 4, tmp2_cached[4].w(), value.status);
  tmp1_output.ju(tmp0_desc, 5, IsoTimestampSerializer_getInstance(), value.maturationDate);
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.paidOn == null)) {
    tmp1_output.lu(tmp0_desc, 6, StringSerializer_getInstance(), value.paidOn);
  }
  if (tmp1_output.pu(tmp0_desc, 7) ? true : !(value.purchaseDate == null)) {
    tmp1_output.lu(tmp0_desc, 7, StringSerializer_getInstance(), value.purchaseDate);
  }
  if (tmp1_output.pu(tmp0_desc, 8) ? true : !(value.dividendStartDate == null)) {
    tmp1_output.lu(tmp0_desc, 8, StringSerializer_getInstance(), value.dividendStartDate);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_13).gp = function (encoder, value) {
  return this.n3w(encoder, value instanceof DividendPeriodPayout ? value : THROW_CCE());
};
protoOf($serializer_13).hp = function (decoder) {
  var tmp0_desc = this.m3w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0.0;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_input = decoder.ss(tmp0_desc);
  var tmp14_cached = Companion_getInstance_31().l3w_1;
  if (tmp13_input.it()) {
    tmp4_local0 = tmp13_input.et(tmp0_desc, 0, IsoTimestampSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp13_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp13_input.zs(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp13_input.zs(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp13_input.et(tmp0_desc, 4, tmp14_cached[4].w(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp13_input.et(tmp0_desc, 5, IsoTimestampSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp13_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp13_input.gt(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp13_input.gt(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp13_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp13_input.et(tmp0_desc, 0, IsoTimestampSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp13_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp13_input.zs(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp13_input.zs(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp13_input.et(tmp0_desc, 4, tmp14_cached[4].w(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp13_input.et(tmp0_desc, 5, IsoTimestampSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp13_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp13_input.gt(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp13_input.gt(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp13_input.ts(tmp0_desc);
  return DividendPeriodPayout_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
};
protoOf($serializer_13).fp = function () {
  return this.m3w_1;
};
protoOf($serializer_13).z10 = function () {
  var tmp0_cached = Companion_getInstance_31().l3w_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IsoTimestampSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), tmp0_cached[4].w(), IsoTimestampSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 == null)
    new $serializer_13();
  return $serializer_instance_13;
}
function DividendPeriodPayout_init_$Init$(seen0, payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate, serializationConstructorMarker, $this) {
  if (!(63 === (63 & seen0))) {
    throwMissingFieldException(seen0, 63, $serializer_getInstance_13().m3w_1);
  }
  $this.payoutDate = payoutDate;
  $this.earned = earned;
  $this.fee = fee;
  $this.received = received;
  $this.status = status;
  $this.maturationDate = maturationDate;
  if (0 === (seen0 & 64))
    $this.paidOn = null;
  else
    $this.paidOn = paidOn;
  if (0 === (seen0 & 128))
    $this.purchaseDate = null;
  else
    $this.purchaseDate = purchaseDate;
  if (0 === (seen0 & 256))
    $this.dividendStartDate = null;
  else
    $this.dividendStartDate = dividendStartDate;
  return $this;
}
function DividendPeriodPayout_init_$Create$(seen0, payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate, serializationConstructorMarker) {
  return DividendPeriodPayout_init_$Init$(seen0, payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate, serializationConstructorMarker, objectCreate(protoOf(DividendPeriodPayout)));
}
function DividendPeriodPayout(payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate) {
  Companion_getInstance_31();
  paidOn = paidOn === VOID ? null : paidOn;
  purchaseDate = purchaseDate === VOID ? null : purchaseDate;
  dividendStartDate = dividendStartDate === VOID ? null : dividendStartDate;
  this.payoutDate = payoutDate;
  this.earned = earned;
  this.fee = fee;
  this.received = received;
  this.status = status;
  this.maturationDate = maturationDate;
  this.paidOn = paidOn;
  this.purchaseDate = purchaseDate;
  this.dividendStartDate = dividendStartDate;
}
protoOf(DividendPeriodPayout).k3v = function () {
  return this.payoutDate;
};
protoOf(DividendPeriodPayout).o3w = function () {
  return this.earned;
};
protoOf(DividendPeriodPayout).p3w = function () {
  return this.fee;
};
protoOf(DividendPeriodPayout).q3w = function () {
  return this.received;
};
protoOf(DividendPeriodPayout).r3w = function () {
  return this.status;
};
protoOf(DividendPeriodPayout).s3w = function () {
  return this.maturationDate;
};
protoOf(DividendPeriodPayout).t3w = function () {
  return this.paidOn;
};
protoOf(DividendPeriodPayout).u3w = function () {
  return this.purchaseDate;
};
protoOf(DividendPeriodPayout).v3w = function () {
  return this.dividendStartDate;
};
protoOf(DividendPeriodPayout).wf = function () {
  return this.payoutDate;
};
protoOf(DividendPeriodPayout).xf = function () {
  return this.earned;
};
protoOf(DividendPeriodPayout).e3p = function () {
  return this.fee;
};
protoOf(DividendPeriodPayout).f3p = function () {
  return this.received;
};
protoOf(DividendPeriodPayout).u3q = function () {
  return this.status;
};
protoOf(DividendPeriodPayout).v3q = function () {
  return this.maturationDate;
};
protoOf(DividendPeriodPayout).w3q = function () {
  return this.paidOn;
};
protoOf(DividendPeriodPayout).x3q = function () {
  return this.purchaseDate;
};
protoOf(DividendPeriodPayout).y3q = function () {
  return this.dividendStartDate;
};
protoOf(DividendPeriodPayout).w3w = function (payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate) {
  return new DividendPeriodPayout(payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate);
};
protoOf(DividendPeriodPayout).copy = function (payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate, $super) {
  payoutDate = payoutDate === VOID ? this.payoutDate : payoutDate;
  earned = earned === VOID ? this.earned : earned;
  fee = fee === VOID ? this.fee : fee;
  received = received === VOID ? this.received : received;
  status = status === VOID ? this.status : status;
  maturationDate = maturationDate === VOID ? this.maturationDate : maturationDate;
  paidOn = paidOn === VOID ? this.paidOn : paidOn;
  purchaseDate = purchaseDate === VOID ? this.purchaseDate : purchaseDate;
  dividendStartDate = dividendStartDate === VOID ? this.dividendStartDate : dividendStartDate;
  return $super === VOID ? this.w3w(payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate) : $super.w3w.call(this, payoutDate, earned, fee, received, status, maturationDate, paidOn, purchaseDate, dividendStartDate);
};
protoOf(DividendPeriodPayout).toString = function () {
  return 'DividendPeriodPayout(payoutDate=' + this.payoutDate.toString() + ', earned=' + this.earned + ', fee=' + this.fee + ', received=' + this.received + ', status=' + this.status.toString() + ', maturationDate=' + this.maturationDate.toString() + ', paidOn=' + this.paidOn + ', purchaseDate=' + this.purchaseDate + ', dividendStartDate=' + this.dividendStartDate + ')';
};
protoOf(DividendPeriodPayout).hashCode = function () {
  var result = this.payoutDate.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.earned) | 0;
  result = imul(result, 31) + getNumberHashCode(this.fee) | 0;
  result = imul(result, 31) + getNumberHashCode(this.received) | 0;
  result = imul(result, 31) + this.status.hashCode() | 0;
  result = imul(result, 31) + this.maturationDate.hashCode() | 0;
  result = imul(result, 31) + (this.paidOn == null ? 0 : getStringHashCode(this.paidOn)) | 0;
  result = imul(result, 31) + (this.purchaseDate == null ? 0 : getStringHashCode(this.purchaseDate)) | 0;
  result = imul(result, 31) + (this.dividendStartDate == null ? 0 : getStringHashCode(this.dividendStartDate)) | 0;
  return result;
};
protoOf(DividendPeriodPayout).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DividendPeriodPayout))
    return false;
  if (!this.payoutDate.equals(other.payoutDate))
    return false;
  if (!equals(this.earned, other.earned))
    return false;
  if (!equals(this.fee, other.fee))
    return false;
  if (!equals(this.received, other.received))
    return false;
  if (!this.status.equals(other.status))
    return false;
  if (!this.maturationDate.equals(other.maturationDate))
    return false;
  if (!(this.paidOn == other.paidOn))
    return false;
  if (!(this.purchaseDate == other.purchaseDate))
    return false;
  if (!(this.dividendStartDate == other.dividendStartDate))
    return false;
  return true;
};
function DividendPeriod$Companion$$childSerializers$_anonymous__gbusme() {
  return Companion_getInstance_27().o1c();
}
function DividendPeriod$Companion$$childSerializers$_anonymous__gbusme_0() {
  return new ArrayListSerializer($serializer_getInstance_12());
}
function DividendPeriod$Companion$$childSerializers$_anonymous__gbusme_1() {
  return new ArrayListSerializer($serializer_getInstance_13());
}
function Companion_29() {
  Companion_instance_29 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, DividendPeriod$Companion$$childSerializers$_anonymous__gbusme);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_3 = lazy(tmp_2, DividendPeriod$Companion$$childSerializers$_anonymous__gbusme_0);
  var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.x3w_1 = [null, null, null, null, tmp_1, tmp_3, lazy(tmp_4, DividendPeriod$Companion$$childSerializers$_anonymous__gbusme_1)];
}
protoOf(Companion_29).o1c = function () {
  return $serializer_getInstance_14();
};
var Companion_instance_29;
function Companion_getInstance_32() {
  if (Companion_instance_29 == null)
    new Companion_29();
  return Companion_instance_29;
}
function $serializer_14() {
  $serializer_instance_14 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.funds.DividendPeriod', this, 7);
  tmp0_serialDesc.k10('exDividendDate', false);
  tmp0_serialDesc.k10('dividendPayoutDate', false);
  tmp0_serialDesc.k10('dividendPerShare', false);
  tmp0_serialDesc.k10('totalEarnedDivPeriod', false);
  tmp0_serialDesc.k10('status', false);
  tmp0_serialDesc.k10('divEarningsBreakdown', true);
  tmp0_serialDesc.k10('payouts', true);
  this.y3w_1 = tmp0_serialDesc;
}
protoOf($serializer_14).z3w = function (encoder, value) {
  var tmp0_desc = this.y3w_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_32().x3w_1;
  tmp1_output.ju(tmp0_desc, 0, IsoTimestampSerializer_getInstance(), value.exDividendDate);
  tmp1_output.ju(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), value.dividendPayoutDate);
  tmp1_output.eu(tmp0_desc, 2, value.dividendPerShare);
  tmp1_output.eu(tmp0_desc, 3, value.totalEarnedDivPeriod);
  tmp1_output.ju(tmp0_desc, 4, tmp2_cached[4].w(), value.status);
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !equals(value.divEarningsBreakdown, emptyList())) {
    tmp1_output.ju(tmp0_desc, 5, tmp2_cached[5].w(), value.divEarningsBreakdown);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !equals(value.payouts, emptyList())) {
    tmp1_output.ju(tmp0_desc, 6, tmp2_cached[6].w(), value.payouts);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_14).gp = function (encoder, value) {
  return this.z3w(encoder, value instanceof DividendPeriod ? value : THROW_CCE());
};
protoOf($serializer_14).hp = function (decoder) {
  var tmp0_desc = this.y3w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0.0;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.ss(tmp0_desc);
  var tmp12_cached = Companion_getInstance_32().x3w_1;
  if (tmp11_input.it()) {
    tmp4_local0 = tmp11_input.et(tmp0_desc, 0, IsoTimestampSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.et(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.zs(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.zs(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.et(tmp0_desc, 4, tmp12_cached[4].w(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.et(tmp0_desc, 5, tmp12_cached[5].w(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.et(tmp0_desc, 6, tmp12_cached[6].w(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.et(tmp0_desc, 0, IsoTimestampSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.et(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.zs(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.zs(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.et(tmp0_desc, 4, tmp12_cached[4].w(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.et(tmp0_desc, 5, tmp12_cached[5].w(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.et(tmp0_desc, 6, tmp12_cached[6].w(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.ts(tmp0_desc);
  return DividendPeriod_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_14).fp = function () {
  return this.y3w_1;
};
protoOf($serializer_14).z10 = function () {
  var tmp0_cached = Companion_getInstance_32().x3w_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IsoTimestampSerializer_getInstance(), IsoTimestampSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), tmp0_cached[4].w(), tmp0_cached[5].w(), tmp0_cached[6].w()];
};
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 == null)
    new $serializer_14();
  return $serializer_instance_14;
}
function DividendPeriod_init_$Init$(seen0, exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts, serializationConstructorMarker, $this) {
  if (!(31 === (31 & seen0))) {
    throwMissingFieldException(seen0, 31, $serializer_getInstance_14().y3w_1);
  }
  $this.exDividendDate = exDividendDate;
  $this.dividendPayoutDate = dividendPayoutDate;
  $this.dividendPerShare = dividendPerShare;
  $this.totalEarnedDivPeriod = totalEarnedDivPeriod;
  $this.status = status;
  if (0 === (seen0 & 32))
    $this.divEarningsBreakdown = emptyList();
  else
    $this.divEarningsBreakdown = divEarningsBreakdown;
  if (0 === (seen0 & 64))
    $this.payouts = emptyList();
  else
    $this.payouts = payouts;
  return $this;
}
function DividendPeriod_init_$Create$(seen0, exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts, serializationConstructorMarker) {
  return DividendPeriod_init_$Init$(seen0, exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts, serializationConstructorMarker, objectCreate(protoOf(DividendPeriod)));
}
function DividendPeriod(exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts) {
  Companion_getInstance_32();
  divEarningsBreakdown = divEarningsBreakdown === VOID ? emptyList() : divEarningsBreakdown;
  payouts = payouts === VOID ? emptyList() : payouts;
  this.exDividendDate = exDividendDate;
  this.dividendPayoutDate = dividendPayoutDate;
  this.dividendPerShare = dividendPerShare;
  this.totalEarnedDivPeriod = totalEarnedDivPeriod;
  this.status = status;
  this.divEarningsBreakdown = divEarningsBreakdown;
  this.payouts = payouts;
}
protoOf(DividendPeriod).a3x = function () {
  return this.exDividendDate;
};
protoOf(DividendPeriod).b3x = function () {
  return this.dividendPayoutDate;
};
protoOf(DividendPeriod).c3x = function () {
  return this.dividendPerShare;
};
protoOf(DividendPeriod).d3x = function () {
  return this.totalEarnedDivPeriod;
};
protoOf(DividendPeriod).r3w = function () {
  return this.status;
};
protoOf(DividendPeriod).e3x = function () {
  return this.divEarningsBreakdown;
};
protoOf(DividendPeriod).f3x = function () {
  return this.payouts;
};
protoOf(DividendPeriod).wf = function () {
  return this.exDividendDate;
};
protoOf(DividendPeriod).xf = function () {
  return this.dividendPayoutDate;
};
protoOf(DividendPeriod).e3p = function () {
  return this.dividendPerShare;
};
protoOf(DividendPeriod).f3p = function () {
  return this.totalEarnedDivPeriod;
};
protoOf(DividendPeriod).u3q = function () {
  return this.status;
};
protoOf(DividendPeriod).v3q = function () {
  return this.divEarningsBreakdown;
};
protoOf(DividendPeriod).w3q = function () {
  return this.payouts;
};
protoOf(DividendPeriod).g3x = function (exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts) {
  return new DividendPeriod(exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts);
};
protoOf(DividendPeriod).copy = function (exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts, $super) {
  exDividendDate = exDividendDate === VOID ? this.exDividendDate : exDividendDate;
  dividendPayoutDate = dividendPayoutDate === VOID ? this.dividendPayoutDate : dividendPayoutDate;
  dividendPerShare = dividendPerShare === VOID ? this.dividendPerShare : dividendPerShare;
  totalEarnedDivPeriod = totalEarnedDivPeriod === VOID ? this.totalEarnedDivPeriod : totalEarnedDivPeriod;
  status = status === VOID ? this.status : status;
  divEarningsBreakdown = divEarningsBreakdown === VOID ? this.divEarningsBreakdown : divEarningsBreakdown;
  payouts = payouts === VOID ? this.payouts : payouts;
  return $super === VOID ? this.g3x(exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts) : $super.g3x.call(this, exDividendDate, dividendPayoutDate, dividendPerShare, totalEarnedDivPeriod, status, divEarningsBreakdown, payouts);
};
protoOf(DividendPeriod).toString = function () {
  return 'DividendPeriod(exDividendDate=' + this.exDividendDate.toString() + ', dividendPayoutDate=' + this.dividendPayoutDate.toString() + ', dividendPerShare=' + this.dividendPerShare + ', totalEarnedDivPeriod=' + this.totalEarnedDivPeriod + ', status=' + this.status.toString() + ', divEarningsBreakdown=' + toString_0(this.divEarningsBreakdown) + ', payouts=' + toString_0(this.payouts) + ')';
};
protoOf(DividendPeriod).hashCode = function () {
  var result = this.exDividendDate.hashCode();
  result = imul(result, 31) + this.dividendPayoutDate.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.dividendPerShare) | 0;
  result = imul(result, 31) + getNumberHashCode(this.totalEarnedDivPeriod) | 0;
  result = imul(result, 31) + this.status.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.divEarningsBreakdown) | 0;
  result = imul(result, 31) + hashCode(this.payouts) | 0;
  return result;
};
protoOf(DividendPeriod).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DividendPeriod))
    return false;
  if (!this.exDividendDate.equals(other.exDividendDate))
    return false;
  if (!this.dividendPayoutDate.equals(other.dividendPayoutDate))
    return false;
  if (!equals(this.dividendPerShare, other.dividendPerShare))
    return false;
  if (!equals(this.totalEarnedDivPeriod, other.totalEarnedDivPeriod))
    return false;
  if (!this.status.equals(other.status))
    return false;
  if (!equals(this.divEarningsBreakdown, other.divEarningsBreakdown))
    return false;
  if (!equals(this.payouts, other.payouts))
    return false;
  return true;
};
function DividendPeriodStatus_paid_getInstance() {
  DividendPeriodStatus_initEntries();
  return DividendPeriodStatus_paid_instance;
}
function DividendPeriodStatus_partially_paid_getInstance() {
  DividendPeriodStatus_initEntries();
  return DividendPeriodStatus_partially_paid_instance;
}
function DividendPeriodStatus_pending_getInstance() {
  DividendPeriodStatus_initEntries();
  return DividendPeriodStatus_pending_instance;
}
function PayoutStatus_paid_getInstance() {
  PayoutStatus_initEntries();
  return PayoutStatus_paid_instance;
}
function PayoutStatus_pending_getInstance() {
  PayoutStatus_initEntries();
  return PayoutStatus_pending_instance;
}
function DivEarningsBreakdownType_paid_getInstance() {
  DivEarningsBreakdownType_initEntries();
  return DivEarningsBreakdownType_paid_instance;
}
function DivEarningsBreakdownType_projected_getInstance() {
  DivEarningsBreakdownType_initEntries();
  return DivEarningsBreakdownType_projected_instance;
}
function DivEarningsBreakdownType_fee_getInstance() {
  DivEarningsBreakdownType_initEntries();
  return DivEarningsBreakdownType_fee_instance;
}
function Companion_30() {
}
protoOf(Companion_30).o1c = function () {
  return $serializer_getInstance_15();
};
var Companion_instance_30;
function Companion_getInstance_33() {
  return Companion_instance_30;
}
function $serializer_15() {
  $serializer_instance_15 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.funds.Fund', this, 7);
  tmp0_serialDesc.k10('name', true);
  tmp0_serialDesc.k10('ticker', true);
  tmp0_serialDesc.k10('marketCap', true);
  tmp0_serialDesc.k10('sharePrice', true);
  tmp0_serialDesc.k10('totalShares', true);
  tmp0_serialDesc.k10('availableShares', true);
  tmp0_serialDesc.k10('expenseRatio', true);
  this.h3x_1 = tmp0_serialDesc;
}
protoOf($serializer_15).i3x = function (encoder, value) {
  var tmp0_desc = this.h3x_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.name == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.name);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.ticker == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.ticker);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.marketCap == null)) {
    tmp1_output.lu(tmp0_desc, 2, FloatSerializer_getInstance(), value.marketCap);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.sharePrice == null)) {
    tmp1_output.lu(tmp0_desc, 3, FloatSerializer_getInstance(), value.sharePrice);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.totalShares == null)) {
    tmp1_output.lu(tmp0_desc, 4, IntSerializer_getInstance(), value.totalShares);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.availableShares == null)) {
    tmp1_output.lu(tmp0_desc, 5, IntSerializer_getInstance(), value.availableShares);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.expenseRatio == null)) {
    tmp1_output.lu(tmp0_desc, 6, FloatSerializer_getInstance(), value.expenseRatio);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_15).gp = function (encoder, value) {
  return this.i3x(encoder, value instanceof Fund ? value : THROW_CCE());
};
protoOf($serializer_15).hp = function (decoder) {
  var tmp0_desc = this.h3x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.ss(tmp0_desc);
  if (tmp11_input.it()) {
    tmp4_local0 = tmp11_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.gt(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.gt(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.gt(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.gt(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.gt(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.gt(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.gt(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.gt(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.ts(tmp0_desc);
  return Fund_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_15).fp = function () {
  return this.h3x_1;
};
protoOf($serializer_15).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(FloatSerializer_getInstance())];
};
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 == null)
    new $serializer_15();
  return $serializer_instance_15;
}
function Fund_init_$Init$(seen0, name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_15().h3x_1);
  }
  if (0 === (seen0 & 1))
    $this.name = null;
  else
    $this.name = name;
  if (0 === (seen0 & 2))
    $this.ticker = null;
  else
    $this.ticker = ticker;
  if (0 === (seen0 & 4))
    $this.marketCap = null;
  else
    $this.marketCap = marketCap;
  if (0 === (seen0 & 8))
    $this.sharePrice = null;
  else
    $this.sharePrice = sharePrice;
  if (0 === (seen0 & 16))
    $this.totalShares = null;
  else
    $this.totalShares = totalShares;
  if (0 === (seen0 & 32))
    $this.availableShares = null;
  else
    $this.availableShares = availableShares;
  if (0 === (seen0 & 64))
    $this.expenseRatio = null;
  else
    $this.expenseRatio = expenseRatio;
  return $this;
}
function Fund_init_$Create$(seen0, name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio, serializationConstructorMarker) {
  return Fund_init_$Init$(seen0, name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio, serializationConstructorMarker, objectCreate(protoOf(Fund)));
}
function Fund(name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio) {
  name = name === VOID ? null : name;
  ticker = ticker === VOID ? null : ticker;
  marketCap = marketCap === VOID ? null : marketCap;
  sharePrice = sharePrice === VOID ? null : sharePrice;
  totalShares = totalShares === VOID ? null : totalShares;
  availableShares = availableShares === VOID ? null : availableShares;
  expenseRatio = expenseRatio === VOID ? null : expenseRatio;
  this.name = name;
  this.ticker = ticker;
  this.marketCap = marketCap;
  this.sharePrice = sharePrice;
  this.totalShares = totalShares;
  this.availableShares = availableShares;
  this.expenseRatio = expenseRatio;
}
protoOf(Fund).k2 = function () {
  return this.name;
};
protoOf(Fund).f3v = function () {
  return this.ticker;
};
protoOf(Fund).j3x = function () {
  return this.marketCap;
};
protoOf(Fund).k3x = function () {
  return this.sharePrice;
};
protoOf(Fund).m3v = function () {
  return this.totalShares;
};
protoOf(Fund).l3x = function () {
  return this.availableShares;
};
protoOf(Fund).m3x = function () {
  return this.expenseRatio;
};
protoOf(Fund).wf = function () {
  return this.name;
};
protoOf(Fund).xf = function () {
  return this.ticker;
};
protoOf(Fund).e3p = function () {
  return this.marketCap;
};
protoOf(Fund).f3p = function () {
  return this.sharePrice;
};
protoOf(Fund).u3q = function () {
  return this.totalShares;
};
protoOf(Fund).v3q = function () {
  return this.availableShares;
};
protoOf(Fund).w3q = function () {
  return this.expenseRatio;
};
protoOf(Fund).n3x = function (name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio) {
  return new Fund(name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio);
};
protoOf(Fund).copy = function (name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio, $super) {
  name = name === VOID ? this.name : name;
  ticker = ticker === VOID ? this.ticker : ticker;
  marketCap = marketCap === VOID ? this.marketCap : marketCap;
  sharePrice = sharePrice === VOID ? this.sharePrice : sharePrice;
  totalShares = totalShares === VOID ? this.totalShares : totalShares;
  availableShares = availableShares === VOID ? this.availableShares : availableShares;
  expenseRatio = expenseRatio === VOID ? this.expenseRatio : expenseRatio;
  return $super === VOID ? this.n3x(name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio) : $super.n3x.call(this, name, ticker, marketCap, sharePrice, totalShares, availableShares, expenseRatio);
};
protoOf(Fund).toString = function () {
  return 'Fund(name=' + this.name + ', ticker=' + this.ticker + ', marketCap=' + this.marketCap + ', sharePrice=' + this.sharePrice + ', totalShares=' + this.totalShares + ', availableShares=' + this.availableShares + ', expenseRatio=' + this.expenseRatio + ')';
};
protoOf(Fund).hashCode = function () {
  var result = this.name == null ? 0 : getStringHashCode(this.name);
  result = imul(result, 31) + (this.ticker == null ? 0 : getStringHashCode(this.ticker)) | 0;
  result = imul(result, 31) + (this.marketCap == null ? 0 : getNumberHashCode(this.marketCap)) | 0;
  result = imul(result, 31) + (this.sharePrice == null ? 0 : getNumberHashCode(this.sharePrice)) | 0;
  result = imul(result, 31) + (this.totalShares == null ? 0 : this.totalShares) | 0;
  result = imul(result, 31) + (this.availableShares == null ? 0 : this.availableShares) | 0;
  result = imul(result, 31) + (this.expenseRatio == null ? 0 : getNumberHashCode(this.expenseRatio)) | 0;
  return result;
};
protoOf(Fund).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Fund))
    return false;
  if (!(this.name == other.name))
    return false;
  if (!(this.ticker == other.ticker))
    return false;
  if (!equals(this.marketCap, other.marketCap))
    return false;
  if (!equals(this.sharePrice, other.sharePrice))
    return false;
  if (!(this.totalShares == other.totalShares))
    return false;
  if (!(this.availableShares == other.availableShares))
    return false;
  if (!equals(this.expenseRatio, other.expenseRatio))
    return false;
  return true;
};
function TickersResponse$Companion$$childSerializers$_anonymous__tm1tb4() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function Companion_31() {
  Companion_instance_31 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.o3x_1 = [lazy(tmp_0, TickersResponse$Companion$$childSerializers$_anonymous__tm1tb4)];
}
protoOf(Companion_31).o1c = function () {
  return $serializer_getInstance_16();
};
var Companion_instance_31;
function Companion_getInstance_34() {
  if (Companion_instance_31 == null)
    new Companion_31();
  return Companion_instance_31;
}
function $serializer_16() {
  $serializer_instance_16 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.funds.TickersResponse', this, 1);
  tmp0_serialDesc.k10('tickers', true);
  this.p3x_1 = tmp0_serialDesc;
}
protoOf($serializer_16).q3x = function (encoder, value) {
  var tmp0_desc = this.p3x_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_34().o3x_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.tickers == null)) {
    tmp1_output.lu(tmp0_desc, 0, tmp2_cached[0].w(), value.tickers);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_16).gp = function (encoder, value) {
  return this.q3x(encoder, value instanceof TickersResponse ? value : THROW_CCE());
};
protoOf($serializer_16).hp = function (decoder) {
  var tmp0_desc = this.p3x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  var tmp6_cached = Companion_getInstance_34().o3x_1;
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return TickersResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_16).fp = function () {
  return this.p3x_1;
};
protoOf($serializer_16).z10 = function () {
  var tmp0_cached = Companion_getInstance_34().o3x_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(tmp0_cached[0].w())];
};
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 == null)
    new $serializer_16();
  return $serializer_instance_16;
}
function TickersResponse_init_$Init$(seen0, tickers, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_16().p3x_1);
  }
  if (0 === (seen0 & 1))
    $this.tickers = null;
  else
    $this.tickers = tickers;
  return $this;
}
function TickersResponse_init_$Create$(seen0, tickers, serializationConstructorMarker) {
  return TickersResponse_init_$Init$(seen0, tickers, serializationConstructorMarker, objectCreate(protoOf(TickersResponse)));
}
function TickersResponse(tickers) {
  Companion_getInstance_34();
  tickers = tickers === VOID ? null : tickers;
  this.tickers = tickers;
}
protoOf(TickersResponse).r3x = function () {
  return this.tickers;
};
protoOf(TickersResponse).wf = function () {
  return this.tickers;
};
protoOf(TickersResponse).s3x = function (tickers) {
  return new TickersResponse(tickers);
};
protoOf(TickersResponse).copy = function (tickers, $super) {
  tickers = tickers === VOID ? this.tickers : tickers;
  return $super === VOID ? this.s3x(tickers) : $super.s3x.call(this, tickers);
};
protoOf(TickersResponse).toString = function () {
  return 'TickersResponse(tickers=' + toString(this.tickers) + ')';
};
protoOf(TickersResponse).hashCode = function () {
  return this.tickers == null ? 0 : hashCode(this.tickers);
};
protoOf(TickersResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TickersResponse))
    return false;
  if (!equals(this.tickers, other.tickers))
    return false;
  return true;
};
function Companion_32() {
}
protoOf(Companion_32).o1c = function () {
  return $serializer_getInstance_17();
};
var Companion_instance_32;
function Companion_getInstance_35() {
  return Companion_instance_32;
}
function $serializer_17() {
  $serializer_instance_17 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.kyc.KycReferenceResponse', this, 1);
  tmp0_serialDesc.k10('reference', true);
  this.t3x_1 = tmp0_serialDesc;
}
protoOf($serializer_17).u3x = function (encoder, value) {
  var tmp0_desc = this.t3x_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.reference == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.reference);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_17).gp = function (encoder, value) {
  return this.u3x(encoder, value instanceof KycReferenceResponse ? value : THROW_CCE());
};
protoOf($serializer_17).hp = function (decoder) {
  var tmp0_desc = this.t3x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return KycReferenceResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_17).fp = function () {
  return this.t3x_1;
};
protoOf($serializer_17).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 == null)
    new $serializer_17();
  return $serializer_instance_17;
}
function KycReferenceResponse_init_$Init$(seen0, reference, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_17().t3x_1);
  }
  if (0 === (seen0 & 1))
    $this.reference = null;
  else
    $this.reference = reference;
  return $this;
}
function KycReferenceResponse_init_$Create$(seen0, reference, serializationConstructorMarker) {
  return KycReferenceResponse_init_$Init$(seen0, reference, serializationConstructorMarker, objectCreate(protoOf(KycReferenceResponse)));
}
function KycReferenceResponse(reference) {
  reference = reference === VOID ? null : reference;
  this.reference = reference;
}
protoOf(KycReferenceResponse).v3x = function () {
  return this.reference;
};
protoOf(KycReferenceResponse).wf = function () {
  return this.reference;
};
protoOf(KycReferenceResponse).d3s = function (reference) {
  return new KycReferenceResponse(reference);
};
protoOf(KycReferenceResponse).copy = function (reference, $super) {
  reference = reference === VOID ? this.reference : reference;
  return $super === VOID ? this.d3s(reference) : $super.d3s.call(this, reference);
};
protoOf(KycReferenceResponse).toString = function () {
  return 'KycReferenceResponse(reference=' + this.reference + ')';
};
protoOf(KycReferenceResponse).hashCode = function () {
  return this.reference == null ? 0 : getStringHashCode(this.reference);
};
protoOf(KycReferenceResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof KycReferenceResponse))
    return false;
  if (!(this.reference == other.reference))
    return false;
  return true;
};
function Companion_33() {
}
protoOf(Companion_33).o1c = function () {
  return $serializer_getInstance_18();
};
var Companion_instance_33;
function Companion_getInstance_36() {
  return Companion_instance_33;
}
function $serializer_18() {
  $serializer_instance_18 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.kyc.ShuftiMobileConfigResponse', this, 2);
  tmp0_serialDesc.k10('journey_id', false);
  tmp0_serialDesc.k10('form_uuid', false);
  this.w3x_1 = tmp0_serialDesc;
}
protoOf($serializer_18).x3x = function (encoder, value) {
  var tmp0_desc = this.w3x_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.journeyId);
  tmp1_output.hu(tmp0_desc, 1, value.formUuid);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_18).gp = function (encoder, value) {
  return this.x3x(encoder, value instanceof ShuftiMobileConfigResponse ? value : THROW_CCE());
};
protoOf($serializer_18).hp = function (decoder) {
  var tmp0_desc = this.w3x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return ShuftiMobileConfigResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_18).fp = function () {
  return this.w3x_1;
};
protoOf($serializer_18).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_18;
function $serializer_getInstance_18() {
  if ($serializer_instance_18 == null)
    new $serializer_18();
  return $serializer_instance_18;
}
function ShuftiMobileConfigResponse_init_$Init$(seen0, journeyId, formUuid, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_18().w3x_1);
  }
  $this.journeyId = journeyId;
  $this.formUuid = formUuid;
  return $this;
}
function ShuftiMobileConfigResponse_init_$Create$(seen0, journeyId, formUuid, serializationConstructorMarker) {
  return ShuftiMobileConfigResponse_init_$Init$(seen0, journeyId, formUuid, serializationConstructorMarker, objectCreate(protoOf(ShuftiMobileConfigResponse)));
}
function ShuftiMobileConfigResponse(journeyId, formUuid) {
  this.journeyId = journeyId;
  this.formUuid = formUuid;
}
protoOf(ShuftiMobileConfigResponse).y3x = function () {
  return this.journeyId;
};
protoOf(ShuftiMobileConfigResponse).z3x = function () {
  return this.formUuid;
};
protoOf(ShuftiMobileConfigResponse).wf = function () {
  return this.journeyId;
};
protoOf(ShuftiMobileConfigResponse).xf = function () {
  return this.formUuid;
};
protoOf(ShuftiMobileConfigResponse).a3y = function (journeyId, formUuid) {
  return new ShuftiMobileConfigResponse(journeyId, formUuid);
};
protoOf(ShuftiMobileConfigResponse).copy = function (journeyId, formUuid, $super) {
  journeyId = journeyId === VOID ? this.journeyId : journeyId;
  formUuid = formUuid === VOID ? this.formUuid : formUuid;
  return $super === VOID ? this.a3y(journeyId, formUuid) : $super.a3y.call(this, journeyId, formUuid);
};
protoOf(ShuftiMobileConfigResponse).toString = function () {
  return 'ShuftiMobileConfigResponse(journeyId=' + this.journeyId + ', formUuid=' + this.formUuid + ')';
};
protoOf(ShuftiMobileConfigResponse).hashCode = function () {
  var result = getStringHashCode(this.journeyId);
  result = imul(result, 31) + getStringHashCode(this.formUuid) | 0;
  return result;
};
protoOf(ShuftiMobileConfigResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShuftiMobileConfigResponse))
    return false;
  if (!(this.journeyId === other.journeyId))
    return false;
  if (!(this.formUuid === other.formUuid))
    return false;
  return true;
};
function Companion_34() {
}
protoOf(Companion_34).o1c = function () {
  return $serializer_getInstance_19();
};
var Companion_instance_34;
function Companion_getInstance_37() {
  return Companion_instance_34;
}
function $serializer_19() {
  $serializer_instance_19 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.kyc.VerifyKycResponse.Success', this, 2);
  tmp0_serialDesc.k10('verificationUrl', false);
  tmp0_serialDesc.k10('reference', true);
  this.b3y_1 = tmp0_serialDesc;
}
protoOf($serializer_19).c3y = function (encoder, value) {
  var tmp0_desc = this.b3y_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.verificationUrl);
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.reference == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.reference);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_19).gp = function (encoder, value) {
  return this.c3y(encoder, value instanceof Success ? value : THROW_CCE());
};
protoOf($serializer_19).hp = function (decoder) {
  var tmp0_desc = this.b3y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return Success_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_19).fp = function () {
  return this.b3y_1;
};
protoOf($serializer_19).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_19;
function $serializer_getInstance_19() {
  if ($serializer_instance_19 == null)
    new $serializer_19();
  return $serializer_instance_19;
}
function Success_init_$Init$(seen0, verificationUrl, reference, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_19().b3y_1);
  }
  VerifyKycResponse.call($this);
  $this.verificationUrl = verificationUrl;
  if (0 === (seen0 & 2))
    $this.reference = null;
  else
    $this.reference = reference;
  return $this;
}
function Success_init_$Create$(seen0, verificationUrl, reference, serializationConstructorMarker) {
  return Success_init_$Init$(seen0, verificationUrl, reference, serializationConstructorMarker, objectCreate(protoOf(Success)));
}
function Companion_35() {
}
protoOf(Companion_35).o1c = function () {
  return $serializer_getInstance_20();
};
var Companion_instance_35;
function Companion_getInstance_38() {
  return Companion_instance_35;
}
function $serializer_20() {
  $serializer_instance_20 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.kyc.VerifyKycResponse.Error', this, 1);
  tmp0_serialDesc.k10('error', false);
  this.d3y_1 = tmp0_serialDesc;
}
protoOf($serializer_20).e3y = function (encoder, value) {
  var tmp0_desc = this.d3y_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_21(), value.error);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_20).gp = function (encoder, value) {
  return this.e3y(encoder, value instanceof Error_0 ? value : THROW_CCE());
};
protoOf($serializer_20).hp = function (decoder) {
  var tmp0_desc = this.d3y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_21(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_21(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Error_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_20).fp = function () {
  return this.d3y_1;
};
protoOf($serializer_20).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_21()];
};
var $serializer_instance_20;
function $serializer_getInstance_20() {
  if ($serializer_instance_20 == null)
    new $serializer_20();
  return $serializer_instance_20;
}
function Error_init_$Init$(seen0, error, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_20().d3y_1);
  }
  VerifyKycResponse.call($this);
  $this.error = error;
  return $this;
}
function Error_init_$Create$(seen0, error, serializationConstructorMarker) {
  return Error_init_$Init$(seen0, error, serializationConstructorMarker, objectCreate(protoOf(Error_0)));
}
function Success(verificationUrl, reference) {
  reference = reference === VOID ? null : reference;
  VerifyKycResponse.call(this);
  this.verificationUrl = verificationUrl;
  this.reference = reference;
}
protoOf(Success).f3y = function () {
  return this.verificationUrl;
};
protoOf(Success).v3x = function () {
  return this.reference;
};
protoOf(Success).wf = function () {
  return this.verificationUrl;
};
protoOf(Success).xf = function () {
  return this.reference;
};
protoOf(Success).g3y = function (verificationUrl, reference) {
  return new Success(verificationUrl, reference);
};
protoOf(Success).copy = function (verificationUrl, reference, $super) {
  verificationUrl = verificationUrl === VOID ? this.verificationUrl : verificationUrl;
  reference = reference === VOID ? this.reference : reference;
  return $super === VOID ? this.g3y(verificationUrl, reference) : $super.g3y.call(this, verificationUrl, reference);
};
protoOf(Success).toString = function () {
  return 'Success(verificationUrl=' + this.verificationUrl + ', reference=' + this.reference + ')';
};
protoOf(Success).hashCode = function () {
  var result = getStringHashCode(this.verificationUrl);
  result = imul(result, 31) + (this.reference == null ? 0 : getStringHashCode(this.reference)) | 0;
  return result;
};
protoOf(Success).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Success))
    return false;
  if (!(this.verificationUrl === other.verificationUrl))
    return false;
  if (!(this.reference == other.reference))
    return false;
  return true;
};
function Error_0(error) {
  VerifyKycResponse.call(this);
  this.error = error;
}
protoOf(Error_0).h3y = function () {
  return this.error;
};
protoOf(Error_0).wf = function () {
  return this.error;
};
protoOf(Error_0).i3y = function (error) {
  return new Error_0(error);
};
protoOf(Error_0).copy = function (error, $super) {
  error = error === VOID ? this.error : error;
  return $super === VOID ? this.i3y(error) : $super.i3y.call(this, error);
};
protoOf(Error_0).toString = function () {
  return 'Error(error=' + this.error.toString() + ')';
};
protoOf(Error_0).hashCode = function () {
  return this.error.hashCode();
};
protoOf(Error_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Error_0))
    return false;
  if (!this.error.equals(other.error))
    return false;
  return true;
};
function Companion_36() {
}
protoOf(Companion_36).o1c = function () {
  return VerifyKycResponseSerializer_getInstance();
};
var Companion_instance_36;
function Companion_getInstance_39() {
  return Companion_instance_36;
}
function VerifyKycResponse() {
}
function Companion_37() {
}
protoOf(Companion_37).o1c = function () {
  return $serializer_getInstance_21();
};
var Companion_instance_37;
function Companion_getInstance_40() {
  return Companion_instance_37;
}
function $serializer_21() {
  $serializer_instance_21 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.kyc.VerifyKyErrorDetails', this, 3);
  tmp0_serialDesc.k10('key', false);
  tmp0_serialDesc.k10('message', false);
  tmp0_serialDesc.k10('service', false);
  this.j3y_1 = tmp0_serialDesc;
}
protoOf($serializer_21).k3y = function (encoder, value) {
  var tmp0_desc = this.j3y_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.key);
  tmp1_output.hu(tmp0_desc, 1, value.message);
  tmp1_output.hu(tmp0_desc, 2, value.service);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_21).gp = function (encoder, value) {
  return this.k3y(encoder, value instanceof VerifyKyErrorDetails ? value : THROW_CCE());
};
protoOf($serializer_21).hp = function (decoder) {
  var tmp0_desc = this.j3y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return VerifyKyErrorDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_21).fp = function () {
  return this.j3y_1;
};
protoOf($serializer_21).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_21;
function $serializer_getInstance_21() {
  if ($serializer_instance_21 == null)
    new $serializer_21();
  return $serializer_instance_21;
}
function VerifyKyErrorDetails_init_$Init$(seen0, key, message, service, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_21().j3y_1);
  }
  $this.key = key;
  $this.message = message;
  $this.service = service;
  return $this;
}
function VerifyKyErrorDetails_init_$Create$(seen0, key, message, service, serializationConstructorMarker) {
  return VerifyKyErrorDetails_init_$Init$(seen0, key, message, service, serializationConstructorMarker, objectCreate(protoOf(VerifyKyErrorDetails)));
}
function VerifyKyErrorDetails(key, message, service) {
  this.key = key;
  this.message = message;
  this.service = service;
}
protoOf(VerifyKyErrorDetails).v = function () {
  return this.key;
};
protoOf(VerifyKyErrorDetails).e = function () {
  return this.message;
};
protoOf(VerifyKyErrorDetails).l3y = function () {
  return this.service;
};
protoOf(VerifyKyErrorDetails).wf = function () {
  return this.key;
};
protoOf(VerifyKyErrorDetails).xf = function () {
  return this.message;
};
protoOf(VerifyKyErrorDetails).e3p = function () {
  return this.service;
};
protoOf(VerifyKyErrorDetails).m3y = function (key, message, service) {
  return new VerifyKyErrorDetails(key, message, service);
};
protoOf(VerifyKyErrorDetails).copy = function (key, message, service, $super) {
  key = key === VOID ? this.key : key;
  message = message === VOID ? this.message : message;
  service = service === VOID ? this.service : service;
  return $super === VOID ? this.m3y(key, message, service) : $super.m3y.call(this, key, message, service);
};
protoOf(VerifyKyErrorDetails).toString = function () {
  return 'VerifyKyErrorDetails(key=' + this.key + ', message=' + this.message + ', service=' + this.service + ')';
};
protoOf(VerifyKyErrorDetails).hashCode = function () {
  var result = getStringHashCode(this.key);
  result = imul(result, 31) + getStringHashCode(this.message) | 0;
  result = imul(result, 31) + getStringHashCode(this.service) | 0;
  return result;
};
protoOf(VerifyKyErrorDetails).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VerifyKyErrorDetails))
    return false;
  if (!(this.key === other.key))
    return false;
  if (!(this.message === other.message))
    return false;
  if (!(this.service === other.service))
    return false;
  return true;
};
function IPortfolio() {
}
function OverallPortfolio$Companion$$childSerializers$_anonymous__f3ab0x() {
  return new ArrayListSerializer($serializer_getInstance_23());
}
function OverallPortfolio$Companion$$childSerializers$_anonymous__f3ab0x_0() {
  return new ArrayListSerializer($serializer_getInstance_24());
}
function Companion_38() {
  Companion_instance_38 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, OverallPortfolio$Companion$$childSerializers$_anonymous__f3ab0x);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.q3y_1 = [null, null, null, null, null, null, tmp_1, lazy(tmp_2, OverallPortfolio$Companion$$childSerializers$_anonymous__f3ab0x_0)];
}
protoOf(Companion_38).empty = function () {
  return new OverallPortfolio(0.0, 0.0, 0.0, null, false, 0, emptyList(), emptyList());
};
protoOf(Companion_38).o1c = function () {
  return $serializer_getInstance_22();
};
var Companion_instance_38;
function Companion_getInstance_41() {
  if (Companion_instance_38 == null)
    new Companion_38();
  return Companion_instance_38;
}
function $serializer_22() {
  $serializer_instance_22 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.portfolio.OverallPortfolio', this, 8);
  tmp0_serialDesc.k10('totalValue', false);
  tmp0_serialDesc.k10('divAllTime', false);
  tmp0_serialDesc.k10('nextDivEst', false);
  tmp0_serialDesc.k10('nextPayDate', false);
  tmp0_serialDesc.k10('isEligibleForDividend', false);
  tmp0_serialDesc.k10('nonMaturedShares', false);
  tmp0_serialDesc.k10('estimatedDividend', false);
  tmp0_serialDesc.k10('position', false);
  this.r3y_1 = tmp0_serialDesc;
}
protoOf($serializer_22).s3y = function (encoder, value) {
  var tmp0_desc = this.r3y_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_41().q3y_1;
  tmp1_output.eu(tmp0_desc, 0, value.t3y_1);
  tmp1_output.eu(tmp0_desc, 1, value.u3y_1);
  tmp1_output.eu(tmp0_desc, 2, value.v3y_1);
  tmp1_output.lu(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), value.nextPayDate);
  tmp1_output.zt(tmp0_desc, 4, value.isEligibleForDividend);
  tmp1_output.cu(tmp0_desc, 5, value.nonMaturedShares);
  tmp1_output.ju(tmp0_desc, 6, tmp2_cached[6].w(), value.estimatedDividend);
  tmp1_output.ju(tmp0_desc, 7, tmp2_cached[7].w(), value.position);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_22).gp = function (encoder, value) {
  return this.s3y(encoder, value instanceof OverallPortfolio ? value : THROW_CCE());
};
protoOf($serializer_22).hp = function (decoder) {
  var tmp0_desc = this.r3y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = null;
  var tmp8_local4 = false;
  var tmp9_local5 = 0;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_input = decoder.ss(tmp0_desc);
  var tmp13_cached = Companion_getInstance_41().q3y_1;
  if (tmp12_input.it()) {
    tmp4_local0 = tmp12_input.zs(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp12_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp12_input.zs(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp12_input.gt(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp12_input.us(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp12_input.xs(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp12_input.et(tmp0_desc, 6, tmp13_cached[6].w(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp12_input.et(tmp0_desc, 7, tmp13_cached[7].w(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp12_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp12_input.zs(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp12_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp12_input.zs(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp12_input.gt(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp12_input.us(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp12_input.xs(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp12_input.et(tmp0_desc, 6, tmp13_cached[6].w(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp12_input.et(tmp0_desc, 7, tmp13_cached[7].w(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp12_input.ts(tmp0_desc);
  return OverallPortfolio_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
};
protoOf($serializer_22).fp = function () {
  return this.r3y_1;
};
protoOf($serializer_22).z10 = function () {
  var tmp0_cached = Companion_getInstance_41().q3y_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), get_nullable(IsoTimestampSerializer_getInstance()), BooleanSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[6].w(), tmp0_cached[7].w()];
};
var $serializer_instance_22;
function $serializer_getInstance_22() {
  if ($serializer_instance_22 == null)
    new $serializer_22();
  return $serializer_instance_22;
}
function OverallPortfolio_init_$Init$(seen0, totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position, serializationConstructorMarker, $this) {
  if (!(255 === (255 & seen0))) {
    throwMissingFieldException(seen0, 255, $serializer_getInstance_22().r3y_1);
  }
  $this.t3y_1 = totalValue;
  $this.u3y_1 = divAllTime;
  $this.v3y_1 = nextDivEst;
  $this.nextPayDate = nextPayDate;
  $this.isEligibleForDividend = isEligibleForDividend;
  $this.nonMaturedShares = nonMaturedShares;
  $this.estimatedDividend = estimatedDividend;
  $this.position = position;
  return $this;
}
function OverallPortfolio_init_$Create$(seen0, totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position, serializationConstructorMarker) {
  return OverallPortfolio_init_$Init$(seen0, totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position, serializationConstructorMarker, objectCreate(protoOf(OverallPortfolio)));
}
function OverallPortfolio(totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position) {
  Companion_getInstance_41();
  this.t3y_1 = totalValue;
  this.u3y_1 = divAllTime;
  this.v3y_1 = nextDivEst;
  this.nextPayDate = nextPayDate;
  this.isEligibleForDividend = isEligibleForDividend;
  this.nonMaturedShares = nonMaturedShares;
  this.estimatedDividend = estimatedDividend;
  this.position = position;
}
protoOf(OverallPortfolio).n3y = function () {
  return this.t3y_1;
};
protoOf(OverallPortfolio).o3y = function () {
  return this.u3y_1;
};
protoOf(OverallPortfolio).p3y = function () {
  return this.v3y_1;
};
protoOf(OverallPortfolio).w3y = function () {
  return this.nextPayDate;
};
protoOf(OverallPortfolio).x3y = function () {
  return this.isEligibleForDividend;
};
protoOf(OverallPortfolio).y3y = function () {
  return this.nonMaturedShares;
};
protoOf(OverallPortfolio).p3v = function () {
  return this.estimatedDividend;
};
protoOf(OverallPortfolio).z3y = function () {
  return this.position;
};
protoOf(OverallPortfolio).wf = function () {
  return this.t3y_1;
};
protoOf(OverallPortfolio).xf = function () {
  return this.u3y_1;
};
protoOf(OverallPortfolio).e3p = function () {
  return this.v3y_1;
};
protoOf(OverallPortfolio).f3p = function () {
  return this.nextPayDate;
};
protoOf(OverallPortfolio).u3q = function () {
  return this.isEligibleForDividend;
};
protoOf(OverallPortfolio).v3q = function () {
  return this.nonMaturedShares;
};
protoOf(OverallPortfolio).w3q = function () {
  return this.estimatedDividend;
};
protoOf(OverallPortfolio).x3q = function () {
  return this.position;
};
protoOf(OverallPortfolio).a3z = function (totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position) {
  return new OverallPortfolio(totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position);
};
protoOf(OverallPortfolio).copy = function (totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position, $super) {
  totalValue = totalValue === VOID ? this.t3y_1 : totalValue;
  divAllTime = divAllTime === VOID ? this.u3y_1 : divAllTime;
  nextDivEst = nextDivEst === VOID ? this.v3y_1 : nextDivEst;
  nextPayDate = nextPayDate === VOID ? this.nextPayDate : nextPayDate;
  isEligibleForDividend = isEligibleForDividend === VOID ? this.isEligibleForDividend : isEligibleForDividend;
  nonMaturedShares = nonMaturedShares === VOID ? this.nonMaturedShares : nonMaturedShares;
  estimatedDividend = estimatedDividend === VOID ? this.estimatedDividend : estimatedDividend;
  position = position === VOID ? this.position : position;
  return $super === VOID ? this.a3z(totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position) : $super.a3z.call(this, totalValue, divAllTime, nextDivEst, nextPayDate, isEligibleForDividend, nonMaturedShares, estimatedDividend, position);
};
protoOf(OverallPortfolio).toString = function () {
  return 'OverallPortfolio(totalValue=' + this.t3y_1 + ', divAllTime=' + this.u3y_1 + ', nextDivEst=' + this.v3y_1 + ', nextPayDate=' + toString(this.nextPayDate) + ', isEligibleForDividend=' + this.isEligibleForDividend + ', nonMaturedShares=' + this.nonMaturedShares + ', estimatedDividend=' + toString_0(this.estimatedDividend) + ', position=' + toString_0(this.position) + ')';
};
protoOf(OverallPortfolio).hashCode = function () {
  var result = getNumberHashCode(this.t3y_1);
  result = imul(result, 31) + getNumberHashCode(this.u3y_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.v3y_1) | 0;
  result = imul(result, 31) + (this.nextPayDate == null ? 0 : this.nextPayDate.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.isEligibleForDividend) | 0;
  result = imul(result, 31) + this.nonMaturedShares | 0;
  result = imul(result, 31) + hashCode(this.estimatedDividend) | 0;
  result = imul(result, 31) + hashCode(this.position) | 0;
  return result;
};
protoOf(OverallPortfolio).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof OverallPortfolio))
    return false;
  if (!equals(this.t3y_1, other.t3y_1))
    return false;
  if (!equals(this.u3y_1, other.u3y_1))
    return false;
  if (!equals(this.v3y_1, other.v3y_1))
    return false;
  if (!equals(this.nextPayDate, other.nextPayDate))
    return false;
  if (!(this.isEligibleForDividend === other.isEligibleForDividend))
    return false;
  if (!(this.nonMaturedShares === other.nonMaturedShares))
    return false;
  if (!equals(this.estimatedDividend, other.estimatedDividend))
    return false;
  if (!equals(this.position, other.position))
    return false;
  return true;
};
function Companion_39() {
}
protoOf(Companion_39).o1c = function () {
  return $serializer_getInstance_23();
};
var Companion_instance_39;
function Companion_getInstance_42() {
  return Companion_instance_39;
}
function $serializer_23() {
  $serializer_instance_23 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.portfolio.EstimatedDividend', this, 4);
  tmp0_serialDesc.k10('estimatedDividend', false);
  tmp0_serialDesc.k10('estimatedDividendHigh', false);
  tmp0_serialDesc.k10('estimatedDividendLow', false);
  tmp0_serialDesc.k10('payoutDate', false);
  this.b3z_1 = tmp0_serialDesc;
}
protoOf($serializer_23).c3z = function (encoder, value) {
  var tmp0_desc = this.b3z_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.eu(tmp0_desc, 0, value.estimatedDividend);
  tmp1_output.eu(tmp0_desc, 1, value.estimatedDividendHigh);
  tmp1_output.eu(tmp0_desc, 2, value.estimatedDividendLow);
  tmp1_output.ju(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), value.payoutDate);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_23).gp = function (encoder, value) {
  return this.c3z(encoder, value instanceof EstimatedDividend ? value : THROW_CCE());
};
protoOf($serializer_23).hp = function (decoder) {
  var tmp0_desc = this.b3z_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = null;
  var tmp8_input = decoder.ss(tmp0_desc);
  if (tmp8_input.it()) {
    tmp4_local0 = tmp8_input.zs(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.zs(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.zs(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.zs(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.ts(tmp0_desc);
  return EstimatedDividend_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_23).fp = function () {
  return this.b3z_1;
};
protoOf($serializer_23).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IsoTimestampSerializer_getInstance()];
};
var $serializer_instance_23;
function $serializer_getInstance_23() {
  if ($serializer_instance_23 == null)
    new $serializer_23();
  return $serializer_instance_23;
}
function EstimatedDividend_init_$Init$(seen0, estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_23().b3z_1);
  }
  $this.estimatedDividend = estimatedDividend;
  $this.estimatedDividendHigh = estimatedDividendHigh;
  $this.estimatedDividendLow = estimatedDividendLow;
  $this.payoutDate = payoutDate;
  return $this;
}
function EstimatedDividend_init_$Create$(seen0, estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate, serializationConstructorMarker) {
  return EstimatedDividend_init_$Init$(seen0, estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate, serializationConstructorMarker, objectCreate(protoOf(EstimatedDividend)));
}
function EstimatedDividend(estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate) {
  this.estimatedDividend = estimatedDividend;
  this.estimatedDividendHigh = estimatedDividendHigh;
  this.estimatedDividendLow = estimatedDividendLow;
  this.payoutDate = payoutDate;
}
protoOf(EstimatedDividend).p3v = function () {
  return this.estimatedDividend;
};
protoOf(EstimatedDividend).r3v = function () {
  return this.estimatedDividendHigh;
};
protoOf(EstimatedDividend).q3v = function () {
  return this.estimatedDividendLow;
};
protoOf(EstimatedDividend).k3v = function () {
  return this.payoutDate;
};
protoOf(EstimatedDividend).wf = function () {
  return this.estimatedDividend;
};
protoOf(EstimatedDividend).xf = function () {
  return this.estimatedDividendHigh;
};
protoOf(EstimatedDividend).e3p = function () {
  return this.estimatedDividendLow;
};
protoOf(EstimatedDividend).f3p = function () {
  return this.payoutDate;
};
protoOf(EstimatedDividend).d3z = function (estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate) {
  return new EstimatedDividend(estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate);
};
protoOf(EstimatedDividend).copy = function (estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate, $super) {
  estimatedDividend = estimatedDividend === VOID ? this.estimatedDividend : estimatedDividend;
  estimatedDividendHigh = estimatedDividendHigh === VOID ? this.estimatedDividendHigh : estimatedDividendHigh;
  estimatedDividendLow = estimatedDividendLow === VOID ? this.estimatedDividendLow : estimatedDividendLow;
  payoutDate = payoutDate === VOID ? this.payoutDate : payoutDate;
  return $super === VOID ? this.d3z(estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate) : $super.d3z.call(this, estimatedDividend, estimatedDividendHigh, estimatedDividendLow, payoutDate);
};
protoOf(EstimatedDividend).toString = function () {
  return 'EstimatedDividend(estimatedDividend=' + this.estimatedDividend + ', estimatedDividendHigh=' + this.estimatedDividendHigh + ', estimatedDividendLow=' + this.estimatedDividendLow + ', payoutDate=' + this.payoutDate.toString() + ')';
};
protoOf(EstimatedDividend).hashCode = function () {
  var result = getNumberHashCode(this.estimatedDividend);
  result = imul(result, 31) + getNumberHashCode(this.estimatedDividendHigh) | 0;
  result = imul(result, 31) + getNumberHashCode(this.estimatedDividendLow) | 0;
  result = imul(result, 31) + this.payoutDate.hashCode() | 0;
  return result;
};
protoOf(EstimatedDividend).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EstimatedDividend))
    return false;
  if (!equals(this.estimatedDividend, other.estimatedDividend))
    return false;
  if (!equals(this.estimatedDividendHigh, other.estimatedDividendHigh))
    return false;
  if (!equals(this.estimatedDividendLow, other.estimatedDividendLow))
    return false;
  if (!this.payoutDate.equals(other.payoutDate))
    return false;
  return true;
};
function Companion_40() {
}
protoOf(Companion_40).o1c = function () {
  return $serializer_getInstance_24();
};
var Companion_instance_40;
function Companion_getInstance_43() {
  return Companion_instance_40;
}
function $serializer_24() {
  $serializer_instance_24 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.portfolio.Position', this, 2);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('value', false);
  this.e3z_1 = tmp0_serialDesc;
}
protoOf($serializer_24).f3z = function (encoder, value) {
  var tmp0_desc = this.e3z_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.ticker);
  tmp1_output.eu(tmp0_desc, 1, value.value);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_24).gp = function (encoder, value) {
  return this.f3z(encoder, value instanceof Position ? value : THROW_CCE());
};
protoOf($serializer_24).hp = function (decoder) {
  var tmp0_desc = this.e3z_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0.0;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return Position_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_24).fp = function () {
  return this.e3z_1;
};
protoOf($serializer_24).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), FloatSerializer_getInstance()];
};
var $serializer_instance_24;
function $serializer_getInstance_24() {
  if ($serializer_instance_24 == null)
    new $serializer_24();
  return $serializer_instance_24;
}
function Position_init_$Init$(seen0, ticker, value, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_24().e3z_1);
  }
  $this.ticker = ticker;
  $this.value = value;
  return $this;
}
function Position_init_$Create$(seen0, ticker, value, serializationConstructorMarker) {
  return Position_init_$Init$(seen0, ticker, value, serializationConstructorMarker, objectCreate(protoOf(Position)));
}
function Position(ticker, value) {
  this.ticker = ticker;
  this.value = value;
}
protoOf(Position).f3v = function () {
  return this.ticker;
};
protoOf(Position).w = function () {
  return this.value;
};
protoOf(Position).wf = function () {
  return this.ticker;
};
protoOf(Position).xf = function () {
  return this.value;
};
protoOf(Position).g3z = function (ticker, value) {
  return new Position(ticker, value);
};
protoOf(Position).copy = function (ticker, value, $super) {
  ticker = ticker === VOID ? this.ticker : ticker;
  value = value === VOID ? this.value : value;
  return $super === VOID ? this.g3z(ticker, value) : $super.g3z.call(this, ticker, value);
};
protoOf(Position).toString = function () {
  return 'Position(ticker=' + this.ticker + ', value=' + this.value + ')';
};
protoOf(Position).hashCode = function () {
  var result = getStringHashCode(this.ticker);
  result = imul(result, 31) + getNumberHashCode(this.value) | 0;
  return result;
};
protoOf(Position).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Position))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!equals(this.value, other.value))
    return false;
  return true;
};
function Portfolio$Companion$$childSerializers$_anonymous__fozrj6() {
  return new ArrayListSerializer($serializer_getInstance_26());
}
function Portfolio$Companion$$childSerializers$_anonymous__fozrj6_0() {
  return new ArrayListSerializer($serializer_getInstance_14());
}
function Companion_41() {
  Companion_instance_41 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, Portfolio$Companion$$childSerializers$_anonymous__fozrj6);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.h3z_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, tmp_1, lazy(tmp_2, Portfolio$Companion$$childSerializers$_anonymous__fozrj6_0)];
}
protoOf(Companion_41).o1c = function () {
  return $serializer_getInstance_25();
};
var Companion_instance_41;
function Companion_getInstance_44() {
  if (Companion_instance_41 == null)
    new Companion_41();
  return Companion_instance_41;
}
function $serializer_25() {
  $serializer_instance_25 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.portfolio.Portfolio', this, 15);
  tmp0_serialDesc.k10('ticker', true);
  tmp0_serialDesc.k10('sharePrice', true);
  tmp0_serialDesc.k10('totalValue', true);
  tmp0_serialDesc.k10('totalShares', true);
  tmp0_serialDesc.k10('bankTransferFee', true);
  tmp0_serialDesc.k10('nextDivEst', true);
  tmp0_serialDesc.k10('nonMaturedShares', true);
  tmp0_serialDesc.k10('maxSell', true);
  tmp0_serialDesc.k10('nextPayDate', true);
  tmp0_serialDesc.k10('isEligibleForDividend', true);
  tmp0_serialDesc.k10('ytdDiv', true);
  tmp0_serialDesc.k10('divAllTime', true);
  tmp0_serialDesc.k10('totalDividendAmount', true);
  tmp0_serialDesc.k10('lots', true);
  tmp0_serialDesc.k10('dividends', true);
  this.i3z_1 = tmp0_serialDesc;
}
protoOf($serializer_25).j3z = function (encoder, value) {
  var tmp0_desc = this.i3z_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_44().h3z_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.ticker === '')) {
    tmp1_output.hu(tmp0_desc, 0, value.ticker);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !equals(value.sharePrice, 0.0)) {
    tmp1_output.eu(tmp0_desc, 1, value.sharePrice);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !equals(value.k3z_1, 0.0)) {
    tmp1_output.eu(tmp0_desc, 2, value.k3z_1);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.totalShares === 0)) {
    tmp1_output.cu(tmp0_desc, 3, value.totalShares);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !equals(value.bankTransferFee, 0.0)) {
    tmp1_output.eu(tmp0_desc, 4, value.bankTransferFee);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !equals(value.l3z_1, 0.0)) {
    tmp1_output.eu(tmp0_desc, 5, value.l3z_1);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.nonMaturedShares === 0)) {
    tmp1_output.cu(tmp0_desc, 6, value.nonMaturedShares);
  }
  if (tmp1_output.pu(tmp0_desc, 7) ? true : !(value.maxSell === 0)) {
    tmp1_output.cu(tmp0_desc, 7, value.maxSell);
  }
  if (tmp1_output.pu(tmp0_desc, 8) ? true : !(value.nextPayDate == null)) {
    tmp1_output.lu(tmp0_desc, 8, IsoTimestampSerializer_getInstance(), value.nextPayDate);
  }
  if (tmp1_output.pu(tmp0_desc, 9) ? true : !(value.isEligibleForDividend === false)) {
    tmp1_output.zt(tmp0_desc, 9, value.isEligibleForDividend);
  }
  if (tmp1_output.pu(tmp0_desc, 10) ? true : !(value.ytdDiv == null)) {
    tmp1_output.lu(tmp0_desc, 10, FloatSerializer_getInstance(), value.ytdDiv);
  }
  if (tmp1_output.pu(tmp0_desc, 11) ? true : !equals(value.m3z_1, 0.0)) {
    tmp1_output.eu(tmp0_desc, 11, value.m3z_1);
  }
  if (tmp1_output.pu(tmp0_desc, 12) ? true : !(value.totalDividendAmount == null)) {
    tmp1_output.lu(tmp0_desc, 12, FloatSerializer_getInstance(), value.totalDividendAmount);
  }
  if (tmp1_output.pu(tmp0_desc, 13) ? true : !equals(value.lots, emptyList())) {
    tmp1_output.ju(tmp0_desc, 13, tmp2_cached[13].w(), value.lots);
  }
  if (tmp1_output.pu(tmp0_desc, 14) ? true : !equals(value.dividends, emptyList())) {
    tmp1_output.ju(tmp0_desc, 14, tmp2_cached[14].w(), value.dividends);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_25).gp = function (encoder, value) {
  return this.j3z(encoder, value instanceof Portfolio ? value : THROW_CCE());
};
protoOf($serializer_25).hp = function (decoder) {
  var tmp0_desc = this.i3z_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0;
  var tmp8_local4 = 0.0;
  var tmp9_local5 = 0.0;
  var tmp10_local6 = 0;
  var tmp11_local7 = 0;
  var tmp12_local8 = null;
  var tmp13_local9 = false;
  var tmp14_local10 = null;
  var tmp15_local11 = 0.0;
  var tmp16_local12 = null;
  var tmp17_local13 = null;
  var tmp18_local14 = null;
  var tmp19_input = decoder.ss(tmp0_desc);
  var tmp20_cached = Companion_getInstance_44().h3z_1;
  if (tmp19_input.it()) {
    tmp4_local0 = tmp19_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp19_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp19_input.zs(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp19_input.xs(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp19_input.zs(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp19_input.zs(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp19_input.xs(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp19_input.xs(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp19_input.gt(tmp0_desc, 8, IsoTimestampSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp19_input.us(tmp0_desc, 9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp19_input.gt(tmp0_desc, 10, FloatSerializer_getInstance(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp19_input.zs(tmp0_desc, 11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp19_input.gt(tmp0_desc, 12, FloatSerializer_getInstance(), tmp16_local12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp19_input.et(tmp0_desc, 13, tmp20_cached[13].w(), tmp17_local13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp19_input.et(tmp0_desc, 14, tmp20_cached[14].w(), tmp18_local14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp19_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp19_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp19_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp19_input.zs(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp19_input.xs(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp19_input.zs(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp19_input.zs(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp19_input.xs(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp19_input.xs(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp19_input.gt(tmp0_desc, 8, IsoTimestampSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp19_input.us(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp19_input.gt(tmp0_desc, 10, FloatSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp19_input.zs(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp19_input.gt(tmp0_desc, 12, FloatSerializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp19_input.et(tmp0_desc, 13, tmp20_cached[13].w(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp19_input.et(tmp0_desc, 14, tmp20_cached[14].w(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp19_input.ts(tmp0_desc);
  return Portfolio_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
};
protoOf($serializer_25).fp = function () {
  return this.i3z_1;
};
protoOf($serializer_25).z10 = function () {
  var tmp0_cached = Companion_getInstance_44().h3z_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(IsoTimestampSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(FloatSerializer_getInstance()), FloatSerializer_getInstance(), get_nullable(FloatSerializer_getInstance()), tmp0_cached[13].w(), tmp0_cached[14].w()];
};
var $serializer_instance_25;
function $serializer_getInstance_25() {
  if ($serializer_instance_25 == null)
    new $serializer_25();
  return $serializer_instance_25;
}
function Portfolio_init_$Init$(seen0, ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_25().i3z_1);
  }
  if (0 === (seen0 & 1))
    $this.ticker = '';
  else
    $this.ticker = ticker;
  if (0 === (seen0 & 2))
    $this.sharePrice = 0.0;
  else
    $this.sharePrice = sharePrice;
  if (0 === (seen0 & 4))
    $this.k3z_1 = 0.0;
  else
    $this.k3z_1 = totalValue;
  if (0 === (seen0 & 8))
    $this.totalShares = 0;
  else
    $this.totalShares = totalShares;
  if (0 === (seen0 & 16))
    $this.bankTransferFee = 0.0;
  else
    $this.bankTransferFee = bankTransferFee;
  if (0 === (seen0 & 32))
    $this.l3z_1 = 0.0;
  else
    $this.l3z_1 = nextDivEst;
  if (0 === (seen0 & 64))
    $this.nonMaturedShares = 0;
  else
    $this.nonMaturedShares = nonMaturedShares;
  if (0 === (seen0 & 128))
    $this.maxSell = 0;
  else
    $this.maxSell = maxSell;
  if (0 === (seen0 & 256))
    $this.nextPayDate = null;
  else
    $this.nextPayDate = nextPayDate;
  if (0 === (seen0 & 512))
    $this.isEligibleForDividend = false;
  else
    $this.isEligibleForDividend = isEligibleForDividend;
  if (0 === (seen0 & 1024))
    $this.ytdDiv = null;
  else
    $this.ytdDiv = ytdDiv;
  if (0 === (seen0 & 2048))
    $this.m3z_1 = 0.0;
  else
    $this.m3z_1 = divAllTime;
  if (0 === (seen0 & 4096))
    $this.totalDividendAmount = null;
  else
    $this.totalDividendAmount = totalDividendAmount;
  if (0 === (seen0 & 8192))
    $this.lots = emptyList();
  else
    $this.lots = lots;
  if (0 === (seen0 & 16384))
    $this.dividends = emptyList();
  else
    $this.dividends = dividends;
  return $this;
}
function Portfolio_init_$Create$(seen0, ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends, serializationConstructorMarker) {
  return Portfolio_init_$Init$(seen0, ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends, serializationConstructorMarker, objectCreate(protoOf(Portfolio)));
}
function Portfolio(ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends) {
  Companion_getInstance_44();
  ticker = ticker === VOID ? '' : ticker;
  sharePrice = sharePrice === VOID ? 0.0 : sharePrice;
  totalValue = totalValue === VOID ? 0.0 : totalValue;
  totalShares = totalShares === VOID ? 0 : totalShares;
  bankTransferFee = bankTransferFee === VOID ? 0.0 : bankTransferFee;
  nextDivEst = nextDivEst === VOID ? 0.0 : nextDivEst;
  nonMaturedShares = nonMaturedShares === VOID ? 0 : nonMaturedShares;
  maxSell = maxSell === VOID ? 0 : maxSell;
  nextPayDate = nextPayDate === VOID ? null : nextPayDate;
  isEligibleForDividend = isEligibleForDividend === VOID ? false : isEligibleForDividend;
  ytdDiv = ytdDiv === VOID ? null : ytdDiv;
  divAllTime = divAllTime === VOID ? 0.0 : divAllTime;
  totalDividendAmount = totalDividendAmount === VOID ? null : totalDividendAmount;
  lots = lots === VOID ? emptyList() : lots;
  dividends = dividends === VOID ? emptyList() : dividends;
  this.ticker = ticker;
  this.sharePrice = sharePrice;
  this.k3z_1 = totalValue;
  this.totalShares = totalShares;
  this.bankTransferFee = bankTransferFee;
  this.l3z_1 = nextDivEst;
  this.nonMaturedShares = nonMaturedShares;
  this.maxSell = maxSell;
  this.nextPayDate = nextPayDate;
  this.isEligibleForDividend = isEligibleForDividend;
  this.ytdDiv = ytdDiv;
  this.m3z_1 = divAllTime;
  this.totalDividendAmount = totalDividendAmount;
  this.lots = lots;
  this.dividends = dividends;
}
protoOf(Portfolio).f3v = function () {
  return this.ticker;
};
protoOf(Portfolio).k3x = function () {
  return this.sharePrice;
};
protoOf(Portfolio).n3y = function () {
  return this.k3z_1;
};
protoOf(Portfolio).m3v = function () {
  return this.totalShares;
};
protoOf(Portfolio).n3z = function () {
  return this.bankTransferFee;
};
protoOf(Portfolio).p3y = function () {
  return this.l3z_1;
};
protoOf(Portfolio).y3y = function () {
  return this.nonMaturedShares;
};
protoOf(Portfolio).o3z = function () {
  return this.maxSell;
};
protoOf(Portfolio).w3y = function () {
  return this.nextPayDate;
};
protoOf(Portfolio).x3y = function () {
  return this.isEligibleForDividend;
};
protoOf(Portfolio).p3z = function () {
  return this.ytdDiv;
};
protoOf(Portfolio).o3y = function () {
  return this.m3z_1;
};
protoOf(Portfolio).q3z = function () {
  return this.totalDividendAmount;
};
protoOf(Portfolio).r3z = function () {
  return this.lots;
};
protoOf(Portfolio).s3z = function () {
  return this.dividends;
};
protoOf(Portfolio).wf = function () {
  return this.ticker;
};
protoOf(Portfolio).xf = function () {
  return this.sharePrice;
};
protoOf(Portfolio).e3p = function () {
  return this.k3z_1;
};
protoOf(Portfolio).f3p = function () {
  return this.totalShares;
};
protoOf(Portfolio).u3q = function () {
  return this.bankTransferFee;
};
protoOf(Portfolio).v3q = function () {
  return this.l3z_1;
};
protoOf(Portfolio).w3q = function () {
  return this.nonMaturedShares;
};
protoOf(Portfolio).x3q = function () {
  return this.maxSell;
};
protoOf(Portfolio).y3q = function () {
  return this.nextPayDate;
};
protoOf(Portfolio).z3q = function () {
  return this.isEligibleForDividend;
};
protoOf(Portfolio).a3r = function () {
  return this.ytdDiv;
};
protoOf(Portfolio).b3r = function () {
  return this.m3z_1;
};
protoOf(Portfolio).c3r = function () {
  return this.totalDividendAmount;
};
protoOf(Portfolio).d3r = function () {
  return this.lots;
};
protoOf(Portfolio).e3r = function () {
  return this.dividends;
};
protoOf(Portfolio).t3z = function (ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends) {
  return new Portfolio(ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends);
};
protoOf(Portfolio).copy = function (ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends, $super) {
  ticker = ticker === VOID ? this.ticker : ticker;
  sharePrice = sharePrice === VOID ? this.sharePrice : sharePrice;
  totalValue = totalValue === VOID ? this.k3z_1 : totalValue;
  totalShares = totalShares === VOID ? this.totalShares : totalShares;
  bankTransferFee = bankTransferFee === VOID ? this.bankTransferFee : bankTransferFee;
  nextDivEst = nextDivEst === VOID ? this.l3z_1 : nextDivEst;
  nonMaturedShares = nonMaturedShares === VOID ? this.nonMaturedShares : nonMaturedShares;
  maxSell = maxSell === VOID ? this.maxSell : maxSell;
  nextPayDate = nextPayDate === VOID ? this.nextPayDate : nextPayDate;
  isEligibleForDividend = isEligibleForDividend === VOID ? this.isEligibleForDividend : isEligibleForDividend;
  ytdDiv = ytdDiv === VOID ? this.ytdDiv : ytdDiv;
  divAllTime = divAllTime === VOID ? this.m3z_1 : divAllTime;
  totalDividendAmount = totalDividendAmount === VOID ? this.totalDividendAmount : totalDividendAmount;
  lots = lots === VOID ? this.lots : lots;
  dividends = dividends === VOID ? this.dividends : dividends;
  return $super === VOID ? this.t3z(ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends) : $super.t3z.call(this, ticker, sharePrice, totalValue, totalShares, bankTransferFee, nextDivEst, nonMaturedShares, maxSell, nextPayDate, isEligibleForDividend, ytdDiv, divAllTime, totalDividendAmount, lots, dividends);
};
protoOf(Portfolio).toString = function () {
  return 'Portfolio(ticker=' + this.ticker + ', sharePrice=' + this.sharePrice + ', totalValue=' + this.k3z_1 + ', totalShares=' + this.totalShares + ', bankTransferFee=' + this.bankTransferFee + ', nextDivEst=' + this.l3z_1 + ', nonMaturedShares=' + this.nonMaturedShares + ', maxSell=' + this.maxSell + ', nextPayDate=' + toString(this.nextPayDate) + ', isEligibleForDividend=' + this.isEligibleForDividend + ', ytdDiv=' + this.ytdDiv + ', divAllTime=' + this.m3z_1 + ', totalDividendAmount=' + this.totalDividendAmount + ', lots=' + toString_0(this.lots) + ', dividends=' + toString_0(this.dividends) + ')';
};
protoOf(Portfolio).hashCode = function () {
  var result = getStringHashCode(this.ticker);
  result = imul(result, 31) + getNumberHashCode(this.sharePrice) | 0;
  result = imul(result, 31) + getNumberHashCode(this.k3z_1) | 0;
  result = imul(result, 31) + this.totalShares | 0;
  result = imul(result, 31) + getNumberHashCode(this.bankTransferFee) | 0;
  result = imul(result, 31) + getNumberHashCode(this.l3z_1) | 0;
  result = imul(result, 31) + this.nonMaturedShares | 0;
  result = imul(result, 31) + this.maxSell | 0;
  result = imul(result, 31) + (this.nextPayDate == null ? 0 : this.nextPayDate.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.isEligibleForDividend) | 0;
  result = imul(result, 31) + (this.ytdDiv == null ? 0 : getNumberHashCode(this.ytdDiv)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.m3z_1) | 0;
  result = imul(result, 31) + (this.totalDividendAmount == null ? 0 : getNumberHashCode(this.totalDividendAmount)) | 0;
  result = imul(result, 31) + hashCode(this.lots) | 0;
  result = imul(result, 31) + hashCode(this.dividends) | 0;
  return result;
};
protoOf(Portfolio).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Portfolio))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!equals(this.sharePrice, other.sharePrice))
    return false;
  if (!equals(this.k3z_1, other.k3z_1))
    return false;
  if (!(this.totalShares === other.totalShares))
    return false;
  if (!equals(this.bankTransferFee, other.bankTransferFee))
    return false;
  if (!equals(this.l3z_1, other.l3z_1))
    return false;
  if (!(this.nonMaturedShares === other.nonMaturedShares))
    return false;
  if (!(this.maxSell === other.maxSell))
    return false;
  if (!equals(this.nextPayDate, other.nextPayDate))
    return false;
  if (!(this.isEligibleForDividend === other.isEligibleForDividend))
    return false;
  if (!equals(this.ytdDiv, other.ytdDiv))
    return false;
  if (!equals(this.m3z_1, other.m3z_1))
    return false;
  if (!equals(this.totalDividendAmount, other.totalDividendAmount))
    return false;
  if (!equals(this.lots, other.lots))
    return false;
  if (!equals(this.dividends, other.dividends))
    return false;
  return true;
};
function Companion_42() {
}
protoOf(Companion_42).o1c = function () {
  return $serializer_getInstance_26();
};
var Companion_instance_42;
function Companion_getInstance_45() {
  return Companion_instance_42;
}
function $serializer_26() {
  $serializer_instance_26 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.portfolio.LotDetail', this, 7);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('shares', false);
  tmp0_serialDesc.k10('date', false);
  tmp0_serialDesc.k10('maturationDate', false);
  tmp0_serialDesc.k10('isMatured', false);
  tmp0_serialDesc.k10('costBasis', false);
  tmp0_serialDesc.k10('gainLoss', false);
  this.u3z_1 = tmp0_serialDesc;
}
protoOf($serializer_26).v3z = function (encoder, value) {
  var tmp0_desc = this.u3z_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.ticker);
  tmp1_output.cu(tmp0_desc, 1, value.shares);
  tmp1_output.ju(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), value.date);
  tmp1_output.ju(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), value.maturationDate);
  tmp1_output.zt(tmp0_desc, 4, value.isMatured);
  tmp1_output.lu(tmp0_desc, 5, FloatSerializer_getInstance(), value.costBasis);
  tmp1_output.lu(tmp0_desc, 6, FloatSerializer_getInstance(), value.gainLoss);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_26).gp = function (encoder, value) {
  return this.v3z(encoder, value instanceof LotDetail ? value : THROW_CCE());
};
protoOf($serializer_26).hp = function (decoder) {
  var tmp0_desc = this.u3z_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = false;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.ss(tmp0_desc);
  if (tmp11_input.it()) {
    tmp4_local0 = tmp11_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.xs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.et(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.us(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.gt(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.gt(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.xs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.et(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.us(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.gt(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.gt(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.ts(tmp0_desc);
  return LotDetail_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_26).fp = function () {
  return this.u3z_1;
};
protoOf($serializer_26).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), IntSerializer_getInstance(), IsoTimestampSerializer_getInstance(), IsoTimestampSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance())];
};
var $serializer_instance_26;
function $serializer_getInstance_26() {
  if ($serializer_instance_26 == null)
    new $serializer_26();
  return $serializer_instance_26;
}
function LotDetail_init_$Init$(seen0, ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss, serializationConstructorMarker, $this) {
  if (!(127 === (127 & seen0))) {
    throwMissingFieldException(seen0, 127, $serializer_getInstance_26().u3z_1);
  }
  $this.ticker = ticker;
  $this.shares = shares;
  $this.date = date;
  $this.maturationDate = maturationDate;
  $this.isMatured = isMatured;
  $this.costBasis = costBasis;
  $this.gainLoss = gainLoss;
  return $this;
}
function LotDetail_init_$Create$(seen0, ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss, serializationConstructorMarker) {
  return LotDetail_init_$Init$(seen0, ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss, serializationConstructorMarker, objectCreate(protoOf(LotDetail)));
}
function LotDetail(ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss) {
  this.ticker = ticker;
  this.shares = shares;
  this.date = date;
  this.maturationDate = maturationDate;
  this.isMatured = isMatured;
  this.costBasis = costBasis;
  this.gainLoss = gainLoss;
}
protoOf(LotDetail).f3v = function () {
  return this.ticker;
};
protoOf(LotDetail).w3z = function () {
  return this.shares;
};
protoOf(LotDetail).x3z = function () {
  return this.date;
};
protoOf(LotDetail).s3w = function () {
  return this.maturationDate;
};
protoOf(LotDetail).y3z = function () {
  return this.isMatured;
};
protoOf(LotDetail).z3z = function () {
  return this.costBasis;
};
protoOf(LotDetail).a40 = function () {
  return this.gainLoss;
};
protoOf(LotDetail).wf = function () {
  return this.ticker;
};
protoOf(LotDetail).xf = function () {
  return this.shares;
};
protoOf(LotDetail).e3p = function () {
  return this.date;
};
protoOf(LotDetail).f3p = function () {
  return this.maturationDate;
};
protoOf(LotDetail).u3q = function () {
  return this.isMatured;
};
protoOf(LotDetail).v3q = function () {
  return this.costBasis;
};
protoOf(LotDetail).w3q = function () {
  return this.gainLoss;
};
protoOf(LotDetail).b40 = function (ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss) {
  return new LotDetail(ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss);
};
protoOf(LotDetail).copy = function (ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss, $super) {
  ticker = ticker === VOID ? this.ticker : ticker;
  shares = shares === VOID ? this.shares : shares;
  date = date === VOID ? this.date : date;
  maturationDate = maturationDate === VOID ? this.maturationDate : maturationDate;
  isMatured = isMatured === VOID ? this.isMatured : isMatured;
  costBasis = costBasis === VOID ? this.costBasis : costBasis;
  gainLoss = gainLoss === VOID ? this.gainLoss : gainLoss;
  return $super === VOID ? this.b40(ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss) : $super.b40.call(this, ticker, shares, date, maturationDate, isMatured, costBasis, gainLoss);
};
protoOf(LotDetail).toString = function () {
  return 'LotDetail(ticker=' + this.ticker + ', shares=' + this.shares + ', date=' + this.date.toString() + ', maturationDate=' + this.maturationDate.toString() + ', isMatured=' + this.isMatured + ', costBasis=' + this.costBasis + ', gainLoss=' + this.gainLoss + ')';
};
protoOf(LotDetail).hashCode = function () {
  var result = getStringHashCode(this.ticker);
  result = imul(result, 31) + this.shares | 0;
  result = imul(result, 31) + this.date.hashCode() | 0;
  result = imul(result, 31) + this.maturationDate.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.isMatured) | 0;
  result = imul(result, 31) + (this.costBasis == null ? 0 : getNumberHashCode(this.costBasis)) | 0;
  result = imul(result, 31) + (this.gainLoss == null ? 0 : getNumberHashCode(this.gainLoss)) | 0;
  return result;
};
protoOf(LotDetail).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LotDetail))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!(this.shares === other.shares))
    return false;
  if (!this.date.equals(other.date))
    return false;
  if (!this.maturationDate.equals(other.maturationDate))
    return false;
  if (!(this.isMatured === other.isMatured))
    return false;
  if (!equals(this.costBasis, other.costBasis))
    return false;
  if (!equals(this.gainLoss, other.gainLoss))
    return false;
  return true;
};
function Companion_43() {
}
protoOf(Companion_43).o1c = function () {
  return $serializer_getInstance_27();
};
var Companion_instance_43;
function Companion_getInstance_46() {
  return Companion_instance_43;
}
function $serializer_27() {
  $serializer_instance_27 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.property.ChartPoint', this, 2);
  tmp0_serialDesc.k10('x', false);
  tmp0_serialDesc.k10('y', false);
  this.c40_1 = tmp0_serialDesc;
}
protoOf($serializer_27).d40 = function (encoder, value) {
  var tmp0_desc = this.c40_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.du(tmp0_desc, 0, value.x);
  tmp1_output.cu(tmp0_desc, 1, value.y);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_27).gp = function (encoder, value) {
  return this.d40(encoder, value instanceof ChartPoint ? value : THROW_CCE());
};
protoOf($serializer_27).hp = function (decoder) {
  var tmp0_desc = this.c40_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0n;
  var tmp5_local1 = 0;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.ys(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.xs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ys(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.xs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return ChartPoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_27).fp = function () {
  return this.c40_1;
};
protoOf($serializer_27).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_27;
function $serializer_getInstance_27() {
  if ($serializer_instance_27 == null)
    new $serializer_27();
  return $serializer_instance_27;
}
function ChartPoint_init_$Init$(seen0, x, y, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_27().c40_1);
  }
  $this.x = x;
  $this.y = y;
  return $this;
}
function ChartPoint_init_$Create$(seen0, x, y, serializationConstructorMarker) {
  return ChartPoint_init_$Init$(seen0, x, y, serializationConstructorMarker, objectCreate(protoOf(ChartPoint)));
}
function ChartPoint(x, y) {
  this.x = x;
  this.y = y;
}
protoOf(ChartPoint).e40 = function () {
  return this.x;
};
protoOf(ChartPoint).f40 = function () {
  return this.y;
};
protoOf(ChartPoint).wf = function () {
  return this.x;
};
protoOf(ChartPoint).xf = function () {
  return this.y;
};
protoOf(ChartPoint).g40 = function (x, y) {
  return new ChartPoint(x, y);
};
protoOf(ChartPoint).copy = function (x, y, $super) {
  x = x === VOID ? this.x : x;
  y = y === VOID ? this.y : y;
  return $super === VOID ? this.g40(x, y) : $super.g40.call(this, x, y);
};
protoOf(ChartPoint).toString = function () {
  return 'ChartPoint(x=' + this.x.toString() + ', y=' + this.y + ')';
};
protoOf(ChartPoint).hashCode = function () {
  var result = getBigIntHashCode(this.x);
  result = imul(result, 31) + this.y | 0;
  return result;
};
protoOf(ChartPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ChartPoint))
    return false;
  if (!(this.x === other.x))
    return false;
  if (!(this.y === other.y))
    return false;
  return true;
};
function Companion_44() {
}
protoOf(Companion_44).o1c = function () {
  return $serializer_getInstance_28();
};
var Companion_instance_44;
function Companion_getInstance_47() {
  return Companion_instance_44;
}
function $serializer_28() {
  $serializer_instance_28 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.property.CreatePropertyRequest', this, 3);
  tmp0_serialDesc.k10('name', false);
  tmp0_serialDesc.k10('name_alt', false);
  tmp0_serialDesc.k10('property_type', false);
  this.h40_1 = tmp0_serialDesc;
}
protoOf($serializer_28).i40 = function (encoder, value) {
  var tmp0_desc = this.h40_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.name);
  tmp1_output.hu(tmp0_desc, 1, value.nameAlt);
  tmp1_output.hu(tmp0_desc, 2, value.propertyType);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_28).gp = function (encoder, value) {
  return this.i40(encoder, value instanceof CreatePropertyRequest ? value : THROW_CCE());
};
protoOf($serializer_28).hp = function (decoder) {
  var tmp0_desc = this.h40_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return CreatePropertyRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_28).fp = function () {
  return this.h40_1;
};
protoOf($serializer_28).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_28;
function $serializer_getInstance_28() {
  if ($serializer_instance_28 == null)
    new $serializer_28();
  return $serializer_instance_28;
}
function CreatePropertyRequest_init_$Init$(seen0, name, nameAlt, propertyType, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_28().h40_1);
  }
  $this.name = name;
  $this.nameAlt = nameAlt;
  $this.propertyType = propertyType;
  return $this;
}
function CreatePropertyRequest_init_$Create$(seen0, name, nameAlt, propertyType, serializationConstructorMarker) {
  return CreatePropertyRequest_init_$Init$(seen0, name, nameAlt, propertyType, serializationConstructorMarker, objectCreate(protoOf(CreatePropertyRequest)));
}
function CreatePropertyRequest(name, nameAlt, propertyType) {
  this.name = name;
  this.nameAlt = nameAlt;
  this.propertyType = propertyType;
}
protoOf(CreatePropertyRequest).k2 = function () {
  return this.name;
};
protoOf(CreatePropertyRequest).j40 = function () {
  return this.nameAlt;
};
protoOf(CreatePropertyRequest).k40 = function () {
  return this.propertyType;
};
protoOf(CreatePropertyRequest).wf = function () {
  return this.name;
};
protoOf(CreatePropertyRequest).xf = function () {
  return this.nameAlt;
};
protoOf(CreatePropertyRequest).e3p = function () {
  return this.propertyType;
};
protoOf(CreatePropertyRequest).m3y = function (name, nameAlt, propertyType) {
  return new CreatePropertyRequest(name, nameAlt, propertyType);
};
protoOf(CreatePropertyRequest).copy = function (name, nameAlt, propertyType, $super) {
  name = name === VOID ? this.name : name;
  nameAlt = nameAlt === VOID ? this.nameAlt : nameAlt;
  propertyType = propertyType === VOID ? this.propertyType : propertyType;
  return $super === VOID ? this.m3y(name, nameAlt, propertyType) : $super.m3y.call(this, name, nameAlt, propertyType);
};
protoOf(CreatePropertyRequest).toString = function () {
  return 'CreatePropertyRequest(name=' + this.name + ', nameAlt=' + this.nameAlt + ', propertyType=' + this.propertyType + ')';
};
protoOf(CreatePropertyRequest).hashCode = function () {
  var result = getStringHashCode(this.name);
  result = imul(result, 31) + getStringHashCode(this.nameAlt) | 0;
  result = imul(result, 31) + getStringHashCode(this.propertyType) | 0;
  return result;
};
protoOf(CreatePropertyRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CreatePropertyRequest))
    return false;
  if (!(this.name === other.name))
    return false;
  if (!(this.nameAlt === other.nameAlt))
    return false;
  if (!(this.propertyType === other.propertyType))
    return false;
  return true;
};
function Companion_45() {
}
protoOf(Companion_45).o1c = function () {
  return $serializer_getInstance_29();
};
var Companion_instance_45;
function Companion_getInstance_48() {
  return Companion_instance_45;
}
function $serializer_29() {
  $serializer_instance_29 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.property.CreatePropertyResponse', this, 1);
  tmp0_serialDesc.k10('id', false);
  this.l40_1 = tmp0_serialDesc;
}
protoOf($serializer_29).m40 = function (encoder, value) {
  var tmp0_desc = this.l40_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.id);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_29).gp = function (encoder, value) {
  return this.m40(encoder, value instanceof CreatePropertyResponse ? value : THROW_CCE());
};
protoOf($serializer_29).hp = function (decoder) {
  var tmp0_desc = this.l40_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return CreatePropertyResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_29).fp = function () {
  return this.l40_1;
};
protoOf($serializer_29).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_29;
function $serializer_getInstance_29() {
  if ($serializer_instance_29 == null)
    new $serializer_29();
  return $serializer_instance_29;
}
function CreatePropertyResponse_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_29().l40_1);
  }
  $this.id = id;
  return $this;
}
function CreatePropertyResponse_init_$Create$(seen0, id, serializationConstructorMarker) {
  return CreatePropertyResponse_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(CreatePropertyResponse)));
}
function CreatePropertyResponse(id) {
  this.id = id;
}
protoOf(CreatePropertyResponse).l3t = function () {
  return this.id;
};
protoOf(CreatePropertyResponse).wf = function () {
  return this.id;
};
protoOf(CreatePropertyResponse).s3t = function (id) {
  return new CreatePropertyResponse(id);
};
protoOf(CreatePropertyResponse).copy = function (id, $super) {
  id = id === VOID ? this.id : id;
  return $super === VOID ? this.s3t(id) : $super.s3t.call(this, id);
};
protoOf(CreatePropertyResponse).toString = function () {
  return 'CreatePropertyResponse(id=' + this.id + ')';
};
protoOf(CreatePropertyResponse).hashCode = function () {
  return getStringHashCode(this.id);
};
protoOf(CreatePropertyResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CreatePropertyResponse))
    return false;
  if (!(this.id === other.id))
    return false;
  return true;
};
function Companion_46() {
}
protoOf(Companion_46).o1c = function () {
  return $serializer_getInstance_30();
};
var Companion_instance_46;
function Companion_getInstance_49() {
  return Companion_instance_46;
}
function $serializer_30() {
  $serializer_instance_30 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.property.UploadHoldingsRequest', this, 19);
  tmp0_serialDesc.k10('id', false);
  tmp0_serialDesc.k10('annual_income', false);
  tmp0_serialDesc.k10('closing_date', false);
  tmp0_serialDesc.k10('holding_type', false);
  tmp0_serialDesc.k10('holding_value', false);
  tmp0_serialDesc.k10('interest_rate', false);
  tmp0_serialDesc.k10('loan_id', false);
  tmp0_serialDesc.k10('loan_type', false);
  tmp0_serialDesc.k10('maturation_date', false);
  tmp0_serialDesc.k10('name', false);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('updated_at', false);
  tmp0_serialDesc.k10('properties_value', false);
  tmp0_serialDesc.k10('term', false);
  tmp0_serialDesc.k10('payment_schedule', false);
  tmp0_serialDesc.k10('schedule_updated', false);
  tmp0_serialDesc.k10('market_value_local', false);
  tmp0_serialDesc.k10('units_total', false);
  tmp0_serialDesc.k10('units_occupied', false);
  this.n40_1 = tmp0_serialDesc;
}
protoOf($serializer_30).o40 = function (encoder, value) {
  var tmp0_desc = this.n40_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.id);
  tmp1_output.cu(tmp0_desc, 1, value.annualIncome);
  tmp1_output.hu(tmp0_desc, 2, value.closingDate);
  tmp1_output.hu(tmp0_desc, 3, value.holdingType);
  tmp1_output.cu(tmp0_desc, 4, value.holdingValue);
  tmp1_output.cu(tmp0_desc, 5, value.interestRate);
  tmp1_output.hu(tmp0_desc, 6, value.loanId);
  tmp1_output.hu(tmp0_desc, 7, value.loanType);
  tmp1_output.hu(tmp0_desc, 8, value.maturationDate);
  tmp1_output.hu(tmp0_desc, 9, value.name);
  tmp1_output.hu(tmp0_desc, 10, value.ticker);
  tmp1_output.hu(tmp0_desc, 11, value.updatedAt);
  tmp1_output.cu(tmp0_desc, 12, value.propertiesValue);
  tmp1_output.cu(tmp0_desc, 13, value.term);
  tmp1_output.hu(tmp0_desc, 14, value.paymentSchedule);
  tmp1_output.hu(tmp0_desc, 15, value.scheduleUpdated);
  tmp1_output.cu(tmp0_desc, 16, value.marketValueLocal);
  tmp1_output.cu(tmp0_desc, 17, value.unitsTotal);
  tmp1_output.cu(tmp0_desc, 18, value.unitsOccupied);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_30).gp = function (encoder, value) {
  return this.o40(encoder, value instanceof UploadHoldingsRequest ? value : THROW_CCE());
};
protoOf($serializer_30).hp = function (decoder) {
  var tmp0_desc = this.n40_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = 0;
  var tmp9_local5 = 0;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_local12 = 0;
  var tmp17_local13 = 0;
  var tmp18_local14 = null;
  var tmp19_local15 = null;
  var tmp20_local16 = 0;
  var tmp21_local17 = 0;
  var tmp22_local18 = 0;
  var tmp23_input = decoder.ss(tmp0_desc);
  if (tmp23_input.it()) {
    tmp4_local0 = tmp23_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp23_input.xs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp23_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp23_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp23_input.xs(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp23_input.xs(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp23_input.ct(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp23_input.ct(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp23_input.ct(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp23_input.ct(tmp0_desc, 9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp23_input.ct(tmp0_desc, 10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp23_input.ct(tmp0_desc, 11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp23_input.xs(tmp0_desc, 12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp23_input.xs(tmp0_desc, 13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp23_input.ct(tmp0_desc, 14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp23_input.ct(tmp0_desc, 15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp23_input.xs(tmp0_desc, 16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp21_local17 = tmp23_input.xs(tmp0_desc, 17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    tmp22_local18 = tmp23_input.xs(tmp0_desc, 18);
    tmp3_bitMask0 = tmp3_bitMask0 | 262144;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp23_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp23_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp23_input.xs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp23_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp23_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp23_input.xs(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp23_input.xs(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp23_input.ct(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp23_input.ct(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp23_input.ct(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp23_input.ct(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp23_input.ct(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp23_input.ct(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp23_input.xs(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp23_input.xs(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp23_input.ct(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp23_input.ct(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp23_input.xs(tmp0_desc, 16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp21_local17 = tmp23_input.xs(tmp0_desc, 17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        case 18:
          tmp22_local18 = tmp23_input.xs(tmp0_desc, 18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp23_input.ts(tmp0_desc);
  return UploadHoldingsRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, null);
};
protoOf($serializer_30).fp = function () {
  return this.n40_1;
};
protoOf($serializer_30).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_30;
function $serializer_getInstance_30() {
  if ($serializer_instance_30 == null)
    new $serializer_30();
  return $serializer_instance_30;
}
function UploadHoldingsRequest_init_$Init$(seen0, id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied, serializationConstructorMarker, $this) {
  if (!(524287 === (524287 & seen0))) {
    throwMissingFieldException(seen0, 524287, $serializer_getInstance_30().n40_1);
  }
  $this.id = id;
  $this.annualIncome = annualIncome;
  $this.closingDate = closingDate;
  $this.holdingType = holdingType;
  $this.holdingValue = holdingValue;
  $this.interestRate = interestRate;
  $this.loanId = loanId;
  $this.loanType = loanType;
  $this.maturationDate = maturationDate;
  $this.name = name;
  $this.ticker = ticker;
  $this.updatedAt = updatedAt;
  $this.propertiesValue = propertiesValue;
  $this.term = term;
  $this.paymentSchedule = paymentSchedule;
  $this.scheduleUpdated = scheduleUpdated;
  $this.marketValueLocal = marketValueLocal;
  $this.unitsTotal = unitsTotal;
  $this.unitsOccupied = unitsOccupied;
  return $this;
}
function UploadHoldingsRequest_init_$Create$(seen0, id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied, serializationConstructorMarker) {
  return UploadHoldingsRequest_init_$Init$(seen0, id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied, serializationConstructorMarker, objectCreate(protoOf(UploadHoldingsRequest)));
}
function UploadHoldingsRequest(id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied) {
  this.id = id;
  this.annualIncome = annualIncome;
  this.closingDate = closingDate;
  this.holdingType = holdingType;
  this.holdingValue = holdingValue;
  this.interestRate = interestRate;
  this.loanId = loanId;
  this.loanType = loanType;
  this.maturationDate = maturationDate;
  this.name = name;
  this.ticker = ticker;
  this.updatedAt = updatedAt;
  this.propertiesValue = propertiesValue;
  this.term = term;
  this.paymentSchedule = paymentSchedule;
  this.scheduleUpdated = scheduleUpdated;
  this.marketValueLocal = marketValueLocal;
  this.unitsTotal = unitsTotal;
  this.unitsOccupied = unitsOccupied;
}
protoOf(UploadHoldingsRequest).l3t = function () {
  return this.id;
};
protoOf(UploadHoldingsRequest).p40 = function () {
  return this.annualIncome;
};
protoOf(UploadHoldingsRequest).q40 = function () {
  return this.closingDate;
};
protoOf(UploadHoldingsRequest).r40 = function () {
  return this.holdingType;
};
protoOf(UploadHoldingsRequest).s40 = function () {
  return this.holdingValue;
};
protoOf(UploadHoldingsRequest).t40 = function () {
  return this.interestRate;
};
protoOf(UploadHoldingsRequest).u40 = function () {
  return this.loanId;
};
protoOf(UploadHoldingsRequest).v40 = function () {
  return this.loanType;
};
protoOf(UploadHoldingsRequest).s3w = function () {
  return this.maturationDate;
};
protoOf(UploadHoldingsRequest).k2 = function () {
  return this.name;
};
protoOf(UploadHoldingsRequest).f3v = function () {
  return this.ticker;
};
protoOf(UploadHoldingsRequest).w40 = function () {
  return this.updatedAt;
};
protoOf(UploadHoldingsRequest).x40 = function () {
  return this.propertiesValue;
};
protoOf(UploadHoldingsRequest).y40 = function () {
  return this.term;
};
protoOf(UploadHoldingsRequest).z40 = function () {
  return this.paymentSchedule;
};
protoOf(UploadHoldingsRequest).a41 = function () {
  return this.scheduleUpdated;
};
protoOf(UploadHoldingsRequest).b41 = function () {
  return this.marketValueLocal;
};
protoOf(UploadHoldingsRequest).c41 = function () {
  return this.unitsTotal;
};
protoOf(UploadHoldingsRequest).d41 = function () {
  return this.unitsOccupied;
};
protoOf(UploadHoldingsRequest).wf = function () {
  return this.id;
};
protoOf(UploadHoldingsRequest).xf = function () {
  return this.annualIncome;
};
protoOf(UploadHoldingsRequest).e3p = function () {
  return this.closingDate;
};
protoOf(UploadHoldingsRequest).f3p = function () {
  return this.holdingType;
};
protoOf(UploadHoldingsRequest).u3q = function () {
  return this.holdingValue;
};
protoOf(UploadHoldingsRequest).v3q = function () {
  return this.interestRate;
};
protoOf(UploadHoldingsRequest).w3q = function () {
  return this.loanId;
};
protoOf(UploadHoldingsRequest).x3q = function () {
  return this.loanType;
};
protoOf(UploadHoldingsRequest).y3q = function () {
  return this.maturationDate;
};
protoOf(UploadHoldingsRequest).z3q = function () {
  return this.name;
};
protoOf(UploadHoldingsRequest).a3r = function () {
  return this.ticker;
};
protoOf(UploadHoldingsRequest).b3r = function () {
  return this.updatedAt;
};
protoOf(UploadHoldingsRequest).c3r = function () {
  return this.propertiesValue;
};
protoOf(UploadHoldingsRequest).d3r = function () {
  return this.term;
};
protoOf(UploadHoldingsRequest).e3r = function () {
  return this.paymentSchedule;
};
protoOf(UploadHoldingsRequest).f3r = function () {
  return this.scheduleUpdated;
};
protoOf(UploadHoldingsRequest).g3r = function () {
  return this.marketValueLocal;
};
protoOf(UploadHoldingsRequest).h3r = function () {
  return this.unitsTotal;
};
protoOf(UploadHoldingsRequest).i3r = function () {
  return this.unitsOccupied;
};
protoOf(UploadHoldingsRequest).e41 = function (id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied) {
  return new UploadHoldingsRequest(id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied);
};
protoOf(UploadHoldingsRequest).copy = function (id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied, $super) {
  id = id === VOID ? this.id : id;
  annualIncome = annualIncome === VOID ? this.annualIncome : annualIncome;
  closingDate = closingDate === VOID ? this.closingDate : closingDate;
  holdingType = holdingType === VOID ? this.holdingType : holdingType;
  holdingValue = holdingValue === VOID ? this.holdingValue : holdingValue;
  interestRate = interestRate === VOID ? this.interestRate : interestRate;
  loanId = loanId === VOID ? this.loanId : loanId;
  loanType = loanType === VOID ? this.loanType : loanType;
  maturationDate = maturationDate === VOID ? this.maturationDate : maturationDate;
  name = name === VOID ? this.name : name;
  ticker = ticker === VOID ? this.ticker : ticker;
  updatedAt = updatedAt === VOID ? this.updatedAt : updatedAt;
  propertiesValue = propertiesValue === VOID ? this.propertiesValue : propertiesValue;
  term = term === VOID ? this.term : term;
  paymentSchedule = paymentSchedule === VOID ? this.paymentSchedule : paymentSchedule;
  scheduleUpdated = scheduleUpdated === VOID ? this.scheduleUpdated : scheduleUpdated;
  marketValueLocal = marketValueLocal === VOID ? this.marketValueLocal : marketValueLocal;
  unitsTotal = unitsTotal === VOID ? this.unitsTotal : unitsTotal;
  unitsOccupied = unitsOccupied === VOID ? this.unitsOccupied : unitsOccupied;
  return $super === VOID ? this.e41(id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied) : $super.e41.call(this, id, annualIncome, closingDate, holdingType, holdingValue, interestRate, loanId, loanType, maturationDate, name, ticker, updatedAt, propertiesValue, term, paymentSchedule, scheduleUpdated, marketValueLocal, unitsTotal, unitsOccupied);
};
protoOf(UploadHoldingsRequest).toString = function () {
  return 'UploadHoldingsRequest(id=' + this.id + ', annualIncome=' + this.annualIncome + ', closingDate=' + this.closingDate + ', holdingType=' + this.holdingType + ', holdingValue=' + this.holdingValue + ', interestRate=' + this.interestRate + ', loanId=' + this.loanId + ', loanType=' + this.loanType + ', maturationDate=' + this.maturationDate + ', name=' + this.name + ', ticker=' + this.ticker + ', updatedAt=' + this.updatedAt + ', propertiesValue=' + this.propertiesValue + ', term=' + this.term + ', paymentSchedule=' + this.paymentSchedule + ', scheduleUpdated=' + this.scheduleUpdated + ', marketValueLocal=' + this.marketValueLocal + ', unitsTotal=' + this.unitsTotal + ', unitsOccupied=' + this.unitsOccupied + ')';
};
protoOf(UploadHoldingsRequest).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + this.annualIncome | 0;
  result = imul(result, 31) + getStringHashCode(this.closingDate) | 0;
  result = imul(result, 31) + getStringHashCode(this.holdingType) | 0;
  result = imul(result, 31) + this.holdingValue | 0;
  result = imul(result, 31) + this.interestRate | 0;
  result = imul(result, 31) + getStringHashCode(this.loanId) | 0;
  result = imul(result, 31) + getStringHashCode(this.loanType) | 0;
  result = imul(result, 31) + getStringHashCode(this.maturationDate) | 0;
  result = imul(result, 31) + getStringHashCode(this.name) | 0;
  result = imul(result, 31) + getStringHashCode(this.ticker) | 0;
  result = imul(result, 31) + getStringHashCode(this.updatedAt) | 0;
  result = imul(result, 31) + this.propertiesValue | 0;
  result = imul(result, 31) + this.term | 0;
  result = imul(result, 31) + getStringHashCode(this.paymentSchedule) | 0;
  result = imul(result, 31) + getStringHashCode(this.scheduleUpdated) | 0;
  result = imul(result, 31) + this.marketValueLocal | 0;
  result = imul(result, 31) + this.unitsTotal | 0;
  result = imul(result, 31) + this.unitsOccupied | 0;
  return result;
};
protoOf(UploadHoldingsRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UploadHoldingsRequest))
    return false;
  if (!(this.id === other.id))
    return false;
  if (!(this.annualIncome === other.annualIncome))
    return false;
  if (!(this.closingDate === other.closingDate))
    return false;
  if (!(this.holdingType === other.holdingType))
    return false;
  if (!(this.holdingValue === other.holdingValue))
    return false;
  if (!(this.interestRate === other.interestRate))
    return false;
  if (!(this.loanId === other.loanId))
    return false;
  if (!(this.loanType === other.loanType))
    return false;
  if (!(this.maturationDate === other.maturationDate))
    return false;
  if (!(this.name === other.name))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!(this.updatedAt === other.updatedAt))
    return false;
  if (!(this.propertiesValue === other.propertiesValue))
    return false;
  if (!(this.term === other.term))
    return false;
  if (!(this.paymentSchedule === other.paymentSchedule))
    return false;
  if (!(this.scheduleUpdated === other.scheduleUpdated))
    return false;
  if (!(this.marketValueLocal === other.marketValueLocal))
    return false;
  if (!(this.unitsTotal === other.unitsTotal))
    return false;
  if (!(this.unitsOccupied === other.unitsOccupied))
    return false;
  return true;
};
function Companion_47() {
}
var Companion_instance_47;
function Companion_getInstance_50() {
  return Companion_instance_47;
}
function $serializer_31() {
  $serializer_instance_31 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes.Passwordless', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('passwordless'));
  this.f41_1 = tmp0_serialDesc;
}
protoOf($serializer_31).g41 = function (encoder, value) {
  var tmp0_desc = this.f41_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.h41_1, new AuthRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_37(), value.h41_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_31).gp = function (encoder, value) {
  return this.g41(encoder, value instanceof Passwordless ? value : THROW_CCE());
};
protoOf($serializer_31).hp = function (decoder) {
  var tmp0_desc = this.f41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Passwordless_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_31).fp = function () {
  return this.f41_1;
};
protoOf($serializer_31).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_37()];
};
var $serializer_instance_31;
function $serializer_getInstance_31() {
  if ($serializer_instance_31 == null)
    new $serializer_31();
  return $serializer_instance_31;
}
function Passwordless_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_31().f41_1);
  }
  if (0 === (seen0 & 1))
    $this.h41_1 = new AuthRoutes();
  else
    $this.h41_1 = parent;
  return $this;
}
function Passwordless_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Passwordless_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Passwordless)));
}
function Companion_48() {
}
var Companion_instance_48;
function Companion_getInstance_51() {
  return Companion_instance_48;
}
function $serializer_32() {
  $serializer_instance_32 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes.Verify', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('verify'));
  this.i41_1 = tmp0_serialDesc;
}
protoOf($serializer_32).j41 = function (encoder, value) {
  var tmp0_desc = this.i41_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.k41_1, new AuthRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_37(), value.k41_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_32).gp = function (encoder, value) {
  return this.j41(encoder, value instanceof Verify ? value : THROW_CCE());
};
protoOf($serializer_32).hp = function (decoder) {
  var tmp0_desc = this.i41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Verify_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_32).fp = function () {
  return this.i41_1;
};
protoOf($serializer_32).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_37()];
};
var $serializer_instance_32;
function $serializer_getInstance_32() {
  if ($serializer_instance_32 == null)
    new $serializer_32();
  return $serializer_instance_32;
}
function Verify_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_32().i41_1);
  }
  if (0 === (seen0 & 1))
    $this.k41_1 = new AuthRoutes();
  else
    $this.k41_1 = parent;
  return $this;
}
function Verify_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Verify_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Verify)));
}
function Companion_49() {
}
var Companion_instance_49;
function Companion_getInstance_52() {
  return Companion_instance_49;
}
function $serializer_33() {
  $serializer_instance_33 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes.Renew', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('renew'));
  this.l41_1 = tmp0_serialDesc;
}
protoOf($serializer_33).m41 = function (encoder, value) {
  var tmp0_desc = this.l41_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.n41_1, new AuthRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_37(), value.n41_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_33).gp = function (encoder, value) {
  return this.m41(encoder, value instanceof Renew ? value : THROW_CCE());
};
protoOf($serializer_33).hp = function (decoder) {
  var tmp0_desc = this.l41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Renew_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_33).fp = function () {
  return this.l41_1;
};
protoOf($serializer_33).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_37()];
};
var $serializer_instance_33;
function $serializer_getInstance_33() {
  if ($serializer_instance_33 == null)
    new $serializer_33();
  return $serializer_instance_33;
}
function Renew_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_33().l41_1);
  }
  if (0 === (seen0 & 1))
    $this.n41_1 = new AuthRoutes();
  else
    $this.n41_1 = parent;
  return $this;
}
function Renew_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Renew_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Renew)));
}
function Companion_50() {
}
var Companion_instance_50;
function Companion_getInstance_53() {
  return Companion_instance_50;
}
function $serializer_34() {
  $serializer_instance_34 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes.Profile', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('profile'));
  this.o41_1 = tmp0_serialDesc;
}
protoOf($serializer_34).p41 = function (encoder, value) {
  var tmp0_desc = this.o41_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.q41_1, new AuthRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_37(), value.q41_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_34).gp = function (encoder, value) {
  return this.p41(encoder, value instanceof Profile ? value : THROW_CCE());
};
protoOf($serializer_34).hp = function (decoder) {
  var tmp0_desc = this.o41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Profile_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_34).fp = function () {
  return this.o41_1;
};
protoOf($serializer_34).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_37()];
};
var $serializer_instance_34;
function $serializer_getInstance_34() {
  if ($serializer_instance_34 == null)
    new $serializer_34();
  return $serializer_instance_34;
}
function Profile_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_34().o41_1);
  }
  if (0 === (seen0 & 1))
    $this.q41_1 = new AuthRoutes();
  else
    $this.q41_1 = parent;
  return $this;
}
function Profile_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Profile_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Profile)));
}
function Companion_51() {
}
var Companion_instance_51;
function Companion_getInstance_54() {
  return Companion_instance_51;
}
function $serializer_35() {
  $serializer_instance_35 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes.ShuftiReference', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('shufti_reference'));
  this.r41_1 = tmp0_serialDesc;
}
protoOf($serializer_35).s41 = function (encoder, value) {
  var tmp0_desc = this.r41_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.t41_1, new AuthRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_37(), value.t41_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_35).gp = function (encoder, value) {
  return this.s41(encoder, value instanceof ShuftiReference ? value : THROW_CCE());
};
protoOf($serializer_35).hp = function (decoder) {
  var tmp0_desc = this.r41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return ShuftiReference_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_35).fp = function () {
  return this.r41_1;
};
protoOf($serializer_35).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_37()];
};
var $serializer_instance_35;
function $serializer_getInstance_35() {
  if ($serializer_instance_35 == null)
    new $serializer_35();
  return $serializer_instance_35;
}
function ShuftiReference_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_35().r41_1);
  }
  if (0 === (seen0 & 1))
    $this.t41_1 = new AuthRoutes();
  else
    $this.t41_1 = parent;
  return $this;
}
function ShuftiReference_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return ShuftiReference_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(ShuftiReference)));
}
function Companion_52() {
}
var Companion_instance_52;
function Companion_getInstance_55() {
  return Companion_instance_52;
}
function $serializer_36() {
  $serializer_instance_36 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes.ShuftiVerification', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('shufti_verification'));
  this.u41_1 = tmp0_serialDesc;
}
protoOf($serializer_36).v41 = function (encoder, value) {
  var tmp0_desc = this.u41_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.w41_1, new AuthRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_37(), value.w41_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_36).gp = function (encoder, value) {
  return this.v41(encoder, value instanceof ShuftiVerification ? value : THROW_CCE());
};
protoOf($serializer_36).hp = function (decoder) {
  var tmp0_desc = this.u41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_37(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return ShuftiVerification_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_36).fp = function () {
  return this.u41_1;
};
protoOf($serializer_36).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_37()];
};
var $serializer_instance_36;
function $serializer_getInstance_36() {
  if ($serializer_instance_36 == null)
    new $serializer_36();
  return $serializer_instance_36;
}
function ShuftiVerification_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_36().u41_1);
  }
  if (0 === (seen0 & 1))
    $this.w41_1 = new AuthRoutes();
  else
    $this.w41_1 = parent;
  return $this;
}
function ShuftiVerification_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return ShuftiVerification_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(ShuftiVerification)));
}
function Passwordless(parent) {
  parent = parent === VOID ? new AuthRoutes() : parent;
  this.h41_1 = parent;
}
protoOf(Passwordless).toString = function () {
  return 'Passwordless(parent=' + toString_0(this.h41_1) + ')';
};
protoOf(Passwordless).hashCode = function () {
  return hashCode(this.h41_1);
};
protoOf(Passwordless).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Passwordless))
    return false;
  if (!equals(this.h41_1, other.h41_1))
    return false;
  return true;
};
function Verify(parent) {
  parent = parent === VOID ? new AuthRoutes() : parent;
  this.k41_1 = parent;
}
protoOf(Verify).toString = function () {
  return 'Verify(parent=' + toString_0(this.k41_1) + ')';
};
protoOf(Verify).hashCode = function () {
  return hashCode(this.k41_1);
};
protoOf(Verify).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Verify))
    return false;
  if (!equals(this.k41_1, other.k41_1))
    return false;
  return true;
};
function Renew(parent) {
  parent = parent === VOID ? new AuthRoutes() : parent;
  this.n41_1 = parent;
}
protoOf(Renew).toString = function () {
  return 'Renew(parent=' + toString_0(this.n41_1) + ')';
};
protoOf(Renew).hashCode = function () {
  return hashCode(this.n41_1);
};
protoOf(Renew).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Renew))
    return false;
  if (!equals(this.n41_1, other.n41_1))
    return false;
  return true;
};
function Profile(parent) {
  parent = parent === VOID ? new AuthRoutes() : parent;
  this.q41_1 = parent;
}
protoOf(Profile).toString = function () {
  return 'Profile(parent=' + toString_0(this.q41_1) + ')';
};
protoOf(Profile).hashCode = function () {
  return hashCode(this.q41_1);
};
protoOf(Profile).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Profile))
    return false;
  if (!equals(this.q41_1, other.q41_1))
    return false;
  return true;
};
function ShuftiReference(parent) {
  parent = parent === VOID ? new AuthRoutes() : parent;
  this.t41_1 = parent;
}
protoOf(ShuftiReference).toString = function () {
  return 'ShuftiReference(parent=' + toString_0(this.t41_1) + ')';
};
protoOf(ShuftiReference).hashCode = function () {
  return hashCode(this.t41_1);
};
protoOf(ShuftiReference).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShuftiReference))
    return false;
  if (!equals(this.t41_1, other.t41_1))
    return false;
  return true;
};
function ShuftiVerification(parent) {
  parent = parent === VOID ? new AuthRoutes() : parent;
  this.w41_1 = parent;
}
protoOf(ShuftiVerification).toString = function () {
  return 'ShuftiVerification(parent=' + toString_0(this.w41_1) + ')';
};
protoOf(ShuftiVerification).hashCode = function () {
  return hashCode(this.w41_1);
};
protoOf(ShuftiVerification).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShuftiVerification))
    return false;
  if (!equals(this.w41_1, other.w41_1))
    return false;
  return true;
};
function Companion_53() {
}
var Companion_instance_53;
function Companion_getInstance_56() {
  return Companion_instance_53;
}
function $serializer_37() {
  $serializer_instance_37 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.AuthRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/auth'));
  this.x41_1 = tmp0_serialDesc;
}
protoOf($serializer_37).y41 = function (encoder, value) {
  var tmp0_desc = this.x41_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_37).gp = function (encoder, value) {
  return this.y41(encoder, value instanceof AuthRoutes ? value : THROW_CCE());
};
protoOf($serializer_37).hp = function (decoder) {
  var tmp0_desc = this.x41_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return AuthRoutes_init_$Create$(0, null);
};
protoOf($serializer_37).fp = function () {
  return this.x41_1;
};
protoOf($serializer_37).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_37;
function $serializer_getInstance_37() {
  if ($serializer_instance_37 == null)
    new $serializer_37();
  return $serializer_instance_37;
}
function AuthRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_37().x41_1);
  }
  return $this;
}
function AuthRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return AuthRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(AuthRoutes)));
}
function AuthRoutes() {
}
function FileRoutes$ByPath$Companion$$childSerializers$_anonymous__8d20y8() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function Companion_54() {
  Companion_instance_54 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.z41_1 = [null, lazy(tmp_0, FileRoutes$ByPath$Companion$$childSerializers$_anonymous__8d20y8)];
}
var Companion_instance_54;
function Companion_getInstance_57() {
  if (Companion_instance_54 == null)
    new Companion_54();
  return Companion_instance_54;
}
function $serializer_38() {
  $serializer_instance_38 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.FileRoutes.ByPath', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('path', false);
  tmp0_serialDesc.oz(new Resource('{path...}'));
  this.a42_1 = tmp0_serialDesc;
}
protoOf($serializer_38).b42 = function (encoder, value) {
  var tmp0_desc = this.a42_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_57().z41_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.c42_1, new FileRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_39(), value.c42_1);
  }
  tmp1_output.ju(tmp0_desc, 1, tmp2_cached[1].w(), value.d42_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_38).gp = function (encoder, value) {
  return this.b42(encoder, value instanceof ByPath ? value : THROW_CCE());
};
protoOf($serializer_38).hp = function (decoder) {
  var tmp0_desc = this.a42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  var tmp7_cached = Companion_getInstance_57().z41_1;
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_39(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.et(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_39(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.et(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return ByPath_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_38).fp = function () {
  return this.a42_1;
};
protoOf($serializer_38).z10 = function () {
  var tmp0_cached = Companion_getInstance_57().z41_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_39(), tmp0_cached[1].w()];
};
var $serializer_instance_38;
function $serializer_getInstance_38() {
  if ($serializer_instance_38 == null)
    new $serializer_38();
  return $serializer_instance_38;
}
function ByPath_init_$Init$(seen0, parent, path, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_38().a42_1);
  }
  if (0 === (seen0 & 1))
    $this.c42_1 = new FileRoutes();
  else
    $this.c42_1 = parent;
  $this.d42_1 = path;
  return $this;
}
function ByPath_init_$Create$(seen0, parent, path, serializationConstructorMarker) {
  return ByPath_init_$Init$(seen0, parent, path, serializationConstructorMarker, objectCreate(protoOf(ByPath)));
}
function ByPath(parent, path) {
  Companion_getInstance_57();
  parent = parent === VOID ? new FileRoutes() : parent;
  this.c42_1 = parent;
  this.d42_1 = path;
}
protoOf(ByPath).toString = function () {
  return 'ByPath(parent=' + toString_0(this.c42_1) + ', path=' + toString_0(this.d42_1) + ')';
};
protoOf(ByPath).hashCode = function () {
  var result = hashCode(this.c42_1);
  result = imul(result, 31) + hashCode(this.d42_1) | 0;
  return result;
};
protoOf(ByPath).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ByPath))
    return false;
  if (!equals(this.c42_1, other.c42_1))
    return false;
  if (!equals(this.d42_1, other.d42_1))
    return false;
  return true;
};
function Companion_55() {
}
var Companion_instance_55;
function Companion_getInstance_58() {
  return Companion_instance_55;
}
function $serializer_39() {
  $serializer_instance_39 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.FileRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/file'));
  this.e42_1 = tmp0_serialDesc;
}
protoOf($serializer_39).f42 = function (encoder, value) {
  var tmp0_desc = this.e42_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_39).gp = function (encoder, value) {
  return this.f42(encoder, value instanceof FileRoutes ? value : THROW_CCE());
};
protoOf($serializer_39).hp = function (decoder) {
  var tmp0_desc = this.e42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return FileRoutes_init_$Create$(0, null);
};
protoOf($serializer_39).fp = function () {
  return this.e42_1;
};
protoOf($serializer_39).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_39;
function $serializer_getInstance_39() {
  if ($serializer_instance_39 == null)
    new $serializer_39();
  return $serializer_instance_39;
}
function FileRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_39().e42_1);
  }
  return $this;
}
function FileRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return FileRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(FileRoutes)));
}
function FileRoutes() {
}
function ContentRoutes$ByPath$Companion$$childSerializers$_anonymous__5ic1bn() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function Companion_56() {
  Companion_instance_56 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g42_1 = [null, lazy(tmp_0, ContentRoutes$ByPath$Companion$$childSerializers$_anonymous__5ic1bn)];
}
var Companion_instance_56;
function Companion_getInstance_59() {
  if (Companion_instance_56 == null)
    new Companion_56();
  return Companion_instance_56;
}
function $serializer_40() {
  $serializer_instance_40 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.ContentRoutes.ByPath', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('path', false);
  tmp0_serialDesc.oz(new Resource('{path...}'));
  this.h42_1 = tmp0_serialDesc;
}
protoOf($serializer_40).i42 = function (encoder, value) {
  var tmp0_desc = this.h42_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_59().g42_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.j42_1, new ContentRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_41(), value.j42_1);
  }
  tmp1_output.ju(tmp0_desc, 1, tmp2_cached[1].w(), value.k42_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_40).gp = function (encoder, value) {
  return this.i42(encoder, value instanceof ByPath_0 ? value : THROW_CCE());
};
protoOf($serializer_40).hp = function (decoder) {
  var tmp0_desc = this.h42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  var tmp7_cached = Companion_getInstance_59().g42_1;
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_41(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.et(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_41(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.et(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return ByPath_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_40).fp = function () {
  return this.h42_1;
};
protoOf($serializer_40).z10 = function () {
  var tmp0_cached = Companion_getInstance_59().g42_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_41(), tmp0_cached[1].w()];
};
var $serializer_instance_40;
function $serializer_getInstance_40() {
  if ($serializer_instance_40 == null)
    new $serializer_40();
  return $serializer_instance_40;
}
function ByPath_init_$Init$_0(seen0, parent, path, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_40().h42_1);
  }
  if (0 === (seen0 & 1))
    $this.j42_1 = new ContentRoutes();
  else
    $this.j42_1 = parent;
  $this.k42_1 = path;
  return $this;
}
function ByPath_init_$Create$_0(seen0, parent, path, serializationConstructorMarker) {
  return ByPath_init_$Init$_0(seen0, parent, path, serializationConstructorMarker, objectCreate(protoOf(ByPath_0)));
}
function ByPath_0(parent, path) {
  Companion_getInstance_59();
  parent = parent === VOID ? new ContentRoutes() : parent;
  this.j42_1 = parent;
  this.k42_1 = path;
}
protoOf(ByPath_0).toString = function () {
  return 'ByPath(parent=' + toString_0(this.j42_1) + ', path=' + toString_0(this.k42_1) + ')';
};
protoOf(ByPath_0).hashCode = function () {
  var result = hashCode(this.j42_1);
  result = imul(result, 31) + hashCode(this.k42_1) | 0;
  return result;
};
protoOf(ByPath_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ByPath_0))
    return false;
  if (!equals(this.j42_1, other.j42_1))
    return false;
  if (!equals(this.k42_1, other.k42_1))
    return false;
  return true;
};
function Companion_57() {
}
var Companion_instance_57;
function Companion_getInstance_60() {
  return Companion_instance_57;
}
function $serializer_41() {
  $serializer_instance_41 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.ContentRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/content'));
  this.l42_1 = tmp0_serialDesc;
}
protoOf($serializer_41).m42 = function (encoder, value) {
  var tmp0_desc = this.l42_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_41).gp = function (encoder, value) {
  return this.m42(encoder, value instanceof ContentRoutes ? value : THROW_CCE());
};
protoOf($serializer_41).hp = function (decoder) {
  var tmp0_desc = this.l42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return ContentRoutes_init_$Create$(0, null);
};
protoOf($serializer_41).fp = function () {
  return this.l42_1;
};
protoOf($serializer_41).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_41;
function $serializer_getInstance_41() {
  if ($serializer_instance_41 == null)
    new $serializer_41();
  return $serializer_instance_41;
}
function ContentRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_41().l42_1);
  }
  return $this;
}
function ContentRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return ContentRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(ContentRoutes)));
}
function ContentRoutes() {
}
function Companion_58() {
}
var Companion_instance_58;
function Companion_getInstance_61() {
  return Companion_instance_58;
}
function $serializer_42() {
  $serializer_instance_42 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.FundsRoutes.List', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource(''));
  this.n42_1 = tmp0_serialDesc;
}
protoOf($serializer_42).o42 = function (encoder, value) {
  var tmp0_desc = this.n42_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.p42_1, new FundsRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_45(), value.p42_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_42).gp = function (encoder, value) {
  return this.o42(encoder, value instanceof List ? value : THROW_CCE());
};
protoOf($serializer_42).hp = function (decoder) {
  var tmp0_desc = this.n42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return List_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_42).fp = function () {
  return this.n42_1;
};
protoOf($serializer_42).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_45()];
};
var $serializer_instance_42;
function $serializer_getInstance_42() {
  if ($serializer_instance_42 == null)
    new $serializer_42();
  return $serializer_instance_42;
}
function List_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_42().n42_1);
  }
  if (0 === (seen0 & 1))
    $this.p42_1 = new FundsRoutes();
  else
    $this.p42_1 = parent;
  return $this;
}
function List_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return List_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(List)));
}
function Companion_59() {
}
var Companion_instance_59;
function Companion_getInstance_62() {
  return Companion_instance_59;
}
function $serializer_43() {
  $serializer_instance_43 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.FundsRoutes.ByTicker', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.oz(new Resource('{ticker}'));
  this.q42_1 = tmp0_serialDesc;
}
protoOf($serializer_43).r42 = function (encoder, value) {
  var tmp0_desc = this.q42_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.s42_1, new FundsRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_45(), value.s42_1);
  }
  tmp1_output.hu(tmp0_desc, 1, value.t42_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_43).gp = function (encoder, value) {
  return this.r42(encoder, value instanceof ByTicker ? value : THROW_CCE());
};
protoOf($serializer_43).hp = function (decoder) {
  var tmp0_desc = this.q42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return ByTicker_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_43).fp = function () {
  return this.q42_1;
};
protoOf($serializer_43).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_45(), StringSerializer_getInstance()];
};
var $serializer_instance_43;
function $serializer_getInstance_43() {
  if ($serializer_instance_43 == null)
    new $serializer_43();
  return $serializer_instance_43;
}
function ByTicker_init_$Init$(seen0, parent, ticker, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_43().q42_1);
  }
  if (0 === (seen0 & 1))
    $this.s42_1 = new FundsRoutes();
  else
    $this.s42_1 = parent;
  $this.t42_1 = ticker;
  return $this;
}
function ByTicker_init_$Create$(seen0, parent, ticker, serializationConstructorMarker) {
  return ByTicker_init_$Init$(seen0, parent, ticker, serializationConstructorMarker, objectCreate(protoOf(ByTicker)));
}
function Companion_60() {
}
var Companion_instance_60;
function Companion_getInstance_63() {
  return Companion_instance_60;
}
function $serializer_44() {
  $serializer_instance_44 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.FundsRoutes.Dividends', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.oz(new Resource('{ticker}/dividends'));
  this.u42_1 = tmp0_serialDesc;
}
protoOf($serializer_44).v42 = function (encoder, value) {
  var tmp0_desc = this.u42_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.w42_1, new FundsRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_45(), value.w42_1);
  }
  tmp1_output.hu(tmp0_desc, 1, value.x42_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_44).gp = function (encoder, value) {
  return this.v42(encoder, value instanceof Dividends ? value : THROW_CCE());
};
protoOf($serializer_44).hp = function (decoder) {
  var tmp0_desc = this.u42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_45(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return Dividends_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_44).fp = function () {
  return this.u42_1;
};
protoOf($serializer_44).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_45(), StringSerializer_getInstance()];
};
var $serializer_instance_44;
function $serializer_getInstance_44() {
  if ($serializer_instance_44 == null)
    new $serializer_44();
  return $serializer_instance_44;
}
function Dividends_init_$Init$(seen0, parent, ticker, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_44().u42_1);
  }
  if (0 === (seen0 & 1))
    $this.w42_1 = new FundsRoutes();
  else
    $this.w42_1 = parent;
  $this.x42_1 = ticker;
  return $this;
}
function Dividends_init_$Create$(seen0, parent, ticker, serializationConstructorMarker) {
  return Dividends_init_$Init$(seen0, parent, ticker, serializationConstructorMarker, objectCreate(protoOf(Dividends)));
}
function List(parent) {
  parent = parent === VOID ? new FundsRoutes() : parent;
  this.p42_1 = parent;
}
protoOf(List).toString = function () {
  return 'List(parent=' + toString_0(this.p42_1) + ')';
};
protoOf(List).hashCode = function () {
  return hashCode(this.p42_1);
};
protoOf(List).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof List))
    return false;
  if (!equals(this.p42_1, other.p42_1))
    return false;
  return true;
};
function ByTicker(parent, ticker) {
  parent = parent === VOID ? new FundsRoutes() : parent;
  this.s42_1 = parent;
  this.t42_1 = ticker;
}
protoOf(ByTicker).toString = function () {
  return 'ByTicker(parent=' + toString_0(this.s42_1) + ', ticker=' + this.t42_1 + ')';
};
protoOf(ByTicker).hashCode = function () {
  var result = hashCode(this.s42_1);
  result = imul(result, 31) + getStringHashCode(this.t42_1) | 0;
  return result;
};
protoOf(ByTicker).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ByTicker))
    return false;
  if (!equals(this.s42_1, other.s42_1))
    return false;
  if (!(this.t42_1 === other.t42_1))
    return false;
  return true;
};
function Dividends(parent, ticker) {
  parent = parent === VOID ? new FundsRoutes() : parent;
  this.w42_1 = parent;
  this.x42_1 = ticker;
}
protoOf(Dividends).toString = function () {
  return 'Dividends(parent=' + toString_0(this.w42_1) + ', ticker=' + this.x42_1 + ')';
};
protoOf(Dividends).hashCode = function () {
  var result = hashCode(this.w42_1);
  result = imul(result, 31) + getStringHashCode(this.x42_1) | 0;
  return result;
};
protoOf(Dividends).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Dividends))
    return false;
  if (!equals(this.w42_1, other.w42_1))
    return false;
  if (!(this.x42_1 === other.x42_1))
    return false;
  return true;
};
function Companion_61() {
}
var Companion_instance_61;
function Companion_getInstance_64() {
  return Companion_instance_61;
}
function $serializer_45() {
  $serializer_instance_45 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.FundsRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/funds'));
  this.y42_1 = tmp0_serialDesc;
}
protoOf($serializer_45).z42 = function (encoder, value) {
  var tmp0_desc = this.y42_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_45).gp = function (encoder, value) {
  return this.z42(encoder, value instanceof FundsRoutes ? value : THROW_CCE());
};
protoOf($serializer_45).hp = function (decoder) {
  var tmp0_desc = this.y42_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return FundsRoutes_init_$Create$(0, null);
};
protoOf($serializer_45).fp = function () {
  return this.y42_1;
};
protoOf($serializer_45).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_45;
function $serializer_getInstance_45() {
  if ($serializer_instance_45 == null)
    new $serializer_45();
  return $serializer_instance_45;
}
function FundsRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_45().y42_1);
  }
  return $this;
}
function FundsRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return FundsRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(FundsRoutes)));
}
function FundsRoutes() {
}
function Companion_62() {
}
var Companion_instance_62;
function Companion_getInstance_65() {
  return Companion_instance_62;
}
function $serializer_46() {
  $serializer_instance_46 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.Settings', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource(''));
  this.a43_1 = tmp0_serialDesc;
}
protoOf($serializer_46).b43 = function (encoder, value) {
  var tmp0_desc = this.a43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.c43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.c43_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_46).gp = function (encoder, value) {
  return this.b43(encoder, value instanceof Settings ? value : THROW_CCE());
};
protoOf($serializer_46).hp = function (decoder) {
  var tmp0_desc = this.a43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Settings_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_46).fp = function () {
  return this.a43_1;
};
protoOf($serializer_46).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53()];
};
var $serializer_instance_46;
function $serializer_getInstance_46() {
  if ($serializer_instance_46 == null)
    new $serializer_46();
  return $serializer_instance_46;
}
function Settings_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_46().a43_1);
  }
  if (0 === (seen0 & 1))
    $this.c43_1 = new SecurityRoutes();
  else
    $this.c43_1 = parent;
  return $this;
}
function Settings_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Settings_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Settings)));
}
function Companion_63() {
}
var Companion_instance_63;
function Companion_getInstance_66() {
  return Companion_instance_63;
}
function $serializer_47() {
  $serializer_instance_47 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.SetDefault2FA', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('2fa/default'));
  this.d43_1 = tmp0_serialDesc;
}
protoOf($serializer_47).e43 = function (encoder, value) {
  var tmp0_desc = this.d43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.f43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.f43_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_47).gp = function (encoder, value) {
  return this.e43(encoder, value instanceof SetDefault2FA ? value : THROW_CCE());
};
protoOf($serializer_47).hp = function (decoder) {
  var tmp0_desc = this.d43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return SetDefault2FA_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_47).fp = function () {
  return this.d43_1;
};
protoOf($serializer_47).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53()];
};
var $serializer_instance_47;
function $serializer_getInstance_47() {
  if ($serializer_instance_47 == null)
    new $serializer_47();
  return $serializer_instance_47;
}
function SetDefault2FA_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_47().d43_1);
  }
  if (0 === (seen0 & 1))
    $this.f43_1 = new SecurityRoutes();
  else
    $this.f43_1 = parent;
  return $this;
}
function SetDefault2FA_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return SetDefault2FA_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(SetDefault2FA)));
}
function Companion_64() {
}
var Companion_instance_64;
function Companion_getInstance_67() {
  return Companion_instance_64;
}
function $serializer_48() {
  $serializer_instance_48 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.Totp', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('2fa/totp'));
  this.g43_1 = tmp0_serialDesc;
}
protoOf($serializer_48).h43 = function (encoder, value) {
  var tmp0_desc = this.g43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.i43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.i43_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_48).gp = function (encoder, value) {
  return this.h43(encoder, value instanceof Totp ? value : THROW_CCE());
};
protoOf($serializer_48).hp = function (decoder) {
  var tmp0_desc = this.g43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Totp_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_48).fp = function () {
  return this.g43_1;
};
protoOf($serializer_48).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53()];
};
var $serializer_instance_48;
function $serializer_getInstance_48() {
  if ($serializer_instance_48 == null)
    new $serializer_48();
  return $serializer_instance_48;
}
function Totp_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_48().g43_1);
  }
  if (0 === (seen0 & 1))
    $this.i43_1 = new SecurityRoutes();
  else
    $this.i43_1 = parent;
  return $this;
}
function Totp_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Totp_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Totp)));
}
function Companion_65() {
}
var Companion_instance_65;
function Companion_getInstance_68() {
  return Companion_instance_65;
}
function $serializer_49() {
  $serializer_instance_49 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.Password', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('password'));
  this.j43_1 = tmp0_serialDesc;
}
protoOf($serializer_49).k43 = function (encoder, value) {
  var tmp0_desc = this.j43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.l43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.l43_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_49).gp = function (encoder, value) {
  return this.k43(encoder, value instanceof Password ? value : THROW_CCE());
};
protoOf($serializer_49).hp = function (decoder) {
  var tmp0_desc = this.j43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Password_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_49).fp = function () {
  return this.j43_1;
};
protoOf($serializer_49).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53()];
};
var $serializer_instance_49;
function $serializer_getInstance_49() {
  if ($serializer_instance_49 == null)
    new $serializer_49();
  return $serializer_instance_49;
}
function Password_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_49().j43_1);
  }
  if (0 === (seen0 & 1))
    $this.l43_1 = new SecurityRoutes();
  else
    $this.l43_1 = parent;
  return $this;
}
function Password_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Password_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Password)));
}
function Companion_66() {
}
var Companion_instance_66;
function Companion_getInstance_69() {
  return Companion_instance_66;
}
function $serializer_50() {
  $serializer_instance_50 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.WebAuthn', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('2fa/webauthn'));
  this.m43_1 = tmp0_serialDesc;
}
protoOf($serializer_50).n43 = function (encoder, value) {
  var tmp0_desc = this.m43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.o43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.o43_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_50).gp = function (encoder, value) {
  return this.n43(encoder, value instanceof WebAuthn ? value : THROW_CCE());
};
protoOf($serializer_50).hp = function (decoder) {
  var tmp0_desc = this.m43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return WebAuthn_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_50).fp = function () {
  return this.m43_1;
};
protoOf($serializer_50).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53()];
};
var $serializer_instance_50;
function $serializer_getInstance_50() {
  if ($serializer_instance_50 == null)
    new $serializer_50();
  return $serializer_instance_50;
}
function WebAuthn_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_50().m43_1);
  }
  if (0 === (seen0 & 1))
    $this.o43_1 = new SecurityRoutes();
  else
    $this.o43_1 = parent;
  return $this;
}
function WebAuthn_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return WebAuthn_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(WebAuthn)));
}
function Companion_67() {
}
var Companion_instance_67;
function Companion_getInstance_70() {
  return Companion_instance_67;
}
function $serializer_51() {
  $serializer_instance_51 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.WebAuthnRegister', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('2fa/webauthn/register'));
  this.p43_1 = tmp0_serialDesc;
}
protoOf($serializer_51).q43 = function (encoder, value) {
  var tmp0_desc = this.p43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.r43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.r43_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_51).gp = function (encoder, value) {
  return this.q43(encoder, value instanceof WebAuthnRegister ? value : THROW_CCE());
};
protoOf($serializer_51).hp = function (decoder) {
  var tmp0_desc = this.p43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return WebAuthnRegister_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_51).fp = function () {
  return this.p43_1;
};
protoOf($serializer_51).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53()];
};
var $serializer_instance_51;
function $serializer_getInstance_51() {
  if ($serializer_instance_51 == null)
    new $serializer_51();
  return $serializer_instance_51;
}
function WebAuthnRegister_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_51().p43_1);
  }
  if (0 === (seen0 & 1))
    $this.r43_1 = new SecurityRoutes();
  else
    $this.r43_1 = parent;
  return $this;
}
function WebAuthnRegister_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return WebAuthnRegister_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(WebAuthnRegister)));
}
function Companion_68() {
}
var Companion_instance_68;
function Companion_getInstance_71() {
  return Companion_instance_68;
}
function $serializer_52() {
  $serializer_instance_52 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes.WebAuthnByUuid', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('uuid', false);
  tmp0_serialDesc.oz(new Resource('2fa/webauthn/{uuid}'));
  this.s43_1 = tmp0_serialDesc;
}
protoOf($serializer_52).t43 = function (encoder, value) {
  var tmp0_desc = this.s43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.u43_1, new SecurityRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_53(), value.u43_1);
  }
  tmp1_output.hu(tmp0_desc, 1, value.v43_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_52).gp = function (encoder, value) {
  return this.t43(encoder, value instanceof WebAuthnByUuid ? value : THROW_CCE());
};
protoOf($serializer_52).hp = function (decoder) {
  var tmp0_desc = this.s43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_53(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return WebAuthnByUuid_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_52).fp = function () {
  return this.s43_1;
};
protoOf($serializer_52).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_53(), StringSerializer_getInstance()];
};
var $serializer_instance_52;
function $serializer_getInstance_52() {
  if ($serializer_instance_52 == null)
    new $serializer_52();
  return $serializer_instance_52;
}
function WebAuthnByUuid_init_$Init$(seen0, parent, uuid, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_52().s43_1);
  }
  if (0 === (seen0 & 1))
    $this.u43_1 = new SecurityRoutes();
  else
    $this.u43_1 = parent;
  $this.v43_1 = uuid;
  return $this;
}
function WebAuthnByUuid_init_$Create$(seen0, parent, uuid, serializationConstructorMarker) {
  return WebAuthnByUuid_init_$Init$(seen0, parent, uuid, serializationConstructorMarker, objectCreate(protoOf(WebAuthnByUuid)));
}
function Settings(parent) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.c43_1 = parent;
}
protoOf(Settings).toString = function () {
  return 'Settings(parent=' + toString_0(this.c43_1) + ')';
};
protoOf(Settings).hashCode = function () {
  return hashCode(this.c43_1);
};
protoOf(Settings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Settings))
    return false;
  if (!equals(this.c43_1, other.c43_1))
    return false;
  return true;
};
function SetDefault2FA(parent) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.f43_1 = parent;
}
protoOf(SetDefault2FA).toString = function () {
  return 'SetDefault2FA(parent=' + toString_0(this.f43_1) + ')';
};
protoOf(SetDefault2FA).hashCode = function () {
  return hashCode(this.f43_1);
};
protoOf(SetDefault2FA).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetDefault2FA))
    return false;
  if (!equals(this.f43_1, other.f43_1))
    return false;
  return true;
};
function Totp(parent) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.i43_1 = parent;
}
protoOf(Totp).toString = function () {
  return 'Totp(parent=' + toString_0(this.i43_1) + ')';
};
protoOf(Totp).hashCode = function () {
  return hashCode(this.i43_1);
};
protoOf(Totp).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Totp))
    return false;
  if (!equals(this.i43_1, other.i43_1))
    return false;
  return true;
};
function Password(parent) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.l43_1 = parent;
}
protoOf(Password).toString = function () {
  return 'Password(parent=' + toString_0(this.l43_1) + ')';
};
protoOf(Password).hashCode = function () {
  return hashCode(this.l43_1);
};
protoOf(Password).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Password))
    return false;
  if (!equals(this.l43_1, other.l43_1))
    return false;
  return true;
};
function WebAuthn(parent) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.o43_1 = parent;
}
protoOf(WebAuthn).toString = function () {
  return 'WebAuthn(parent=' + toString_0(this.o43_1) + ')';
};
protoOf(WebAuthn).hashCode = function () {
  return hashCode(this.o43_1);
};
protoOf(WebAuthn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebAuthn))
    return false;
  if (!equals(this.o43_1, other.o43_1))
    return false;
  return true;
};
function WebAuthnRegister(parent) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.r43_1 = parent;
}
protoOf(WebAuthnRegister).toString = function () {
  return 'WebAuthnRegister(parent=' + toString_0(this.r43_1) + ')';
};
protoOf(WebAuthnRegister).hashCode = function () {
  return hashCode(this.r43_1);
};
protoOf(WebAuthnRegister).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebAuthnRegister))
    return false;
  if (!equals(this.r43_1, other.r43_1))
    return false;
  return true;
};
function WebAuthnByUuid(parent, uuid) {
  parent = parent === VOID ? new SecurityRoutes() : parent;
  this.u43_1 = parent;
  this.v43_1 = uuid;
}
protoOf(WebAuthnByUuid).toString = function () {
  return 'WebAuthnByUuid(parent=' + toString_0(this.u43_1) + ', uuid=' + this.v43_1 + ')';
};
protoOf(WebAuthnByUuid).hashCode = function () {
  var result = hashCode(this.u43_1);
  result = imul(result, 31) + getStringHashCode(this.v43_1) | 0;
  return result;
};
protoOf(WebAuthnByUuid).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebAuthnByUuid))
    return false;
  if (!equals(this.u43_1, other.u43_1))
    return false;
  if (!(this.v43_1 === other.v43_1))
    return false;
  return true;
};
function Companion_69() {
}
var Companion_instance_69;
function Companion_getInstance_72() {
  return Companion_instance_69;
}
function $serializer_53() {
  $serializer_instance_53 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.SecurityRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/security'));
  this.w43_1 = tmp0_serialDesc;
}
protoOf($serializer_53).x43 = function (encoder, value) {
  var tmp0_desc = this.w43_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_53).gp = function (encoder, value) {
  return this.x43(encoder, value instanceof SecurityRoutes ? value : THROW_CCE());
};
protoOf($serializer_53).hp = function (decoder) {
  var tmp0_desc = this.w43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return SecurityRoutes_init_$Create$(0, null);
};
protoOf($serializer_53).fp = function () {
  return this.w43_1;
};
protoOf($serializer_53).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_53;
function $serializer_getInstance_53() {
  if ($serializer_instance_53 == null)
    new $serializer_53();
  return $serializer_instance_53;
}
function SecurityRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_53().w43_1);
  }
  return $this;
}
function SecurityRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return SecurityRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(SecurityRoutes)));
}
function SecurityRoutes() {
}
function Companion_70() {
}
var Companion_instance_70;
function Companion_getInstance_73() {
  return Companion_instance_70;
}
function $serializer_54() {
  $serializer_instance_54 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.ShuftiRoutes.MobileConfig', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('mobile_config'));
  this.y43_1 = tmp0_serialDesc;
}
protoOf($serializer_54).z43 = function (encoder, value) {
  var tmp0_desc = this.y43_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.a44_1, new ShuftiRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_55(), value.a44_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_54).gp = function (encoder, value) {
  return this.z43(encoder, value instanceof MobileConfig ? value : THROW_CCE());
};
protoOf($serializer_54).hp = function (decoder) {
  var tmp0_desc = this.y43_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_55(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_55(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return MobileConfig_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_54).fp = function () {
  return this.y43_1;
};
protoOf($serializer_54).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_55()];
};
var $serializer_instance_54;
function $serializer_getInstance_54() {
  if ($serializer_instance_54 == null)
    new $serializer_54();
  return $serializer_instance_54;
}
function MobileConfig_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_54().y43_1);
  }
  if (0 === (seen0 & 1))
    $this.a44_1 = new ShuftiRoutes();
  else
    $this.a44_1 = parent;
  return $this;
}
function MobileConfig_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return MobileConfig_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(MobileConfig)));
}
function MobileConfig(parent) {
  parent = parent === VOID ? new ShuftiRoutes() : parent;
  this.a44_1 = parent;
}
protoOf(MobileConfig).toString = function () {
  return 'MobileConfig(parent=' + toString_0(this.a44_1) + ')';
};
protoOf(MobileConfig).hashCode = function () {
  return hashCode(this.a44_1);
};
protoOf(MobileConfig).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MobileConfig))
    return false;
  if (!equals(this.a44_1, other.a44_1))
    return false;
  return true;
};
function Companion_71() {
}
var Companion_instance_71;
function Companion_getInstance_74() {
  return Companion_instance_71;
}
function $serializer_55() {
  $serializer_instance_55 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.ShuftiRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/shufti'));
  this.b44_1 = tmp0_serialDesc;
}
protoOf($serializer_55).c44 = function (encoder, value) {
  var tmp0_desc = this.b44_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_55).gp = function (encoder, value) {
  return this.c44(encoder, value instanceof ShuftiRoutes ? value : THROW_CCE());
};
protoOf($serializer_55).hp = function (decoder) {
  var tmp0_desc = this.b44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return ShuftiRoutes_init_$Create$(0, null);
};
protoOf($serializer_55).fp = function () {
  return this.b44_1;
};
protoOf($serializer_55).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_55;
function $serializer_getInstance_55() {
  if ($serializer_instance_55 == null)
    new $serializer_55();
  return $serializer_instance_55;
}
function ShuftiRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_55().b44_1);
  }
  return $this;
}
function ShuftiRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return ShuftiRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(ShuftiRoutes)));
}
function ShuftiRoutes() {
}
function Companion_72() {
}
var Companion_instance_72;
function Companion_getInstance_75() {
  return Companion_instance_72;
}
function $serializer_56() {
  $serializer_instance_56 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.VersionRoute', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/version'));
  this.d44_1 = tmp0_serialDesc;
}
protoOf($serializer_56).e44 = function (encoder, value) {
  var tmp0_desc = this.d44_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_56).gp = function (encoder, value) {
  return this.e44(encoder, value instanceof VersionRoute ? value : THROW_CCE());
};
protoOf($serializer_56).hp = function (decoder) {
  var tmp0_desc = this.d44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return VersionRoute_init_$Create$(0, null);
};
protoOf($serializer_56).fp = function () {
  return this.d44_1;
};
protoOf($serializer_56).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_56;
function $serializer_getInstance_56() {
  if ($serializer_instance_56 == null)
    new $serializer_56();
  return $serializer_instance_56;
}
function VersionRoute_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_56().d44_1);
  }
  return $this;
}
function VersionRoute_init_$Create$(seen0, serializationConstructorMarker) {
  return VersionRoute_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(VersionRoute)));
}
function VersionRoute() {
}
function Companion_73() {
}
var Companion_instance_73;
function Companion_getInstance_76() {
  return Companion_instance_73;
}
function $serializer_57() {
  $serializer_instance_57 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.TransactionById', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('id', false);
  tmp0_serialDesc.oz(new Resource('transaction/{id}'));
  this.f44_1 = tmp0_serialDesc;
}
protoOf($serializer_57).g44 = function (encoder, value) {
  var tmp0_desc = this.f44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.h44_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.h44_1);
  }
  tmp1_output.ju(tmp0_desc, 1, UuidStringSerializer_getInstance(), value.i44_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_57).gp = function (encoder, value) {
  return this.g44(encoder, value instanceof TransactionById ? value : THROW_CCE());
};
protoOf($serializer_57).hp = function (decoder) {
  var tmp0_desc = this.f44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.et(tmp0_desc, 1, UuidStringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.et(tmp0_desc, 1, UuidStringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return TransactionById_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_57).fp = function () {
  return this.f44_1;
};
protoOf($serializer_57).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70(), UuidStringSerializer_getInstance()];
};
var $serializer_instance_57;
function $serializer_getInstance_57() {
  if ($serializer_instance_57 == null)
    new $serializer_57();
  return $serializer_instance_57;
}
function TransactionById_init_$Init$(seen0, parent, id, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_57().f44_1);
  }
  if (0 === (seen0 & 1))
    $this.h44_1 = new UserRoutes();
  else
    $this.h44_1 = parent;
  $this.i44_1 = id;
  return $this;
}
function TransactionById_init_$Create$(seen0, parent, id, serializationConstructorMarker) {
  return TransactionById_init_$Init$(seen0, parent, id, serializationConstructorMarker, objectCreate(protoOf(TransactionById)));
}
function Companion_74() {
}
var Companion_instance_74;
function Companion_getInstance_77() {
  return Companion_instance_74;
}
function $serializer_58() {
  $serializer_instance_58 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.DepositBankDetail', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('deposit_bank/detail'));
  this.j44_1 = tmp0_serialDesc;
}
protoOf($serializer_58).k44 = function (encoder, value) {
  var tmp0_desc = this.j44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.l44_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.l44_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_58).gp = function (encoder, value) {
  return this.k44(encoder, value instanceof DepositBankDetail ? value : THROW_CCE());
};
protoOf($serializer_58).hp = function (decoder) {
  var tmp0_desc = this.j44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return DepositBankDetail_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_58).fp = function () {
  return this.j44_1;
};
protoOf($serializer_58).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_58;
function $serializer_getInstance_58() {
  if ($serializer_instance_58 == null)
    new $serializer_58();
  return $serializer_instance_58;
}
function DepositBankDetail_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_58().j44_1);
  }
  if (0 === (seen0 & 1))
    $this.l44_1 = new UserRoutes();
  else
    $this.l44_1 = parent;
  return $this;
}
function DepositBankDetail_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return DepositBankDetail_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(DepositBankDetail)));
}
function Companion_75() {
}
var Companion_instance_75;
function Companion_getInstance_78() {
  return Companion_instance_75;
}
function $serializer_59() {
  $serializer_instance_59 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.PayoutBank', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('payout_bank'));
  this.m44_1 = tmp0_serialDesc;
}
protoOf($serializer_59).n44 = function (encoder, value) {
  var tmp0_desc = this.m44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.o44_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.o44_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_59).gp = function (encoder, value) {
  return this.n44(encoder, value instanceof PayoutBank ? value : THROW_CCE());
};
protoOf($serializer_59).hp = function (decoder) {
  var tmp0_desc = this.m44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return PayoutBank_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_59).fp = function () {
  return this.m44_1;
};
protoOf($serializer_59).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_59;
function $serializer_getInstance_59() {
  if ($serializer_instance_59 == null)
    new $serializer_59();
  return $serializer_instance_59;
}
function PayoutBank_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_59().m44_1);
  }
  if (0 === (seen0 & 1))
    $this.o44_1 = new UserRoutes();
  else
    $this.o44_1 = parent;
  return $this;
}
function PayoutBank_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return PayoutBank_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(PayoutBank)));
}
function Companion_76() {
}
var Companion_instance_76;
function Companion_getInstance_79() {
  return Companion_instance_76;
}
function $serializer_60() {
  $serializer_instance_60 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.BankAccountBeneficiary', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('payout_bank/beneficiary'));
  this.p44_1 = tmp0_serialDesc;
}
protoOf($serializer_60).q44 = function (encoder, value) {
  var tmp0_desc = this.p44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.r44_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.r44_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_60).gp = function (encoder, value) {
  return this.q44(encoder, value instanceof BankAccountBeneficiary ? value : THROW_CCE());
};
protoOf($serializer_60).hp = function (decoder) {
  var tmp0_desc = this.p44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return BankAccountBeneficiary_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_60).fp = function () {
  return this.p44_1;
};
protoOf($serializer_60).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_60;
function $serializer_getInstance_60() {
  if ($serializer_instance_60 == null)
    new $serializer_60();
  return $serializer_instance_60;
}
function BankAccountBeneficiary_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_60().p44_1);
  }
  if (0 === (seen0 & 1))
    $this.r44_1 = new UserRoutes();
  else
    $this.r44_1 = parent;
  return $this;
}
function BankAccountBeneficiary_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return BankAccountBeneficiary_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(BankAccountBeneficiary)));
}
function Companion_77() {
}
var Companion_instance_77;
function Companion_getInstance_80() {
  return Companion_instance_77;
}
function $serializer_61() {
  $serializer_instance_61 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.BankAccount', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('payout_bank/account'));
  this.s44_1 = tmp0_serialDesc;
}
protoOf($serializer_61).t44 = function (encoder, value) {
  var tmp0_desc = this.s44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.u44_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.u44_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_61).gp = function (encoder, value) {
  return this.t44(encoder, value instanceof BankAccount ? value : THROW_CCE());
};
protoOf($serializer_61).hp = function (decoder) {
  var tmp0_desc = this.s44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return BankAccount_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_61).fp = function () {
  return this.s44_1;
};
protoOf($serializer_61).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_61;
function $serializer_getInstance_61() {
  if ($serializer_instance_61 == null)
    new $serializer_61();
  return $serializer_instance_61;
}
function BankAccount_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_61().s44_1);
  }
  if (0 === (seen0 & 1))
    $this.u44_1 = new UserRoutes();
  else
    $this.u44_1 = parent;
  return $this;
}
function BankAccount_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return BankAccount_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(BankAccount)));
}
function Companion_78() {
}
var Companion_instance_78;
function Companion_getInstance_81() {
  return Companion_instance_78;
}
function $serializer_62() {
  $serializer_instance_62 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.ShuftiAccessToken', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('shufti/access_token'));
  this.v44_1 = tmp0_serialDesc;
}
protoOf($serializer_62).w44 = function (encoder, value) {
  var tmp0_desc = this.v44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.x44_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.x44_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_62).gp = function (encoder, value) {
  return this.w44(encoder, value instanceof ShuftiAccessToken ? value : THROW_CCE());
};
protoOf($serializer_62).hp = function (decoder) {
  var tmp0_desc = this.v44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return ShuftiAccessToken_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_62).fp = function () {
  return this.v44_1;
};
protoOf($serializer_62).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_62;
function $serializer_getInstance_62() {
  if ($serializer_instance_62 == null)
    new $serializer_62();
  return $serializer_instance_62;
}
function ShuftiAccessToken_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_62().v44_1);
  }
  if (0 === (seen0 & 1))
    $this.x44_1 = new UserRoutes();
  else
    $this.x44_1 = parent;
  return $this;
}
function ShuftiAccessToken_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return ShuftiAccessToken_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(ShuftiAccessToken)));
}
function Companion_79() {
}
var Companion_instance_79;
function Companion_getInstance_82() {
  return Companion_instance_79;
}
function $serializer_63() {
  $serializer_instance_63 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.PortfolioByTicker', this, 4);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('page', true);
  tmp0_serialDesc.k10('pageSize', true);
  tmp0_serialDesc.oz(new Resource('portfolio/{ticker}'));
  this.y44_1 = tmp0_serialDesc;
}
protoOf($serializer_63).z44 = function (encoder, value) {
  var tmp0_desc = this.y44_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.a45_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.a45_1);
  }
  tmp1_output.hu(tmp0_desc, 1, value.b45_1);
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.c45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 2, LongSerializer_getInstance(), value.c45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.d45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 3, LongSerializer_getInstance(), value.d45_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_63).gp = function (encoder, value) {
  return this.z44(encoder, value instanceof PortfolioByTicker ? value : THROW_CCE());
};
protoOf($serializer_63).hp = function (decoder) {
  var tmp0_desc = this.y44_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.ss(tmp0_desc);
  if (tmp8_input.it()) {
    tmp4_local0 = tmp8_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.gt(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.gt(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.gt(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.gt(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.ts(tmp0_desc);
  return PortfolioByTicker_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_63).fp = function () {
  return this.y44_1;
};
protoOf($serializer_63).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
};
var $serializer_instance_63;
function $serializer_getInstance_63() {
  if ($serializer_instance_63 == null)
    new $serializer_63();
  return $serializer_instance_63;
}
function PortfolioByTicker_init_$Init$(seen0, parent, ticker, page, pageSize, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_63().y44_1);
  }
  if (0 === (seen0 & 1))
    $this.a45_1 = new UserRoutes();
  else
    $this.a45_1 = parent;
  $this.b45_1 = ticker;
  if (0 === (seen0 & 4))
    $this.c45_1 = null;
  else
    $this.c45_1 = page;
  if (0 === (seen0 & 8))
    $this.d45_1 = null;
  else
    $this.d45_1 = pageSize;
  return $this;
}
function PortfolioByTicker_init_$Create$(seen0, parent, ticker, page, pageSize, serializationConstructorMarker) {
  return PortfolioByTicker_init_$Init$(seen0, parent, ticker, page, pageSize, serializationConstructorMarker, objectCreate(protoOf(PortfolioByTicker)));
}
function Companion_80() {
}
var Companion_instance_80;
function Companion_getInstance_83() {
  return Companion_instance_80;
}
function $serializer_64() {
  $serializer_instance_64 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.Portfolios', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('portfolios'));
  this.e45_1 = tmp0_serialDesc;
}
protoOf($serializer_64).f45 = function (encoder, value) {
  var tmp0_desc = this.e45_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.g45_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.g45_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_64).gp = function (encoder, value) {
  return this.f45(encoder, value instanceof Portfolios ? value : THROW_CCE());
};
protoOf($serializer_64).hp = function (decoder) {
  var tmp0_desc = this.e45_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return Portfolios_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_64).fp = function () {
  return this.e45_1;
};
protoOf($serializer_64).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_64;
function $serializer_getInstance_64() {
  if ($serializer_instance_64 == null)
    new $serializer_64();
  return $serializer_instance_64;
}
function Portfolios_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_64().e45_1);
  }
  if (0 === (seen0 & 1))
    $this.g45_1 = new UserRoutes();
  else
    $this.g45_1 = parent;
  return $this;
}
function Portfolios_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return Portfolios_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(Portfolios)));
}
function UserRoutes$Transactions$Companion$$childSerializers$_anonymous__7d4fja() {
  return Companion_getInstance_22().o1c();
}
function UserRoutes$Transactions$Companion$$childSerializers$_anonymous__7d4fja_0() {
  return Companion_getInstance_21().o1c();
}
function Companion_81() {
  Companion_instance_81 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, UserRoutes$Transactions$Companion$$childSerializers$_anonymous__7d4fja);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.h45_1 = [null, null, null, tmp_1, null, null, null, null, null, lazy(tmp_2, UserRoutes$Transactions$Companion$$childSerializers$_anonymous__7d4fja_0)];
}
var Companion_instance_81;
function Companion_getInstance_84() {
  if (Companion_instance_81 == null)
    new Companion_81();
  return Companion_instance_81;
}
function $serializer_65() {
  $serializer_instance_65 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.Transactions', this, 10);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('page', true);
  tmp0_serialDesc.k10('pageSize', true);
  tmp0_serialDesc.k10('status', true);
  tmp0_serialDesc.k10('start', true);
  tmp0_serialDesc.k10('end', true);
  tmp0_serialDesc.k10('ticker', true);
  tmp0_serialDesc.k10('latest', true);
  tmp0_serialDesc.k10('inProgress', true);
  tmp0_serialDesc.k10('transactionType', true);
  tmp0_serialDesc.oz(new Resource('transactions'));
  this.i45_1 = tmp0_serialDesc;
}
protoOf($serializer_65).j45 = function (encoder, value) {
  var tmp0_desc = this.i45_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_84().h45_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.k45_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.k45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.l45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 1, LongSerializer_getInstance(), value.l45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.m45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 2, LongSerializer_getInstance(), value.m45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.n45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 3, tmp2_cached[3].w(), value.n45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.o45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 4, StringSerializer_getInstance(), value.o45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.p45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 5, StringSerializer_getInstance(), value.p45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.q45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 6, StringSerializer_getInstance(), value.q45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 7) ? true : !(value.r45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 7, BooleanSerializer_getInstance(), value.r45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 8) ? true : !(value.s45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 8, BooleanSerializer_getInstance(), value.s45_1);
  }
  if (tmp1_output.pu(tmp0_desc, 9) ? true : !(value.t45_1 == null)) {
    tmp1_output.lu(tmp0_desc, 9, tmp2_cached[9].w(), value.t45_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_65).gp = function (encoder, value) {
  return this.j45(encoder, value instanceof Transactions ? value : THROW_CCE());
};
protoOf($serializer_65).hp = function (decoder) {
  var tmp0_desc = this.i45_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_input = decoder.ss(tmp0_desc);
  var tmp15_cached = Companion_getInstance_84().h45_1;
  if (tmp14_input.it()) {
    tmp4_local0 = tmp14_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp14_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp14_input.gt(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp14_input.gt(tmp0_desc, 3, tmp15_cached[3].w(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp14_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp14_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp14_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp14_input.gt(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp14_input.gt(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp14_input.gt(tmp0_desc, 9, tmp15_cached[9].w(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp14_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp14_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp14_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp14_input.gt(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp14_input.gt(tmp0_desc, 3, tmp15_cached[3].w(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp14_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp14_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp14_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp14_input.gt(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp14_input.gt(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp14_input.gt(tmp0_desc, 9, tmp15_cached[9].w(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp14_input.ts(tmp0_desc);
  return Transactions_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
};
protoOf($serializer_65).fp = function () {
  return this.i45_1;
};
protoOf($serializer_65).z10 = function () {
  var tmp0_cached = Companion_getInstance_84().h45_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(tmp0_cached[3].w()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[9].w())];
};
var $serializer_instance_65;
function $serializer_getInstance_65() {
  if ($serializer_instance_65 == null)
    new $serializer_65();
  return $serializer_instance_65;
}
function Transactions_init_$Init$(seen0, parent, page, pageSize, status, start, end, ticker, latest, inProgress, transactionType, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_65().i45_1);
  }
  if (0 === (seen0 & 1))
    $this.k45_1 = new UserRoutes();
  else
    $this.k45_1 = parent;
  if (0 === (seen0 & 2))
    $this.l45_1 = null;
  else
    $this.l45_1 = page;
  if (0 === (seen0 & 4))
    $this.m45_1 = null;
  else
    $this.m45_1 = pageSize;
  if (0 === (seen0 & 8))
    $this.n45_1 = null;
  else
    $this.n45_1 = status;
  if (0 === (seen0 & 16))
    $this.o45_1 = null;
  else
    $this.o45_1 = start;
  if (0 === (seen0 & 32))
    $this.p45_1 = null;
  else
    $this.p45_1 = end;
  if (0 === (seen0 & 64))
    $this.q45_1 = null;
  else
    $this.q45_1 = ticker;
  if (0 === (seen0 & 128))
    $this.r45_1 = null;
  else
    $this.r45_1 = latest;
  if (0 === (seen0 & 256))
    $this.s45_1 = null;
  else
    $this.s45_1 = inProgress;
  if (0 === (seen0 & 512))
    $this.t45_1 = null;
  else
    $this.t45_1 = transactionType;
  return $this;
}
function Transactions_init_$Create$(seen0, parent, page, pageSize, status, start, end, ticker, latest, inProgress, transactionType, serializationConstructorMarker) {
  return Transactions_init_$Init$(seen0, parent, page, pageSize, status, start, end, ticker, latest, inProgress, transactionType, serializationConstructorMarker, objectCreate(protoOf(Transactions)));
}
function Companion_82() {
}
var Companion_instance_82;
function Companion_getInstance_85() {
  return Companion_instance_82;
}
function $serializer_66() {
  $serializer_instance_66 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.Reservation', this, 2);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.oz(new Resource('reservation/{ticker}'));
  this.u45_1 = tmp0_serialDesc;
}
protoOf($serializer_66).v45 = function (encoder, value) {
  var tmp0_desc = this.u45_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.w45_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.w45_1);
  }
  tmp1_output.hu(tmp0_desc, 1, value.x45_1);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_66).gp = function (encoder, value) {
  return this.v45(encoder, value instanceof Reservation ? value : THROW_CCE());
};
protoOf($serializer_66).hp = function (decoder) {
  var tmp0_desc = this.u45_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return Reservation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_66).fp = function () {
  return this.u45_1;
};
protoOf($serializer_66).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70(), StringSerializer_getInstance()];
};
var $serializer_instance_66;
function $serializer_getInstance_66() {
  if ($serializer_instance_66 == null)
    new $serializer_66();
  return $serializer_instance_66;
}
function Reservation_init_$Init$(seen0, parent, ticker, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_66().u45_1);
  }
  if (0 === (seen0 & 1))
    $this.w45_1 = new UserRoutes();
  else
    $this.w45_1 = parent;
  $this.x45_1 = ticker;
  return $this;
}
function Reservation_init_$Create$(seen0, parent, ticker, serializationConstructorMarker) {
  return Reservation_init_$Init$(seen0, parent, ticker, serializationConstructorMarker, objectCreate(protoOf(Reservation)));
}
function Companion_83() {
}
var Companion_instance_83;
function Companion_getInstance_86() {
  return Companion_instance_83;
}
function $serializer_67() {
  $serializer_instance_67 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.CreateTransaction', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('transaction'));
  this.y45_1 = tmp0_serialDesc;
}
protoOf($serializer_67).z45 = function (encoder, value) {
  var tmp0_desc = this.y45_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.a46_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.a46_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_67).gp = function (encoder, value) {
  return this.z45(encoder, value instanceof CreateTransaction ? value : THROW_CCE());
};
protoOf($serializer_67).hp = function (decoder) {
  var tmp0_desc = this.y45_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return CreateTransaction_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_67).fp = function () {
  return this.y45_1;
};
protoOf($serializer_67).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_67;
function $serializer_getInstance_67() {
  if ($serializer_instance_67 == null)
    new $serializer_67();
  return $serializer_instance_67;
}
function CreateTransaction_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_67().y45_1);
  }
  if (0 === (seen0 & 1))
    $this.a46_1 = new UserRoutes();
  else
    $this.a46_1 = parent;
  return $this;
}
function CreateTransaction_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return CreateTransaction_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(CreateTransaction)));
}
function Companion_84() {
}
var Companion_instance_84;
function Companion_getInstance_87() {
  return Companion_instance_84;
}
function $serializer_68() {
  $serializer_instance_68 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.FeedbackSurvey', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('feedback_survey'));
  this.b46_1 = tmp0_serialDesc;
}
protoOf($serializer_68).c46 = function (encoder, value) {
  var tmp0_desc = this.b46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.d46_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.d46_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_68).gp = function (encoder, value) {
  return this.c46(encoder, value instanceof FeedbackSurvey ? value : THROW_CCE());
};
protoOf($serializer_68).hp = function (decoder) {
  var tmp0_desc = this.b46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return FeedbackSurvey_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_68).fp = function () {
  return this.b46_1;
};
protoOf($serializer_68).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_68;
function $serializer_getInstance_68() {
  if ($serializer_instance_68 == null)
    new $serializer_68();
  return $serializer_instance_68;
}
function FeedbackSurvey_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_68().b46_1);
  }
  if (0 === (seen0 & 1))
    $this.d46_1 = new UserRoutes();
  else
    $this.d46_1 = parent;
  return $this;
}
function FeedbackSurvey_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return FeedbackSurvey_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(FeedbackSurvey)));
}
function Companion_85() {
}
var Companion_instance_85;
function Companion_getInstance_88() {
  return Companion_instance_85;
}
function $serializer_69() {
  $serializer_instance_69 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes.UpdateThreshold', this, 1);
  tmp0_serialDesc.k10('parent', true);
  tmp0_serialDesc.oz(new Resource('update_threshold'));
  this.e46_1 = tmp0_serialDesc;
}
protoOf($serializer_69).f46 = function (encoder, value) {
  var tmp0_desc = this.e46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !equals(value.g46_1, new UserRoutes())) {
    tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_70(), value.g46_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_69).gp = function (encoder, value) {
  return this.f46(encoder, value instanceof UpdateThreshold ? value : THROW_CCE());
};
protoOf($serializer_69).hp = function (decoder) {
  var tmp0_desc = this.e46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_70(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return UpdateThreshold_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_69).fp = function () {
  return this.e46_1;
};
protoOf($serializer_69).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_70()];
};
var $serializer_instance_69;
function $serializer_getInstance_69() {
  if ($serializer_instance_69 == null)
    new $serializer_69();
  return $serializer_instance_69;
}
function UpdateThreshold_init_$Init$(seen0, parent, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_69().e46_1);
  }
  if (0 === (seen0 & 1))
    $this.g46_1 = new UserRoutes();
  else
    $this.g46_1 = parent;
  return $this;
}
function UpdateThreshold_init_$Create$(seen0, parent, serializationConstructorMarker) {
  return UpdateThreshold_init_$Init$(seen0, parent, serializationConstructorMarker, objectCreate(protoOf(UpdateThreshold)));
}
function TransactionById(parent, id) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.h44_1 = parent;
  this.i44_1 = id;
}
protoOf(TransactionById).toString = function () {
  return 'TransactionById(parent=' + toString_0(this.h44_1) + ', id=' + this.i44_1.toString() + ')';
};
protoOf(TransactionById).hashCode = function () {
  var result = hashCode(this.h44_1);
  result = imul(result, 31) + this.i44_1.hashCode() | 0;
  return result;
};
protoOf(TransactionById).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransactionById))
    return false;
  if (!equals(this.h44_1, other.h44_1))
    return false;
  if (!this.i44_1.equals(other.i44_1))
    return false;
  return true;
};
function DepositBankDetail(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.l44_1 = parent;
}
protoOf(DepositBankDetail).toString = function () {
  return 'DepositBankDetail(parent=' + toString_0(this.l44_1) + ')';
};
protoOf(DepositBankDetail).hashCode = function () {
  return hashCode(this.l44_1);
};
protoOf(DepositBankDetail).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DepositBankDetail))
    return false;
  if (!equals(this.l44_1, other.l44_1))
    return false;
  return true;
};
function PayoutBank(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.o44_1 = parent;
}
protoOf(PayoutBank).toString = function () {
  return 'PayoutBank(parent=' + toString_0(this.o44_1) + ')';
};
protoOf(PayoutBank).hashCode = function () {
  return hashCode(this.o44_1);
};
protoOf(PayoutBank).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PayoutBank))
    return false;
  if (!equals(this.o44_1, other.o44_1))
    return false;
  return true;
};
function BankAccountBeneficiary(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.r44_1 = parent;
}
protoOf(BankAccountBeneficiary).toString = function () {
  return 'BankAccountBeneficiary(parent=' + toString_0(this.r44_1) + ')';
};
protoOf(BankAccountBeneficiary).hashCode = function () {
  return hashCode(this.r44_1);
};
protoOf(BankAccountBeneficiary).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BankAccountBeneficiary))
    return false;
  if (!equals(this.r44_1, other.r44_1))
    return false;
  return true;
};
function BankAccount(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.u44_1 = parent;
}
protoOf(BankAccount).toString = function () {
  return 'BankAccount(parent=' + toString_0(this.u44_1) + ')';
};
protoOf(BankAccount).hashCode = function () {
  return hashCode(this.u44_1);
};
protoOf(BankAccount).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BankAccount))
    return false;
  if (!equals(this.u44_1, other.u44_1))
    return false;
  return true;
};
function ShuftiAccessToken(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.x44_1 = parent;
}
protoOf(ShuftiAccessToken).toString = function () {
  return 'ShuftiAccessToken(parent=' + toString_0(this.x44_1) + ')';
};
protoOf(ShuftiAccessToken).hashCode = function () {
  return hashCode(this.x44_1);
};
protoOf(ShuftiAccessToken).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShuftiAccessToken))
    return false;
  if (!equals(this.x44_1, other.x44_1))
    return false;
  return true;
};
function PortfolioByTicker(parent, ticker, page, pageSize) {
  parent = parent === VOID ? new UserRoutes() : parent;
  page = page === VOID ? null : page;
  pageSize = pageSize === VOID ? null : pageSize;
  this.a45_1 = parent;
  this.b45_1 = ticker;
  this.c45_1 = page;
  this.d45_1 = pageSize;
}
protoOf(PortfolioByTicker).toString = function () {
  return 'PortfolioByTicker(parent=' + toString_0(this.a45_1) + ', ticker=' + this.b45_1 + ', page=' + toString(this.c45_1) + ', pageSize=' + toString(this.d45_1) + ')';
};
protoOf(PortfolioByTicker).hashCode = function () {
  var result = hashCode(this.a45_1);
  result = imul(result, 31) + getStringHashCode(this.b45_1) | 0;
  result = imul(result, 31) + (this.c45_1 == null ? 0 : getBigIntHashCode(this.c45_1)) | 0;
  result = imul(result, 31) + (this.d45_1 == null ? 0 : getBigIntHashCode(this.d45_1)) | 0;
  return result;
};
protoOf(PortfolioByTicker).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PortfolioByTicker))
    return false;
  if (!equals(this.a45_1, other.a45_1))
    return false;
  if (!(this.b45_1 === other.b45_1))
    return false;
  if (!(this.c45_1 == other.c45_1))
    return false;
  if (!(this.d45_1 == other.d45_1))
    return false;
  return true;
};
function Portfolios(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.g45_1 = parent;
}
protoOf(Portfolios).toString = function () {
  return 'Portfolios(parent=' + toString_0(this.g45_1) + ')';
};
protoOf(Portfolios).hashCode = function () {
  return hashCode(this.g45_1);
};
protoOf(Portfolios).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Portfolios))
    return false;
  if (!equals(this.g45_1, other.g45_1))
    return false;
  return true;
};
function Transactions(parent, page, pageSize, status, start, end, ticker, latest, inProgress, transactionType) {
  Companion_getInstance_84();
  parent = parent === VOID ? new UserRoutes() : parent;
  page = page === VOID ? null : page;
  pageSize = pageSize === VOID ? null : pageSize;
  status = status === VOID ? null : status;
  start = start === VOID ? null : start;
  end = end === VOID ? null : end;
  ticker = ticker === VOID ? null : ticker;
  latest = latest === VOID ? null : latest;
  inProgress = inProgress === VOID ? null : inProgress;
  transactionType = transactionType === VOID ? null : transactionType;
  this.k45_1 = parent;
  this.l45_1 = page;
  this.m45_1 = pageSize;
  this.n45_1 = status;
  this.o45_1 = start;
  this.p45_1 = end;
  this.q45_1 = ticker;
  this.r45_1 = latest;
  this.s45_1 = inProgress;
  this.t45_1 = transactionType;
}
protoOf(Transactions).toString = function () {
  return 'Transactions(parent=' + toString_0(this.k45_1) + ', page=' + toString(this.l45_1) + ', pageSize=' + toString(this.m45_1) + ', status=' + toString(this.n45_1) + ', start=' + this.o45_1 + ', end=' + this.p45_1 + ', ticker=' + this.q45_1 + ', latest=' + this.r45_1 + ', inProgress=' + this.s45_1 + ', transactionType=' + toString(this.t45_1) + ')';
};
protoOf(Transactions).hashCode = function () {
  var result = hashCode(this.k45_1);
  result = imul(result, 31) + (this.l45_1 == null ? 0 : getBigIntHashCode(this.l45_1)) | 0;
  result = imul(result, 31) + (this.m45_1 == null ? 0 : getBigIntHashCode(this.m45_1)) | 0;
  result = imul(result, 31) + (this.n45_1 == null ? 0 : this.n45_1.hashCode()) | 0;
  result = imul(result, 31) + (this.o45_1 == null ? 0 : getStringHashCode(this.o45_1)) | 0;
  result = imul(result, 31) + (this.p45_1 == null ? 0 : getStringHashCode(this.p45_1)) | 0;
  result = imul(result, 31) + (this.q45_1 == null ? 0 : getStringHashCode(this.q45_1)) | 0;
  result = imul(result, 31) + (this.r45_1 == null ? 0 : getBooleanHashCode(this.r45_1)) | 0;
  result = imul(result, 31) + (this.s45_1 == null ? 0 : getBooleanHashCode(this.s45_1)) | 0;
  result = imul(result, 31) + (this.t45_1 == null ? 0 : this.t45_1.hashCode()) | 0;
  return result;
};
protoOf(Transactions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Transactions))
    return false;
  if (!equals(this.k45_1, other.k45_1))
    return false;
  if (!(this.l45_1 == other.l45_1))
    return false;
  if (!(this.m45_1 == other.m45_1))
    return false;
  if (!equals(this.n45_1, other.n45_1))
    return false;
  if (!(this.o45_1 == other.o45_1))
    return false;
  if (!(this.p45_1 == other.p45_1))
    return false;
  if (!(this.q45_1 == other.q45_1))
    return false;
  if (!(this.r45_1 == other.r45_1))
    return false;
  if (!(this.s45_1 == other.s45_1))
    return false;
  if (!equals(this.t45_1, other.t45_1))
    return false;
  return true;
};
function Reservation(parent, ticker) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.w45_1 = parent;
  this.x45_1 = ticker;
}
protoOf(Reservation).toString = function () {
  return 'Reservation(parent=' + toString_0(this.w45_1) + ', ticker=' + this.x45_1 + ')';
};
protoOf(Reservation).hashCode = function () {
  var result = hashCode(this.w45_1);
  result = imul(result, 31) + getStringHashCode(this.x45_1) | 0;
  return result;
};
protoOf(Reservation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Reservation))
    return false;
  if (!equals(this.w45_1, other.w45_1))
    return false;
  if (!(this.x45_1 === other.x45_1))
    return false;
  return true;
};
function CreateTransaction(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.a46_1 = parent;
}
protoOf(CreateTransaction).toString = function () {
  return 'CreateTransaction(parent=' + toString_0(this.a46_1) + ')';
};
protoOf(CreateTransaction).hashCode = function () {
  return hashCode(this.a46_1);
};
protoOf(CreateTransaction).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CreateTransaction))
    return false;
  if (!equals(this.a46_1, other.a46_1))
    return false;
  return true;
};
function FeedbackSurvey(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.d46_1 = parent;
}
protoOf(FeedbackSurvey).toString = function () {
  return 'FeedbackSurvey(parent=' + toString_0(this.d46_1) + ')';
};
protoOf(FeedbackSurvey).hashCode = function () {
  return hashCode(this.d46_1);
};
protoOf(FeedbackSurvey).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FeedbackSurvey))
    return false;
  if (!equals(this.d46_1, other.d46_1))
    return false;
  return true;
};
function UpdateThreshold(parent) {
  parent = parent === VOID ? new UserRoutes() : parent;
  this.g46_1 = parent;
}
protoOf(UpdateThreshold).toString = function () {
  return 'UpdateThreshold(parent=' + toString_0(this.g46_1) + ')';
};
protoOf(UpdateThreshold).hashCode = function () {
  return hashCode(this.g46_1);
};
protoOf(UpdateThreshold).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UpdateThreshold))
    return false;
  if (!equals(this.g46_1, other.g46_1))
    return false;
  return true;
};
function Companion_86() {
}
var Companion_instance_86;
function Companion_getInstance_89() {
  return Companion_instance_86;
}
function $serializer_70() {
  $serializer_instance_70 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.routes.UserRoutes', this, 0);
  tmp0_serialDesc.oz(new Resource('/api/v1/user'));
  this.h46_1 = tmp0_serialDesc;
}
protoOf($serializer_70).i46 = function (encoder, value) {
  var tmp0_desc = this.h46_1;
  encoder.ss(tmp0_desc).ts(tmp0_desc);
};
protoOf($serializer_70).gp = function (encoder, value) {
  return this.i46(encoder, value instanceof UserRoutes ? value : THROW_CCE());
};
protoOf($serializer_70).hp = function (decoder) {
  var tmp0_desc = this.h46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp4_input = decoder.ss(tmp0_desc);
  if (!tmp4_input.it())
    while (tmp1_flag) {
      tmp2_index = tmp4_input.jt(tmp0_desc);
      if (tmp2_index === -1)
        tmp1_flag = false;
      else
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  tmp4_input.ts(tmp0_desc);
  return UserRoutes_init_$Create$(0, null);
};
protoOf($serializer_70).fp = function () {
  return this.h46_1;
};
protoOf($serializer_70).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [];
};
var $serializer_instance_70;
function $serializer_getInstance_70() {
  if ($serializer_instance_70 == null)
    new $serializer_70();
  return $serializer_instance_70;
}
function UserRoutes_init_$Init$(seen0, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_70().h46_1);
  }
  return $this;
}
function UserRoutes_init_$Create$(seen0, serializationConstructorMarker) {
  return UserRoutes_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(UserRoutes)));
}
function UserRoutes() {
}
function Companion_87() {
}
protoOf(Companion_87).o1c = function () {
  return $serializer_getInstance_71();
};
var Companion_instance_87;
function Companion_getInstance_90() {
  return Companion_instance_87;
}
function $serializer_71() {
  $serializer_instance_71 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.ActivateTotpResponse', this, 1);
  tmp0_serialDesc.k10('key', false);
  this.j46_1 = tmp0_serialDesc;
}
protoOf($serializer_71).k46 = function (encoder, value) {
  var tmp0_desc = this.j46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.key);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_71).gp = function (encoder, value) {
  return this.k46(encoder, value instanceof ActivateTotpResponse ? value : THROW_CCE());
};
protoOf($serializer_71).hp = function (decoder) {
  var tmp0_desc = this.j46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return ActivateTotpResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_71).fp = function () {
  return this.j46_1;
};
protoOf($serializer_71).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_71;
function $serializer_getInstance_71() {
  if ($serializer_instance_71 == null)
    new $serializer_71();
  return $serializer_instance_71;
}
function ActivateTotpResponse_init_$Init$(seen0, key, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_71().j46_1);
  }
  $this.key = key;
  return $this;
}
function ActivateTotpResponse_init_$Create$(seen0, key, serializationConstructorMarker) {
  return ActivateTotpResponse_init_$Init$(seen0, key, serializationConstructorMarker, objectCreate(protoOf(ActivateTotpResponse)));
}
function ActivateTotpResponse(key) {
  this.key = key;
}
protoOf(ActivateTotpResponse).v = function () {
  return this.key;
};
protoOf(ActivateTotpResponse).wf = function () {
  return this.key;
};
protoOf(ActivateTotpResponse).s3t = function (key) {
  return new ActivateTotpResponse(key);
};
protoOf(ActivateTotpResponse).copy = function (key, $super) {
  key = key === VOID ? this.key : key;
  return $super === VOID ? this.s3t(key) : $super.s3t.call(this, key);
};
protoOf(ActivateTotpResponse).toString = function () {
  return 'ActivateTotpResponse(key=' + this.key + ')';
};
protoOf(ActivateTotpResponse).hashCode = function () {
  return getStringHashCode(this.key);
};
protoOf(ActivateTotpResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ActivateTotpResponse))
    return false;
  if (!(this.key === other.key))
    return false;
  return true;
};
function Companion_88() {
}
protoOf(Companion_88).o1c = function () {
  return $serializer_getInstance_72();
};
var Companion_instance_88;
function Companion_getInstance_91() {
  return Companion_instance_88;
}
function $serializer_72() {
  $serializer_instance_72 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.EnablePasswordRequest', this, 1);
  tmp0_serialDesc.k10('password', false);
  this.l46_1 = tmp0_serialDesc;
}
protoOf($serializer_72).m46 = function (encoder, value) {
  var tmp0_desc = this.l46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.password);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_72).gp = function (encoder, value) {
  return this.m46(encoder, value instanceof EnablePasswordRequest ? value : THROW_CCE());
};
protoOf($serializer_72).hp = function (decoder) {
  var tmp0_desc = this.l46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return EnablePasswordRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_72).fp = function () {
  return this.l46_1;
};
protoOf($serializer_72).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_72;
function $serializer_getInstance_72() {
  if ($serializer_instance_72 == null)
    new $serializer_72();
  return $serializer_instance_72;
}
function EnablePasswordRequest_init_$Init$(seen0, password, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_72().l46_1);
  }
  $this.password = password;
  return $this;
}
function EnablePasswordRequest_init_$Create$(seen0, password, serializationConstructorMarker) {
  return EnablePasswordRequest_init_$Init$(seen0, password, serializationConstructorMarker, objectCreate(protoOf(EnablePasswordRequest)));
}
function EnablePasswordRequest(password) {
  this.password = password;
}
protoOf(EnablePasswordRequest).l3e = function () {
  return this.password;
};
protoOf(EnablePasswordRequest).wf = function () {
  return this.password;
};
protoOf(EnablePasswordRequest).s3t = function (password) {
  return new EnablePasswordRequest(password);
};
protoOf(EnablePasswordRequest).copy = function (password, $super) {
  password = password === VOID ? this.password : password;
  return $super === VOID ? this.s3t(password) : $super.s3t.call(this, password);
};
protoOf(EnablePasswordRequest).toString = function () {
  return 'EnablePasswordRequest(password=' + this.password + ')';
};
protoOf(EnablePasswordRequest).hashCode = function () {
  return getStringHashCode(this.password);
};
protoOf(EnablePasswordRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EnablePasswordRequest))
    return false;
  if (!(this.password === other.password))
    return false;
  return true;
};
function Companion_89() {
}
protoOf(Companion_89).o1c = function () {
  return $serializer_getInstance_73();
};
var Companion_instance_89;
function Companion_getInstance_92() {
  return Companion_instance_89;
}
function $serializer_73() {
  $serializer_instance_73 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.GetUserSettingsResponseEnable', this, 1);
  tmp0_serialDesc.k10('enabled', false);
  this.n46_1 = tmp0_serialDesc;
}
protoOf($serializer_73).o46 = function (encoder, value) {
  var tmp0_desc = this.n46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.zt(tmp0_desc, 0, value.enabled);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_73).gp = function (encoder, value) {
  return this.o46(encoder, value instanceof GetUserSettingsResponseEnable ? value : THROW_CCE());
};
protoOf($serializer_73).hp = function (decoder) {
  var tmp0_desc = this.n46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.us(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.us(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return GetUserSettingsResponseEnable_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_73).fp = function () {
  return this.n46_1;
};
protoOf($serializer_73).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance()];
};
var $serializer_instance_73;
function $serializer_getInstance_73() {
  if ($serializer_instance_73 == null)
    new $serializer_73();
  return $serializer_instance_73;
}
function GetUserSettingsResponseEnable_init_$Init$(seen0, enabled, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_73().n46_1);
  }
  $this.enabled = enabled;
  return $this;
}
function GetUserSettingsResponseEnable_init_$Create$(seen0, enabled, serializationConstructorMarker) {
  return GetUserSettingsResponseEnable_init_$Init$(seen0, enabled, serializationConstructorMarker, objectCreate(protoOf(GetUserSettingsResponseEnable)));
}
function GetUserSettingsResponseEnable(enabled) {
  this.enabled = enabled;
}
protoOf(GetUserSettingsResponseEnable).p46 = function () {
  return this.enabled;
};
protoOf(GetUserSettingsResponseEnable).wf = function () {
  return this.enabled;
};
protoOf(GetUserSettingsResponseEnable).q46 = function (enabled) {
  return new GetUserSettingsResponseEnable(enabled);
};
protoOf(GetUserSettingsResponseEnable).copy = function (enabled, $super) {
  enabled = enabled === VOID ? this.enabled : enabled;
  return $super === VOID ? this.q46(enabled) : $super.q46.call(this, enabled);
};
protoOf(GetUserSettingsResponseEnable).toString = function () {
  return 'GetUserSettingsResponseEnable(enabled=' + this.enabled + ')';
};
protoOf(GetUserSettingsResponseEnable).hashCode = function () {
  return getBooleanHashCode(this.enabled);
};
protoOf(GetUserSettingsResponseEnable).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GetUserSettingsResponseEnable))
    return false;
  if (!(this.enabled === other.enabled))
    return false;
  return true;
};
function GetUserSettingsResponseWebAuthn$Companion$$childSerializers$_anonymous__k5sh3n() {
  return new ArrayListSerializer($serializer_getInstance_75());
}
function Companion_90() {
  Companion_instance_90 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r46_1 = [lazy(tmp_0, GetUserSettingsResponseWebAuthn$Companion$$childSerializers$_anonymous__k5sh3n)];
}
protoOf(Companion_90).o1c = function () {
  return $serializer_getInstance_74();
};
var Companion_instance_90;
function Companion_getInstance_93() {
  if (Companion_instance_90 == null)
    new Companion_90();
  return Companion_instance_90;
}
function $serializer_74() {
  $serializer_instance_74 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.GetUserSettingsResponseWebAuthn', this, 1);
  tmp0_serialDesc.k10('devices', false);
  this.s46_1 = tmp0_serialDesc;
}
protoOf($serializer_74).t46 = function (encoder, value) {
  var tmp0_desc = this.s46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_93().r46_1;
  tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.devices);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_74).gp = function (encoder, value) {
  return this.t46(encoder, value instanceof GetUserSettingsResponseWebAuthn ? value : THROW_CCE());
};
protoOf($serializer_74).hp = function (decoder) {
  var tmp0_desc = this.s46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  var tmp6_cached = Companion_getInstance_93().r46_1;
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return GetUserSettingsResponseWebAuthn_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_74).fp = function () {
  return this.s46_1;
};
protoOf($serializer_74).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_93().r46_1[0].w()];
};
var $serializer_instance_74;
function $serializer_getInstance_74() {
  if ($serializer_instance_74 == null)
    new $serializer_74();
  return $serializer_instance_74;
}
function GetUserSettingsResponseWebAuthn_init_$Init$(seen0, devices, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_74().s46_1);
  }
  $this.devices = devices;
  return $this;
}
function GetUserSettingsResponseWebAuthn_init_$Create$(seen0, devices, serializationConstructorMarker) {
  return GetUserSettingsResponseWebAuthn_init_$Init$(seen0, devices, serializationConstructorMarker, objectCreate(protoOf(GetUserSettingsResponseWebAuthn)));
}
function GetUserSettingsResponseWebAuthn(devices) {
  Companion_getInstance_93();
  this.devices = devices;
}
protoOf(GetUserSettingsResponseWebAuthn).u46 = function () {
  return this.devices;
};
protoOf(GetUserSettingsResponseWebAuthn).wf = function () {
  return this.devices;
};
protoOf(GetUserSettingsResponseWebAuthn).v46 = function (devices) {
  return new GetUserSettingsResponseWebAuthn(devices);
};
protoOf(GetUserSettingsResponseWebAuthn).copy = function (devices, $super) {
  devices = devices === VOID ? this.devices : devices;
  return $super === VOID ? this.v46(devices) : $super.v46.call(this, devices);
};
protoOf(GetUserSettingsResponseWebAuthn).toString = function () {
  return 'GetUserSettingsResponseWebAuthn(devices=' + toString_0(this.devices) + ')';
};
protoOf(GetUserSettingsResponseWebAuthn).hashCode = function () {
  return hashCode(this.devices);
};
protoOf(GetUserSettingsResponseWebAuthn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GetUserSettingsResponseWebAuthn))
    return false;
  if (!equals(this.devices, other.devices))
    return false;
  return true;
};
function Companion_91() {
}
protoOf(Companion_91).o1c = function () {
  return $serializer_getInstance_75();
};
var Companion_instance_91;
function Companion_getInstance_94() {
  return Companion_instance_91;
}
function $serializer_75() {
  $serializer_instance_75 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.WebAuthnDevice', this, 2);
  tmp0_serialDesc.k10('id', false);
  tmp0_serialDesc.k10('label', false);
  this.w46_1 = tmp0_serialDesc;
}
protoOf($serializer_75).x46 = function (encoder, value) {
  var tmp0_desc = this.w46_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, UuidStringSerializer_getInstance(), value.id);
  tmp1_output.hu(tmp0_desc, 1, value.label);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_75).gp = function (encoder, value) {
  return this.x46(encoder, value instanceof WebAuthnDevice ? value : THROW_CCE());
};
protoOf($serializer_75).hp = function (decoder) {
  var tmp0_desc = this.w46_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, UuidStringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, UuidStringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return WebAuthnDevice_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_75).fp = function () {
  return this.w46_1;
};
protoOf($serializer_75).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [UuidStringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_75;
function $serializer_getInstance_75() {
  if ($serializer_instance_75 == null)
    new $serializer_75();
  return $serializer_instance_75;
}
function WebAuthnDevice_init_$Init$(seen0, id, label, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_75().w46_1);
  }
  $this.id = id;
  $this.label = label;
  return $this;
}
function WebAuthnDevice_init_$Create$(seen0, id, label, serializationConstructorMarker) {
  return WebAuthnDevice_init_$Init$(seen0, id, label, serializationConstructorMarker, objectCreate(protoOf(WebAuthnDevice)));
}
function WebAuthnDevice(id, label) {
  this.id = id;
  this.label = label;
}
protoOf(WebAuthnDevice).l3t = function () {
  return this.id;
};
protoOf(WebAuthnDevice).y46 = function () {
  return this.label;
};
protoOf(WebAuthnDevice).wf = function () {
  return this.id;
};
protoOf(WebAuthnDevice).xf = function () {
  return this.label;
};
protoOf(WebAuthnDevice).z46 = function (id, label) {
  return new WebAuthnDevice(id, label);
};
protoOf(WebAuthnDevice).copy = function (id, label, $super) {
  id = id === VOID ? this.id : id;
  label = label === VOID ? this.label : label;
  return $super === VOID ? this.z46(id, label) : $super.z46.call(this, id, label);
};
protoOf(WebAuthnDevice).toString = function () {
  return 'WebAuthnDevice(id=' + this.id.toString() + ', label=' + this.label + ')';
};
protoOf(WebAuthnDevice).hashCode = function () {
  var result = this.id.hashCode();
  result = imul(result, 31) + getStringHashCode(this.label) | 0;
  return result;
};
protoOf(WebAuthnDevice).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebAuthnDevice))
    return false;
  if (!this.id.equals(other.id))
    return false;
  if (!(this.label === other.label))
    return false;
  return true;
};
function Companion_92() {
}
protoOf(Companion_92).o1c = function () {
  return $serializer_getInstance_76();
};
var Companion_instance_92;
function Companion_getInstance_95() {
  return Companion_instance_92;
}
function $serializer_76() {
  $serializer_instance_76 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.GetUserSettingsResponse', this, 4);
  tmp0_serialDesc.k10('password', false);
  tmp0_serialDesc.k10('totp', false);
  tmp0_serialDesc.k10('webauthn', false);
  tmp0_serialDesc.k10('default2FA', true);
  this.a47_1 = tmp0_serialDesc;
}
protoOf($serializer_76).b47 = function (encoder, value) {
  var tmp0_desc = this.a47_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_73(), value.password);
  tmp1_output.ju(tmp0_desc, 1, $serializer_getInstance_73(), value.totp);
  tmp1_output.ju(tmp0_desc, 2, $serializer_getInstance_74(), value.webauthn);
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.default2FA === '')) {
    tmp1_output.hu(tmp0_desc, 3, value.default2FA);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_76).gp = function (encoder, value) {
  return this.b47(encoder, value instanceof GetUserSettingsResponse ? value : THROW_CCE());
};
protoOf($serializer_76).hp = function (decoder) {
  var tmp0_desc = this.a47_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.ss(tmp0_desc);
  if (tmp8_input.it()) {
    tmp4_local0 = tmp8_input.et(tmp0_desc, 0, $serializer_getInstance_73(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.et(tmp0_desc, 1, $serializer_getInstance_73(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.et(tmp0_desc, 2, $serializer_getInstance_74(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.et(tmp0_desc, 0, $serializer_getInstance_73(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.et(tmp0_desc, 1, $serializer_getInstance_73(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.et(tmp0_desc, 2, $serializer_getInstance_74(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.ts(tmp0_desc);
  return GetUserSettingsResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_76).fp = function () {
  return this.a47_1;
};
protoOf($serializer_76).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_73(), $serializer_getInstance_73(), $serializer_getInstance_74(), StringSerializer_getInstance()];
};
var $serializer_instance_76;
function $serializer_getInstance_76() {
  if ($serializer_instance_76 == null)
    new $serializer_76();
  return $serializer_instance_76;
}
function GetUserSettingsResponse_init_$Init$(seen0, password, totp, webauthn, default2FA, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_76().a47_1);
  }
  $this.password = password;
  $this.totp = totp;
  $this.webauthn = webauthn;
  if (0 === (seen0 & 8))
    $this.default2FA = '';
  else
    $this.default2FA = default2FA;
  return $this;
}
function GetUserSettingsResponse_init_$Create$(seen0, password, totp, webauthn, default2FA, serializationConstructorMarker) {
  return GetUserSettingsResponse_init_$Init$(seen0, password, totp, webauthn, default2FA, serializationConstructorMarker, objectCreate(protoOf(GetUserSettingsResponse)));
}
function GetUserSettingsResponse(password, totp, webauthn, default2FA) {
  default2FA = default2FA === VOID ? '' : default2FA;
  this.password = password;
  this.totp = totp;
  this.webauthn = webauthn;
  this.default2FA = default2FA;
}
protoOf(GetUserSettingsResponse).l3e = function () {
  return this.password;
};
protoOf(GetUserSettingsResponse).c47 = function () {
  return this.totp;
};
protoOf(GetUserSettingsResponse).d47 = function () {
  return this.webauthn;
};
protoOf(GetUserSettingsResponse).e47 = function () {
  return this.default2FA;
};
protoOf(GetUserSettingsResponse).wf = function () {
  return this.password;
};
protoOf(GetUserSettingsResponse).xf = function () {
  return this.totp;
};
protoOf(GetUserSettingsResponse).e3p = function () {
  return this.webauthn;
};
protoOf(GetUserSettingsResponse).f3p = function () {
  return this.default2FA;
};
protoOf(GetUserSettingsResponse).f47 = function (password, totp, webauthn, default2FA) {
  return new GetUserSettingsResponse(password, totp, webauthn, default2FA);
};
protoOf(GetUserSettingsResponse).copy = function (password, totp, webauthn, default2FA, $super) {
  password = password === VOID ? this.password : password;
  totp = totp === VOID ? this.totp : totp;
  webauthn = webauthn === VOID ? this.webauthn : webauthn;
  default2FA = default2FA === VOID ? this.default2FA : default2FA;
  return $super === VOID ? this.f47(password, totp, webauthn, default2FA) : $super.f47.call(this, password, totp, webauthn, default2FA);
};
protoOf(GetUserSettingsResponse).toString = function () {
  return 'GetUserSettingsResponse(password=' + this.password.toString() + ', totp=' + this.totp.toString() + ', webauthn=' + this.webauthn.toString() + ', default2FA=' + this.default2FA + ')';
};
protoOf(GetUserSettingsResponse).hashCode = function () {
  var result = this.password.hashCode();
  result = imul(result, 31) + this.totp.hashCode() | 0;
  result = imul(result, 31) + this.webauthn.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.default2FA) | 0;
  return result;
};
protoOf(GetUserSettingsResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GetUserSettingsResponse))
    return false;
  if (!this.password.equals(other.password))
    return false;
  if (!this.totp.equals(other.totp))
    return false;
  if (!this.webauthn.equals(other.webauthn))
    return false;
  if (!(this.default2FA === other.default2FA))
    return false;
  return true;
};
function Companion_93() {
}
protoOf(Companion_93).o1c = function () {
  return $serializer_getInstance_77();
};
var Companion_instance_93;
function Companion_getInstance_96() {
  return Companion_instance_93;
}
function $serializer_77() {
  $serializer_instance_77 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.RegisterWebAuthnRequest', this, 6);
  tmp0_serialDesc.k10('id', false);
  tmp0_serialDesc.k10('rawId', false);
  tmp0_serialDesc.k10('type', false);
  tmp0_serialDesc.k10('authenticatorAttachment', false);
  tmp0_serialDesc.k10('response', false);
  tmp0_serialDesc.k10('clientExtensionResults', false);
  this.g47_1 = tmp0_serialDesc;
}
protoOf($serializer_77).h47 = function (encoder, value) {
  var tmp0_desc = this.g47_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.id);
  tmp1_output.hu(tmp0_desc, 1, value.rawId);
  tmp1_output.hu(tmp0_desc, 2, value.type);
  tmp1_output.hu(tmp0_desc, 3, value.authenticatorAttachment);
  tmp1_output.ju(tmp0_desc, 4, $serializer_getInstance_78(), value.response);
  tmp1_output.ju(tmp0_desc, 5, $serializer_getInstance_79(), value.clientExtensionResults);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_77).gp = function (encoder, value) {
  return this.h47(encoder, value instanceof RegisterWebAuthnRequest ? value : THROW_CCE());
};
protoOf($serializer_77).hp = function (decoder) {
  var tmp0_desc = this.g47_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_input = decoder.ss(tmp0_desc);
  if (tmp10_input.it()) {
    tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.et(tmp0_desc, 4, $serializer_getInstance_78(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.et(tmp0_desc, 5, $serializer_getInstance_79(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.et(tmp0_desc, 4, $serializer_getInstance_78(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.et(tmp0_desc, 5, $serializer_getInstance_79(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.ts(tmp0_desc);
  return RegisterWebAuthnRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_77).fp = function () {
  return this.g47_1;
};
protoOf($serializer_77).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_78(), $serializer_getInstance_79()];
};
var $serializer_instance_77;
function $serializer_getInstance_77() {
  if ($serializer_instance_77 == null)
    new $serializer_77();
  return $serializer_instance_77;
}
function RegisterWebAuthnRequest_init_$Init$(seen0, id, rawId, type, authenticatorAttachment, response, clientExtensionResults, serializationConstructorMarker, $this) {
  if (!(63 === (63 & seen0))) {
    throwMissingFieldException(seen0, 63, $serializer_getInstance_77().g47_1);
  }
  $this.id = id;
  $this.rawId = rawId;
  $this.type = type;
  $this.authenticatorAttachment = authenticatorAttachment;
  $this.response = response;
  $this.clientExtensionResults = clientExtensionResults;
  return $this;
}
function RegisterWebAuthnRequest_init_$Create$(seen0, id, rawId, type, authenticatorAttachment, response, clientExtensionResults, serializationConstructorMarker) {
  return RegisterWebAuthnRequest_init_$Init$(seen0, id, rawId, type, authenticatorAttachment, response, clientExtensionResults, serializationConstructorMarker, objectCreate(protoOf(RegisterWebAuthnRequest)));
}
function RegisterWebAuthnRequest(id, rawId, type, authenticatorAttachment, response, clientExtensionResults) {
  this.id = id;
  this.rawId = rawId;
  this.type = type;
  this.authenticatorAttachment = authenticatorAttachment;
  this.response = response;
  this.clientExtensionResults = clientExtensionResults;
}
protoOf(RegisterWebAuthnRequest).i47 = function (_set____db54di) {
  this.id = _set____db54di;
};
protoOf(RegisterWebAuthnRequest).l3t = function () {
  return this.id;
};
protoOf(RegisterWebAuthnRequest).j47 = function (_set____db54di) {
  this.rawId = _set____db54di;
};
protoOf(RegisterWebAuthnRequest).k47 = function () {
  return this.rawId;
};
protoOf(RegisterWebAuthnRequest).m3t = function () {
  return this.type;
};
protoOf(RegisterWebAuthnRequest).l47 = function () {
  return this.authenticatorAttachment;
};
protoOf(RegisterWebAuthnRequest).m47 = function () {
  return this.response;
};
protoOf(RegisterWebAuthnRequest).n47 = function () {
  return this.clientExtensionResults;
};
protoOf(RegisterWebAuthnRequest).wf = function () {
  return this.id;
};
protoOf(RegisterWebAuthnRequest).xf = function () {
  return this.rawId;
};
protoOf(RegisterWebAuthnRequest).e3p = function () {
  return this.type;
};
protoOf(RegisterWebAuthnRequest).f3p = function () {
  return this.authenticatorAttachment;
};
protoOf(RegisterWebAuthnRequest).u3q = function () {
  return this.response;
};
protoOf(RegisterWebAuthnRequest).v3q = function () {
  return this.clientExtensionResults;
};
protoOf(RegisterWebAuthnRequest).o47 = function (id, rawId, type, authenticatorAttachment, response, clientExtensionResults) {
  return new RegisterWebAuthnRequest(id, rawId, type, authenticatorAttachment, response, clientExtensionResults);
};
protoOf(RegisterWebAuthnRequest).copy = function (id, rawId, type, authenticatorAttachment, response, clientExtensionResults, $super) {
  id = id === VOID ? this.id : id;
  rawId = rawId === VOID ? this.rawId : rawId;
  type = type === VOID ? this.type : type;
  authenticatorAttachment = authenticatorAttachment === VOID ? this.authenticatorAttachment : authenticatorAttachment;
  response = response === VOID ? this.response : response;
  clientExtensionResults = clientExtensionResults === VOID ? this.clientExtensionResults : clientExtensionResults;
  return $super === VOID ? this.o47(id, rawId, type, authenticatorAttachment, response, clientExtensionResults) : $super.o47.call(this, id, rawId, type, authenticatorAttachment, response, clientExtensionResults);
};
protoOf(RegisterWebAuthnRequest).toString = function () {
  return 'RegisterWebAuthnRequest(id=' + this.id + ', rawId=' + this.rawId + ', type=' + this.type + ', authenticatorAttachment=' + this.authenticatorAttachment + ', response=' + this.response.toString() + ', clientExtensionResults=' + this.clientExtensionResults.toString() + ')';
};
protoOf(RegisterWebAuthnRequest).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + getStringHashCode(this.rawId) | 0;
  result = imul(result, 31) + getStringHashCode(this.type) | 0;
  result = imul(result, 31) + getStringHashCode(this.authenticatorAttachment) | 0;
  result = imul(result, 31) + this.response.hashCode() | 0;
  result = imul(result, 31) + this.clientExtensionResults.hashCode() | 0;
  return result;
};
protoOf(RegisterWebAuthnRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RegisterWebAuthnRequest))
    return false;
  if (!(this.id === other.id))
    return false;
  if (!(this.rawId === other.rawId))
    return false;
  if (!(this.type === other.type))
    return false;
  if (!(this.authenticatorAttachment === other.authenticatorAttachment))
    return false;
  if (!this.response.equals(other.response))
    return false;
  if (!this.clientExtensionResults.equals(other.clientExtensionResults))
    return false;
  return true;
};
function RegisterWebAuthnRequestResponse$Companion$$childSerializers$_anonymous__brzowf() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function Companion_94() {
  Companion_instance_94 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.p47_1 = [null, null, lazy(tmp_0, RegisterWebAuthnRequestResponse$Companion$$childSerializers$_anonymous__brzowf), null, null, null];
}
protoOf(Companion_94).o1c = function () {
  return $serializer_getInstance_78();
};
var Companion_instance_94;
function Companion_getInstance_97() {
  if (Companion_instance_94 == null)
    new Companion_94();
  return Companion_instance_94;
}
function $serializer_78() {
  $serializer_instance_78 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.RegisterWebAuthnRequestResponse', this, 6);
  tmp0_serialDesc.k10('clientDataJSON', false);
  tmp0_serialDesc.k10('attestationObject', false);
  tmp0_serialDesc.k10('transports', false);
  tmp0_serialDesc.k10('authenticatorData', true);
  tmp0_serialDesc.k10('publicKeyAlgorithm', true);
  tmp0_serialDesc.k10('publicKey', true);
  this.q47_1 = tmp0_serialDesc;
}
protoOf($serializer_78).r47 = function (encoder, value) {
  var tmp0_desc = this.q47_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_97().p47_1;
  tmp1_output.hu(tmp0_desc, 0, value.clientDataJSON);
  tmp1_output.hu(tmp0_desc, 1, value.attestationObject);
  tmp1_output.ju(tmp0_desc, 2, tmp2_cached[2].w(), value.transports);
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.authenticatorData == null)) {
    tmp1_output.lu(tmp0_desc, 3, StringSerializer_getInstance(), value.authenticatorData);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.publicKeyAlgorithm == null)) {
    tmp1_output.lu(tmp0_desc, 4, IntSerializer_getInstance(), value.publicKeyAlgorithm);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.publicKey == null)) {
    tmp1_output.lu(tmp0_desc, 5, StringSerializer_getInstance(), value.publicKey);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_78).gp = function (encoder, value) {
  return this.r47(encoder, value instanceof RegisterWebAuthnRequestResponse ? value : THROW_CCE());
};
protoOf($serializer_78).hp = function (decoder) {
  var tmp0_desc = this.q47_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_input = decoder.ss(tmp0_desc);
  var tmp11_cached = Companion_getInstance_97().p47_1;
  if (tmp10_input.it()) {
    tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.et(tmp0_desc, 2, tmp11_cached[2].w(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.et(tmp0_desc, 2, tmp11_cached[2].w(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.ts(tmp0_desc);
  return RegisterWebAuthnRequestResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_78).fp = function () {
  return this.q47_1;
};
protoOf($serializer_78).z10 = function () {
  var tmp0_cached = Companion_getInstance_97().p47_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].w(), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_78;
function $serializer_getInstance_78() {
  if ($serializer_instance_78 == null)
    new $serializer_78();
  return $serializer_instance_78;
}
function RegisterWebAuthnRequestResponse_init_$Init$(seen0, clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_78().q47_1);
  }
  $this.clientDataJSON = clientDataJSON;
  $this.attestationObject = attestationObject;
  $this.transports = transports;
  if (0 === (seen0 & 8))
    $this.authenticatorData = null;
  else
    $this.authenticatorData = authenticatorData;
  if (0 === (seen0 & 16))
    $this.publicKeyAlgorithm = null;
  else
    $this.publicKeyAlgorithm = publicKeyAlgorithm;
  if (0 === (seen0 & 32))
    $this.publicKey = null;
  else
    $this.publicKey = publicKey;
  return $this;
}
function RegisterWebAuthnRequestResponse_init_$Create$(seen0, clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey, serializationConstructorMarker) {
  return RegisterWebAuthnRequestResponse_init_$Init$(seen0, clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey, serializationConstructorMarker, objectCreate(protoOf(RegisterWebAuthnRequestResponse)));
}
function RegisterWebAuthnRequestResponse(clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey) {
  Companion_getInstance_97();
  authenticatorData = authenticatorData === VOID ? null : authenticatorData;
  publicKeyAlgorithm = publicKeyAlgorithm === VOID ? null : publicKeyAlgorithm;
  publicKey = publicKey === VOID ? null : publicKey;
  this.clientDataJSON = clientDataJSON;
  this.attestationObject = attestationObject;
  this.transports = transports;
  this.authenticatorData = authenticatorData;
  this.publicKeyAlgorithm = publicKeyAlgorithm;
  this.publicKey = publicKey;
}
protoOf(RegisterWebAuthnRequestResponse).s47 = function (_set____db54di) {
  this.clientDataJSON = _set____db54di;
};
protoOf(RegisterWebAuthnRequestResponse).t47 = function () {
  return this.clientDataJSON;
};
protoOf(RegisterWebAuthnRequestResponse).u47 = function (_set____db54di) {
  this.attestationObject = _set____db54di;
};
protoOf(RegisterWebAuthnRequestResponse).v47 = function () {
  return this.attestationObject;
};
protoOf(RegisterWebAuthnRequestResponse).w47 = function (_set____db54di) {
  this.transports = _set____db54di;
};
protoOf(RegisterWebAuthnRequestResponse).n3t = function () {
  return this.transports;
};
protoOf(RegisterWebAuthnRequestResponse).x47 = function (_set____db54di) {
  this.authenticatorData = _set____db54di;
};
protoOf(RegisterWebAuthnRequestResponse).y47 = function () {
  return this.authenticatorData;
};
protoOf(RegisterWebAuthnRequestResponse).z47 = function (_set____db54di) {
  this.publicKeyAlgorithm = _set____db54di;
};
protoOf(RegisterWebAuthnRequestResponse).a48 = function () {
  return this.publicKeyAlgorithm;
};
protoOf(RegisterWebAuthnRequestResponse).b48 = function (_set____db54di) {
  this.publicKey = _set____db54di;
};
protoOf(RegisterWebAuthnRequestResponse).u3s = function () {
  return this.publicKey;
};
protoOf(RegisterWebAuthnRequestResponse).wf = function () {
  return this.clientDataJSON;
};
protoOf(RegisterWebAuthnRequestResponse).xf = function () {
  return this.attestationObject;
};
protoOf(RegisterWebAuthnRequestResponse).e3p = function () {
  return this.transports;
};
protoOf(RegisterWebAuthnRequestResponse).f3p = function () {
  return this.authenticatorData;
};
protoOf(RegisterWebAuthnRequestResponse).u3q = function () {
  return this.publicKeyAlgorithm;
};
protoOf(RegisterWebAuthnRequestResponse).v3q = function () {
  return this.publicKey;
};
protoOf(RegisterWebAuthnRequestResponse).c48 = function (clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey) {
  return new RegisterWebAuthnRequestResponse(clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey);
};
protoOf(RegisterWebAuthnRequestResponse).copy = function (clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey, $super) {
  clientDataJSON = clientDataJSON === VOID ? this.clientDataJSON : clientDataJSON;
  attestationObject = attestationObject === VOID ? this.attestationObject : attestationObject;
  transports = transports === VOID ? this.transports : transports;
  authenticatorData = authenticatorData === VOID ? this.authenticatorData : authenticatorData;
  publicKeyAlgorithm = publicKeyAlgorithm === VOID ? this.publicKeyAlgorithm : publicKeyAlgorithm;
  publicKey = publicKey === VOID ? this.publicKey : publicKey;
  return $super === VOID ? this.c48(clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey) : $super.c48.call(this, clientDataJSON, attestationObject, transports, authenticatorData, publicKeyAlgorithm, publicKey);
};
protoOf(RegisterWebAuthnRequestResponse).toString = function () {
  return 'RegisterWebAuthnRequestResponse(clientDataJSON=' + this.clientDataJSON + ', attestationObject=' + this.attestationObject + ', transports=' + toString_0(this.transports) + ', authenticatorData=' + this.authenticatorData + ', publicKeyAlgorithm=' + this.publicKeyAlgorithm + ', publicKey=' + this.publicKey + ')';
};
protoOf(RegisterWebAuthnRequestResponse).hashCode = function () {
  var result = getStringHashCode(this.clientDataJSON);
  result = imul(result, 31) + getStringHashCode(this.attestationObject) | 0;
  result = imul(result, 31) + hashCode(this.transports) | 0;
  result = imul(result, 31) + (this.authenticatorData == null ? 0 : getStringHashCode(this.authenticatorData)) | 0;
  result = imul(result, 31) + (this.publicKeyAlgorithm == null ? 0 : this.publicKeyAlgorithm) | 0;
  result = imul(result, 31) + (this.publicKey == null ? 0 : getStringHashCode(this.publicKey)) | 0;
  return result;
};
protoOf(RegisterWebAuthnRequestResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RegisterWebAuthnRequestResponse))
    return false;
  if (!(this.clientDataJSON === other.clientDataJSON))
    return false;
  if (!(this.attestationObject === other.attestationObject))
    return false;
  if (!equals(this.transports, other.transports))
    return false;
  if (!(this.authenticatorData == other.authenticatorData))
    return false;
  if (!(this.publicKeyAlgorithm == other.publicKeyAlgorithm))
    return false;
  if (!(this.publicKey == other.publicKey))
    return false;
  return true;
};
function Companion_95() {
}
protoOf(Companion_95).o1c = function () {
  return $serializer_getInstance_79();
};
var Companion_instance_95;
function Companion_getInstance_98() {
  return Companion_instance_95;
}
function $serializer_79() {
  $serializer_instance_79 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.RegisterWebAuthnRequestClientExtensionResults', this, 1);
  tmp0_serialDesc.k10('credProps', false);
  this.d48_1 = tmp0_serialDesc;
}
protoOf($serializer_79).e48 = function (encoder, value) {
  var tmp0_desc = this.d48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_80(), value.credProps);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_79).gp = function (encoder, value) {
  return this.e48(encoder, value instanceof RegisterWebAuthnRequestClientExtensionResults ? value : THROW_CCE());
};
protoOf($serializer_79).hp = function (decoder) {
  var tmp0_desc = this.d48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_80(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, $serializer_getInstance_80(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return RegisterWebAuthnRequestClientExtensionResults_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_79).fp = function () {
  return this.d48_1;
};
protoOf($serializer_79).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_80()];
};
var $serializer_instance_79;
function $serializer_getInstance_79() {
  if ($serializer_instance_79 == null)
    new $serializer_79();
  return $serializer_instance_79;
}
function RegisterWebAuthnRequestClientExtensionResults_init_$Init$(seen0, credProps, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_79().d48_1);
  }
  $this.credProps = credProps;
  return $this;
}
function RegisterWebAuthnRequestClientExtensionResults_init_$Create$(seen0, credProps, serializationConstructorMarker) {
  return RegisterWebAuthnRequestClientExtensionResults_init_$Init$(seen0, credProps, serializationConstructorMarker, objectCreate(protoOf(RegisterWebAuthnRequestClientExtensionResults)));
}
function RegisterWebAuthnRequestClientExtensionResults(credProps) {
  this.credProps = credProps;
}
protoOf(RegisterWebAuthnRequestClientExtensionResults).f48 = function () {
  return this.credProps;
};
protoOf(RegisterWebAuthnRequestClientExtensionResults).wf = function () {
  return this.credProps;
};
protoOf(RegisterWebAuthnRequestClientExtensionResults).g48 = function (credProps) {
  return new RegisterWebAuthnRequestClientExtensionResults(credProps);
};
protoOf(RegisterWebAuthnRequestClientExtensionResults).copy = function (credProps, $super) {
  credProps = credProps === VOID ? this.credProps : credProps;
  return $super === VOID ? this.g48(credProps) : $super.g48.call(this, credProps);
};
protoOf(RegisterWebAuthnRequestClientExtensionResults).toString = function () {
  return 'RegisterWebAuthnRequestClientExtensionResults(credProps=' + this.credProps.toString() + ')';
};
protoOf(RegisterWebAuthnRequestClientExtensionResults).hashCode = function () {
  return this.credProps.hashCode();
};
protoOf(RegisterWebAuthnRequestClientExtensionResults).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RegisterWebAuthnRequestClientExtensionResults))
    return false;
  if (!this.credProps.equals(other.credProps))
    return false;
  return true;
};
function Companion_96() {
}
protoOf(Companion_96).o1c = function () {
  return $serializer_getInstance_80();
};
var Companion_instance_96;
function Companion_getInstance_99() {
  return Companion_instance_96;
}
function $serializer_80() {
  $serializer_instance_80 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.RegisterWebAuthnRequestCredProps', this, 1);
  tmp0_serialDesc.k10('rk', false);
  this.h48_1 = tmp0_serialDesc;
}
protoOf($serializer_80).i48 = function (encoder, value) {
  var tmp0_desc = this.h48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.zt(tmp0_desc, 0, value.rk);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_80).gp = function (encoder, value) {
  return this.i48(encoder, value instanceof RegisterWebAuthnRequestCredProps ? value : THROW_CCE());
};
protoOf($serializer_80).hp = function (decoder) {
  var tmp0_desc = this.h48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.us(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.us(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return RegisterWebAuthnRequestCredProps_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_80).fp = function () {
  return this.h48_1;
};
protoOf($serializer_80).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance()];
};
var $serializer_instance_80;
function $serializer_getInstance_80() {
  if ($serializer_instance_80 == null)
    new $serializer_80();
  return $serializer_instance_80;
}
function RegisterWebAuthnRequestCredProps_init_$Init$(seen0, rk, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_80().h48_1);
  }
  $this.rk = rk;
  return $this;
}
function RegisterWebAuthnRequestCredProps_init_$Create$(seen0, rk, serializationConstructorMarker) {
  return RegisterWebAuthnRequestCredProps_init_$Init$(seen0, rk, serializationConstructorMarker, objectCreate(protoOf(RegisterWebAuthnRequestCredProps)));
}
function RegisterWebAuthnRequestCredProps(rk) {
  this.rk = rk;
}
protoOf(RegisterWebAuthnRequestCredProps).j48 = function () {
  return this.rk;
};
protoOf(RegisterWebAuthnRequestCredProps).wf = function () {
  return this.rk;
};
protoOf(RegisterWebAuthnRequestCredProps).q46 = function (rk) {
  return new RegisterWebAuthnRequestCredProps(rk);
};
protoOf(RegisterWebAuthnRequestCredProps).copy = function (rk, $super) {
  rk = rk === VOID ? this.rk : rk;
  return $super === VOID ? this.q46(rk) : $super.q46.call(this, rk);
};
protoOf(RegisterWebAuthnRequestCredProps).toString = function () {
  return 'RegisterWebAuthnRequestCredProps(rk=' + this.rk + ')';
};
protoOf(RegisterWebAuthnRequestCredProps).hashCode = function () {
  return getBooleanHashCode(this.rk);
};
protoOf(RegisterWebAuthnRequestCredProps).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RegisterWebAuthnRequestCredProps))
    return false;
  if (!(this.rk === other.rk))
    return false;
  return true;
};
function SetDefault2FARequest$Companion$$childSerializers$_anonymous__hkqcjt() {
  return Companion_getInstance_23().o1c();
}
function Companion_97() {
  Companion_instance_97 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.k48_1 = [lazy(tmp_0, SetDefault2FARequest$Companion$$childSerializers$_anonymous__hkqcjt)];
}
protoOf(Companion_97).o1c = function () {
  return $serializer_getInstance_81();
};
var Companion_instance_97;
function Companion_getInstance_100() {
  if (Companion_instance_97 == null)
    new Companion_97();
  return Companion_instance_97;
}
function $serializer_81() {
  $serializer_instance_81 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.SetDefault2FARequest', this, 1);
  tmp0_serialDesc.k10('default2FA', false);
  this.l48_1 = tmp0_serialDesc;
}
protoOf($serializer_81).m48 = function (encoder, value) {
  var tmp0_desc = this.l48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_100().k48_1;
  tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.default2FA);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_81).gp = function (encoder, value) {
  return this.m48(encoder, value instanceof SetDefault2FARequest ? value : THROW_CCE());
};
protoOf($serializer_81).hp = function (decoder) {
  var tmp0_desc = this.l48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  var tmp6_cached = Companion_getInstance_100().k48_1;
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return SetDefault2FARequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_81).fp = function () {
  return this.l48_1;
};
protoOf($serializer_81).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_100().k48_1[0].w()];
};
var $serializer_instance_81;
function $serializer_getInstance_81() {
  if ($serializer_instance_81 == null)
    new $serializer_81();
  return $serializer_instance_81;
}
function SetDefault2FARequest_init_$Init$(seen0, default2FA, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_81().l48_1);
  }
  $this.default2FA = default2FA;
  return $this;
}
function SetDefault2FARequest_init_$Create$(seen0, default2FA, serializationConstructorMarker) {
  return SetDefault2FARequest_init_$Init$(seen0, default2FA, serializationConstructorMarker, objectCreate(protoOf(SetDefault2FARequest)));
}
function SetDefault2FARequest(default2FA) {
  Companion_getInstance_100();
  this.default2FA = default2FA;
}
protoOf(SetDefault2FARequest).e47 = function () {
  return this.default2FA;
};
protoOf(SetDefault2FARequest).wf = function () {
  return this.default2FA;
};
protoOf(SetDefault2FARequest).n48 = function (default2FA) {
  return new SetDefault2FARequest(default2FA);
};
protoOf(SetDefault2FARequest).copy = function (default2FA, $super) {
  default2FA = default2FA === VOID ? this.default2FA : default2FA;
  return $super === VOID ? this.n48(default2FA) : $super.n48.call(this, default2FA);
};
protoOf(SetDefault2FARequest).toString = function () {
  return 'SetDefault2FARequest(default2FA=' + this.default2FA.toString() + ')';
};
protoOf(SetDefault2FARequest).hashCode = function () {
  return this.default2FA.hashCode();
};
protoOf(SetDefault2FARequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetDefault2FARequest))
    return false;
  if (!this.default2FA.equals(other.default2FA))
    return false;
  return true;
};
function Companion_98() {
}
protoOf(Companion_98).o1c = function () {
  return $serializer_getInstance_82();
};
var Companion_instance_98;
function Companion_getInstance_101() {
  return Companion_instance_98;
}
function $serializer_82() {
  $serializer_instance_82 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.StartRegisterWebAuthnRequest', this, 2);
  tmp0_serialDesc.k10('label', false);
  tmp0_serialDesc.k10('expires_time', true);
  this.o48_1 = tmp0_serialDesc;
}
protoOf($serializer_82).p48 = function (encoder, value) {
  var tmp0_desc = this.o48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.label);
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.expiresTime == null)) {
    tmp1_output.lu(tmp0_desc, 1, LongSerializer_getInstance(), value.expiresTime);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_82).gp = function (encoder, value) {
  return this.p48(encoder, value instanceof StartRegisterWebAuthnRequest ? value : THROW_CCE());
};
protoOf($serializer_82).hp = function (decoder) {
  var tmp0_desc = this.o48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return StartRegisterWebAuthnRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_82).fp = function () {
  return this.o48_1;
};
protoOf($serializer_82).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
};
var $serializer_instance_82;
function $serializer_getInstance_82() {
  if ($serializer_instance_82 == null)
    new $serializer_82();
  return $serializer_instance_82;
}
function StartRegisterWebAuthnRequest_init_$Init$(seen0, label, expiresTime, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_82().o48_1);
  }
  $this.label = label;
  if (0 === (seen0 & 2))
    $this.expiresTime = null;
  else
    $this.expiresTime = expiresTime;
  return $this;
}
function StartRegisterWebAuthnRequest_init_$Create$(seen0, label, expiresTime, serializationConstructorMarker) {
  return StartRegisterWebAuthnRequest_init_$Init$(seen0, label, expiresTime, serializationConstructorMarker, objectCreate(protoOf(StartRegisterWebAuthnRequest)));
}
function StartRegisterWebAuthnRequest(label, expiresTime) {
  expiresTime = expiresTime === VOID ? null : expiresTime;
  this.label = label;
  this.expiresTime = expiresTime;
}
protoOf(StartRegisterWebAuthnRequest).y46 = function () {
  return this.label;
};
protoOf(StartRegisterWebAuthnRequest).y3r = function () {
  return this.expiresTime;
};
protoOf(StartRegisterWebAuthnRequest).wf = function () {
  return this.label;
};
protoOf(StartRegisterWebAuthnRequest).xf = function () {
  return this.expiresTime;
};
protoOf(StartRegisterWebAuthnRequest).q48 = function (label, expiresTime) {
  return new StartRegisterWebAuthnRequest(label, expiresTime);
};
protoOf(StartRegisterWebAuthnRequest).copy = function (label, expiresTime, $super) {
  label = label === VOID ? this.label : label;
  expiresTime = expiresTime === VOID ? this.expiresTime : expiresTime;
  return $super === VOID ? this.q48(label, expiresTime) : $super.q48.call(this, label, expiresTime);
};
protoOf(StartRegisterWebAuthnRequest).toString = function () {
  return 'StartRegisterWebAuthnRequest(label=' + this.label + ', expiresTime=' + toString(this.expiresTime) + ')';
};
protoOf(StartRegisterWebAuthnRequest).hashCode = function () {
  var result = getStringHashCode(this.label);
  result = imul(result, 31) + (this.expiresTime == null ? 0 : getBigIntHashCode(this.expiresTime)) | 0;
  return result;
};
protoOf(StartRegisterWebAuthnRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StartRegisterWebAuthnRequest))
    return false;
  if (!(this.label === other.label))
    return false;
  if (!(this.expiresTime == other.expiresTime))
    return false;
  return true;
};
function Companion_99() {
}
protoOf(Companion_99).o1c = function () {
  return $serializer_getInstance_83();
};
var Companion_instance_99;
function Companion_getInstance_102() {
  return Companion_instance_99;
}
function $serializer_83() {
  $serializer_instance_83 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.PublicKeyCredentialCreationRp', this, 2);
  tmp0_serialDesc.k10('id', true);
  tmp0_serialDesc.k10('name', true);
  this.r48_1 = tmp0_serialDesc;
}
protoOf($serializer_83).s48 = function (encoder, value) {
  var tmp0_desc = this.r48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.id == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.id);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.name == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.name);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_83).gp = function (encoder, value) {
  return this.s48(encoder, value instanceof PublicKeyCredentialCreationRp ? value : THROW_CCE());
};
protoOf($serializer_83).hp = function (decoder) {
  var tmp0_desc = this.r48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return PublicKeyCredentialCreationRp_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_83).fp = function () {
  return this.r48_1;
};
protoOf($serializer_83).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_83;
function $serializer_getInstance_83() {
  if ($serializer_instance_83 == null)
    new $serializer_83();
  return $serializer_instance_83;
}
function PublicKeyCredentialCreationRp_init_$Init$(seen0, id, name, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_83().r48_1);
  }
  if (0 === (seen0 & 1))
    $this.id = null;
  else
    $this.id = id;
  if (0 === (seen0 & 2))
    $this.name = null;
  else
    $this.name = name;
  return $this;
}
function PublicKeyCredentialCreationRp_init_$Create$(seen0, id, name, serializationConstructorMarker) {
  return PublicKeyCredentialCreationRp_init_$Init$(seen0, id, name, serializationConstructorMarker, objectCreate(protoOf(PublicKeyCredentialCreationRp)));
}
function PublicKeyCredentialCreationRp(id, name) {
  id = id === VOID ? null : id;
  name = name === VOID ? null : name;
  this.id = id;
  this.name = name;
}
protoOf(PublicKeyCredentialCreationRp).l3t = function () {
  return this.id;
};
protoOf(PublicKeyCredentialCreationRp).k2 = function () {
  return this.name;
};
protoOf(PublicKeyCredentialCreationRp).wf = function () {
  return this.id;
};
protoOf(PublicKeyCredentialCreationRp).xf = function () {
  return this.name;
};
protoOf(PublicKeyCredentialCreationRp).t48 = function (id, name) {
  return new PublicKeyCredentialCreationRp(id, name);
};
protoOf(PublicKeyCredentialCreationRp).copy = function (id, name, $super) {
  id = id === VOID ? this.id : id;
  name = name === VOID ? this.name : name;
  return $super === VOID ? this.t48(id, name) : $super.t48.call(this, id, name);
};
protoOf(PublicKeyCredentialCreationRp).toString = function () {
  return 'PublicKeyCredentialCreationRp(id=' + this.id + ', name=' + this.name + ')';
};
protoOf(PublicKeyCredentialCreationRp).hashCode = function () {
  var result = this.id == null ? 0 : getStringHashCode(this.id);
  result = imul(result, 31) + (this.name == null ? 0 : getStringHashCode(this.name)) | 0;
  return result;
};
protoOf(PublicKeyCredentialCreationRp).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PublicKeyCredentialCreationRp))
    return false;
  if (!(this.id == other.id))
    return false;
  if (!(this.name == other.name))
    return false;
  return true;
};
function Companion_100() {
}
protoOf(Companion_100).o1c = function () {
  return $serializer_getInstance_84();
};
var Companion_instance_100;
function Companion_getInstance_103() {
  return Companion_instance_100;
}
function $serializer_84() {
  $serializer_instance_84 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.PublicKeyCredentialCreationUser', this, 3);
  tmp0_serialDesc.k10('id', true);
  tmp0_serialDesc.k10('name', true);
  tmp0_serialDesc.k10('displayName', true);
  this.u48_1 = tmp0_serialDesc;
}
protoOf($serializer_84).v48 = function (encoder, value) {
  var tmp0_desc = this.u48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.id == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.id);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.name == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.name);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.displayName == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.displayName);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_84).gp = function (encoder, value) {
  return this.v48(encoder, value instanceof PublicKeyCredentialCreationUser ? value : THROW_CCE());
};
protoOf($serializer_84).hp = function (decoder) {
  var tmp0_desc = this.u48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return PublicKeyCredentialCreationUser_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_84).fp = function () {
  return this.u48_1;
};
protoOf($serializer_84).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_84;
function $serializer_getInstance_84() {
  if ($serializer_instance_84 == null)
    new $serializer_84();
  return $serializer_instance_84;
}
function PublicKeyCredentialCreationUser_init_$Init$(seen0, id, name, displayName, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_84().u48_1);
  }
  if (0 === (seen0 & 1))
    $this.id = null;
  else
    $this.id = id;
  if (0 === (seen0 & 2))
    $this.name = null;
  else
    $this.name = name;
  if (0 === (seen0 & 4))
    $this.displayName = null;
  else
    $this.displayName = displayName;
  return $this;
}
function PublicKeyCredentialCreationUser_init_$Create$(seen0, id, name, displayName, serializationConstructorMarker) {
  return PublicKeyCredentialCreationUser_init_$Init$(seen0, id, name, displayName, serializationConstructorMarker, objectCreate(protoOf(PublicKeyCredentialCreationUser)));
}
function PublicKeyCredentialCreationUser(id, name, displayName) {
  id = id === VOID ? null : id;
  name = name === VOID ? null : name;
  displayName = displayName === VOID ? null : displayName;
  this.id = id;
  this.name = name;
  this.displayName = displayName;
}
protoOf(PublicKeyCredentialCreationUser).l3t = function () {
  return this.id;
};
protoOf(PublicKeyCredentialCreationUser).k2 = function () {
  return this.name;
};
protoOf(PublicKeyCredentialCreationUser).w48 = function () {
  return this.displayName;
};
protoOf(PublicKeyCredentialCreationUser).wf = function () {
  return this.id;
};
protoOf(PublicKeyCredentialCreationUser).xf = function () {
  return this.name;
};
protoOf(PublicKeyCredentialCreationUser).e3p = function () {
  return this.displayName;
};
protoOf(PublicKeyCredentialCreationUser).x48 = function (id, name, displayName) {
  return new PublicKeyCredentialCreationUser(id, name, displayName);
};
protoOf(PublicKeyCredentialCreationUser).copy = function (id, name, displayName, $super) {
  id = id === VOID ? this.id : id;
  name = name === VOID ? this.name : name;
  displayName = displayName === VOID ? this.displayName : displayName;
  return $super === VOID ? this.x48(id, name, displayName) : $super.x48.call(this, id, name, displayName);
};
protoOf(PublicKeyCredentialCreationUser).toString = function () {
  return 'PublicKeyCredentialCreationUser(id=' + this.id + ', name=' + this.name + ', displayName=' + this.displayName + ')';
};
protoOf(PublicKeyCredentialCreationUser).hashCode = function () {
  var result = this.id == null ? 0 : getStringHashCode(this.id);
  result = imul(result, 31) + (this.name == null ? 0 : getStringHashCode(this.name)) | 0;
  result = imul(result, 31) + (this.displayName == null ? 0 : getStringHashCode(this.displayName)) | 0;
  return result;
};
protoOf(PublicKeyCredentialCreationUser).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PublicKeyCredentialCreationUser))
    return false;
  if (!(this.id == other.id))
    return false;
  if (!(this.name == other.name))
    return false;
  if (!(this.displayName == other.displayName))
    return false;
  return true;
};
function Companion_101() {
}
protoOf(Companion_101).o1c = function () {
  return $serializer_getInstance_85();
};
var Companion_instance_101;
function Companion_getInstance_104() {
  return Companion_instance_101;
}
function $serializer_85() {
  $serializer_instance_85 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.PublicKeyCredentialCreationPubKeyCredParam', this, 2);
  tmp0_serialDesc.k10('type', true);
  tmp0_serialDesc.k10('alg', true);
  this.y48_1 = tmp0_serialDesc;
}
protoOf($serializer_85).z48 = function (encoder, value) {
  var tmp0_desc = this.y48_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.type == null)) {
    tmp1_output.lu(tmp0_desc, 0, StringSerializer_getInstance(), value.type);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.alg == null)) {
    tmp1_output.lu(tmp0_desc, 1, IntSerializer_getInstance(), value.alg);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_85).gp = function (encoder, value) {
  return this.z48(encoder, value instanceof PublicKeyCredentialCreationPubKeyCredParam ? value : THROW_CCE());
};
protoOf($serializer_85).hp = function (decoder) {
  var tmp0_desc = this.y48_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return PublicKeyCredentialCreationPubKeyCredParam_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_85).fp = function () {
  return this.y48_1;
};
protoOf($serializer_85).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
};
var $serializer_instance_85;
function $serializer_getInstance_85() {
  if ($serializer_instance_85 == null)
    new $serializer_85();
  return $serializer_instance_85;
}
function PublicKeyCredentialCreationPubKeyCredParam_init_$Init$(seen0, type, alg, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_85().y48_1);
  }
  if (0 === (seen0 & 1))
    $this.type = null;
  else
    $this.type = type;
  if (0 === (seen0 & 2))
    $this.alg = null;
  else
    $this.alg = alg;
  return $this;
}
function PublicKeyCredentialCreationPubKeyCredParam_init_$Create$(seen0, type, alg, serializationConstructorMarker) {
  return PublicKeyCredentialCreationPubKeyCredParam_init_$Init$(seen0, type, alg, serializationConstructorMarker, objectCreate(protoOf(PublicKeyCredentialCreationPubKeyCredParam)));
}
function PublicKeyCredentialCreationPubKeyCredParam(type, alg) {
  type = type === VOID ? null : type;
  alg = alg === VOID ? null : alg;
  this.type = type;
  this.alg = alg;
}
protoOf(PublicKeyCredentialCreationPubKeyCredParam).m3t = function () {
  return this.type;
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).a49 = function () {
  return this.alg;
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).wf = function () {
  return this.type;
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).xf = function () {
  return this.alg;
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).b49 = function (type, alg) {
  return new PublicKeyCredentialCreationPubKeyCredParam(type, alg);
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).copy = function (type, alg, $super) {
  type = type === VOID ? this.type : type;
  alg = alg === VOID ? this.alg : alg;
  return $super === VOID ? this.b49(type, alg) : $super.b49.call(this, type, alg);
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).toString = function () {
  return 'PublicKeyCredentialCreationPubKeyCredParam(type=' + this.type + ', alg=' + this.alg + ')';
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).hashCode = function () {
  var result = this.type == null ? 0 : getStringHashCode(this.type);
  result = imul(result, 31) + (this.alg == null ? 0 : this.alg) | 0;
  return result;
};
protoOf(PublicKeyCredentialCreationPubKeyCredParam).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PublicKeyCredentialCreationPubKeyCredParam))
    return false;
  if (!(this.type == other.type))
    return false;
  if (!(this.alg == other.alg))
    return false;
  return true;
};
function Companion_102() {
}
protoOf(Companion_102).o1c = function () {
  return $serializer_getInstance_86();
};
var Companion_instance_102;
function Companion_getInstance_105() {
  return Companion_instance_102;
}
function $serializer_86() {
  $serializer_instance_86 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.PublicKeyCredentialCreationAuthenticatorSelection', this, 4);
  tmp0_serialDesc.k10('requireResidentKey', true);
  tmp0_serialDesc.k10('userVerification', true);
  tmp0_serialDesc.k10('authenticatorAttachment', true);
  tmp0_serialDesc.k10('residentKey', true);
  this.c49_1 = tmp0_serialDesc;
}
protoOf($serializer_86).d49 = function (encoder, value) {
  var tmp0_desc = this.c49_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.requireResidentKey == null)) {
    tmp1_output.lu(tmp0_desc, 0, BooleanSerializer_getInstance(), value.requireResidentKey);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.userVerification == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.userVerification);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.authenticatorAttachment == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.authenticatorAttachment);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.residentKey == null)) {
    tmp1_output.lu(tmp0_desc, 3, StringSerializer_getInstance(), value.residentKey);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_86).gp = function (encoder, value) {
  return this.d49(encoder, value instanceof PublicKeyCredentialCreationAuthenticatorSelection ? value : THROW_CCE());
};
protoOf($serializer_86).hp = function (decoder) {
  var tmp0_desc = this.c49_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.ss(tmp0_desc);
  if (tmp8_input.it()) {
    tmp4_local0 = tmp8_input.gt(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.gt(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.ts(tmp0_desc);
  return PublicKeyCredentialCreationAuthenticatorSelection_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_86).fp = function () {
  return this.c49_1;
};
protoOf($serializer_86).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_86;
function $serializer_getInstance_86() {
  if ($serializer_instance_86 == null)
    new $serializer_86();
  return $serializer_instance_86;
}
function PublicKeyCredentialCreationAuthenticatorSelection_init_$Init$(seen0, requireResidentKey, userVerification, authenticatorAttachment, residentKey, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_86().c49_1);
  }
  if (0 === (seen0 & 1))
    $this.requireResidentKey = null;
  else
    $this.requireResidentKey = requireResidentKey;
  if (0 === (seen0 & 2))
    $this.userVerification = null;
  else
    $this.userVerification = userVerification;
  if (0 === (seen0 & 4))
    $this.authenticatorAttachment = null;
  else
    $this.authenticatorAttachment = authenticatorAttachment;
  if (0 === (seen0 & 8))
    $this.residentKey = null;
  else
    $this.residentKey = residentKey;
  return $this;
}
function PublicKeyCredentialCreationAuthenticatorSelection_init_$Create$(seen0, requireResidentKey, userVerification, authenticatorAttachment, residentKey, serializationConstructorMarker) {
  return PublicKeyCredentialCreationAuthenticatorSelection_init_$Init$(seen0, requireResidentKey, userVerification, authenticatorAttachment, residentKey, serializationConstructorMarker, objectCreate(protoOf(PublicKeyCredentialCreationAuthenticatorSelection)));
}
function PublicKeyCredentialCreationAuthenticatorSelection(requireResidentKey, userVerification, authenticatorAttachment, residentKey) {
  requireResidentKey = requireResidentKey === VOID ? null : requireResidentKey;
  userVerification = userVerification === VOID ? null : userVerification;
  authenticatorAttachment = authenticatorAttachment === VOID ? null : authenticatorAttachment;
  residentKey = residentKey === VOID ? null : residentKey;
  this.requireResidentKey = requireResidentKey;
  this.userVerification = userVerification;
  this.authenticatorAttachment = authenticatorAttachment;
  this.residentKey = residentKey;
}
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).e49 = function () {
  return this.requireResidentKey;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).e3t = function () {
  return this.userVerification;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).l47 = function () {
  return this.authenticatorAttachment;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).f49 = function () {
  return this.residentKey;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).wf = function () {
  return this.requireResidentKey;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).xf = function () {
  return this.userVerification;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).e3p = function () {
  return this.authenticatorAttachment;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).f3p = function () {
  return this.residentKey;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).g49 = function (requireResidentKey, userVerification, authenticatorAttachment, residentKey) {
  return new PublicKeyCredentialCreationAuthenticatorSelection(requireResidentKey, userVerification, authenticatorAttachment, residentKey);
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).copy = function (requireResidentKey, userVerification, authenticatorAttachment, residentKey, $super) {
  requireResidentKey = requireResidentKey === VOID ? this.requireResidentKey : requireResidentKey;
  userVerification = userVerification === VOID ? this.userVerification : userVerification;
  authenticatorAttachment = authenticatorAttachment === VOID ? this.authenticatorAttachment : authenticatorAttachment;
  residentKey = residentKey === VOID ? this.residentKey : residentKey;
  return $super === VOID ? this.g49(requireResidentKey, userVerification, authenticatorAttachment, residentKey) : $super.g49.call(this, requireResidentKey, userVerification, authenticatorAttachment, residentKey);
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).toString = function () {
  return 'PublicKeyCredentialCreationAuthenticatorSelection(requireResidentKey=' + this.requireResidentKey + ', userVerification=' + this.userVerification + ', authenticatorAttachment=' + this.authenticatorAttachment + ', residentKey=' + this.residentKey + ')';
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).hashCode = function () {
  var result = this.requireResidentKey == null ? 0 : getBooleanHashCode(this.requireResidentKey);
  result = imul(result, 31) + (this.userVerification == null ? 0 : getStringHashCode(this.userVerification)) | 0;
  result = imul(result, 31) + (this.authenticatorAttachment == null ? 0 : getStringHashCode(this.authenticatorAttachment)) | 0;
  result = imul(result, 31) + (this.residentKey == null ? 0 : getStringHashCode(this.residentKey)) | 0;
  return result;
};
protoOf(PublicKeyCredentialCreationAuthenticatorSelection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PublicKeyCredentialCreationAuthenticatorSelection))
    return false;
  if (!(this.requireResidentKey == other.requireResidentKey))
    return false;
  if (!(this.userVerification == other.userVerification))
    return false;
  if (!(this.authenticatorAttachment == other.authenticatorAttachment))
    return false;
  if (!(this.residentKey == other.residentKey))
    return false;
  return true;
};
function Companion_103() {
}
protoOf(Companion_103).o1c = function () {
  return $serializer_getInstance_87();
};
var Companion_instance_103;
function Companion_getInstance_106() {
  return Companion_instance_103;
}
function $serializer_87() {
  $serializer_instance_87 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.PublicKeyCredentialCreationExtensions', this, 2);
  tmp0_serialDesc.k10('uvm', true);
  tmp0_serialDesc.k10('credProps', true);
  this.h49_1 = tmp0_serialDesc;
}
protoOf($serializer_87).i49 = function (encoder, value) {
  var tmp0_desc = this.h49_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.uvm == null)) {
    tmp1_output.lu(tmp0_desc, 0, BooleanSerializer_getInstance(), value.uvm);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.credProps == null)) {
    tmp1_output.lu(tmp0_desc, 1, BooleanSerializer_getInstance(), value.credProps);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_87).gp = function (encoder, value) {
  return this.i49(encoder, value instanceof PublicKeyCredentialCreationExtensions ? value : THROW_CCE());
};
protoOf($serializer_87).hp = function (decoder) {
  var tmp0_desc = this.h49_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return PublicKeyCredentialCreationExtensions_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_87).fp = function () {
  return this.h49_1;
};
protoOf($serializer_87).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
};
var $serializer_instance_87;
function $serializer_getInstance_87() {
  if ($serializer_instance_87 == null)
    new $serializer_87();
  return $serializer_instance_87;
}
function PublicKeyCredentialCreationExtensions_init_$Init$(seen0, uvm, credProps, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_87().h49_1);
  }
  if (0 === (seen0 & 1))
    $this.uvm = null;
  else
    $this.uvm = uvm;
  if (0 === (seen0 & 2))
    $this.credProps = null;
  else
    $this.credProps = credProps;
  return $this;
}
function PublicKeyCredentialCreationExtensions_init_$Create$(seen0, uvm, credProps, serializationConstructorMarker) {
  return PublicKeyCredentialCreationExtensions_init_$Init$(seen0, uvm, credProps, serializationConstructorMarker, objectCreate(protoOf(PublicKeyCredentialCreationExtensions)));
}
function PublicKeyCredentialCreationExtensions(uvm, credProps) {
  uvm = uvm === VOID ? null : uvm;
  credProps = credProps === VOID ? null : credProps;
  this.uvm = uvm;
  this.credProps = credProps;
}
protoOf(PublicKeyCredentialCreationExtensions).j49 = function () {
  return this.uvm;
};
protoOf(PublicKeyCredentialCreationExtensions).f48 = function () {
  return this.credProps;
};
protoOf(PublicKeyCredentialCreationExtensions).wf = function () {
  return this.uvm;
};
protoOf(PublicKeyCredentialCreationExtensions).xf = function () {
  return this.credProps;
};
protoOf(PublicKeyCredentialCreationExtensions).k49 = function (uvm, credProps) {
  return new PublicKeyCredentialCreationExtensions(uvm, credProps);
};
protoOf(PublicKeyCredentialCreationExtensions).copy = function (uvm, credProps, $super) {
  uvm = uvm === VOID ? this.uvm : uvm;
  credProps = credProps === VOID ? this.credProps : credProps;
  return $super === VOID ? this.k49(uvm, credProps) : $super.k49.call(this, uvm, credProps);
};
protoOf(PublicKeyCredentialCreationExtensions).toString = function () {
  return 'PublicKeyCredentialCreationExtensions(uvm=' + this.uvm + ', credProps=' + this.credProps + ')';
};
protoOf(PublicKeyCredentialCreationExtensions).hashCode = function () {
  var result = this.uvm == null ? 0 : getBooleanHashCode(this.uvm);
  result = imul(result, 31) + (this.credProps == null ? 0 : getBooleanHashCode(this.credProps)) | 0;
  return result;
};
protoOf(PublicKeyCredentialCreationExtensions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PublicKeyCredentialCreationExtensions))
    return false;
  if (!(this.uvm == other.uvm))
    return false;
  if (!(this.credProps == other.credProps))
    return false;
  return true;
};
function MHPublicKeyCredentialCreationOptions$Companion$$childSerializers$_anonymous__oc8cjn() {
  return new ArrayListSerializer($serializer_getInstance_85());
}
function Companion_104() {
  Companion_instance_104 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.l49_1 = [null, null, null, lazy(tmp_0, MHPublicKeyCredentialCreationOptions$Companion$$childSerializers$_anonymous__oc8cjn), null, null, null, null];
}
protoOf(Companion_104).o1c = function () {
  return $serializer_getInstance_88();
};
var Companion_instance_104;
function Companion_getInstance_107() {
  if (Companion_instance_104 == null)
    new Companion_104();
  return Companion_instance_104;
}
function $serializer_88() {
  $serializer_instance_88 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.MHPublicKeyCredentialCreationOptions', this, 8);
  tmp0_serialDesc.k10('rp', true);
  tmp0_serialDesc.k10('user', true);
  tmp0_serialDesc.k10('challenge', true);
  tmp0_serialDesc.k10('pubKeyCredParams', true);
  tmp0_serialDesc.k10('timeout', true);
  tmp0_serialDesc.k10('attestation', true);
  tmp0_serialDesc.k10('authenticatorSelection', true);
  tmp0_serialDesc.k10('extensions', true);
  this.m49_1 = tmp0_serialDesc;
}
protoOf($serializer_88).n49 = function (encoder, value) {
  var tmp0_desc = this.m49_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_107().l49_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.rp == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_83(), value.rp);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.user == null)) {
    tmp1_output.lu(tmp0_desc, 1, $serializer_getInstance_84(), value.user);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.challenge == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.challenge);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.pubKeyCredParams == null)) {
    tmp1_output.lu(tmp0_desc, 3, tmp2_cached[3].w(), value.pubKeyCredParams);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.timeout == null)) {
    tmp1_output.lu(tmp0_desc, 4, IntSerializer_getInstance(), value.timeout);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.attestation == null)) {
    tmp1_output.lu(tmp0_desc, 5, StringSerializer_getInstance(), value.attestation);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.authenticatorSelection == null)) {
    tmp1_output.lu(tmp0_desc, 6, $serializer_getInstance_86(), value.authenticatorSelection);
  }
  if (tmp1_output.pu(tmp0_desc, 7) ? true : !(value.extensions == null)) {
    tmp1_output.lu(tmp0_desc, 7, $serializer_getInstance_87(), value.extensions);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_88).gp = function (encoder, value) {
  return this.n49(encoder, value instanceof MHPublicKeyCredentialCreationOptions ? value : THROW_CCE());
};
protoOf($serializer_88).hp = function (decoder) {
  var tmp0_desc = this.m49_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_input = decoder.ss(tmp0_desc);
  var tmp13_cached = Companion_getInstance_107().l49_1;
  if (tmp12_input.it()) {
    tmp4_local0 = tmp12_input.gt(tmp0_desc, 0, $serializer_getInstance_83(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp12_input.gt(tmp0_desc, 1, $serializer_getInstance_84(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp12_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp12_input.gt(tmp0_desc, 3, tmp13_cached[3].w(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp12_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp12_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp12_input.gt(tmp0_desc, 6, $serializer_getInstance_86(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp12_input.gt(tmp0_desc, 7, $serializer_getInstance_87(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp12_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp12_input.gt(tmp0_desc, 0, $serializer_getInstance_83(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp12_input.gt(tmp0_desc, 1, $serializer_getInstance_84(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp12_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp12_input.gt(tmp0_desc, 3, tmp13_cached[3].w(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp12_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp12_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp12_input.gt(tmp0_desc, 6, $serializer_getInstance_86(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp12_input.gt(tmp0_desc, 7, $serializer_getInstance_87(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp12_input.ts(tmp0_desc);
  return MHPublicKeyCredentialCreationOptions_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
};
protoOf($serializer_88).fp = function () {
  return this.m49_1;
};
protoOf($serializer_88).z10 = function () {
  var tmp0_cached = Companion_getInstance_107().l49_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_83()), get_nullable($serializer_getInstance_84()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].w()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_86()), get_nullable($serializer_getInstance_87())];
};
var $serializer_instance_88;
function $serializer_getInstance_88() {
  if ($serializer_instance_88 == null)
    new $serializer_88();
  return $serializer_instance_88;
}
function MHPublicKeyCredentialCreationOptions_init_$Init$(seen0, rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_88().m49_1);
  }
  if (0 === (seen0 & 1))
    $this.rp = null;
  else
    $this.rp = rp;
  if (0 === (seen0 & 2))
    $this.user = null;
  else
    $this.user = user;
  if (0 === (seen0 & 4))
    $this.challenge = null;
  else
    $this.challenge = challenge;
  if (0 === (seen0 & 8))
    $this.pubKeyCredParams = null;
  else
    $this.pubKeyCredParams = pubKeyCredParams;
  if (0 === (seen0 & 16))
    $this.timeout = null;
  else
    $this.timeout = timeout;
  if (0 === (seen0 & 32))
    $this.attestation = null;
  else
    $this.attestation = attestation;
  if (0 === (seen0 & 64))
    $this.authenticatorSelection = null;
  else
    $this.authenticatorSelection = authenticatorSelection;
  if (0 === (seen0 & 128))
    $this.extensions = null;
  else
    $this.extensions = extensions;
  return $this;
}
function MHPublicKeyCredentialCreationOptions_init_$Create$(seen0, rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions, serializationConstructorMarker) {
  return MHPublicKeyCredentialCreationOptions_init_$Init$(seen0, rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions, serializationConstructorMarker, objectCreate(protoOf(MHPublicKeyCredentialCreationOptions)));
}
function MHPublicKeyCredentialCreationOptions(rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions) {
  Companion_getInstance_107();
  rp = rp === VOID ? null : rp;
  user = user === VOID ? null : user;
  challenge = challenge === VOID ? null : challenge;
  pubKeyCredParams = pubKeyCredParams === VOID ? null : pubKeyCredParams;
  timeout = timeout === VOID ? null : timeout;
  attestation = attestation === VOID ? null : attestation;
  authenticatorSelection = authenticatorSelection === VOID ? null : authenticatorSelection;
  extensions = extensions === VOID ? null : extensions;
  this.rp = rp;
  this.user = user;
  this.challenge = challenge;
  this.pubKeyCredParams = pubKeyCredParams;
  this.timeout = timeout;
  this.attestation = attestation;
  this.authenticatorSelection = authenticatorSelection;
  this.extensions = extensions;
}
protoOf(MHPublicKeyCredentialCreationOptions).o49 = function () {
  return this.rp;
};
protoOf(MHPublicKeyCredentialCreationOptions).k3e = function () {
  return this.user;
};
protoOf(MHPublicKeyCredentialCreationOptions).b3t = function () {
  return this.challenge;
};
protoOf(MHPublicKeyCredentialCreationOptions).p49 = function () {
  return this.pubKeyCredParams;
};
protoOf(MHPublicKeyCredentialCreationOptions).c3t = function () {
  return this.timeout;
};
protoOf(MHPublicKeyCredentialCreationOptions).q49 = function () {
  return this.attestation;
};
protoOf(MHPublicKeyCredentialCreationOptions).r49 = function (_set____db54di) {
  this.authenticatorSelection = _set____db54di;
};
protoOf(MHPublicKeyCredentialCreationOptions).s49 = function () {
  return this.authenticatorSelection;
};
protoOf(MHPublicKeyCredentialCreationOptions).t49 = function () {
  return this.extensions;
};
protoOf(MHPublicKeyCredentialCreationOptions).wf = function () {
  return this.rp;
};
protoOf(MHPublicKeyCredentialCreationOptions).xf = function () {
  return this.user;
};
protoOf(MHPublicKeyCredentialCreationOptions).e3p = function () {
  return this.challenge;
};
protoOf(MHPublicKeyCredentialCreationOptions).f3p = function () {
  return this.pubKeyCredParams;
};
protoOf(MHPublicKeyCredentialCreationOptions).u3q = function () {
  return this.timeout;
};
protoOf(MHPublicKeyCredentialCreationOptions).v3q = function () {
  return this.attestation;
};
protoOf(MHPublicKeyCredentialCreationOptions).w3q = function () {
  return this.authenticatorSelection;
};
protoOf(MHPublicKeyCredentialCreationOptions).x3q = function () {
  return this.extensions;
};
protoOf(MHPublicKeyCredentialCreationOptions).u49 = function (rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions) {
  return new MHPublicKeyCredentialCreationOptions(rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions);
};
protoOf(MHPublicKeyCredentialCreationOptions).copy = function (rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions, $super) {
  rp = rp === VOID ? this.rp : rp;
  user = user === VOID ? this.user : user;
  challenge = challenge === VOID ? this.challenge : challenge;
  pubKeyCredParams = pubKeyCredParams === VOID ? this.pubKeyCredParams : pubKeyCredParams;
  timeout = timeout === VOID ? this.timeout : timeout;
  attestation = attestation === VOID ? this.attestation : attestation;
  authenticatorSelection = authenticatorSelection === VOID ? this.authenticatorSelection : authenticatorSelection;
  extensions = extensions === VOID ? this.extensions : extensions;
  return $super === VOID ? this.u49(rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions) : $super.u49.call(this, rp, user, challenge, pubKeyCredParams, timeout, attestation, authenticatorSelection, extensions);
};
protoOf(MHPublicKeyCredentialCreationOptions).toString = function () {
  return 'MHPublicKeyCredentialCreationOptions(rp=' + toString(this.rp) + ', user=' + toString(this.user) + ', challenge=' + this.challenge + ', pubKeyCredParams=' + toString(this.pubKeyCredParams) + ', timeout=' + this.timeout + ', attestation=' + this.attestation + ', authenticatorSelection=' + toString(this.authenticatorSelection) + ', extensions=' + toString(this.extensions) + ')';
};
protoOf(MHPublicKeyCredentialCreationOptions).hashCode = function () {
  var result = this.rp == null ? 0 : this.rp.hashCode();
  result = imul(result, 31) + (this.user == null ? 0 : this.user.hashCode()) | 0;
  result = imul(result, 31) + (this.challenge == null ? 0 : getStringHashCode(this.challenge)) | 0;
  result = imul(result, 31) + (this.pubKeyCredParams == null ? 0 : hashCode(this.pubKeyCredParams)) | 0;
  result = imul(result, 31) + (this.timeout == null ? 0 : this.timeout) | 0;
  result = imul(result, 31) + (this.attestation == null ? 0 : getStringHashCode(this.attestation)) | 0;
  result = imul(result, 31) + (this.authenticatorSelection == null ? 0 : this.authenticatorSelection.hashCode()) | 0;
  result = imul(result, 31) + (this.extensions == null ? 0 : this.extensions.hashCode()) | 0;
  return result;
};
protoOf(MHPublicKeyCredentialCreationOptions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MHPublicKeyCredentialCreationOptions))
    return false;
  if (!equals(this.rp, other.rp))
    return false;
  if (!equals(this.user, other.user))
    return false;
  if (!(this.challenge == other.challenge))
    return false;
  if (!equals(this.pubKeyCredParams, other.pubKeyCredParams))
    return false;
  if (!(this.timeout == other.timeout))
    return false;
  if (!(this.attestation == other.attestation))
    return false;
  if (!equals(this.authenticatorSelection, other.authenticatorSelection))
    return false;
  if (!equals(this.extensions, other.extensions))
    return false;
  return true;
};
function Companion_105() {
}
protoOf(Companion_105).o1c = function () {
  return $serializer_getInstance_89();
};
var Companion_instance_105;
function Companion_getInstance_108() {
  return Companion_instance_105;
}
function $serializer_89() {
  $serializer_instance_89 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.security.StartRegisterWebAuthnResponse', this, 2);
  tmp0_serialDesc.k10('publicKey', true);
  tmp0_serialDesc.k10('accessToken', true);
  this.v49_1 = tmp0_serialDesc;
}
protoOf($serializer_89).w49 = function (encoder, value) {
  var tmp0_desc = this.v49_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.publicKey == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_88(), value.publicKey);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.accessToken == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.accessToken);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_89).gp = function (encoder, value) {
  return this.w49(encoder, value instanceof StartRegisterWebAuthnResponse ? value : THROW_CCE());
};
protoOf($serializer_89).hp = function (decoder) {
  var tmp0_desc = this.v49_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, $serializer_getInstance_88(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, $serializer_getInstance_88(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return StartRegisterWebAuthnResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_89).fp = function () {
  return this.v49_1;
};
protoOf($serializer_89).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_88()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_89;
function $serializer_getInstance_89() {
  if ($serializer_instance_89 == null)
    new $serializer_89();
  return $serializer_instance_89;
}
function StartRegisterWebAuthnResponse_init_$Init$(seen0, publicKey, accessToken, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_89().v49_1);
  }
  if (0 === (seen0 & 1))
    $this.publicKey = null;
  else
    $this.publicKey = publicKey;
  if (0 === (seen0 & 2))
    $this.accessToken = null;
  else
    $this.accessToken = accessToken;
  return $this;
}
function StartRegisterWebAuthnResponse_init_$Create$(seen0, publicKey, accessToken, serializationConstructorMarker) {
  return StartRegisterWebAuthnResponse_init_$Init$(seen0, publicKey, accessToken, serializationConstructorMarker, objectCreate(protoOf(StartRegisterWebAuthnResponse)));
}
function StartRegisterWebAuthnResponse(publicKey, accessToken) {
  publicKey = publicKey === VOID ? null : publicKey;
  accessToken = accessToken === VOID ? null : accessToken;
  this.publicKey = publicKey;
  this.accessToken = accessToken;
}
protoOf(StartRegisterWebAuthnResponse).u3s = function () {
  return this.publicKey;
};
protoOf(StartRegisterWebAuthnResponse).c3s = function () {
  return this.accessToken;
};
protoOf(StartRegisterWebAuthnResponse).wf = function () {
  return this.publicKey;
};
protoOf(StartRegisterWebAuthnResponse).xf = function () {
  return this.accessToken;
};
protoOf(StartRegisterWebAuthnResponse).x49 = function (publicKey, accessToken) {
  return new StartRegisterWebAuthnResponse(publicKey, accessToken);
};
protoOf(StartRegisterWebAuthnResponse).copy = function (publicKey, accessToken, $super) {
  publicKey = publicKey === VOID ? this.publicKey : publicKey;
  accessToken = accessToken === VOID ? this.accessToken : accessToken;
  return $super === VOID ? this.x49(publicKey, accessToken) : $super.x49.call(this, publicKey, accessToken);
};
protoOf(StartRegisterWebAuthnResponse).toString = function () {
  return 'StartRegisterWebAuthnResponse(publicKey=' + toString(this.publicKey) + ', accessToken=' + this.accessToken + ')';
};
protoOf(StartRegisterWebAuthnResponse).hashCode = function () {
  var result = this.publicKey == null ? 0 : this.publicKey.hashCode();
  result = imul(result, 31) + (this.accessToken == null ? 0 : getStringHashCode(this.accessToken)) | 0;
  return result;
};
protoOf(StartRegisterWebAuthnResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StartRegisterWebAuthnResponse))
    return false;
  if (!equals(this.publicKey, other.publicKey))
    return false;
  if (!(this.accessToken == other.accessToken))
    return false;
  return true;
};
function LocalDateSerializer() {
  LocalDateSerializer_instance = this;
  this.y49_1 = PrimitiveSerialDescriptor('LocalDate', STRING_getInstance());
}
protoOf(LocalDateSerializer).fp = function () {
  return this.y49_1;
};
protoOf(LocalDateSerializer).w1s = function (encoder, value) {
  encoder.wt(value.toString());
};
protoOf(LocalDateSerializer).gp = function (encoder, value) {
  return this.w1s(encoder, value instanceof LocalDate ? value : THROW_CCE());
};
protoOf(LocalDateSerializer).hp = function (decoder) {
  return Companion_getInstance_1().v1s(decoder.ns());
};
var LocalDateSerializer_instance;
function LocalDateSerializer_getInstance() {
  if (LocalDateSerializer_instance == null)
    new LocalDateSerializer();
  return LocalDateSerializer_instance;
}
function VerifyKycResponseSerializer() {
  VerifyKycResponseSerializer_instance = this;
  JsonContentPolymorphicSerializer.call(this, getKClass(VerifyKycResponse));
}
protoOf(VerifyKycResponseSerializer).c1c = function (element) {
  var tmp;
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  var this_0 = get_jsonObject(element);
  if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).f2('error')) {
    tmp = Companion_instance_35.o1c();
  } else {
    var tmp0 = get_jsonObject(element);
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = 'verificationUrl';
    if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).f2(key)) {
      tmp = Companion_instance_34.o1c();
    } else {
      throw IllegalArgumentException_init_$Create$('Unknown VerifyKycResponse type: ' + toString_0(element));
    }
  }
  return tmp;
};
var VerifyKycResponseSerializer_instance;
function VerifyKycResponseSerializer_getInstance() {
  if (VerifyKycResponseSerializer_instance == null)
    new VerifyKycResponseSerializer();
  return VerifyKycResponseSerializer_instance;
}
function FeedbackSurveyStatusRequest$Companion$$childSerializers$_anonymous__y4fygc() {
  return Companion_getInstance_14().o1c();
}
function Companion_106() {
  Companion_instance_106 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.b4a_1 = [lazy(tmp_0, FeedbackSurveyStatusRequest$Companion$$childSerializers$_anonymous__y4fygc)];
}
protoOf(Companion_106).o1c = function () {
  return $serializer_getInstance_90();
};
var Companion_instance_106;
function Companion_getInstance_109() {
  if (Companion_instance_106 == null)
    new Companion_106();
  return Companion_instance_106;
}
function $serializer_90() {
  $serializer_instance_90 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.FeedbackSurveyStatusRequest', this, 1);
  tmp0_serialDesc.k10('feedbackType', false);
  this.c4a_1 = tmp0_serialDesc;
}
protoOf($serializer_90).d4a = function (encoder, value) {
  var tmp0_desc = this.c4a_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_109().b4a_1;
  tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.feedbackType);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_90).gp = function (encoder, value) {
  return this.d4a(encoder, value instanceof FeedbackSurveyStatusRequest ? value : THROW_CCE());
};
protoOf($serializer_90).hp = function (decoder) {
  var tmp0_desc = this.c4a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  var tmp6_cached = Companion_getInstance_109().b4a_1;
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return FeedbackSurveyStatusRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_90).fp = function () {
  return this.c4a_1;
};
protoOf($serializer_90).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_109().b4a_1[0].w()];
};
var $serializer_instance_90;
function $serializer_getInstance_90() {
  if ($serializer_instance_90 == null)
    new $serializer_90();
  return $serializer_instance_90;
}
function FeedbackSurveyStatusRequest_init_$Init$(seen0, feedbackType, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_90().c4a_1);
  }
  $this.feedbackType = feedbackType;
  return $this;
}
function FeedbackSurveyStatusRequest_init_$Create$(seen0, feedbackType, serializationConstructorMarker) {
  return FeedbackSurveyStatusRequest_init_$Init$(seen0, feedbackType, serializationConstructorMarker, objectCreate(protoOf(FeedbackSurveyStatusRequest)));
}
function FeedbackSurveyStatusRequest(feedbackType) {
  Companion_getInstance_109();
  this.feedbackType = feedbackType;
}
protoOf(FeedbackSurveyStatusRequest).e4a = function () {
  return this.feedbackType;
};
protoOf(FeedbackSurveyStatusRequest).wf = function () {
  return this.feedbackType;
};
protoOf(FeedbackSurveyStatusRequest).f4a = function (feedbackType) {
  return new FeedbackSurveyStatusRequest(feedbackType);
};
protoOf(FeedbackSurveyStatusRequest).copy = function (feedbackType, $super) {
  feedbackType = feedbackType === VOID ? this.feedbackType : feedbackType;
  return $super === VOID ? this.f4a(feedbackType) : $super.f4a.call(this, feedbackType);
};
protoOf(FeedbackSurveyStatusRequest).toString = function () {
  return 'FeedbackSurveyStatusRequest(feedbackType=' + this.feedbackType.toString() + ')';
};
protoOf(FeedbackSurveyStatusRequest).hashCode = function () {
  return this.feedbackType.hashCode();
};
protoOf(FeedbackSurveyStatusRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FeedbackSurveyStatusRequest))
    return false;
  if (!this.feedbackType.equals(other.feedbackType))
    return false;
  return true;
};
function SupportFormResponse$Companion$$childSerializers$_anonymous__7phihi() {
  return new ArrayListSerializer($serializer_getInstance_94());
}
function Companion_107() {
  Companion_instance_107 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g4a_1 = [null, lazy(tmp_0, SupportFormResponse$Companion$$childSerializers$_anonymous__7phihi)];
}
protoOf(Companion_107).o1c = function () {
  return $serializer_getInstance_91();
};
var Companion_instance_107;
function Companion_getInstance_110() {
  if (Companion_instance_107 == null)
    new Companion_107();
  return Companion_instance_107;
}
function $serializer_91() {
  $serializer_instance_91 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.SupportFormResponse', this, 2);
  tmp0_serialDesc.k10('ticketResponse', true);
  tmp0_serialDesc.k10('uploadResponses', true);
  this.h4a_1 = tmp0_serialDesc;
}
protoOf($serializer_91).i4a = function (encoder, value) {
  var tmp0_desc = this.h4a_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_110().g4a_1;
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.ticketResponse == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_92(), value.ticketResponse);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.uploadResponses == null)) {
    tmp1_output.lu(tmp0_desc, 1, tmp2_cached[1].w(), value.uploadResponses);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_91).gp = function (encoder, value) {
  return this.i4a(encoder, value instanceof SupportFormResponse ? value : THROW_CCE());
};
protoOf($serializer_91).hp = function (decoder) {
  var tmp0_desc = this.h4a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  var tmp7_cached = Companion_getInstance_110().g4a_1;
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, $serializer_getInstance_92(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, $serializer_getInstance_92(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, tmp7_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return SupportFormResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_91).fp = function () {
  return this.h4a_1;
};
protoOf($serializer_91).z10 = function () {
  var tmp0_cached = Companion_getInstance_110().g4a_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_92()), get_nullable(tmp0_cached[1].w())];
};
var $serializer_instance_91;
function $serializer_getInstance_91() {
  if ($serializer_instance_91 == null)
    new $serializer_91();
  return $serializer_instance_91;
}
function SupportFormResponse_init_$Init$(seen0, ticketResponse, uploadResponses, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_91().h4a_1);
  }
  if (0 === (seen0 & 1))
    $this.ticketResponse = null;
  else
    $this.ticketResponse = ticketResponse;
  if (0 === (seen0 & 2))
    $this.uploadResponses = null;
  else
    $this.uploadResponses = uploadResponses;
  return $this;
}
function SupportFormResponse_init_$Create$(seen0, ticketResponse, uploadResponses, serializationConstructorMarker) {
  return SupportFormResponse_init_$Init$(seen0, ticketResponse, uploadResponses, serializationConstructorMarker, objectCreate(protoOf(SupportFormResponse)));
}
function SupportFormResponse(ticketResponse, uploadResponses) {
  Companion_getInstance_110();
  ticketResponse = ticketResponse === VOID ? null : ticketResponse;
  uploadResponses = uploadResponses === VOID ? null : uploadResponses;
  this.ticketResponse = ticketResponse;
  this.uploadResponses = uploadResponses;
}
protoOf(SupportFormResponse).j4a = function () {
  return this.ticketResponse;
};
protoOf(SupportFormResponse).k4a = function () {
  return this.uploadResponses;
};
protoOf(SupportFormResponse).wf = function () {
  return this.ticketResponse;
};
protoOf(SupportFormResponse).xf = function () {
  return this.uploadResponses;
};
protoOf(SupportFormResponse).l4a = function (ticketResponse, uploadResponses) {
  return new SupportFormResponse(ticketResponse, uploadResponses);
};
protoOf(SupportFormResponse).copy = function (ticketResponse, uploadResponses, $super) {
  ticketResponse = ticketResponse === VOID ? this.ticketResponse : ticketResponse;
  uploadResponses = uploadResponses === VOID ? this.uploadResponses : uploadResponses;
  return $super === VOID ? this.l4a(ticketResponse, uploadResponses) : $super.l4a.call(this, ticketResponse, uploadResponses);
};
protoOf(SupportFormResponse).toString = function () {
  return 'SupportFormResponse(ticketResponse=' + toString(this.ticketResponse) + ', uploadResponses=' + toString(this.uploadResponses) + ')';
};
protoOf(SupportFormResponse).hashCode = function () {
  var result = this.ticketResponse == null ? 0 : this.ticketResponse.hashCode();
  result = imul(result, 31) + (this.uploadResponses == null ? 0 : hashCode(this.uploadResponses)) | 0;
  return result;
};
protoOf(SupportFormResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SupportFormResponse))
    return false;
  if (!equals(this.ticketResponse, other.ticketResponse))
    return false;
  if (!equals(this.uploadResponses, other.uploadResponses))
    return false;
  return true;
};
function Companion_108() {
}
protoOf(Companion_108).o1c = function () {
  return $serializer_getInstance_92();
};
var Companion_instance_108;
function Companion_getInstance_111() {
  return Companion_instance_108;
}
function $serializer_92() {
  $serializer_instance_92 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.SupportFormTicketResponse', this, 1);
  tmp0_serialDesc.k10('ticket', true);
  this.m4a_1 = tmp0_serialDesc;
}
protoOf($serializer_92).n4a = function (encoder, value) {
  var tmp0_desc = this.m4a_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.ticket == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_93(), value.ticket);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_92).gp = function (encoder, value) {
  return this.n4a(encoder, value instanceof SupportFormTicketResponse ? value : THROW_CCE());
};
protoOf($serializer_92).hp = function (decoder) {
  var tmp0_desc = this.m4a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, $serializer_getInstance_93(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, $serializer_getInstance_93(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return SupportFormTicketResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_92).fp = function () {
  return this.m4a_1;
};
protoOf($serializer_92).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_93())];
};
var $serializer_instance_92;
function $serializer_getInstance_92() {
  if ($serializer_instance_92 == null)
    new $serializer_92();
  return $serializer_instance_92;
}
function SupportFormTicketResponse_init_$Init$(seen0, ticket, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_92().m4a_1);
  }
  if (0 === (seen0 & 1))
    $this.ticket = null;
  else
    $this.ticket = ticket;
  return $this;
}
function SupportFormTicketResponse_init_$Create$(seen0, ticket, serializationConstructorMarker) {
  return SupportFormTicketResponse_init_$Init$(seen0, ticket, serializationConstructorMarker, objectCreate(protoOf(SupportFormTicketResponse)));
}
function SupportFormTicketResponse(ticket) {
  ticket = ticket === VOID ? null : ticket;
  this.ticket = ticket;
}
protoOf(SupportFormTicketResponse).o4a = function () {
  return this.ticket;
};
protoOf(SupportFormTicketResponse).wf = function () {
  return this.ticket;
};
protoOf(SupportFormTicketResponse).p4a = function (ticket) {
  return new SupportFormTicketResponse(ticket);
};
protoOf(SupportFormTicketResponse).copy = function (ticket, $super) {
  ticket = ticket === VOID ? this.ticket : ticket;
  return $super === VOID ? this.p4a(ticket) : $super.p4a.call(this, ticket);
};
protoOf(SupportFormTicketResponse).toString = function () {
  return 'SupportFormTicketResponse(ticket=' + toString(this.ticket) + ')';
};
protoOf(SupportFormTicketResponse).hashCode = function () {
  return this.ticket == null ? 0 : this.ticket.hashCode();
};
protoOf(SupportFormTicketResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SupportFormTicketResponse))
    return false;
  if (!equals(this.ticket, other.ticket))
    return false;
  return true;
};
function Companion_109() {
}
protoOf(Companion_109).o1c = function () {
  return $serializer_getInstance_93();
};
var Companion_instance_109;
function Companion_getInstance_112() {
  return Companion_instance_109;
}
function $serializer_93() {
  $serializer_instance_93 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.SupportFormTicketResponseTicket', this, 5);
  tmp0_serialDesc.k10('id', true);
  tmp0_serialDesc.k10('requester_id', true);
  tmp0_serialDesc.k10('created_at', true);
  tmp0_serialDesc.k10('subject', true);
  tmp0_serialDesc.k10('description', true);
  this.q4a_1 = tmp0_serialDesc;
}
protoOf($serializer_93).r4a = function (encoder, value) {
  var tmp0_desc = this.q4a_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.id == null)) {
    tmp1_output.lu(tmp0_desc, 0, LongSerializer_getInstance(), value.id);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.requester_id == null)) {
    tmp1_output.lu(tmp0_desc, 1, LongSerializer_getInstance(), value.requester_id);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.created_at == null)) {
    tmp1_output.lu(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), value.created_at);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.subject == null)) {
    tmp1_output.lu(tmp0_desc, 3, StringSerializer_getInstance(), value.subject);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.description == null)) {
    tmp1_output.lu(tmp0_desc, 4, StringSerializer_getInstance(), value.description);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_93).gp = function (encoder, value) {
  return this.r4a(encoder, value instanceof SupportFormTicketResponseTicket ? value : THROW_CCE());
};
protoOf($serializer_93).hp = function (decoder) {
  var tmp0_desc = this.q4a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.ss(tmp0_desc);
  if (tmp9_input.it()) {
    tmp4_local0 = tmp9_input.gt(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.gt(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.gt(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.gt(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.gt(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.ts(tmp0_desc);
  return SupportFormTicketResponseTicket_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_93).fp = function () {
  return this.q4a_1;
};
protoOf($serializer_93).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(IsoTimestampSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_93;
function $serializer_getInstance_93() {
  if ($serializer_instance_93 == null)
    new $serializer_93();
  return $serializer_instance_93;
}
function SupportFormTicketResponseTicket_init_$Init$(seen0, id, requester_id, created_at, subject, description, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_93().q4a_1);
  }
  if (0 === (seen0 & 1))
    $this.id = null;
  else
    $this.id = id;
  if (0 === (seen0 & 2))
    $this.requester_id = null;
  else
    $this.requester_id = requester_id;
  if (0 === (seen0 & 4))
    $this.created_at = null;
  else
    $this.created_at = created_at;
  if (0 === (seen0 & 8))
    $this.subject = null;
  else
    $this.subject = subject;
  if (0 === (seen0 & 16))
    $this.description = null;
  else
    $this.description = description;
  return $this;
}
function SupportFormTicketResponseTicket_init_$Create$(seen0, id, requester_id, created_at, subject, description, serializationConstructorMarker) {
  return SupportFormTicketResponseTicket_init_$Init$(seen0, id, requester_id, created_at, subject, description, serializationConstructorMarker, objectCreate(protoOf(SupportFormTicketResponseTicket)));
}
function SupportFormTicketResponseTicket(id, requester_id, created_at, subject, description) {
  id = id === VOID ? null : id;
  requester_id = requester_id === VOID ? null : requester_id;
  created_at = created_at === VOID ? null : created_at;
  subject = subject === VOID ? null : subject;
  description = description === VOID ? null : description;
  this.id = id;
  this.requester_id = requester_id;
  this.created_at = created_at;
  this.subject = subject;
  this.description = description;
}
protoOf(SupportFormTicketResponseTicket).l3t = function () {
  return this.id;
};
protoOf(SupportFormTicketResponseTicket).s4a = function () {
  return this.requester_id;
};
protoOf(SupportFormTicketResponseTicket).t4a = function () {
  return this.created_at;
};
protoOf(SupportFormTicketResponseTicket).d30 = function () {
  return this.subject;
};
protoOf(SupportFormTicketResponseTicket).u4a = function () {
  return this.description;
};
protoOf(SupportFormTicketResponseTicket).wf = function () {
  return this.id;
};
protoOf(SupportFormTicketResponseTicket).xf = function () {
  return this.requester_id;
};
protoOf(SupportFormTicketResponseTicket).e3p = function () {
  return this.created_at;
};
protoOf(SupportFormTicketResponseTicket).f3p = function () {
  return this.subject;
};
protoOf(SupportFormTicketResponseTicket).u3q = function () {
  return this.description;
};
protoOf(SupportFormTicketResponseTicket).v4a = function (id, requester_id, created_at, subject, description) {
  return new SupportFormTicketResponseTicket(id, requester_id, created_at, subject, description);
};
protoOf(SupportFormTicketResponseTicket).copy = function (id, requester_id, created_at, subject, description, $super) {
  id = id === VOID ? this.id : id;
  requester_id = requester_id === VOID ? this.requester_id : requester_id;
  created_at = created_at === VOID ? this.created_at : created_at;
  subject = subject === VOID ? this.subject : subject;
  description = description === VOID ? this.description : description;
  return $super === VOID ? this.v4a(id, requester_id, created_at, subject, description) : $super.v4a.call(this, id, requester_id, created_at, subject, description);
};
protoOf(SupportFormTicketResponseTicket).toString = function () {
  return 'SupportFormTicketResponseTicket(id=' + toString(this.id) + ', requester_id=' + toString(this.requester_id) + ', created_at=' + toString(this.created_at) + ', subject=' + this.subject + ', description=' + this.description + ')';
};
protoOf(SupportFormTicketResponseTicket).hashCode = function () {
  var result = this.id == null ? 0 : getBigIntHashCode(this.id);
  result = imul(result, 31) + (this.requester_id == null ? 0 : getBigIntHashCode(this.requester_id)) | 0;
  result = imul(result, 31) + (this.created_at == null ? 0 : this.created_at.hashCode()) | 0;
  result = imul(result, 31) + (this.subject == null ? 0 : getStringHashCode(this.subject)) | 0;
  result = imul(result, 31) + (this.description == null ? 0 : getStringHashCode(this.description)) | 0;
  return result;
};
protoOf(SupportFormTicketResponseTicket).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SupportFormTicketResponseTicket))
    return false;
  if (!(this.id == other.id))
    return false;
  if (!(this.requester_id == other.requester_id))
    return false;
  if (!equals(this.created_at, other.created_at))
    return false;
  if (!(this.subject == other.subject))
    return false;
  if (!(this.description == other.description))
    return false;
  return true;
};
function Companion_110() {
}
protoOf(Companion_110).o1c = function () {
  return $serializer_getInstance_94();
};
var Companion_instance_110;
function Companion_getInstance_113() {
  return Companion_instance_110;
}
function $serializer_94() {
  $serializer_instance_94 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.SupportFormUploadResponse', this, 1);
  tmp0_serialDesc.k10('upload', true);
  this.w4a_1 = tmp0_serialDesc;
}
protoOf($serializer_94).x4a = function (encoder, value) {
  var tmp0_desc = this.w4a_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.upload == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_95(), value.upload);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_94).gp = function (encoder, value) {
  return this.x4a(encoder, value instanceof SupportFormUploadResponse ? value : THROW_CCE());
};
protoOf($serializer_94).hp = function (decoder) {
  var tmp0_desc = this.w4a_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, $serializer_getInstance_95(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.gt(tmp0_desc, 0, $serializer_getInstance_95(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return SupportFormUploadResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_94).fp = function () {
  return this.w4a_1;
};
protoOf($serializer_94).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_95())];
};
var $serializer_instance_94;
function $serializer_getInstance_94() {
  if ($serializer_instance_94 == null)
    new $serializer_94();
  return $serializer_instance_94;
}
function SupportFormUploadResponse_init_$Init$(seen0, upload, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_94().w4a_1);
  }
  if (0 === (seen0 & 1))
    $this.upload = null;
  else
    $this.upload = upload;
  return $this;
}
function SupportFormUploadResponse_init_$Create$(seen0, upload, serializationConstructorMarker) {
  return SupportFormUploadResponse_init_$Init$(seen0, upload, serializationConstructorMarker, objectCreate(protoOf(SupportFormUploadResponse)));
}
function SupportFormUploadResponse(upload) {
  upload = upload === VOID ? null : upload;
  this.upload = upload;
}
protoOf(SupportFormUploadResponse).y4a = function () {
  return this.upload;
};
protoOf(SupportFormUploadResponse).wf = function () {
  return this.upload;
};
protoOf(SupportFormUploadResponse).z4a = function (upload) {
  return new SupportFormUploadResponse(upload);
};
protoOf(SupportFormUploadResponse).copy = function (upload, $super) {
  upload = upload === VOID ? this.upload : upload;
  return $super === VOID ? this.z4a(upload) : $super.z4a.call(this, upload);
};
protoOf(SupportFormUploadResponse).toString = function () {
  return 'SupportFormUploadResponse(upload=' + toString(this.upload) + ')';
};
protoOf(SupportFormUploadResponse).hashCode = function () {
  return this.upload == null ? 0 : this.upload.hashCode();
};
protoOf(SupportFormUploadResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SupportFormUploadResponse))
    return false;
  if (!equals(this.upload, other.upload))
    return false;
  return true;
};
function Companion_111() {
}
protoOf(Companion_111).o1c = function () {
  return $serializer_getInstance_95();
};
var Companion_instance_111;
function Companion_getInstance_114() {
  return Companion_instance_111;
}
function $serializer_95() {
  $serializer_instance_95 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.SupportFormUploadResponseUpload', this, 2);
  tmp0_serialDesc.k10('attachment', true);
  tmp0_serialDesc.k10('expires_at', true);
  this.a4b_1 = tmp0_serialDesc;
}
protoOf($serializer_95).b4b = function (encoder, value) {
  var tmp0_desc = this.a4b_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.attachment == null)) {
    tmp1_output.lu(tmp0_desc, 0, $serializer_getInstance_96(), value.attachment);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.expires_at == null)) {
    tmp1_output.lu(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), value.expires_at);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_95).gp = function (encoder, value) {
  return this.b4b(encoder, value instanceof SupportFormUploadResponseUpload ? value : THROW_CCE());
};
protoOf($serializer_95).hp = function (decoder) {
  var tmp0_desc = this.a4b_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, $serializer_getInstance_96(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, $serializer_getInstance_96(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return SupportFormUploadResponseUpload_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_95).fp = function () {
  return this.a4b_1;
};
protoOf($serializer_95).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_96()), get_nullable(IsoTimestampSerializer_getInstance())];
};
var $serializer_instance_95;
function $serializer_getInstance_95() {
  if ($serializer_instance_95 == null)
    new $serializer_95();
  return $serializer_instance_95;
}
function SupportFormUploadResponseUpload_init_$Init$(seen0, attachment, expires_at, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_95().a4b_1);
  }
  if (0 === (seen0 & 1))
    $this.attachment = null;
  else
    $this.attachment = attachment;
  if (0 === (seen0 & 2))
    $this.expires_at = null;
  else
    $this.expires_at = expires_at;
  return $this;
}
function SupportFormUploadResponseUpload_init_$Create$(seen0, attachment, expires_at, serializationConstructorMarker) {
  return SupportFormUploadResponseUpload_init_$Init$(seen0, attachment, expires_at, serializationConstructorMarker, objectCreate(protoOf(SupportFormUploadResponseUpload)));
}
function SupportFormUploadResponseUpload(attachment, expires_at) {
  attachment = attachment === VOID ? null : attachment;
  expires_at = expires_at === VOID ? null : expires_at;
  this.attachment = attachment;
  this.expires_at = expires_at;
}
protoOf(SupportFormUploadResponseUpload).c4b = function () {
  return this.attachment;
};
protoOf(SupportFormUploadResponseUpload).d4b = function () {
  return this.expires_at;
};
protoOf(SupportFormUploadResponseUpload).wf = function () {
  return this.attachment;
};
protoOf(SupportFormUploadResponseUpload).xf = function () {
  return this.expires_at;
};
protoOf(SupportFormUploadResponseUpload).e4b = function (attachment, expires_at) {
  return new SupportFormUploadResponseUpload(attachment, expires_at);
};
protoOf(SupportFormUploadResponseUpload).copy = function (attachment, expires_at, $super) {
  attachment = attachment === VOID ? this.attachment : attachment;
  expires_at = expires_at === VOID ? this.expires_at : expires_at;
  return $super === VOID ? this.e4b(attachment, expires_at) : $super.e4b.call(this, attachment, expires_at);
};
protoOf(SupportFormUploadResponseUpload).toString = function () {
  return 'SupportFormUploadResponseUpload(attachment=' + toString(this.attachment) + ', expires_at=' + toString(this.expires_at) + ')';
};
protoOf(SupportFormUploadResponseUpload).hashCode = function () {
  var result = this.attachment == null ? 0 : this.attachment.hashCode();
  result = imul(result, 31) + (this.expires_at == null ? 0 : this.expires_at.hashCode()) | 0;
  return result;
};
protoOf(SupportFormUploadResponseUpload).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SupportFormUploadResponseUpload))
    return false;
  if (!equals(this.attachment, other.attachment))
    return false;
  if (!equals(this.expires_at, other.expires_at))
    return false;
  return true;
};
function Companion_112() {
}
protoOf(Companion_112).o1c = function () {
  return $serializer_getInstance_96();
};
var Companion_instance_112;
function Companion_getInstance_115() {
  return Companion_instance_112;
}
function $serializer_96() {
  $serializer_instance_96 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.support.SupportFormUploadResponseUploadAttachment', this, 7);
  tmp0_serialDesc.k10('id', true);
  tmp0_serialDesc.k10('content_type', true);
  tmp0_serialDesc.k10('content_url', true);
  tmp0_serialDesc.k10('file_name', true);
  tmp0_serialDesc.k10('width', true);
  tmp0_serialDesc.k10('height', true);
  tmp0_serialDesc.k10('size', true);
  this.f4b_1 = tmp0_serialDesc;
}
protoOf($serializer_96).g4b = function (encoder, value) {
  var tmp0_desc = this.f4b_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.id == null)) {
    tmp1_output.lu(tmp0_desc, 0, LongSerializer_getInstance(), value.id);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.content_type == null)) {
    tmp1_output.lu(tmp0_desc, 1, StringSerializer_getInstance(), value.content_type);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.content_url == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.content_url);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.file_name == null)) {
    tmp1_output.lu(tmp0_desc, 3, StringSerializer_getInstance(), value.file_name);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.width == null)) {
    tmp1_output.lu(tmp0_desc, 4, IntSerializer_getInstance(), value.width);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.height == null)) {
    tmp1_output.lu(tmp0_desc, 5, IntSerializer_getInstance(), value.height);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.size == null)) {
    tmp1_output.lu(tmp0_desc, 6, IntSerializer_getInstance(), value.size);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_96).gp = function (encoder, value) {
  return this.g4b(encoder, value instanceof SupportFormUploadResponseUploadAttachment ? value : THROW_CCE());
};
protoOf($serializer_96).hp = function (decoder) {
  var tmp0_desc = this.f4b_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.ss(tmp0_desc);
  if (tmp11_input.it()) {
    tmp4_local0 = tmp11_input.gt(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.gt(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.gt(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.gt(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.gt(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.gt(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.gt(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.gt(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.gt(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.ts(tmp0_desc);
  return SupportFormUploadResponseUploadAttachment_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_96).fp = function () {
  return this.f4b_1;
};
protoOf($serializer_96).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
};
var $serializer_instance_96;
function $serializer_getInstance_96() {
  if ($serializer_instance_96 == null)
    new $serializer_96();
  return $serializer_instance_96;
}
function SupportFormUploadResponseUploadAttachment_init_$Init$(seen0, id, content_type, content_url, file_name, width, height, size, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_96().f4b_1);
  }
  if (0 === (seen0 & 1))
    $this.id = null;
  else
    $this.id = id;
  if (0 === (seen0 & 2))
    $this.content_type = null;
  else
    $this.content_type = content_type;
  if (0 === (seen0 & 4))
    $this.content_url = null;
  else
    $this.content_url = content_url;
  if (0 === (seen0 & 8))
    $this.file_name = null;
  else
    $this.file_name = file_name;
  if (0 === (seen0 & 16))
    $this.width = null;
  else
    $this.width = width;
  if (0 === (seen0 & 32))
    $this.height = null;
  else
    $this.height = height;
  if (0 === (seen0 & 64))
    $this.size = null;
  else
    $this.size = size;
  return $this;
}
function SupportFormUploadResponseUploadAttachment_init_$Create$(seen0, id, content_type, content_url, file_name, width, height, size, serializationConstructorMarker) {
  return SupportFormUploadResponseUploadAttachment_init_$Init$(seen0, id, content_type, content_url, file_name, width, height, size, serializationConstructorMarker, objectCreate(protoOf(SupportFormUploadResponseUploadAttachment)));
}
function SupportFormUploadResponseUploadAttachment(id, content_type, content_url, file_name, width, height, size) {
  id = id === VOID ? null : id;
  content_type = content_type === VOID ? null : content_type;
  content_url = content_url === VOID ? null : content_url;
  file_name = file_name === VOID ? null : file_name;
  width = width === VOID ? null : width;
  height = height === VOID ? null : height;
  size = size === VOID ? null : size;
  this.id = id;
  this.content_type = content_type;
  this.content_url = content_url;
  this.file_name = file_name;
  this.width = width;
  this.height = height;
  this.size = size;
}
protoOf(SupportFormUploadResponseUploadAttachment).l3t = function () {
  return this.id;
};
protoOf(SupportFormUploadResponseUploadAttachment).h4b = function () {
  return this.content_type;
};
protoOf(SupportFormUploadResponseUploadAttachment).i4b = function () {
  return this.content_url;
};
protoOf(SupportFormUploadResponseUploadAttachment).j4b = function () {
  return this.file_name;
};
protoOf(SupportFormUploadResponseUploadAttachment).k4b = function () {
  return this.width;
};
protoOf(SupportFormUploadResponseUploadAttachment).l4b = function () {
  return this.height;
};
protoOf(SupportFormUploadResponseUploadAttachment).o = function () {
  return this.size;
};
protoOf(SupportFormUploadResponseUploadAttachment).wf = function () {
  return this.id;
};
protoOf(SupportFormUploadResponseUploadAttachment).xf = function () {
  return this.content_type;
};
protoOf(SupportFormUploadResponseUploadAttachment).e3p = function () {
  return this.content_url;
};
protoOf(SupportFormUploadResponseUploadAttachment).f3p = function () {
  return this.file_name;
};
protoOf(SupportFormUploadResponseUploadAttachment).u3q = function () {
  return this.width;
};
protoOf(SupportFormUploadResponseUploadAttachment).v3q = function () {
  return this.height;
};
protoOf(SupportFormUploadResponseUploadAttachment).w3q = function () {
  return this.size;
};
protoOf(SupportFormUploadResponseUploadAttachment).m4b = function (id, content_type, content_url, file_name, width, height, size) {
  return new SupportFormUploadResponseUploadAttachment(id, content_type, content_url, file_name, width, height, size);
};
protoOf(SupportFormUploadResponseUploadAttachment).copy = function (id, content_type, content_url, file_name, width, height, size, $super) {
  id = id === VOID ? this.id : id;
  content_type = content_type === VOID ? this.content_type : content_type;
  content_url = content_url === VOID ? this.content_url : content_url;
  file_name = file_name === VOID ? this.file_name : file_name;
  width = width === VOID ? this.width : width;
  height = height === VOID ? this.height : height;
  size = size === VOID ? this.size : size;
  return $super === VOID ? this.m4b(id, content_type, content_url, file_name, width, height, size) : $super.m4b.call(this, id, content_type, content_url, file_name, width, height, size);
};
protoOf(SupportFormUploadResponseUploadAttachment).toString = function () {
  return 'SupportFormUploadResponseUploadAttachment(id=' + toString(this.id) + ', content_type=' + this.content_type + ', content_url=' + this.content_url + ', file_name=' + this.file_name + ', width=' + this.width + ', height=' + this.height + ', size=' + this.size + ')';
};
protoOf(SupportFormUploadResponseUploadAttachment).hashCode = function () {
  var result = this.id == null ? 0 : getBigIntHashCode(this.id);
  result = imul(result, 31) + (this.content_type == null ? 0 : getStringHashCode(this.content_type)) | 0;
  result = imul(result, 31) + (this.content_url == null ? 0 : getStringHashCode(this.content_url)) | 0;
  result = imul(result, 31) + (this.file_name == null ? 0 : getStringHashCode(this.file_name)) | 0;
  result = imul(result, 31) + (this.width == null ? 0 : this.width) | 0;
  result = imul(result, 31) + (this.height == null ? 0 : this.height) | 0;
  result = imul(result, 31) + (this.size == null ? 0 : this.size) | 0;
  return result;
};
protoOf(SupportFormUploadResponseUploadAttachment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SupportFormUploadResponseUploadAttachment))
    return false;
  if (!(this.id == other.id))
    return false;
  if (!(this.content_type == other.content_type))
    return false;
  if (!(this.content_url == other.content_url))
    return false;
  if (!(this.file_name == other.file_name))
    return false;
  if (!(this.width == other.width))
    return false;
  if (!(this.height == other.height))
    return false;
  if (!(this.size == other.size))
    return false;
  return true;
};
function Companion_113() {
}
protoOf(Companion_113).o1c = function () {
  return IsoDateSerializer_getInstance();
};
var Companion_instance_113;
function Companion_getInstance_116() {
  return Companion_instance_113;
}
function IsoDate(value) {
  this.value = value;
}
protoOf(IsoDate).w = function () {
  return this.value;
};
protoOf(IsoDate).toString = function () {
  return this.value;
};
protoOf(IsoDate).n4b = function (other) {
  return compareTo(this.value, other.value);
};
protoOf(IsoDate).d = function (other) {
  return this.n4b(other instanceof IsoDate ? other : THROW_CCE());
};
protoOf(IsoDate).wf = function () {
  return this.value;
};
protoOf(IsoDate).s3t = function (value) {
  return new IsoDate(value);
};
protoOf(IsoDate).copy = function (value, $super) {
  value = value === VOID ? this.value : value;
  return $super === VOID ? this.s3t(value) : $super.s3t.call(this, value);
};
protoOf(IsoDate).hashCode = function () {
  return getStringHashCode(this.value);
};
protoOf(IsoDate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof IsoDate))
    return false;
  if (!(this.value === other.value))
    return false;
  return true;
};
function IsoDateSerializer() {
  IsoDateSerializer_instance = this;
  this.o4b_1 = PrimitiveSerialDescriptor('IsoDate', STRING_getInstance());
}
protoOf(IsoDateSerializer).fp = function () {
  return this.o4b_1;
};
protoOf(IsoDateSerializer).p4b = function (encoder, value) {
  encoder.wt(value.value);
};
protoOf(IsoDateSerializer).gp = function (encoder, value) {
  return this.p4b(encoder, value instanceof IsoDate ? value : THROW_CCE());
};
protoOf(IsoDateSerializer).hp = function (decoder) {
  var str = decoder.ns();
  Companion_getInstance_1().v1s(str);
  return new IsoDate(str);
};
var IsoDateSerializer_instance;
function IsoDateSerializer_getInstance() {
  if (IsoDateSerializer_instance == null)
    new IsoDateSerializer();
  return IsoDateSerializer_instance;
}
function toIsoDate(_this__u8e3s4) {
  return new IsoDate(_this__u8e3s4.toString());
}
function Companion_114() {
}
protoOf(Companion_114).o1c = function () {
  return IsoTimestampSerializer_getInstance();
};
var Companion_instance_114;
function Companion_getInstance_117() {
  return Companion_instance_114;
}
function IsoTimestamp(value) {
  this.value = value;
}
protoOf(IsoTimestamp).w = function () {
  return this.value;
};
protoOf(IsoTimestamp).toString = function () {
  return this.value;
};
protoOf(IsoTimestamp).q4b = function (other) {
  return compareTo(this.value, other.value);
};
protoOf(IsoTimestamp).d = function (other) {
  return this.q4b(other instanceof IsoTimestamp ? other : THROW_CCE());
};
protoOf(IsoTimestamp).wf = function () {
  return this.value;
};
protoOf(IsoTimestamp).s3t = function (value) {
  return new IsoTimestamp(value);
};
protoOf(IsoTimestamp).copy = function (value, $super) {
  value = value === VOID ? this.value : value;
  return $super === VOID ? this.s3t(value) : $super.s3t.call(this, value);
};
protoOf(IsoTimestamp).hashCode = function () {
  return getStringHashCode(this.value);
};
protoOf(IsoTimestamp).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof IsoTimestamp))
    return false;
  if (!(this.value === other.value))
    return false;
  return true;
};
function toIsoTimestamp(_this__u8e3s4) {
  return new IsoTimestamp(_this__u8e3s4.toString());
}
function IsoTimestampSerializer() {
  IsoTimestampSerializer_instance = this;
  this.r4b_1 = PrimitiveSerialDescriptor('IsoTimestamp', STRING_getInstance());
}
protoOf(IsoTimestampSerializer).fp = function () {
  return this.r4b_1;
};
protoOf(IsoTimestampSerializer).s4b = function (encoder, value) {
  encoder.wt(value.value);
};
protoOf(IsoTimestampSerializer).gp = function (encoder, value) {
  return this.s4b(encoder, value instanceof IsoTimestamp ? value : THROW_CCE());
};
protoOf(IsoTimestampSerializer).hp = function (decoder) {
  var str = decoder.ns();
  Companion_getInstance_0().yl(str);
  return new IsoTimestamp(str);
};
var IsoTimestampSerializer_instance;
function IsoTimestampSerializer_getInstance() {
  if (IsoTimestampSerializer_instance == null)
    new IsoTimestampSerializer();
  return IsoTimestampSerializer_instance;
}
function Companion_115() {
}
protoOf(Companion_115).o1c = function () {
  return UuidStringSerializer_getInstance();
};
var Companion_instance_115;
function Companion_getInstance_118() {
  return Companion_instance_115;
}
function UuidString(value) {
  this.value = value;
}
protoOf(UuidString).w = function () {
  return this.value;
};
protoOf(UuidString).toString = function () {
  return this.value;
};
protoOf(UuidString).wf = function () {
  return this.value;
};
protoOf(UuidString).s3t = function (value) {
  return new UuidString(value);
};
protoOf(UuidString).copy = function (value, $super) {
  value = value === VOID ? this.value : value;
  return $super === VOID ? this.s3t(value) : $super.s3t.call(this, value);
};
protoOf(UuidString).hashCode = function () {
  return getStringHashCode(this.value);
};
protoOf(UuidString).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UuidString))
    return false;
  if (!(this.value === other.value))
    return false;
  return true;
};
function toUuidString(_this__u8e3s4) {
  return new UuidString(_this__u8e3s4.toString());
}
function UuidStringSerializer() {
  UuidStringSerializer_instance = this;
  this.t4b_1 = PrimitiveSerialDescriptor('UuidString', STRING_getInstance());
}
protoOf(UuidStringSerializer).fp = function () {
  return this.t4b_1;
};
protoOf(UuidStringSerializer).u4b = function (encoder, value) {
  encoder.wt(value.value);
};
protoOf(UuidStringSerializer).gp = function (encoder, value) {
  return this.u4b(encoder, value instanceof UuidString ? value : THROW_CCE());
};
protoOf(UuidStringSerializer).hp = function (decoder) {
  var str = decoder.ns();
  Companion_getInstance().in(str);
  return new UuidString(str);
};
var UuidStringSerializer_instance;
function UuidStringSerializer_getInstance() {
  if (UuidStringSerializer_instance == null)
    new UuidStringSerializer();
  return UuidStringSerializer_instance;
}
function Companion_116() {
}
protoOf(Companion_116).o1c = function () {
  return $serializer_getInstance_97();
};
var Companion_instance_116;
function Companion_getInstance_119() {
  return Companion_instance_116;
}
function $serializer_97() {
  $serializer_instance_97 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.AccountHolderDetailsRequest', this, 6);
  tmp0_serialDesc.k10('addressLine1', false);
  tmp0_serialDesc.k10('addressLine2', true);
  tmp0_serialDesc.k10('city', false);
  tmp0_serialDesc.k10('state', false);
  tmp0_serialDesc.k10('postalCode', false);
  tmp0_serialDesc.k10('country', false);
  this.v4b_1 = tmp0_serialDesc;
}
protoOf($serializer_97).w4b = function (encoder, value) {
  var tmp0_desc = this.v4b_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.addressLine1);
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.addressLine2 === '')) {
    tmp1_output.hu(tmp0_desc, 1, value.addressLine2);
  }
  tmp1_output.hu(tmp0_desc, 2, value.city);
  tmp1_output.hu(tmp0_desc, 3, value.state);
  tmp1_output.hu(tmp0_desc, 4, value.postalCode);
  tmp1_output.hu(tmp0_desc, 5, value.country);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_97).gp = function (encoder, value) {
  return this.w4b(encoder, value instanceof AccountHolderDetailsRequest ? value : THROW_CCE());
};
protoOf($serializer_97).hp = function (decoder) {
  var tmp0_desc = this.v4b_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_input = decoder.ss(tmp0_desc);
  if (tmp10_input.it()) {
    tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.ct(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.ct(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.ct(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.ct(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.ts(tmp0_desc);
  return AccountHolderDetailsRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_97).fp = function () {
  return this.v4b_1;
};
protoOf($serializer_97).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_97;
function $serializer_getInstance_97() {
  if ($serializer_instance_97 == null)
    new $serializer_97();
  return $serializer_instance_97;
}
function AccountHolderDetailsRequest_init_$Init$(seen0, addressLine1, addressLine2, city, state, postalCode, country, serializationConstructorMarker, $this) {
  if (!(61 === (61 & seen0))) {
    throwMissingFieldException(seen0, 61, $serializer_getInstance_97().v4b_1);
  }
  $this.addressLine1 = addressLine1;
  if (0 === (seen0 & 2))
    $this.addressLine2 = '';
  else
    $this.addressLine2 = addressLine2;
  $this.city = city;
  $this.state = state;
  $this.postalCode = postalCode;
  $this.country = country;
  return $this;
}
function AccountHolderDetailsRequest_init_$Create$(seen0, addressLine1, addressLine2, city, state, postalCode, country, serializationConstructorMarker) {
  return AccountHolderDetailsRequest_init_$Init$(seen0, addressLine1, addressLine2, city, state, postalCode, country, serializationConstructorMarker, objectCreate(protoOf(AccountHolderDetailsRequest)));
}
function AccountHolderDetailsRequest(addressLine1, addressLine2, city, state, postalCode, country) {
  addressLine2 = addressLine2 === VOID ? '' : addressLine2;
  this.addressLine1 = addressLine1;
  this.addressLine2 = addressLine2;
  this.city = city;
  this.state = state;
  this.postalCode = postalCode;
  this.country = country;
}
protoOf(AccountHolderDetailsRequest).g3q = function () {
  return this.addressLine1;
};
protoOf(AccountHolderDetailsRequest).h3q = function () {
  return this.addressLine2;
};
protoOf(AccountHolderDetailsRequest).j3q = function () {
  return this.city;
};
protoOf(AccountHolderDetailsRequest).k3q = function () {
  return this.state;
};
protoOf(AccountHolderDetailsRequest).i3q = function () {
  return this.postalCode;
};
protoOf(AccountHolderDetailsRequest).l3q = function () {
  return this.country;
};
protoOf(AccountHolderDetailsRequest).wf = function () {
  return this.addressLine1;
};
protoOf(AccountHolderDetailsRequest).xf = function () {
  return this.addressLine2;
};
protoOf(AccountHolderDetailsRequest).e3p = function () {
  return this.city;
};
protoOf(AccountHolderDetailsRequest).f3p = function () {
  return this.state;
};
protoOf(AccountHolderDetailsRequest).u3q = function () {
  return this.postalCode;
};
protoOf(AccountHolderDetailsRequest).v3q = function () {
  return this.country;
};
protoOf(AccountHolderDetailsRequest).x4b = function (addressLine1, addressLine2, city, state, postalCode, country) {
  return new AccountHolderDetailsRequest(addressLine1, addressLine2, city, state, postalCode, country);
};
protoOf(AccountHolderDetailsRequest).copy = function (addressLine1, addressLine2, city, state, postalCode, country, $super) {
  addressLine1 = addressLine1 === VOID ? this.addressLine1 : addressLine1;
  addressLine2 = addressLine2 === VOID ? this.addressLine2 : addressLine2;
  city = city === VOID ? this.city : city;
  state = state === VOID ? this.state : state;
  postalCode = postalCode === VOID ? this.postalCode : postalCode;
  country = country === VOID ? this.country : country;
  return $super === VOID ? this.x4b(addressLine1, addressLine2, city, state, postalCode, country) : $super.x4b.call(this, addressLine1, addressLine2, city, state, postalCode, country);
};
protoOf(AccountHolderDetailsRequest).toString = function () {
  return 'AccountHolderDetailsRequest(addressLine1=' + this.addressLine1 + ', addressLine2=' + this.addressLine2 + ', city=' + this.city + ', state=' + this.state + ', postalCode=' + this.postalCode + ', country=' + this.country + ')';
};
protoOf(AccountHolderDetailsRequest).hashCode = function () {
  var result = getStringHashCode(this.addressLine1);
  result = imul(result, 31) + getStringHashCode(this.addressLine2) | 0;
  result = imul(result, 31) + getStringHashCode(this.city) | 0;
  result = imul(result, 31) + getStringHashCode(this.state) | 0;
  result = imul(result, 31) + getStringHashCode(this.postalCode) | 0;
  result = imul(result, 31) + getStringHashCode(this.country) | 0;
  return result;
};
protoOf(AccountHolderDetailsRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AccountHolderDetailsRequest))
    return false;
  if (!(this.addressLine1 === other.addressLine1))
    return false;
  if (!(this.addressLine2 === other.addressLine2))
    return false;
  if (!(this.city === other.city))
    return false;
  if (!(this.state === other.state))
    return false;
  if (!(this.postalCode === other.postalCode))
    return false;
  if (!(this.country === other.country))
    return false;
  return true;
};
function Companion_117() {
}
protoOf(Companion_117).generateDemoData = function () {
  return new BankDetails('HSBC Bank plc', '8 Canada Square, London E14 5HQ, United Kingdom', '12345678', 'MIDLGB22', 'GB15MIDL40051512345678');
};
protoOf(Companion_117).o1c = function () {
  return $serializer_getInstance_98();
};
var Companion_instance_117;
function Companion_getInstance_120() {
  return Companion_instance_117;
}
function $serializer_98() {
  $serializer_instance_98 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.BankDetails', this, 5);
  tmp0_serialDesc.k10('bankName', false);
  tmp0_serialDesc.k10('bankAddress', false);
  tmp0_serialDesc.k10('accountNumber', false);
  tmp0_serialDesc.k10('swiftCode', false);
  tmp0_serialDesc.k10('ibanCode', true);
  this.y4b_1 = tmp0_serialDesc;
}
protoOf($serializer_98).z4b = function (encoder, value) {
  var tmp0_desc = this.y4b_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.bankName);
  tmp1_output.hu(tmp0_desc, 1, value.bankAddress);
  tmp1_output.hu(tmp0_desc, 2, value.accountNumber);
  tmp1_output.hu(tmp0_desc, 3, value.swiftCode);
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.ibanCode == null)) {
    tmp1_output.lu(tmp0_desc, 4, StringSerializer_getInstance(), value.ibanCode);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_98).gp = function (encoder, value) {
  return this.z4b(encoder, value instanceof BankDetails ? value : THROW_CCE());
};
protoOf($serializer_98).hp = function (decoder) {
  var tmp0_desc = this.y4b_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.ss(tmp0_desc);
  if (tmp9_input.it()) {
    tmp4_local0 = tmp9_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.ts(tmp0_desc);
  return BankDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_98).fp = function () {
  return this.y4b_1;
};
protoOf($serializer_98).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_98;
function $serializer_getInstance_98() {
  if ($serializer_instance_98 == null)
    new $serializer_98();
  return $serializer_instance_98;
}
function BankDetails_init_$Init$(seen0, bankName, bankAddress, accountNumber, swiftCode, ibanCode, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_98().y4b_1);
  }
  $this.bankName = bankName;
  $this.bankAddress = bankAddress;
  $this.accountNumber = accountNumber;
  $this.swiftCode = swiftCode;
  if (0 === (seen0 & 16))
    $this.ibanCode = null;
  else
    $this.ibanCode = ibanCode;
  return $this;
}
function BankDetails_init_$Create$(seen0, bankName, bankAddress, accountNumber, swiftCode, ibanCode, serializationConstructorMarker) {
  return BankDetails_init_$Init$(seen0, bankName, bankAddress, accountNumber, swiftCode, ibanCode, serializationConstructorMarker, objectCreate(protoOf(BankDetails)));
}
function BankDetails(bankName, bankAddress, accountNumber, swiftCode, ibanCode) {
  ibanCode = ibanCode === VOID ? null : ibanCode;
  this.bankName = bankName;
  this.bankAddress = bankAddress;
  this.accountNumber = accountNumber;
  this.swiftCode = swiftCode;
  this.ibanCode = ibanCode;
}
protoOf(BankDetails).a4c = function () {
  return this.bankName;
};
protoOf(BankDetails).b4c = function () {
  return this.bankAddress;
};
protoOf(BankDetails).c4c = function () {
  return this.accountNumber;
};
protoOf(BankDetails).d4c = function () {
  return this.swiftCode;
};
protoOf(BankDetails).e4c = function () {
  return this.ibanCode;
};
protoOf(BankDetails).wf = function () {
  return this.bankName;
};
protoOf(BankDetails).xf = function () {
  return this.bankAddress;
};
protoOf(BankDetails).e3p = function () {
  return this.accountNumber;
};
protoOf(BankDetails).f3p = function () {
  return this.swiftCode;
};
protoOf(BankDetails).u3q = function () {
  return this.ibanCode;
};
protoOf(BankDetails).f4c = function (bankName, bankAddress, accountNumber, swiftCode, ibanCode) {
  return new BankDetails(bankName, bankAddress, accountNumber, swiftCode, ibanCode);
};
protoOf(BankDetails).copy = function (bankName, bankAddress, accountNumber, swiftCode, ibanCode, $super) {
  bankName = bankName === VOID ? this.bankName : bankName;
  bankAddress = bankAddress === VOID ? this.bankAddress : bankAddress;
  accountNumber = accountNumber === VOID ? this.accountNumber : accountNumber;
  swiftCode = swiftCode === VOID ? this.swiftCode : swiftCode;
  ibanCode = ibanCode === VOID ? this.ibanCode : ibanCode;
  return $super === VOID ? this.f4c(bankName, bankAddress, accountNumber, swiftCode, ibanCode) : $super.f4c.call(this, bankName, bankAddress, accountNumber, swiftCode, ibanCode);
};
protoOf(BankDetails).toString = function () {
  return 'BankDetails(bankName=' + this.bankName + ', bankAddress=' + this.bankAddress + ', accountNumber=' + this.accountNumber + ', swiftCode=' + this.swiftCode + ', ibanCode=' + this.ibanCode + ')';
};
protoOf(BankDetails).hashCode = function () {
  var result = getStringHashCode(this.bankName);
  result = imul(result, 31) + getStringHashCode(this.bankAddress) | 0;
  result = imul(result, 31) + getStringHashCode(this.accountNumber) | 0;
  result = imul(result, 31) + getStringHashCode(this.swiftCode) | 0;
  result = imul(result, 31) + (this.ibanCode == null ? 0 : getStringHashCode(this.ibanCode)) | 0;
  return result;
};
protoOf(BankDetails).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BankDetails))
    return false;
  if (!(this.bankName === other.bankName))
    return false;
  if (!(this.bankAddress === other.bankAddress))
    return false;
  if (!(this.accountNumber === other.accountNumber))
    return false;
  if (!(this.swiftCode === other.swiftCode))
    return false;
  if (!(this.ibanCode == other.ibanCode))
    return false;
  return true;
};
function Companion_118() {
}
protoOf(Companion_118).empty = function () {
  return new BankDetailsResponse('', '', '', '', '', '');
};
protoOf(Companion_118).mock = function (userId) {
  return new BankDetailsResponse(userId, 'DBS Bank', '406 Alexandra Road Singapore', '1234567890ABC', 'AAAABBCCDDD', 'AA12ABCD11223312345678');
};
protoOf(Companion_118).o1c = function () {
  return $serializer_getInstance_99();
};
var Companion_instance_118;
function Companion_getInstance_121() {
  return Companion_instance_118;
}
function $serializer_99() {
  $serializer_instance_99 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.BankDetailsResponse', this, 6);
  tmp0_serialDesc.k10('userId', false);
  tmp0_serialDesc.k10('bankName', false);
  tmp0_serialDesc.k10('bankAddress', false);
  tmp0_serialDesc.k10('accountNumber', false);
  tmp0_serialDesc.k10('swiftCode', false);
  tmp0_serialDesc.k10('ibanCode', false);
  this.g4c_1 = tmp0_serialDesc;
}
protoOf($serializer_99).h4c = function (encoder, value) {
  var tmp0_desc = this.g4c_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.userId);
  tmp1_output.hu(tmp0_desc, 1, value.bankName);
  tmp1_output.hu(tmp0_desc, 2, value.bankAddress);
  tmp1_output.hu(tmp0_desc, 3, value.accountNumber);
  tmp1_output.hu(tmp0_desc, 4, value.swiftCode);
  tmp1_output.hu(tmp0_desc, 5, value.ibanCode);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_99).gp = function (encoder, value) {
  return this.h4c(encoder, value instanceof BankDetailsResponse ? value : THROW_CCE());
};
protoOf($serializer_99).hp = function (decoder) {
  var tmp0_desc = this.g4c_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_input = decoder.ss(tmp0_desc);
  if (tmp10_input.it()) {
    tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.ct(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.ct(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.ct(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.ct(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.ts(tmp0_desc);
  return BankDetailsResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_99).fp = function () {
  return this.g4c_1;
};
protoOf($serializer_99).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_99;
function $serializer_getInstance_99() {
  if ($serializer_instance_99 == null)
    new $serializer_99();
  return $serializer_instance_99;
}
function BankDetailsResponse_init_$Init$(seen0, userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode, serializationConstructorMarker, $this) {
  if (!(63 === (63 & seen0))) {
    throwMissingFieldException(seen0, 63, $serializer_getInstance_99().g4c_1);
  }
  $this.userId = userId;
  $this.bankName = bankName;
  $this.bankAddress = bankAddress;
  $this.accountNumber = accountNumber;
  $this.swiftCode = swiftCode;
  $this.ibanCode = ibanCode;
  return $this;
}
function BankDetailsResponse_init_$Create$(seen0, userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode, serializationConstructorMarker) {
  return BankDetailsResponse_init_$Init$(seen0, userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode, serializationConstructorMarker, objectCreate(protoOf(BankDetailsResponse)));
}
function BankDetailsResponse(userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode) {
  this.userId = userId;
  this.bankName = bankName;
  this.bankAddress = bankAddress;
  this.accountNumber = accountNumber;
  this.swiftCode = swiftCode;
  this.ibanCode = ibanCode;
}
protoOf(BankDetailsResponse).u3p = function () {
  return this.userId;
};
protoOf(BankDetailsResponse).a4c = function () {
  return this.bankName;
};
protoOf(BankDetailsResponse).b4c = function () {
  return this.bankAddress;
};
protoOf(BankDetailsResponse).c4c = function () {
  return this.accountNumber;
};
protoOf(BankDetailsResponse).d4c = function () {
  return this.swiftCode;
};
protoOf(BankDetailsResponse).e4c = function () {
  return this.ibanCode;
};
protoOf(BankDetailsResponse).wf = function () {
  return this.userId;
};
protoOf(BankDetailsResponse).xf = function () {
  return this.bankName;
};
protoOf(BankDetailsResponse).e3p = function () {
  return this.bankAddress;
};
protoOf(BankDetailsResponse).f3p = function () {
  return this.accountNumber;
};
protoOf(BankDetailsResponse).u3q = function () {
  return this.swiftCode;
};
protoOf(BankDetailsResponse).v3q = function () {
  return this.ibanCode;
};
protoOf(BankDetailsResponse).x4b = function (userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode) {
  return new BankDetailsResponse(userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode);
};
protoOf(BankDetailsResponse).copy = function (userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode, $super) {
  userId = userId === VOID ? this.userId : userId;
  bankName = bankName === VOID ? this.bankName : bankName;
  bankAddress = bankAddress === VOID ? this.bankAddress : bankAddress;
  accountNumber = accountNumber === VOID ? this.accountNumber : accountNumber;
  swiftCode = swiftCode === VOID ? this.swiftCode : swiftCode;
  ibanCode = ibanCode === VOID ? this.ibanCode : ibanCode;
  return $super === VOID ? this.x4b(userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode) : $super.x4b.call(this, userId, bankName, bankAddress, accountNumber, swiftCode, ibanCode);
};
protoOf(BankDetailsResponse).toString = function () {
  return 'BankDetailsResponse(userId=' + this.userId + ', bankName=' + this.bankName + ', bankAddress=' + this.bankAddress + ', accountNumber=' + this.accountNumber + ', swiftCode=' + this.swiftCode + ', ibanCode=' + this.ibanCode + ')';
};
protoOf(BankDetailsResponse).hashCode = function () {
  var result = getStringHashCode(this.userId);
  result = imul(result, 31) + getStringHashCode(this.bankName) | 0;
  result = imul(result, 31) + getStringHashCode(this.bankAddress) | 0;
  result = imul(result, 31) + getStringHashCode(this.accountNumber) | 0;
  result = imul(result, 31) + getStringHashCode(this.swiftCode) | 0;
  result = imul(result, 31) + getStringHashCode(this.ibanCode) | 0;
  return result;
};
protoOf(BankDetailsResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BankDetailsResponse))
    return false;
  if (!(this.userId === other.userId))
    return false;
  if (!(this.bankName === other.bankName))
    return false;
  if (!(this.bankAddress === other.bankAddress))
    return false;
  if (!(this.accountNumber === other.accountNumber))
    return false;
  if (!(this.swiftCode === other.swiftCode))
    return false;
  if (!(this.ibanCode === other.ibanCode))
    return false;
  return true;
};
function Companion_119() {
}
protoOf(Companion_119).generateDemoData = function () {
  return new PayoutBankDetails(Companion_instance_120.generateDemoData(), Companion_instance_117.generateDemoData());
};
protoOf(Companion_119).o1c = function () {
  return $serializer_getInstance_100();
};
var Companion_instance_119;
function Companion_getInstance_122() {
  return Companion_instance_119;
}
function $serializer_100() {
  $serializer_instance_100 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.PayoutBankDetails', this, 2);
  tmp0_serialDesc.k10('personalDetails', false);
  tmp0_serialDesc.k10('bankDetails', false);
  this.i4c_1 = tmp0_serialDesc;
}
protoOf($serializer_100).j4c = function (encoder, value) {
  var tmp0_desc = this.i4c_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, $serializer_getInstance_101(), value.personalDetails);
  tmp1_output.ju(tmp0_desc, 1, $serializer_getInstance_98(), value.bankDetails);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_100).gp = function (encoder, value) {
  return this.j4c(encoder, value instanceof PayoutBankDetails ? value : THROW_CCE());
};
protoOf($serializer_100).hp = function (decoder) {
  var tmp0_desc = this.i4c_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_101(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.et(tmp0_desc, 1, $serializer_getInstance_98(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.et(tmp0_desc, 0, $serializer_getInstance_101(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.et(tmp0_desc, 1, $serializer_getInstance_98(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return PayoutBankDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_100).fp = function () {
  return this.i4c_1;
};
protoOf($serializer_100).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_101(), $serializer_getInstance_98()];
};
var $serializer_instance_100;
function $serializer_getInstance_100() {
  if ($serializer_instance_100 == null)
    new $serializer_100();
  return $serializer_instance_100;
}
function PayoutBankDetails_init_$Init$(seen0, personalDetails, bankDetails, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_100().i4c_1);
  }
  $this.personalDetails = personalDetails;
  $this.bankDetails = bankDetails;
  return $this;
}
function PayoutBankDetails_init_$Create$(seen0, personalDetails, bankDetails, serializationConstructorMarker) {
  return PayoutBankDetails_init_$Init$(seen0, personalDetails, bankDetails, serializationConstructorMarker, objectCreate(protoOf(PayoutBankDetails)));
}
function PayoutBankDetails(personalDetails, bankDetails) {
  this.personalDetails = personalDetails;
  this.bankDetails = bankDetails;
}
protoOf(PayoutBankDetails).k4c = function () {
  return this.personalDetails;
};
protoOf(PayoutBankDetails).l4c = function () {
  return this.bankDetails;
};
protoOf(PayoutBankDetails).wf = function () {
  return this.personalDetails;
};
protoOf(PayoutBankDetails).xf = function () {
  return this.bankDetails;
};
protoOf(PayoutBankDetails).m4c = function (personalDetails, bankDetails) {
  return new PayoutBankDetails(personalDetails, bankDetails);
};
protoOf(PayoutBankDetails).copy = function (personalDetails, bankDetails, $super) {
  personalDetails = personalDetails === VOID ? this.personalDetails : personalDetails;
  bankDetails = bankDetails === VOID ? this.bankDetails : bankDetails;
  return $super === VOID ? this.m4c(personalDetails, bankDetails) : $super.m4c.call(this, personalDetails, bankDetails);
};
protoOf(PayoutBankDetails).toString = function () {
  return 'PayoutBankDetails(personalDetails=' + this.personalDetails.toString() + ', bankDetails=' + this.bankDetails.toString() + ')';
};
protoOf(PayoutBankDetails).hashCode = function () {
  var result = this.personalDetails.hashCode();
  result = imul(result, 31) + this.bankDetails.hashCode() | 0;
  return result;
};
protoOf(PayoutBankDetails).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PayoutBankDetails))
    return false;
  if (!this.personalDetails.equals(other.personalDetails))
    return false;
  if (!this.bankDetails.equals(other.bankDetails))
    return false;
  return true;
};
function Companion_120() {
}
protoOf(Companion_120).generateDemoData = function () {
  return new PersonalDetails('No. 189, Sec. 2, Keelung Rd., Xinyi Dist.', 'Rm. 12, 15F.', 'John Doe', 'Taipei', 'Taipei City', '110609', 'Taiwan');
};
protoOf(Companion_120).o1c = function () {
  return $serializer_getInstance_101();
};
var Companion_instance_120;
function Companion_getInstance_123() {
  return Companion_instance_120;
}
function $serializer_101() {
  $serializer_instance_101 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.PersonalDetails', this, 7);
  tmp0_serialDesc.k10('addressLine1', false);
  tmp0_serialDesc.k10('addressLine2', false);
  tmp0_serialDesc.k10('beneficiaryName', false);
  tmp0_serialDesc.k10('city', false);
  tmp0_serialDesc.k10('state', false);
  tmp0_serialDesc.k10('postalCode', false);
  tmp0_serialDesc.k10('country', false);
  this.n4c_1 = tmp0_serialDesc;
}
protoOf($serializer_101).o4c = function (encoder, value) {
  var tmp0_desc = this.n4c_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.addressLine1);
  tmp1_output.hu(tmp0_desc, 1, value.addressLine2);
  tmp1_output.hu(tmp0_desc, 2, value.beneficiaryName);
  tmp1_output.hu(tmp0_desc, 3, value.city);
  tmp1_output.hu(tmp0_desc, 4, value.state);
  tmp1_output.hu(tmp0_desc, 5, value.postalCode);
  tmp1_output.hu(tmp0_desc, 6, value.country);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_101).gp = function (encoder, value) {
  return this.o4c(encoder, value instanceof PersonalDetails ? value : THROW_CCE());
};
protoOf($serializer_101).hp = function (decoder) {
  var tmp0_desc = this.n4c_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.ss(tmp0_desc);
  if (tmp11_input.it()) {
    tmp4_local0 = tmp11_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.ct(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.ct(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.ct(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.ct(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.ct(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.ct(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.ct(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.ct(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.ts(tmp0_desc);
  return PersonalDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_101).fp = function () {
  return this.n4c_1;
};
protoOf($serializer_101).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_101;
function $serializer_getInstance_101() {
  if ($serializer_instance_101 == null)
    new $serializer_101();
  return $serializer_instance_101;
}
function PersonalDetails_init_$Init$(seen0, addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country, serializationConstructorMarker, $this) {
  if (!(127 === (127 & seen0))) {
    throwMissingFieldException(seen0, 127, $serializer_getInstance_101().n4c_1);
  }
  $this.addressLine1 = addressLine1;
  $this.addressLine2 = addressLine2;
  $this.beneficiaryName = beneficiaryName;
  $this.city = city;
  $this.state = state;
  $this.postalCode = postalCode;
  $this.country = country;
  return $this;
}
function PersonalDetails_init_$Create$(seen0, addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country, serializationConstructorMarker) {
  return PersonalDetails_init_$Init$(seen0, addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country, serializationConstructorMarker, objectCreate(protoOf(PersonalDetails)));
}
function PersonalDetails(addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country) {
  this.addressLine1 = addressLine1;
  this.addressLine2 = addressLine2;
  this.beneficiaryName = beneficiaryName;
  this.city = city;
  this.state = state;
  this.postalCode = postalCode;
  this.country = country;
}
protoOf(PersonalDetails).g3q = function () {
  return this.addressLine1;
};
protoOf(PersonalDetails).h3q = function () {
  return this.addressLine2;
};
protoOf(PersonalDetails).p4c = function () {
  return this.beneficiaryName;
};
protoOf(PersonalDetails).j3q = function () {
  return this.city;
};
protoOf(PersonalDetails).k3q = function () {
  return this.state;
};
protoOf(PersonalDetails).i3q = function () {
  return this.postalCode;
};
protoOf(PersonalDetails).l3q = function () {
  return this.country;
};
protoOf(PersonalDetails).wf = function () {
  return this.addressLine1;
};
protoOf(PersonalDetails).xf = function () {
  return this.addressLine2;
};
protoOf(PersonalDetails).e3p = function () {
  return this.beneficiaryName;
};
protoOf(PersonalDetails).f3p = function () {
  return this.city;
};
protoOf(PersonalDetails).u3q = function () {
  return this.state;
};
protoOf(PersonalDetails).v3q = function () {
  return this.postalCode;
};
protoOf(PersonalDetails).w3q = function () {
  return this.country;
};
protoOf(PersonalDetails).q4c = function (addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country) {
  return new PersonalDetails(addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country);
};
protoOf(PersonalDetails).copy = function (addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country, $super) {
  addressLine1 = addressLine1 === VOID ? this.addressLine1 : addressLine1;
  addressLine2 = addressLine2 === VOID ? this.addressLine2 : addressLine2;
  beneficiaryName = beneficiaryName === VOID ? this.beneficiaryName : beneficiaryName;
  city = city === VOID ? this.city : city;
  state = state === VOID ? this.state : state;
  postalCode = postalCode === VOID ? this.postalCode : postalCode;
  country = country === VOID ? this.country : country;
  return $super === VOID ? this.q4c(addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country) : $super.q4c.call(this, addressLine1, addressLine2, beneficiaryName, city, state, postalCode, country);
};
protoOf(PersonalDetails).toString = function () {
  return 'PersonalDetails(addressLine1=' + this.addressLine1 + ', addressLine2=' + this.addressLine2 + ', beneficiaryName=' + this.beneficiaryName + ', city=' + this.city + ', state=' + this.state + ', postalCode=' + this.postalCode + ', country=' + this.country + ')';
};
protoOf(PersonalDetails).hashCode = function () {
  var result = getStringHashCode(this.addressLine1);
  result = imul(result, 31) + getStringHashCode(this.addressLine2) | 0;
  result = imul(result, 31) + getStringHashCode(this.beneficiaryName) | 0;
  result = imul(result, 31) + getStringHashCode(this.city) | 0;
  result = imul(result, 31) + getStringHashCode(this.state) | 0;
  result = imul(result, 31) + getStringHashCode(this.postalCode) | 0;
  result = imul(result, 31) + getStringHashCode(this.country) | 0;
  return result;
};
protoOf(PersonalDetails).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PersonalDetails))
    return false;
  if (!(this.addressLine1 === other.addressLine1))
    return false;
  if (!(this.addressLine2 === other.addressLine2))
    return false;
  if (!(this.beneficiaryName === other.beneficiaryName))
    return false;
  if (!(this.city === other.city))
    return false;
  if (!(this.state === other.state))
    return false;
  if (!(this.postalCode === other.postalCode))
    return false;
  if (!(this.country === other.country))
    return false;
  return true;
};
function RegisterFcmTokenRequest$Companion$$childSerializers$_anonymous__xezq9z() {
  return Companion_getInstance_15().o1c();
}
function Companion_121() {
  Companion_instance_121 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r4c_1 = [null, lazy(tmp_0, RegisterFcmTokenRequest$Companion$$childSerializers$_anonymous__xezq9z), null];
}
protoOf(Companion_121).o1c = function () {
  return $serializer_getInstance_102();
};
var Companion_instance_121;
function Companion_getInstance_124() {
  if (Companion_instance_121 == null)
    new Companion_121();
  return Companion_instance_121;
}
function $serializer_102() {
  $serializer_instance_102 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.RegisterFcmTokenRequest', this, 3);
  tmp0_serialDesc.k10('fcmToken', false);
  tmp0_serialDesc.k10('platform', false);
  tmp0_serialDesc.k10('previousFcmToken', true);
  this.s4c_1 = tmp0_serialDesc;
}
protoOf($serializer_102).t4c = function (encoder, value) {
  var tmp0_desc = this.s4c_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_124().r4c_1;
  tmp1_output.hu(tmp0_desc, 0, value.fcmToken);
  tmp1_output.ju(tmp0_desc, 1, tmp2_cached[1].w(), value.platform);
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.previousFcmToken == null)) {
    tmp1_output.lu(tmp0_desc, 2, StringSerializer_getInstance(), value.previousFcmToken);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_102).gp = function (encoder, value) {
  return this.t4c(encoder, value instanceof RegisterFcmTokenRequest ? value : THROW_CCE());
};
protoOf($serializer_102).hp = function (decoder) {
  var tmp0_desc = this.s4c_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  var tmp8_cached = Companion_getInstance_124().r4c_1;
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.et(tmp0_desc, 1, tmp8_cached[1].w(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.et(tmp0_desc, 1, tmp8_cached[1].w(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return RegisterFcmTokenRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_102).fp = function () {
  return this.s4c_1;
};
protoOf($serializer_102).z10 = function () {
  var tmp0_cached = Companion_getInstance_124().r4c_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), tmp0_cached[1].w(), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_102;
function $serializer_getInstance_102() {
  if ($serializer_instance_102 == null)
    new $serializer_102();
  return $serializer_instance_102;
}
function RegisterFcmTokenRequest_init_$Init$(seen0, fcmToken, platform, previousFcmToken, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_102().s4c_1);
  }
  $this.fcmToken = fcmToken;
  $this.platform = platform;
  if (0 === (seen0 & 4))
    $this.previousFcmToken = null;
  else
    $this.previousFcmToken = previousFcmToken;
  return $this;
}
function RegisterFcmTokenRequest_init_$Create$(seen0, fcmToken, platform, previousFcmToken, serializationConstructorMarker) {
  return RegisterFcmTokenRequest_init_$Init$(seen0, fcmToken, platform, previousFcmToken, serializationConstructorMarker, objectCreate(protoOf(RegisterFcmTokenRequest)));
}
function RegisterFcmTokenRequest(fcmToken, platform, previousFcmToken) {
  Companion_getInstance_124();
  previousFcmToken = previousFcmToken === VOID ? null : previousFcmToken;
  this.fcmToken = fcmToken;
  this.platform = platform;
  this.previousFcmToken = previousFcmToken;
}
protoOf(RegisterFcmTokenRequest).u4c = function () {
  return this.fcmToken;
};
protoOf(RegisterFcmTokenRequest).v4c = function () {
  return this.platform;
};
protoOf(RegisterFcmTokenRequest).w4c = function () {
  return this.previousFcmToken;
};
protoOf(RegisterFcmTokenRequest).wf = function () {
  return this.fcmToken;
};
protoOf(RegisterFcmTokenRequest).xf = function () {
  return this.platform;
};
protoOf(RegisterFcmTokenRequest).e3p = function () {
  return this.previousFcmToken;
};
protoOf(RegisterFcmTokenRequest).x4c = function (fcmToken, platform, previousFcmToken) {
  return new RegisterFcmTokenRequest(fcmToken, platform, previousFcmToken);
};
protoOf(RegisterFcmTokenRequest).copy = function (fcmToken, platform, previousFcmToken, $super) {
  fcmToken = fcmToken === VOID ? this.fcmToken : fcmToken;
  platform = platform === VOID ? this.platform : platform;
  previousFcmToken = previousFcmToken === VOID ? this.previousFcmToken : previousFcmToken;
  return $super === VOID ? this.x4c(fcmToken, platform, previousFcmToken) : $super.x4c.call(this, fcmToken, platform, previousFcmToken);
};
protoOf(RegisterFcmTokenRequest).toString = function () {
  return 'RegisterFcmTokenRequest(fcmToken=' + this.fcmToken + ', platform=' + this.platform.toString() + ', previousFcmToken=' + this.previousFcmToken + ')';
};
protoOf(RegisterFcmTokenRequest).hashCode = function () {
  var result = getStringHashCode(this.fcmToken);
  result = imul(result, 31) + this.platform.hashCode() | 0;
  result = imul(result, 31) + (this.previousFcmToken == null ? 0 : getStringHashCode(this.previousFcmToken)) | 0;
  return result;
};
protoOf(RegisterFcmTokenRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RegisterFcmTokenRequest))
    return false;
  if (!(this.fcmToken === other.fcmToken))
    return false;
  if (!this.platform.equals(other.platform))
    return false;
  if (!(this.previousFcmToken == other.previousFcmToken))
    return false;
  return true;
};
function Companion_122() {
}
protoOf(Companion_122).o1c = function () {
  return $serializer_getInstance_103();
};
var Companion_instance_122;
function Companion_getInstance_125() {
  return Companion_instance_122;
}
function $serializer_103() {
  $serializer_instance_103 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.RegisterFcmTokenResponse', this, 1);
  tmp0_serialDesc.k10('id', false);
  this.y4c_1 = tmp0_serialDesc;
}
protoOf($serializer_103).z4c = function (encoder, value) {
  var tmp0_desc = this.y4c_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.ju(tmp0_desc, 0, UuidStringSerializer_getInstance(), value.id);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_103).gp = function (encoder, value) {
  return this.z4c(encoder, value instanceof RegisterFcmTokenResponse ? value : THROW_CCE());
};
protoOf($serializer_103).hp = function (decoder) {
  var tmp0_desc = this.y4c_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, UuidStringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, UuidStringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return RegisterFcmTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_103).fp = function () {
  return this.y4c_1;
};
protoOf($serializer_103).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [UuidStringSerializer_getInstance()];
};
var $serializer_instance_103;
function $serializer_getInstance_103() {
  if ($serializer_instance_103 == null)
    new $serializer_103();
  return $serializer_instance_103;
}
function RegisterFcmTokenResponse_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_103().y4c_1);
  }
  $this.id = id;
  return $this;
}
function RegisterFcmTokenResponse_init_$Create$(seen0, id, serializationConstructorMarker) {
  return RegisterFcmTokenResponse_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(RegisterFcmTokenResponse)));
}
function RegisterFcmTokenResponse(id) {
  this.id = id;
}
protoOf(RegisterFcmTokenResponse).l3t = function () {
  return this.id;
};
protoOf(RegisterFcmTokenResponse).wf = function () {
  return this.id;
};
protoOf(RegisterFcmTokenResponse).a4d = function (id) {
  return new RegisterFcmTokenResponse(id);
};
protoOf(RegisterFcmTokenResponse).copy = function (id, $super) {
  id = id === VOID ? this.id : id;
  return $super === VOID ? this.a4d(id) : $super.a4d.call(this, id);
};
protoOf(RegisterFcmTokenResponse).toString = function () {
  return 'RegisterFcmTokenResponse(id=' + this.id.toString() + ')';
};
protoOf(RegisterFcmTokenResponse).hashCode = function () {
  return this.id.hashCode();
};
protoOf(RegisterFcmTokenResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RegisterFcmTokenResponse))
    return false;
  if (!this.id.equals(other.id))
    return false;
  return true;
};
function Companion_123() {
}
protoOf(Companion_123).empty = function () {
  return new ReserveShareInfoResponse('', 0.0, 0.0, true, 0, 0);
};
protoOf(Companion_123).o1c = function () {
  return $serializer_getInstance_104();
};
var Companion_instance_123;
function Companion_getInstance_126() {
  return Companion_instance_123;
}
function $serializer_104() {
  $serializer_instance_104 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.ReserveShareInfoResponse', this, 6);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('sharePrice', false);
  tmp0_serialDesc.k10('openingFee', false);
  tmp0_serialDesc.k10('isNewInvestor', false);
  tmp0_serialDesc.k10('minBuy', false);
  tmp0_serialDesc.k10('maxBuy', false);
  this.b4d_1 = tmp0_serialDesc;
}
protoOf($serializer_104).c4d = function (encoder, value) {
  var tmp0_desc = this.b4d_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.hu(tmp0_desc, 0, value.ticker);
  tmp1_output.eu(tmp0_desc, 1, value.sharePrice);
  tmp1_output.eu(tmp0_desc, 2, value.openingFee);
  tmp1_output.zt(tmp0_desc, 3, value.isNewInvestor);
  tmp1_output.cu(tmp0_desc, 4, value.minBuy);
  tmp1_output.cu(tmp0_desc, 5, value.maxBuy);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_104).gp = function (encoder, value) {
  return this.c4d(encoder, value instanceof ReserveShareInfoResponse ? value : THROW_CCE());
};
protoOf($serializer_104).hp = function (decoder) {
  var tmp0_desc = this.b4d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = false;
  var tmp8_local4 = 0;
  var tmp9_local5 = 0;
  var tmp10_input = decoder.ss(tmp0_desc);
  if (tmp10_input.it()) {
    tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.zs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.zs(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.us(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.xs(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.xs(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.zs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.zs(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.us(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.xs(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.xs(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.ts(tmp0_desc);
  return ReserveShareInfoResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_104).fp = function () {
  return this.b4d_1;
};
protoOf($serializer_104).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_104;
function $serializer_getInstance_104() {
  if ($serializer_instance_104 == null)
    new $serializer_104();
  return $serializer_instance_104;
}
function ReserveShareInfoResponse_init_$Init$(seen0, ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy, serializationConstructorMarker, $this) {
  if (!(63 === (63 & seen0))) {
    throwMissingFieldException(seen0, 63, $serializer_getInstance_104().b4d_1);
  }
  $this.ticker = ticker;
  $this.sharePrice = sharePrice;
  $this.openingFee = openingFee;
  $this.isNewInvestor = isNewInvestor;
  $this.minBuy = minBuy;
  $this.maxBuy = maxBuy;
  return $this;
}
function ReserveShareInfoResponse_init_$Create$(seen0, ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy, serializationConstructorMarker) {
  return ReserveShareInfoResponse_init_$Init$(seen0, ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy, serializationConstructorMarker, objectCreate(protoOf(ReserveShareInfoResponse)));
}
function ReserveShareInfoResponse(ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy) {
  this.ticker = ticker;
  this.sharePrice = sharePrice;
  this.openingFee = openingFee;
  this.isNewInvestor = isNewInvestor;
  this.minBuy = minBuy;
  this.maxBuy = maxBuy;
}
protoOf(ReserveShareInfoResponse).f3v = function () {
  return this.ticker;
};
protoOf(ReserveShareInfoResponse).k3x = function () {
  return this.sharePrice;
};
protoOf(ReserveShareInfoResponse).d4d = function () {
  return this.openingFee;
};
protoOf(ReserveShareInfoResponse).e4d = function () {
  return this.isNewInvestor;
};
protoOf(ReserveShareInfoResponse).f4d = function () {
  return this.minBuy;
};
protoOf(ReserveShareInfoResponse).g4d = function () {
  return this.maxBuy;
};
protoOf(ReserveShareInfoResponse).wf = function () {
  return this.ticker;
};
protoOf(ReserveShareInfoResponse).xf = function () {
  return this.sharePrice;
};
protoOf(ReserveShareInfoResponse).e3p = function () {
  return this.openingFee;
};
protoOf(ReserveShareInfoResponse).f3p = function () {
  return this.isNewInvestor;
};
protoOf(ReserveShareInfoResponse).u3q = function () {
  return this.minBuy;
};
protoOf(ReserveShareInfoResponse).v3q = function () {
  return this.maxBuy;
};
protoOf(ReserveShareInfoResponse).h4d = function (ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy) {
  return new ReserveShareInfoResponse(ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy);
};
protoOf(ReserveShareInfoResponse).copy = function (ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy, $super) {
  ticker = ticker === VOID ? this.ticker : ticker;
  sharePrice = sharePrice === VOID ? this.sharePrice : sharePrice;
  openingFee = openingFee === VOID ? this.openingFee : openingFee;
  isNewInvestor = isNewInvestor === VOID ? this.isNewInvestor : isNewInvestor;
  minBuy = minBuy === VOID ? this.minBuy : minBuy;
  maxBuy = maxBuy === VOID ? this.maxBuy : maxBuy;
  return $super === VOID ? this.h4d(ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy) : $super.h4d.call(this, ticker, sharePrice, openingFee, isNewInvestor, minBuy, maxBuy);
};
protoOf(ReserveShareInfoResponse).toString = function () {
  return 'ReserveShareInfoResponse(ticker=' + this.ticker + ', sharePrice=' + this.sharePrice + ', openingFee=' + this.openingFee + ', isNewInvestor=' + this.isNewInvestor + ', minBuy=' + this.minBuy + ', maxBuy=' + this.maxBuy + ')';
};
protoOf(ReserveShareInfoResponse).hashCode = function () {
  var result = getStringHashCode(this.ticker);
  result = imul(result, 31) + getNumberHashCode(this.sharePrice) | 0;
  result = imul(result, 31) + getNumberHashCode(this.openingFee) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.isNewInvestor) | 0;
  result = imul(result, 31) + this.minBuy | 0;
  result = imul(result, 31) + this.maxBuy | 0;
  return result;
};
protoOf(ReserveShareInfoResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ReserveShareInfoResponse))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!equals(this.sharePrice, other.sharePrice))
    return false;
  if (!equals(this.openingFee, other.openingFee))
    return false;
  if (!(this.isNewInvestor === other.isNewInvestor))
    return false;
  if (!(this.minBuy === other.minBuy))
    return false;
  if (!(this.maxBuy === other.maxBuy))
    return false;
  return true;
};
function Companion_124() {
}
protoOf(Companion_124).o1c = function () {
  return $serializer_getInstance_105();
};
var Companion_instance_124;
function Companion_getInstance_127() {
  return Companion_instance_124;
}
function $serializer_105() {
  $serializer_instance_105 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.ReserveSharesResponse', this, 3);
  tmp0_serialDesc.k10('nonMaturedShares', true);
  tmp0_serialDesc.k10('maturedShares', true);
  tmp0_serialDesc.k10('expiryDate', true);
  this.i4d_1 = tmp0_serialDesc;
}
protoOf($serializer_105).j4d = function (encoder, value) {
  var tmp0_desc = this.i4d_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.nonMaturedShares == null)) {
    tmp1_output.lu(tmp0_desc, 0, IntSerializer_getInstance(), value.nonMaturedShares);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.maturedShares == null)) {
    tmp1_output.lu(tmp0_desc, 1, IntSerializer_getInstance(), value.maturedShares);
  }
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !(value.expiryDate == null)) {
    tmp1_output.lu(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), value.expiryDate);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_105).gp = function (encoder, value) {
  return this.j4d(encoder, value instanceof ReserveSharesResponse ? value : THROW_CCE());
};
protoOf($serializer_105).hp = function (decoder) {
  var tmp0_desc = this.i4d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.gt(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.gt(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.gt(tmp0_desc, 2, IsoTimestampSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return ReserveSharesResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_105).fp = function () {
  return this.i4d_1;
};
protoOf($serializer_105).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IsoTimestampSerializer_getInstance())];
};
var $serializer_instance_105;
function $serializer_getInstance_105() {
  if ($serializer_instance_105 == null)
    new $serializer_105();
  return $serializer_instance_105;
}
function ReserveSharesResponse_init_$Init$(seen0, nonMaturedShares, maturedShares, expiryDate, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_105().i4d_1);
  }
  if (0 === (seen0 & 1))
    $this.nonMaturedShares = null;
  else
    $this.nonMaturedShares = nonMaturedShares;
  if (0 === (seen0 & 2))
    $this.maturedShares = null;
  else
    $this.maturedShares = maturedShares;
  if (0 === (seen0 & 4))
    $this.expiryDate = null;
  else
    $this.expiryDate = expiryDate;
  return $this;
}
function ReserveSharesResponse_init_$Create$(seen0, nonMaturedShares, maturedShares, expiryDate, serializationConstructorMarker) {
  return ReserveSharesResponse_init_$Init$(seen0, nonMaturedShares, maturedShares, expiryDate, serializationConstructorMarker, objectCreate(protoOf(ReserveSharesResponse)));
}
function ReserveSharesResponse(nonMaturedShares, maturedShares, expiryDate) {
  nonMaturedShares = nonMaturedShares === VOID ? null : nonMaturedShares;
  maturedShares = maturedShares === VOID ? null : maturedShares;
  expiryDate = expiryDate === VOID ? null : expiryDate;
  this.nonMaturedShares = nonMaturedShares;
  this.maturedShares = maturedShares;
  this.expiryDate = expiryDate;
}
protoOf(ReserveSharesResponse).y3y = function () {
  return this.nonMaturedShares;
};
protoOf(ReserveSharesResponse).k4d = function () {
  return this.maturedShares;
};
protoOf(ReserveSharesResponse).l4d = function () {
  return this.expiryDate;
};
protoOf(ReserveSharesResponse).wf = function () {
  return this.nonMaturedShares;
};
protoOf(ReserveSharesResponse).xf = function () {
  return this.maturedShares;
};
protoOf(ReserveSharesResponse).e3p = function () {
  return this.expiryDate;
};
protoOf(ReserveSharesResponse).m4d = function (nonMaturedShares, maturedShares, expiryDate) {
  return new ReserveSharesResponse(nonMaturedShares, maturedShares, expiryDate);
};
protoOf(ReserveSharesResponse).copy = function (nonMaturedShares, maturedShares, expiryDate, $super) {
  nonMaturedShares = nonMaturedShares === VOID ? this.nonMaturedShares : nonMaturedShares;
  maturedShares = maturedShares === VOID ? this.maturedShares : maturedShares;
  expiryDate = expiryDate === VOID ? this.expiryDate : expiryDate;
  return $super === VOID ? this.m4d(nonMaturedShares, maturedShares, expiryDate) : $super.m4d.call(this, nonMaturedShares, maturedShares, expiryDate);
};
protoOf(ReserveSharesResponse).toString = function () {
  return 'ReserveSharesResponse(nonMaturedShares=' + this.nonMaturedShares + ', maturedShares=' + this.maturedShares + ', expiryDate=' + toString(this.expiryDate) + ')';
};
protoOf(ReserveSharesResponse).hashCode = function () {
  var result = this.nonMaturedShares == null ? 0 : this.nonMaturedShares;
  result = imul(result, 31) + (this.maturedShares == null ? 0 : this.maturedShares) | 0;
  result = imul(result, 31) + (this.expiryDate == null ? 0 : this.expiryDate.hashCode()) | 0;
  return result;
};
protoOf(ReserveSharesResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ReserveSharesResponse))
    return false;
  if (!(this.nonMaturedShares == other.nonMaturedShares))
    return false;
  if (!(this.maturedShares == other.maturedShares))
    return false;
  if (!equals(this.expiryDate, other.expiryDate))
    return false;
  return true;
};
function Companion_125() {
}
protoOf(Companion_125).o1c = function () {
  return $serializer_getInstance_106();
};
var Companion_instance_125;
function Companion_getInstance_128() {
  return Companion_instance_125;
}
function $serializer_106() {
  $serializer_instance_106 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.SellSharesResponse', this, 2);
  tmp0_serialDesc.k10('maturedShares', true);
  tmp0_serialDesc.k10('nonMaturedShares', true);
  this.n4d_1 = tmp0_serialDesc;
}
protoOf($serializer_106).o4d = function (encoder, value) {
  var tmp0_desc = this.n4d_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  if (tmp1_output.pu(tmp0_desc, 0) ? true : !(value.maturedShares == null)) {
    tmp1_output.lu(tmp0_desc, 0, IntSerializer_getInstance(), value.maturedShares);
  }
  if (tmp1_output.pu(tmp0_desc, 1) ? true : !(value.nonMaturedShares == null)) {
    tmp1_output.lu(tmp0_desc, 1, IntSerializer_getInstance(), value.nonMaturedShares);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_106).gp = function (encoder, value) {
  return this.o4d(encoder, value instanceof SellSharesResponse ? value : THROW_CCE());
};
protoOf($serializer_106).hp = function (decoder) {
  var tmp0_desc = this.n4d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.ss(tmp0_desc);
  if (tmp6_input.it()) {
    tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.gt(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gt(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.ts(tmp0_desc);
  return SellSharesResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_106).fp = function () {
  return this.n4d_1;
};
protoOf($serializer_106).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
};
var $serializer_instance_106;
function $serializer_getInstance_106() {
  if ($serializer_instance_106 == null)
    new $serializer_106();
  return $serializer_instance_106;
}
function SellSharesResponse_init_$Init$(seen0, maturedShares, nonMaturedShares, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_106().n4d_1);
  }
  if (0 === (seen0 & 1))
    $this.maturedShares = null;
  else
    $this.maturedShares = maturedShares;
  if (0 === (seen0 & 2))
    $this.nonMaturedShares = null;
  else
    $this.nonMaturedShares = nonMaturedShares;
  return $this;
}
function SellSharesResponse_init_$Create$(seen0, maturedShares, nonMaturedShares, serializationConstructorMarker) {
  return SellSharesResponse_init_$Init$(seen0, maturedShares, nonMaturedShares, serializationConstructorMarker, objectCreate(protoOf(SellSharesResponse)));
}
function SellSharesResponse(maturedShares, nonMaturedShares) {
  maturedShares = maturedShares === VOID ? null : maturedShares;
  nonMaturedShares = nonMaturedShares === VOID ? null : nonMaturedShares;
  this.maturedShares = maturedShares;
  this.nonMaturedShares = nonMaturedShares;
}
protoOf(SellSharesResponse).k4d = function () {
  return this.maturedShares;
};
protoOf(SellSharesResponse).y3y = function () {
  return this.nonMaturedShares;
};
protoOf(SellSharesResponse).wf = function () {
  return this.maturedShares;
};
protoOf(SellSharesResponse).xf = function () {
  return this.nonMaturedShares;
};
protoOf(SellSharesResponse).p4d = function (maturedShares, nonMaturedShares) {
  return new SellSharesResponse(maturedShares, nonMaturedShares);
};
protoOf(SellSharesResponse).copy = function (maturedShares, nonMaturedShares, $super) {
  maturedShares = maturedShares === VOID ? this.maturedShares : maturedShares;
  nonMaturedShares = nonMaturedShares === VOID ? this.nonMaturedShares : nonMaturedShares;
  return $super === VOID ? this.p4d(maturedShares, nonMaturedShares) : $super.p4d.call(this, maturedShares, nonMaturedShares);
};
protoOf(SellSharesResponse).toString = function () {
  return 'SellSharesResponse(maturedShares=' + this.maturedShares + ', nonMaturedShares=' + this.nonMaturedShares + ')';
};
protoOf(SellSharesResponse).hashCode = function () {
  var result = this.maturedShares == null ? 0 : this.maturedShares;
  result = imul(result, 31) + (this.nonMaturedShares == null ? 0 : this.nonMaturedShares) | 0;
  return result;
};
protoOf(SellSharesResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SellSharesResponse))
    return false;
  if (!(this.maturedShares == other.maturedShares))
    return false;
  if (!(this.nonMaturedShares == other.nonMaturedShares))
    return false;
  return true;
};
function TransactSharesRequest$Companion$$childSerializers$_anonymous__sweent() {
  return Companion_getInstance_21().o1c();
}
function TransactSharesRequest$Companion$$childSerializers$_anonymous__sweent_0() {
  return Companion_getInstance_15().o1c();
}
function Companion_126() {
  Companion_instance_126 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, TransactSharesRequest$Companion$$childSerializers$_anonymous__sweent);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.q4d_1 = [null, null, tmp_1, null, lazy(tmp_2, TransactSharesRequest$Companion$$childSerializers$_anonymous__sweent_0)];
}
protoOf(Companion_126).o1c = function () {
  return $serializer_getInstance_107();
};
var Companion_instance_126;
function Companion_getInstance_129() {
  if (Companion_instance_126 == null)
    new Companion_126();
  return Companion_instance_126;
}
function $serializer_107() {
  $serializer_instance_107 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.TransactSharesRequest', this, 5);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('shares', false);
  tmp0_serialDesc.k10('transactionType', false);
  tmp0_serialDesc.k10('forceSell', true);
  tmp0_serialDesc.k10('platform', true);
  this.r4d_1 = tmp0_serialDesc;
}
protoOf($serializer_107).s4d = function (encoder, value) {
  var tmp0_desc = this.r4d_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_129().q4d_1;
  tmp1_output.hu(tmp0_desc, 0, value.ticker);
  tmp1_output.cu(tmp0_desc, 1, value.shares);
  tmp1_output.ju(tmp0_desc, 2, tmp2_cached[2].w(), value.transactionType);
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.forceSell === false)) {
    tmp1_output.zt(tmp0_desc, 3, value.forceSell);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.platform == null)) {
    tmp1_output.lu(tmp0_desc, 4, tmp2_cached[4].w(), value.platform);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_107).gp = function (encoder, value) {
  return this.s4d(encoder, value instanceof TransactSharesRequest ? value : THROW_CCE());
};
protoOf($serializer_107).hp = function (decoder) {
  var tmp0_desc = this.r4d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0;
  var tmp6_local2 = null;
  var tmp7_local3 = false;
  var tmp8_local4 = null;
  var tmp9_input = decoder.ss(tmp0_desc);
  var tmp10_cached = Companion_getInstance_129().q4d_1;
  if (tmp9_input.it()) {
    tmp4_local0 = tmp9_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.xs(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.et(tmp0_desc, 2, tmp10_cached[2].w(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.us(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, tmp10_cached[4].w(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.xs(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.et(tmp0_desc, 2, tmp10_cached[2].w(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.us(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.gt(tmp0_desc, 4, tmp10_cached[4].w(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.ts(tmp0_desc);
  return TransactSharesRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_107).fp = function () {
  return this.r4d_1;
};
protoOf($serializer_107).z10 = function () {
  var tmp0_cached = Companion_getInstance_129().q4d_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[2].w(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[4].w())];
};
var $serializer_instance_107;
function $serializer_getInstance_107() {
  if ($serializer_instance_107 == null)
    new $serializer_107();
  return $serializer_instance_107;
}
function TransactSharesRequest_init_$Init$(seen0, ticker, shares, transactionType, forceSell, platform, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_107().r4d_1);
  }
  $this.ticker = ticker;
  $this.shares = shares;
  $this.transactionType = transactionType;
  if (0 === (seen0 & 8))
    $this.forceSell = false;
  else
    $this.forceSell = forceSell;
  if (0 === (seen0 & 16))
    $this.platform = null;
  else
    $this.platform = platform;
  return $this;
}
function TransactSharesRequest_init_$Create$(seen0, ticker, shares, transactionType, forceSell, platform, serializationConstructorMarker) {
  return TransactSharesRequest_init_$Init$(seen0, ticker, shares, transactionType, forceSell, platform, serializationConstructorMarker, objectCreate(protoOf(TransactSharesRequest)));
}
function TransactSharesRequest(ticker, shares, transactionType, forceSell, platform) {
  Companion_getInstance_129();
  forceSell = forceSell === VOID ? false : forceSell;
  platform = platform === VOID ? null : platform;
  this.ticker = ticker;
  this.shares = shares;
  this.transactionType = transactionType;
  this.forceSell = forceSell;
  this.platform = platform;
}
protoOf(TransactSharesRequest).f3v = function () {
  return this.ticker;
};
protoOf(TransactSharesRequest).w3z = function () {
  return this.shares;
};
protoOf(TransactSharesRequest).t4d = function () {
  return this.transactionType;
};
protoOf(TransactSharesRequest).u4d = function () {
  return this.forceSell;
};
protoOf(TransactSharesRequest).v4c = function () {
  return this.platform;
};
protoOf(TransactSharesRequest).wf = function () {
  return this.ticker;
};
protoOf(TransactSharesRequest).xf = function () {
  return this.shares;
};
protoOf(TransactSharesRequest).e3p = function () {
  return this.transactionType;
};
protoOf(TransactSharesRequest).f3p = function () {
  return this.forceSell;
};
protoOf(TransactSharesRequest).u3q = function () {
  return this.platform;
};
protoOf(TransactSharesRequest).v4d = function (ticker, shares, transactionType, forceSell, platform) {
  return new TransactSharesRequest(ticker, shares, transactionType, forceSell, platform);
};
protoOf(TransactSharesRequest).copy = function (ticker, shares, transactionType, forceSell, platform, $super) {
  ticker = ticker === VOID ? this.ticker : ticker;
  shares = shares === VOID ? this.shares : shares;
  transactionType = transactionType === VOID ? this.transactionType : transactionType;
  forceSell = forceSell === VOID ? this.forceSell : forceSell;
  platform = platform === VOID ? this.platform : platform;
  return $super === VOID ? this.v4d(ticker, shares, transactionType, forceSell, platform) : $super.v4d.call(this, ticker, shares, transactionType, forceSell, platform);
};
protoOf(TransactSharesRequest).toString = function () {
  return 'TransactSharesRequest(ticker=' + this.ticker + ', shares=' + this.shares + ', transactionType=' + this.transactionType.toString() + ', forceSell=' + this.forceSell + ', platform=' + toString(this.platform) + ')';
};
protoOf(TransactSharesRequest).hashCode = function () {
  var result = getStringHashCode(this.ticker);
  result = imul(result, 31) + this.shares | 0;
  result = imul(result, 31) + this.transactionType.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.forceSell) | 0;
  result = imul(result, 31) + (this.platform == null ? 0 : this.platform.hashCode()) | 0;
  return result;
};
protoOf(TransactSharesRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransactSharesRequest))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!(this.shares === other.shares))
    return false;
  if (!this.transactionType.equals(other.transactionType))
    return false;
  if (!(this.forceSell === other.forceSell))
    return false;
  if (!equals(this.platform, other.platform))
    return false;
  return true;
};
function TransactionRecord$Companion$$childSerializers$_anonymous__rc947v() {
  return Companion_getInstance_21().o1c();
}
function TransactionRecord$Companion$$childSerializers$_anonymous__rc947v_0() {
  return new ArrayListSerializer($serializer_getInstance_109());
}
function TransactionRecord$Companion$$childSerializers$_anonymous__rc947v_1() {
  return Companion_getInstance_22().o1c();
}
function Companion_127() {
  Companion_instance_127 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, TransactionRecord$Companion$$childSerializers$_anonymous__rc947v);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_3 = lazy(tmp_2, TransactionRecord$Companion$$childSerializers$_anonymous__rc947v_0);
  var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.w4d_1 = [null, null, null, null, null, tmp_1, null, tmp_3, null, null, lazy(tmp_4, TransactionRecord$Companion$$childSerializers$_anonymous__rc947v_1), null, null, null, null, null, null, null, null];
}
protoOf(Companion_127).o1c = function () {
  return $serializer_getInstance_108();
};
var Companion_instance_127;
function Companion_getInstance_130() {
  if (Companion_instance_127 == null)
    new Companion_127();
  return Companion_instance_127;
}
function $serializer_108() {
  $serializer_instance_108 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.TransactionRecord', this, 19);
  tmp0_serialDesc.k10('userId', false);
  tmp0_serialDesc.k10('transactionId', false);
  tmp0_serialDesc.k10('customerEmail', false);
  tmp0_serialDesc.k10('updatedAt', false);
  tmp0_serialDesc.k10('expiryDate', false);
  tmp0_serialDesc.k10('transactionType', false);
  tmp0_serialDesc.k10('numberOfShares', false);
  tmp0_serialDesc.k10('statuses', false);
  tmp0_serialDesc.k10('fullName', false);
  tmp0_serialDesc.k10('ticker', false);
  tmp0_serialDesc.k10('newestStatus', false);
  tmp0_serialDesc.k10('transactionValue', false);
  tmp0_serialDesc.k10('sharePrice', false);
  tmp0_serialDesc.k10('totalTransactionValue', false);
  tmp0_serialDesc.k10('netTotalTransactionValue', false);
  tmp0_serialDesc.k10('bankTransferFee', false);
  tmp0_serialDesc.k10('openingFee', false);
  tmp0_serialDesc.k10('sellBankTransferFee', false);
  tmp0_serialDesc.k10('maintenanceFee', false);
  this.x4d_1 = tmp0_serialDesc;
}
protoOf($serializer_108).y4d = function (encoder, value) {
  var tmp0_desc = this.x4d_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_130().w4d_1;
  tmp1_output.ju(tmp0_desc, 0, UuidStringSerializer_getInstance(), value.userId);
  tmp1_output.ju(tmp0_desc, 1, UuidStringSerializer_getInstance(), value.transactionId);
  tmp1_output.hu(tmp0_desc, 2, value.customerEmail);
  tmp1_output.ju(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), value.updatedAt);
  tmp1_output.lu(tmp0_desc, 4, IsoTimestampSerializer_getInstance(), value.expiryDate);
  tmp1_output.ju(tmp0_desc, 5, tmp2_cached[5].w(), value.transactionType);
  tmp1_output.cu(tmp0_desc, 6, value.numberOfShares);
  tmp1_output.ju(tmp0_desc, 7, tmp2_cached[7].w(), value.statuses);
  tmp1_output.hu(tmp0_desc, 8, value.fullName);
  tmp1_output.hu(tmp0_desc, 9, value.ticker);
  tmp1_output.ju(tmp0_desc, 10, tmp2_cached[10].w(), value.newestStatus);
  tmp1_output.eu(tmp0_desc, 11, value.transactionValue);
  tmp1_output.eu(tmp0_desc, 12, value.sharePrice);
  tmp1_output.eu(tmp0_desc, 13, value.totalTransactionValue);
  tmp1_output.eu(tmp0_desc, 14, value.netTotalTransactionValue);
  tmp1_output.eu(tmp0_desc, 15, value.bankTransferFee);
  tmp1_output.eu(tmp0_desc, 16, value.openingFee);
  tmp1_output.eu(tmp0_desc, 17, value.sellBankTransferFee);
  tmp1_output.eu(tmp0_desc, 18, value.maintenanceFee);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_108).gp = function (encoder, value) {
  return this.y4d(encoder, value instanceof TransactionRecord ? value : THROW_CCE());
};
protoOf($serializer_108).hp = function (decoder) {
  var tmp0_desc = this.x4d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = 0;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = 0.0;
  var tmp16_local12 = 0.0;
  var tmp17_local13 = 0.0;
  var tmp18_local14 = 0.0;
  var tmp19_local15 = 0.0;
  var tmp20_local16 = 0.0;
  var tmp21_local17 = 0.0;
  var tmp22_local18 = 0.0;
  var tmp23_input = decoder.ss(tmp0_desc);
  var tmp24_cached = Companion_getInstance_130().w4d_1;
  if (tmp23_input.it()) {
    tmp4_local0 = tmp23_input.et(tmp0_desc, 0, UuidStringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp23_input.et(tmp0_desc, 1, UuidStringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp23_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp23_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp23_input.gt(tmp0_desc, 4, IsoTimestampSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp23_input.et(tmp0_desc, 5, tmp24_cached[5].w(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp23_input.xs(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp23_input.et(tmp0_desc, 7, tmp24_cached[7].w(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp23_input.ct(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp23_input.ct(tmp0_desc, 9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp23_input.et(tmp0_desc, 10, tmp24_cached[10].w(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp23_input.zs(tmp0_desc, 11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp23_input.zs(tmp0_desc, 12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp23_input.zs(tmp0_desc, 13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp23_input.zs(tmp0_desc, 14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp23_input.zs(tmp0_desc, 15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp23_input.zs(tmp0_desc, 16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp21_local17 = tmp23_input.zs(tmp0_desc, 17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    tmp22_local18 = tmp23_input.zs(tmp0_desc, 18);
    tmp3_bitMask0 = tmp3_bitMask0 | 262144;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp23_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp23_input.et(tmp0_desc, 0, UuidStringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp23_input.et(tmp0_desc, 1, UuidStringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp23_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp23_input.et(tmp0_desc, 3, IsoTimestampSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp23_input.gt(tmp0_desc, 4, IsoTimestampSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp23_input.et(tmp0_desc, 5, tmp24_cached[5].w(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp23_input.xs(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp23_input.et(tmp0_desc, 7, tmp24_cached[7].w(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp23_input.ct(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp23_input.ct(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp23_input.et(tmp0_desc, 10, tmp24_cached[10].w(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp23_input.zs(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp23_input.zs(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp23_input.zs(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp23_input.zs(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp23_input.zs(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp23_input.zs(tmp0_desc, 16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp21_local17 = tmp23_input.zs(tmp0_desc, 17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        case 18:
          tmp22_local18 = tmp23_input.zs(tmp0_desc, 18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp23_input.ts(tmp0_desc);
  return TransactionRecord_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, null);
};
protoOf($serializer_108).fp = function () {
  return this.x4d_1;
};
protoOf($serializer_108).z10 = function () {
  var tmp0_cached = Companion_getInstance_130().w4d_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [UuidStringSerializer_getInstance(), UuidStringSerializer_getInstance(), StringSerializer_getInstance(), IsoTimestampSerializer_getInstance(), get_nullable(IsoTimestampSerializer_getInstance()), tmp0_cached[5].w(), IntSerializer_getInstance(), tmp0_cached[7].w(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[10].w(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
};
var $serializer_instance_108;
function $serializer_getInstance_108() {
  if ($serializer_instance_108 == null)
    new $serializer_108();
  return $serializer_instance_108;
}
function TransactionRecord_init_$Init$(seen0, userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee, serializationConstructorMarker, $this) {
  if (!(524287 === (524287 & seen0))) {
    throwMissingFieldException(seen0, 524287, $serializer_getInstance_108().x4d_1);
  }
  $this.userId = userId;
  $this.transactionId = transactionId;
  $this.customerEmail = customerEmail;
  $this.updatedAt = updatedAt;
  $this.expiryDate = expiryDate;
  $this.transactionType = transactionType;
  $this.numberOfShares = numberOfShares;
  $this.statuses = statuses;
  $this.fullName = fullName;
  $this.ticker = ticker;
  $this.newestStatus = newestStatus;
  $this.transactionValue = transactionValue;
  $this.sharePrice = sharePrice;
  $this.totalTransactionValue = totalTransactionValue;
  $this.netTotalTransactionValue = netTotalTransactionValue;
  $this.bankTransferFee = bankTransferFee;
  $this.openingFee = openingFee;
  $this.sellBankTransferFee = sellBankTransferFee;
  $this.maintenanceFee = maintenanceFee;
  return $this;
}
function TransactionRecord_init_$Create$(seen0, userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee, serializationConstructorMarker) {
  return TransactionRecord_init_$Init$(seen0, userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee, serializationConstructorMarker, objectCreate(protoOf(TransactionRecord)));
}
function TransactionRecord(userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee) {
  Companion_getInstance_130();
  this.userId = userId;
  this.transactionId = transactionId;
  this.customerEmail = customerEmail;
  this.updatedAt = updatedAt;
  this.expiryDate = expiryDate;
  this.transactionType = transactionType;
  this.numberOfShares = numberOfShares;
  this.statuses = statuses;
  this.fullName = fullName;
  this.ticker = ticker;
  this.newestStatus = newestStatus;
  this.transactionValue = transactionValue;
  this.sharePrice = sharePrice;
  this.totalTransactionValue = totalTransactionValue;
  this.netTotalTransactionValue = netTotalTransactionValue;
  this.bankTransferFee = bankTransferFee;
  this.openingFee = openingFee;
  this.sellBankTransferFee = sellBankTransferFee;
  this.maintenanceFee = maintenanceFee;
}
protoOf(TransactionRecord).u3p = function () {
  return this.userId;
};
protoOf(TransactionRecord).z4d = function () {
  return this.transactionId;
};
protoOf(TransactionRecord).a4e = function () {
  return this.customerEmail;
};
protoOf(TransactionRecord).w40 = function () {
  return this.updatedAt;
};
protoOf(TransactionRecord).l4d = function () {
  return this.expiryDate;
};
protoOf(TransactionRecord).t4d = function () {
  return this.transactionType;
};
protoOf(TransactionRecord).b4e = function () {
  return this.numberOfShares;
};
protoOf(TransactionRecord).c4e = function () {
  return this.statuses;
};
protoOf(TransactionRecord).z3p = function () {
  return this.fullName;
};
protoOf(TransactionRecord).f3v = function () {
  return this.ticker;
};
protoOf(TransactionRecord).d4e = function () {
  return this.newestStatus;
};
protoOf(TransactionRecord).e4e = function () {
  return this.transactionValue;
};
protoOf(TransactionRecord).k3x = function () {
  return this.sharePrice;
};
protoOf(TransactionRecord).f4e = function () {
  return this.totalTransactionValue;
};
protoOf(TransactionRecord).g4e = function () {
  return this.netTotalTransactionValue;
};
protoOf(TransactionRecord).n3z = function () {
  return this.bankTransferFee;
};
protoOf(TransactionRecord).d4d = function () {
  return this.openingFee;
};
protoOf(TransactionRecord).h4e = function () {
  return this.sellBankTransferFee;
};
protoOf(TransactionRecord).i4e = function () {
  return this.maintenanceFee;
};
protoOf(TransactionRecord).check = function () {
  return this.transactionType.checkStatus(this.newestStatus);
};
protoOf(TransactionRecord).wf = function () {
  return this.userId;
};
protoOf(TransactionRecord).xf = function () {
  return this.transactionId;
};
protoOf(TransactionRecord).e3p = function () {
  return this.customerEmail;
};
protoOf(TransactionRecord).f3p = function () {
  return this.updatedAt;
};
protoOf(TransactionRecord).u3q = function () {
  return this.expiryDate;
};
protoOf(TransactionRecord).v3q = function () {
  return this.transactionType;
};
protoOf(TransactionRecord).w3q = function () {
  return this.numberOfShares;
};
protoOf(TransactionRecord).x3q = function () {
  return this.statuses;
};
protoOf(TransactionRecord).y3q = function () {
  return this.fullName;
};
protoOf(TransactionRecord).z3q = function () {
  return this.ticker;
};
protoOf(TransactionRecord).a3r = function () {
  return this.newestStatus;
};
protoOf(TransactionRecord).b3r = function () {
  return this.transactionValue;
};
protoOf(TransactionRecord).c3r = function () {
  return this.sharePrice;
};
protoOf(TransactionRecord).d3r = function () {
  return this.totalTransactionValue;
};
protoOf(TransactionRecord).e3r = function () {
  return this.netTotalTransactionValue;
};
protoOf(TransactionRecord).f3r = function () {
  return this.bankTransferFee;
};
protoOf(TransactionRecord).g3r = function () {
  return this.openingFee;
};
protoOf(TransactionRecord).h3r = function () {
  return this.sellBankTransferFee;
};
protoOf(TransactionRecord).i3r = function () {
  return this.maintenanceFee;
};
protoOf(TransactionRecord).j4e = function (userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee) {
  return new TransactionRecord(userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee);
};
protoOf(TransactionRecord).copy = function (userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee, $super) {
  userId = userId === VOID ? this.userId : userId;
  transactionId = transactionId === VOID ? this.transactionId : transactionId;
  customerEmail = customerEmail === VOID ? this.customerEmail : customerEmail;
  updatedAt = updatedAt === VOID ? this.updatedAt : updatedAt;
  expiryDate = expiryDate === VOID ? this.expiryDate : expiryDate;
  transactionType = transactionType === VOID ? this.transactionType : transactionType;
  numberOfShares = numberOfShares === VOID ? this.numberOfShares : numberOfShares;
  statuses = statuses === VOID ? this.statuses : statuses;
  fullName = fullName === VOID ? this.fullName : fullName;
  ticker = ticker === VOID ? this.ticker : ticker;
  newestStatus = newestStatus === VOID ? this.newestStatus : newestStatus;
  transactionValue = transactionValue === VOID ? this.transactionValue : transactionValue;
  sharePrice = sharePrice === VOID ? this.sharePrice : sharePrice;
  totalTransactionValue = totalTransactionValue === VOID ? this.totalTransactionValue : totalTransactionValue;
  netTotalTransactionValue = netTotalTransactionValue === VOID ? this.netTotalTransactionValue : netTotalTransactionValue;
  bankTransferFee = bankTransferFee === VOID ? this.bankTransferFee : bankTransferFee;
  openingFee = openingFee === VOID ? this.openingFee : openingFee;
  sellBankTransferFee = sellBankTransferFee === VOID ? this.sellBankTransferFee : sellBankTransferFee;
  maintenanceFee = maintenanceFee === VOID ? this.maintenanceFee : maintenanceFee;
  return $super === VOID ? this.j4e(userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee) : $super.j4e.call(this, userId, transactionId, customerEmail, updatedAt, expiryDate, transactionType, numberOfShares, statuses, fullName, ticker, newestStatus, transactionValue, sharePrice, totalTransactionValue, netTotalTransactionValue, bankTransferFee, openingFee, sellBankTransferFee, maintenanceFee);
};
protoOf(TransactionRecord).toString = function () {
  return 'TransactionRecord(userId=' + this.userId.toString() + ', transactionId=' + this.transactionId.toString() + ', customerEmail=' + this.customerEmail + ', updatedAt=' + this.updatedAt.toString() + ', expiryDate=' + toString(this.expiryDate) + ', transactionType=' + this.transactionType.toString() + ', numberOfShares=' + this.numberOfShares + ', statuses=' + toString_0(this.statuses) + ', fullName=' + this.fullName + ', ticker=' + this.ticker + ', newestStatus=' + this.newestStatus.toString() + ', transactionValue=' + this.transactionValue + ', sharePrice=' + this.sharePrice + ', totalTransactionValue=' + this.totalTransactionValue + ', netTotalTransactionValue=' + this.netTotalTransactionValue + ', bankTransferFee=' + this.bankTransferFee + ', openingFee=' + this.openingFee + ', sellBankTransferFee=' + this.sellBankTransferFee + ', maintenanceFee=' + this.maintenanceFee + ')';
};
protoOf(TransactionRecord).hashCode = function () {
  var result = this.userId.hashCode();
  result = imul(result, 31) + this.transactionId.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.customerEmail) | 0;
  result = imul(result, 31) + this.updatedAt.hashCode() | 0;
  result = imul(result, 31) + (this.expiryDate == null ? 0 : this.expiryDate.hashCode()) | 0;
  result = imul(result, 31) + this.transactionType.hashCode() | 0;
  result = imul(result, 31) + this.numberOfShares | 0;
  result = imul(result, 31) + hashCode(this.statuses) | 0;
  result = imul(result, 31) + getStringHashCode(this.fullName) | 0;
  result = imul(result, 31) + getStringHashCode(this.ticker) | 0;
  result = imul(result, 31) + this.newestStatus.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.transactionValue) | 0;
  result = imul(result, 31) + getNumberHashCode(this.sharePrice) | 0;
  result = imul(result, 31) + getNumberHashCode(this.totalTransactionValue) | 0;
  result = imul(result, 31) + getNumberHashCode(this.netTotalTransactionValue) | 0;
  result = imul(result, 31) + getNumberHashCode(this.bankTransferFee) | 0;
  result = imul(result, 31) + getNumberHashCode(this.openingFee) | 0;
  result = imul(result, 31) + getNumberHashCode(this.sellBankTransferFee) | 0;
  result = imul(result, 31) + getNumberHashCode(this.maintenanceFee) | 0;
  return result;
};
protoOf(TransactionRecord).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransactionRecord))
    return false;
  if (!this.userId.equals(other.userId))
    return false;
  if (!this.transactionId.equals(other.transactionId))
    return false;
  if (!(this.customerEmail === other.customerEmail))
    return false;
  if (!this.updatedAt.equals(other.updatedAt))
    return false;
  if (!equals(this.expiryDate, other.expiryDate))
    return false;
  if (!this.transactionType.equals(other.transactionType))
    return false;
  if (!(this.numberOfShares === other.numberOfShares))
    return false;
  if (!equals(this.statuses, other.statuses))
    return false;
  if (!(this.fullName === other.fullName))
    return false;
  if (!(this.ticker === other.ticker))
    return false;
  if (!this.newestStatus.equals(other.newestStatus))
    return false;
  if (!equals(this.transactionValue, other.transactionValue))
    return false;
  if (!equals(this.sharePrice, other.sharePrice))
    return false;
  if (!equals(this.totalTransactionValue, other.totalTransactionValue))
    return false;
  if (!equals(this.netTotalTransactionValue, other.netTotalTransactionValue))
    return false;
  if (!equals(this.bankTransferFee, other.bankTransferFee))
    return false;
  if (!equals(this.openingFee, other.openingFee))
    return false;
  if (!equals(this.sellBankTransferFee, other.sellBankTransferFee))
    return false;
  if (!equals(this.maintenanceFee, other.maintenanceFee))
    return false;
  return true;
};
function TransactionStatus$Companion$$childSerializers$_anonymous__mnk5bu() {
  return Companion_getInstance_22().o1c();
}
function Companion_128() {
  Companion_instance_128 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.k4e_1 = [lazy(tmp_0, TransactionStatus$Companion$$childSerializers$_anonymous__mnk5bu), null, null];
}
protoOf(Companion_128).of = function (status) {
  return new TransactionStatus(status, toIsoTimestamp(Companion_getInstance_0().am()), '');
};
protoOf(Companion_128).o1c = function () {
  return $serializer_getInstance_109();
};
var Companion_instance_128;
function Companion_getInstance_131() {
  if (Companion_instance_128 == null)
    new Companion_128();
  return Companion_instance_128;
}
function $serializer_109() {
  $serializer_instance_109 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.TransactionStatus', this, 3);
  tmp0_serialDesc.k10('status', false);
  tmp0_serialDesc.k10('date', false);
  tmp0_serialDesc.k10('message', false);
  this.l4e_1 = tmp0_serialDesc;
}
protoOf($serializer_109).m4e = function (encoder, value) {
  var tmp0_desc = this.l4e_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_131().k4e_1;
  tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.status);
  tmp1_output.ju(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), value.date);
  tmp1_output.hu(tmp0_desc, 2, value.message);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_109).gp = function (encoder, value) {
  return this.m4e(encoder, value instanceof TransactionStatus ? value : THROW_CCE());
};
protoOf($serializer_109).hp = function (decoder) {
  var tmp0_desc = this.l4e_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.ss(tmp0_desc);
  var tmp8_cached = Companion_getInstance_131().k4e_1;
  if (tmp7_input.it()) {
    tmp4_local0 = tmp7_input.et(tmp0_desc, 0, tmp8_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.et(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.ct(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.et(tmp0_desc, 0, tmp8_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.et(tmp0_desc, 1, IsoTimestampSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.ct(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.ts(tmp0_desc);
  return TransactionStatus_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_109).fp = function () {
  return this.l4e_1;
};
protoOf($serializer_109).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_131().k4e_1[0].w(), IsoTimestampSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_109;
function $serializer_getInstance_109() {
  if ($serializer_instance_109 == null)
    new $serializer_109();
  return $serializer_instance_109;
}
function TransactionStatus_init_$Init$(seen0, status, date, message, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_109().l4e_1);
  }
  $this.status = status;
  $this.date = date;
  $this.message = message;
  return $this;
}
function TransactionStatus_init_$Create$(seen0, status, date, message, serializationConstructorMarker) {
  return TransactionStatus_init_$Init$(seen0, status, date, message, serializationConstructorMarker, objectCreate(protoOf(TransactionStatus)));
}
function TransactionStatus(status, date, message) {
  Companion_getInstance_131();
  this.status = status;
  this.date = date;
  this.message = message;
}
protoOf(TransactionStatus).r3w = function () {
  return this.status;
};
protoOf(TransactionStatus).x3z = function () {
  return this.date;
};
protoOf(TransactionStatus).e = function () {
  return this.message;
};
protoOf(TransactionStatus).wf = function () {
  return this.status;
};
protoOf(TransactionStatus).xf = function () {
  return this.date;
};
protoOf(TransactionStatus).e3p = function () {
  return this.message;
};
protoOf(TransactionStatus).n4e = function (status, date, message) {
  return new TransactionStatus(status, date, message);
};
protoOf(TransactionStatus).copy = function (status, date, message, $super) {
  status = status === VOID ? this.status : status;
  date = date === VOID ? this.date : date;
  message = message === VOID ? this.message : message;
  return $super === VOID ? this.n4e(status, date, message) : $super.n4e.call(this, status, date, message);
};
protoOf(TransactionStatus).toString = function () {
  return 'TransactionStatus(status=' + this.status.toString() + ', date=' + this.date.toString() + ', message=' + this.message + ')';
};
protoOf(TransactionStatus).hashCode = function () {
  var result = this.status.hashCode();
  result = imul(result, 31) + this.date.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.message) | 0;
  return result;
};
protoOf(TransactionStatus).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransactionStatus))
    return false;
  if (!this.status.equals(other.status))
    return false;
  if (!this.date.equals(other.date))
    return false;
  if (!(this.message === other.message))
    return false;
  return true;
};
function Companion_129() {
}
protoOf(Companion_129).o1c = function () {
  return $serializer_getInstance_110();
};
var Companion_instance_129;
function Companion_getInstance_132() {
  return Companion_instance_129;
}
function $serializer_110() {
  $serializer_instance_110 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.UpdateThresholdRequest', this, 1);
  tmp0_serialDesc.k10('threshold', false);
  this.o4e_1 = tmp0_serialDesc;
}
protoOf($serializer_110).p4e = function (encoder, value) {
  var tmp0_desc = this.o4e_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  tmp1_output.cu(tmp0_desc, 0, value.threshold);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_110).gp = function (encoder, value) {
  return this.p4e(encoder, value instanceof UpdateThresholdRequest ? value : THROW_CCE());
};
protoOf($serializer_110).hp = function (decoder) {
  var tmp0_desc = this.o4e_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_input = decoder.ss(tmp0_desc);
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.xs(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.xs(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return UpdateThresholdRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_110).fp = function () {
  return this.o4e_1;
};
protoOf($serializer_110).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance()];
};
var $serializer_instance_110;
function $serializer_getInstance_110() {
  if ($serializer_instance_110 == null)
    new $serializer_110();
  return $serializer_instance_110;
}
function UpdateThresholdRequest_init_$Init$(seen0, threshold, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_110().o4e_1);
  }
  $this.threshold = threshold;
  return $this;
}
function UpdateThresholdRequest_init_$Create$(seen0, threshold, serializationConstructorMarker) {
  return UpdateThresholdRequest_init_$Init$(seen0, threshold, serializationConstructorMarker, objectCreate(protoOf(UpdateThresholdRequest)));
}
function UpdateThresholdRequest(threshold) {
  this.threshold = threshold;
}
protoOf(UpdateThresholdRequest).s3q = function () {
  return this.threshold;
};
protoOf(UpdateThresholdRequest).wf = function () {
  return this.threshold;
};
protoOf(UpdateThresholdRequest).q4e = function (threshold) {
  return new UpdateThresholdRequest(threshold);
};
protoOf(UpdateThresholdRequest).copy = function (threshold, $super) {
  threshold = threshold === VOID ? this.threshold : threshold;
  return $super === VOID ? this.q4e(threshold) : $super.q4e.call(this, threshold);
};
protoOf(UpdateThresholdRequest).toString = function () {
  return 'UpdateThresholdRequest(threshold=' + this.threshold + ')';
};
protoOf(UpdateThresholdRequest).hashCode = function () {
  return this.threshold;
};
protoOf(UpdateThresholdRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UpdateThresholdRequest))
    return false;
  if (!(this.threshold === other.threshold))
    return false;
  return true;
};
function UpdateTransactionStatusRequest$Companion$$childSerializers$_anonymous__ij2ybm() {
  return Companion_getInstance_22().o1c();
}
function Companion_130() {
  Companion_instance_130 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r4e_1 = [lazy(tmp_0, UpdateTransactionStatusRequest$Companion$$childSerializers$_anonymous__ij2ybm)];
}
protoOf(Companion_130).o1c = function () {
  return $serializer_getInstance_111();
};
var Companion_instance_130;
function Companion_getInstance_133() {
  if (Companion_instance_130 == null)
    new Companion_130();
  return Companion_instance_130;
}
function $serializer_111() {
  $serializer_instance_111 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.moreharvest.shared.user.UpdateTransactionStatusRequest', this, 1);
  tmp0_serialDesc.k10('status', false);
  this.s4e_1 = tmp0_serialDesc;
}
protoOf($serializer_111).t4e = function (encoder, value) {
  var tmp0_desc = this.s4e_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_133().r4e_1;
  tmp1_output.ju(tmp0_desc, 0, tmp2_cached[0].w(), value.status);
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer_111).gp = function (encoder, value) {
  return this.t4e(encoder, value instanceof UpdateTransactionStatusRequest ? value : THROW_CCE());
};
protoOf($serializer_111).hp = function (decoder) {
  var tmp0_desc = this.s4e_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.ss(tmp0_desc);
  var tmp6_cached = Companion_getInstance_133().r4e_1;
  if (tmp5_input.it()) {
    tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.et(tmp0_desc, 0, tmp6_cached[0].w(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.ts(tmp0_desc);
  return UpdateTransactionStatusRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_111).fp = function () {
  return this.s4e_1;
};
protoOf($serializer_111).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_133().r4e_1[0].w()];
};
var $serializer_instance_111;
function $serializer_getInstance_111() {
  if ($serializer_instance_111 == null)
    new $serializer_111();
  return $serializer_instance_111;
}
function UpdateTransactionStatusRequest_init_$Init$(seen0, status, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_111().s4e_1);
  }
  $this.status = status;
  return $this;
}
function UpdateTransactionStatusRequest_init_$Create$(seen0, status, serializationConstructorMarker) {
  return UpdateTransactionStatusRequest_init_$Init$(seen0, status, serializationConstructorMarker, objectCreate(protoOf(UpdateTransactionStatusRequest)));
}
function UpdateTransactionStatusRequest(status) {
  Companion_getInstance_133();
  this.status = status;
}
protoOf(UpdateTransactionStatusRequest).r3w = function () {
  return this.status;
};
protoOf(UpdateTransactionStatusRequest).wf = function () {
  return this.status;
};
protoOf(UpdateTransactionStatusRequest).u4e = function (status) {
  return new UpdateTransactionStatusRequest(status);
};
protoOf(UpdateTransactionStatusRequest).copy = function (status, $super) {
  status = status === VOID ? this.status : status;
  return $super === VOID ? this.u4e(status) : $super.u4e.call(this, status);
};
protoOf(UpdateTransactionStatusRequest).toString = function () {
  return 'UpdateTransactionStatusRequest(status=' + this.status.toString() + ')';
};
protoOf(UpdateTransactionStatusRequest).hashCode = function () {
  return this.status.hashCode();
};
protoOf(UpdateTransactionStatusRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UpdateTransactionStatusRequest))
    return false;
  if (!this.status.equals(other.status))
    return false;
  return true;
};
//region block: post-declaration
defineProp(protoOf(AnalyticsAuthErrorCode), 'name', protoOf(AnalyticsAuthErrorCode).k2);
defineProp(protoOf(AnalyticsAuthErrorCode), 'ordinal', protoOf(AnalyticsAuthErrorCode).l2);
defineProp(protoOf(AnalyticsAuthMethod), 'name', protoOf(AnalyticsAuthMethod).k2);
defineProp(protoOf(AnalyticsAuthMethod), 'ordinal', protoOf(AnalyticsAuthMethod).l2);
defineProp(protoOf(AnalyticsAuthStage), 'name', protoOf(AnalyticsAuthStage).k2);
defineProp(protoOf(AnalyticsAuthStage), 'ordinal', protoOf(AnalyticsAuthStage).l2);
defineProp(protoOf(AnalyticsContentType), 'name', protoOf(AnalyticsContentType).k2);
defineProp(protoOf(AnalyticsContentType), 'ordinal', protoOf(AnalyticsContentType).l2);
defineProp(protoOf(AnalyticsFormOutcome), 'name', protoOf(AnalyticsFormOutcome).k2);
defineProp(protoOf(AnalyticsFormOutcome), 'ordinal', protoOf(AnalyticsFormOutcome).l2);
defineProp(protoOf(AnalyticsPaymentType), 'name', protoOf(AnalyticsPaymentType).k2);
defineProp(protoOf(AnalyticsPaymentType), 'ordinal', protoOf(AnalyticsPaymentType).l2);
defineProp(protoOf(AnalyticsTransactionStage), 'name', protoOf(AnalyticsTransactionStage).k2);
defineProp(protoOf(AnalyticsTransactionStage), 'ordinal', protoOf(AnalyticsTransactionStage).l2);
defineProp(protoOf(AnalyticsTransactionType), 'name', protoOf(AnalyticsTransactionType).k2);
defineProp(protoOf(AnalyticsTransactionType), 'ordinal', protoOf(AnalyticsTransactionType).l2);
protoOf($serializer).a11 = typeParametersSerializers;
protoOf($serializer_0).a11 = typeParametersSerializers;
protoOf($serializer_1).a11 = typeParametersSerializers;
protoOf($serializer_2).a11 = typeParametersSerializers;
protoOf($serializer_3).a11 = typeParametersSerializers;
protoOf($serializer_4).a11 = typeParametersSerializers;
protoOf($serializer_5).a11 = typeParametersSerializers;
protoOf($serializer_6).a11 = typeParametersSerializers;
protoOf($serializer_7).a11 = typeParametersSerializers;
protoOf($serializer_8).a11 = typeParametersSerializers;
protoOf($serializer_9).a11 = typeParametersSerializers;
defineProp(protoOf(AccountStatus), 'name', protoOf(AccountStatus).k2);
defineProp(protoOf(AccountStatus), 'ordinal', protoOf(AccountStatus).l2);
defineProp(protoOf(ApiFeedbackSurveyTypeEnum), 'name', protoOf(ApiFeedbackSurveyTypeEnum).k2);
defineProp(protoOf(ApiFeedbackSurveyTypeEnum), 'ordinal', protoOf(ApiFeedbackSurveyTypeEnum).l2);
defineProp(protoOf(DevicePlatformEnum), 'name', protoOf(DevicePlatformEnum).k2);
defineProp(protoOf(DevicePlatformEnum), 'ordinal', protoOf(DevicePlatformEnum).l2);
defineProp(protoOf(FeedbackSurveyStatusEnum), 'name', protoOf(FeedbackSurveyStatusEnum).k2);
defineProp(protoOf(FeedbackSurveyStatusEnum), 'ordinal', protoOf(FeedbackSurveyStatusEnum).l2);
defineProp(protoOf(InvestorTierEnum), 'name', protoOf(InvestorTierEnum).k2);
defineProp(protoOf(InvestorTierEnum), 'ordinal', protoOf(InvestorTierEnum).l2);
defineProp(protoOf(LoginMethod), 'name', protoOf(LoginMethod).k2);
defineProp(protoOf(LoginMethod), 'ordinal', protoOf(LoginMethod).l2);
defineProp(protoOf(PermissionScope), 'name', protoOf(PermissionScope).k2);
defineProp(protoOf(PermissionScope), 'ordinal', protoOf(PermissionScope).l2);
defineProp(protoOf(SecretType), 'name', protoOf(SecretType).k2);
defineProp(protoOf(SecretType), 'ordinal', protoOf(SecretType).l2);
defineProp(protoOf(TransactionTypeEnum), 'name', protoOf(TransactionTypeEnum).k2);
defineProp(protoOf(TransactionTypeEnum), 'ordinal', protoOf(TransactionTypeEnum).l2);
defineProp(protoOf(TransactionStatusEnum), 'name', protoOf(TransactionStatusEnum).k2);
defineProp(protoOf(TransactionStatusEnum), 'ordinal', protoOf(TransactionStatusEnum).l2);
defineProp(protoOf(TwoFactor), 'name', protoOf(TwoFactor).k2);
defineProp(protoOf(TwoFactor), 'ordinal', protoOf(TwoFactor).l2);
defineProp(protoOf(ErrorCode), 'name', protoOf(ErrorCode).k2);
defineProp(protoOf(ErrorCode), 'ordinal', protoOf(ErrorCode).l2);
protoOf($serializer_10).a11 = typeParametersSerializers;
protoOf($serializer_11).a11 = typeParametersSerializers;
defineProp(protoOf(DividendPeriodStatus), 'name', protoOf(DividendPeriodStatus).k2);
defineProp(protoOf(DividendPeriodStatus), 'ordinal', protoOf(DividendPeriodStatus).l2);
defineProp(protoOf(PayoutStatus), 'name', protoOf(PayoutStatus).k2);
defineProp(protoOf(PayoutStatus), 'ordinal', protoOf(PayoutStatus).l2);
defineProp(protoOf(DivEarningsBreakdownType), 'name', protoOf(DivEarningsBreakdownType).k2);
defineProp(protoOf(DivEarningsBreakdownType), 'ordinal', protoOf(DivEarningsBreakdownType).l2);
protoOf($serializer_12).a11 = typeParametersSerializers;
protoOf($serializer_13).a11 = typeParametersSerializers;
protoOf($serializer_14).a11 = typeParametersSerializers;
protoOf($serializer_15).a11 = typeParametersSerializers;
protoOf($serializer_16).a11 = typeParametersSerializers;
protoOf($serializer_17).a11 = typeParametersSerializers;
protoOf($serializer_18).a11 = typeParametersSerializers;
protoOf($serializer_19).a11 = typeParametersSerializers;
protoOf($serializer_20).a11 = typeParametersSerializers;
protoOf($serializer_21).a11 = typeParametersSerializers;
protoOf($serializer_22).a11 = typeParametersSerializers;
defineProp(protoOf(OverallPortfolio), 'totalValue', function () {
  return this.n3y();
});
defineProp(protoOf(OverallPortfolio), 'divAllTime', function () {
  return this.o3y();
});
defineProp(protoOf(OverallPortfolio), 'nextDivEst', function () {
  return this.p3y();
});
protoOf($serializer_23).a11 = typeParametersSerializers;
protoOf($serializer_24).a11 = typeParametersSerializers;
protoOf($serializer_25).a11 = typeParametersSerializers;
defineProp(protoOf(Portfolio), 'totalValue', function () {
  return this.n3y();
});
defineProp(protoOf(Portfolio), 'nextDivEst', function () {
  return this.p3y();
});
defineProp(protoOf(Portfolio), 'divAllTime', function () {
  return this.o3y();
});
protoOf($serializer_26).a11 = typeParametersSerializers;
protoOf($serializer_27).a11 = typeParametersSerializers;
protoOf($serializer_28).a11 = typeParametersSerializers;
protoOf($serializer_29).a11 = typeParametersSerializers;
protoOf($serializer_30).a11 = typeParametersSerializers;
protoOf($serializer_31).a11 = typeParametersSerializers;
protoOf($serializer_32).a11 = typeParametersSerializers;
protoOf($serializer_33).a11 = typeParametersSerializers;
protoOf($serializer_34).a11 = typeParametersSerializers;
protoOf($serializer_35).a11 = typeParametersSerializers;
protoOf($serializer_36).a11 = typeParametersSerializers;
protoOf($serializer_37).a11 = typeParametersSerializers;
protoOf($serializer_38).a11 = typeParametersSerializers;
protoOf($serializer_39).a11 = typeParametersSerializers;
protoOf($serializer_40).a11 = typeParametersSerializers;
protoOf($serializer_41).a11 = typeParametersSerializers;
protoOf($serializer_42).a11 = typeParametersSerializers;
protoOf($serializer_43).a11 = typeParametersSerializers;
protoOf($serializer_44).a11 = typeParametersSerializers;
protoOf($serializer_45).a11 = typeParametersSerializers;
protoOf($serializer_46).a11 = typeParametersSerializers;
protoOf($serializer_47).a11 = typeParametersSerializers;
protoOf($serializer_48).a11 = typeParametersSerializers;
protoOf($serializer_49).a11 = typeParametersSerializers;
protoOf($serializer_50).a11 = typeParametersSerializers;
protoOf($serializer_51).a11 = typeParametersSerializers;
protoOf($serializer_52).a11 = typeParametersSerializers;
protoOf($serializer_53).a11 = typeParametersSerializers;
protoOf($serializer_54).a11 = typeParametersSerializers;
protoOf($serializer_55).a11 = typeParametersSerializers;
protoOf($serializer_56).a11 = typeParametersSerializers;
protoOf($serializer_57).a11 = typeParametersSerializers;
protoOf($serializer_58).a11 = typeParametersSerializers;
protoOf($serializer_59).a11 = typeParametersSerializers;
protoOf($serializer_60).a11 = typeParametersSerializers;
protoOf($serializer_61).a11 = typeParametersSerializers;
protoOf($serializer_62).a11 = typeParametersSerializers;
protoOf($serializer_63).a11 = typeParametersSerializers;
protoOf($serializer_64).a11 = typeParametersSerializers;
protoOf($serializer_65).a11 = typeParametersSerializers;
protoOf($serializer_66).a11 = typeParametersSerializers;
protoOf($serializer_67).a11 = typeParametersSerializers;
protoOf($serializer_68).a11 = typeParametersSerializers;
protoOf($serializer_69).a11 = typeParametersSerializers;
protoOf($serializer_70).a11 = typeParametersSerializers;
protoOf($serializer_71).a11 = typeParametersSerializers;
protoOf($serializer_72).a11 = typeParametersSerializers;
protoOf($serializer_73).a11 = typeParametersSerializers;
protoOf($serializer_74).a11 = typeParametersSerializers;
protoOf($serializer_75).a11 = typeParametersSerializers;
protoOf($serializer_76).a11 = typeParametersSerializers;
protoOf($serializer_77).a11 = typeParametersSerializers;
protoOf($serializer_78).a11 = typeParametersSerializers;
protoOf($serializer_79).a11 = typeParametersSerializers;
protoOf($serializer_80).a11 = typeParametersSerializers;
protoOf($serializer_81).a11 = typeParametersSerializers;
protoOf($serializer_82).a11 = typeParametersSerializers;
protoOf($serializer_83).a11 = typeParametersSerializers;
protoOf($serializer_84).a11 = typeParametersSerializers;
protoOf($serializer_85).a11 = typeParametersSerializers;
protoOf($serializer_86).a11 = typeParametersSerializers;
protoOf($serializer_87).a11 = typeParametersSerializers;
protoOf($serializer_88).a11 = typeParametersSerializers;
protoOf($serializer_89).a11 = typeParametersSerializers;
protoOf($serializer_90).a11 = typeParametersSerializers;
protoOf($serializer_91).a11 = typeParametersSerializers;
protoOf($serializer_92).a11 = typeParametersSerializers;
protoOf($serializer_93).a11 = typeParametersSerializers;
protoOf($serializer_94).a11 = typeParametersSerializers;
protoOf($serializer_95).a11 = typeParametersSerializers;
protoOf($serializer_96).a11 = typeParametersSerializers;
protoOf($serializer_97).a11 = typeParametersSerializers;
protoOf($serializer_98).a11 = typeParametersSerializers;
protoOf($serializer_99).a11 = typeParametersSerializers;
protoOf($serializer_100).a11 = typeParametersSerializers;
protoOf($serializer_101).a11 = typeParametersSerializers;
protoOf($serializer_102).a11 = typeParametersSerializers;
protoOf($serializer_103).a11 = typeParametersSerializers;
protoOf($serializer_104).a11 = typeParametersSerializers;
protoOf($serializer_105).a11 = typeParametersSerializers;
protoOf($serializer_106).a11 = typeParametersSerializers;
protoOf($serializer_107).a11 = typeParametersSerializers;
protoOf($serializer_108).a11 = typeParametersSerializers;
protoOf($serializer_109).a11 = typeParametersSerializers;
protoOf($serializer_110).a11 = typeParametersSerializers;
protoOf($serializer_111).a11 = typeParametersSerializers;
//endregion
//region block: init
AnalyticsChartType_instance = new AnalyticsChartType_0();
AnalyticsClickId_instance = new AnalyticsClickId_0();
AnalyticsContentId_instance = new AnalyticsContentId_0();
AnalyticsCtaId_instance = new AnalyticsCtaId_0();
AnalyticsDestination_instance = new AnalyticsDestination_0();
AnalyticsDropdownId_instance = new AnalyticsDropdownId_0();
AnalyticsEvents_instance = new AnalyticsEvents_0();
AnalyticsFilterType_instance = new AnalyticsFilterType_0();
AnalyticsFormId_instance = new AnalyticsFormId_0();
AnalyticsLinkId_instance = new AnalyticsLinkId_0();
AnalyticsNavLocation_instance = new AnalyticsNavLocation_0();
AnalyticsParams_instance = new AnalyticsParams_0();
AnalyticsScreenName_instance = new AnalyticsScreenName_0();
AnalyticsTimeRange_instance = new AnalyticsTimeRange_0();
AnalyticsUserProperties_instance = new AnalyticsUserProperties_0();
AnalyticsValue_instance = new AnalyticsValue_0();
Companion_instance = new Companion();
Companion_instance_3 = new Companion_3();
Companion_instance_6 = new Companion_6();
Companion_instance_9 = new Companion_9();
Companion_instance_21 = new Companion_21();
Companion_instance_22 = new Companion_22();
Companion_instance_23 = new Companion_23();
Companion_instance_30 = new Companion_30();
Companion_instance_32 = new Companion_32();
Companion_instance_33 = new Companion_33();
Companion_instance_34 = new Companion_34();
Companion_instance_35 = new Companion_35();
Companion_instance_36 = new Companion_36();
Companion_instance_37 = new Companion_37();
Companion_instance_39 = new Companion_39();
Companion_instance_40 = new Companion_40();
Companion_instance_42 = new Companion_42();
Companion_instance_43 = new Companion_43();
Companion_instance_44 = new Companion_44();
Companion_instance_45 = new Companion_45();
Companion_instance_46 = new Companion_46();
Companion_instance_47 = new Companion_47();
Companion_instance_48 = new Companion_48();
Companion_instance_49 = new Companion_49();
Companion_instance_50 = new Companion_50();
Companion_instance_51 = new Companion_51();
Companion_instance_52 = new Companion_52();
Companion_instance_53 = new Companion_53();
Companion_instance_55 = new Companion_55();
Companion_instance_57 = new Companion_57();
Companion_instance_58 = new Companion_58();
Companion_instance_59 = new Companion_59();
Companion_instance_60 = new Companion_60();
Companion_instance_61 = new Companion_61();
Companion_instance_62 = new Companion_62();
Companion_instance_63 = new Companion_63();
Companion_instance_64 = new Companion_64();
Companion_instance_65 = new Companion_65();
Companion_instance_66 = new Companion_66();
Companion_instance_67 = new Companion_67();
Companion_instance_68 = new Companion_68();
Companion_instance_69 = new Companion_69();
Companion_instance_70 = new Companion_70();
Companion_instance_71 = new Companion_71();
Companion_instance_72 = new Companion_72();
Companion_instance_73 = new Companion_73();
Companion_instance_74 = new Companion_74();
Companion_instance_75 = new Companion_75();
Companion_instance_76 = new Companion_76();
Companion_instance_77 = new Companion_77();
Companion_instance_78 = new Companion_78();
Companion_instance_79 = new Companion_79();
Companion_instance_80 = new Companion_80();
Companion_instance_82 = new Companion_82();
Companion_instance_83 = new Companion_83();
Companion_instance_84 = new Companion_84();
Companion_instance_85 = new Companion_85();
Companion_instance_86 = new Companion_86();
Companion_instance_87 = new Companion_87();
Companion_instance_88 = new Companion_88();
Companion_instance_89 = new Companion_89();
Companion_instance_91 = new Companion_91();
Companion_instance_92 = new Companion_92();
Companion_instance_93 = new Companion_93();
Companion_instance_95 = new Companion_95();
Companion_instance_96 = new Companion_96();
Companion_instance_98 = new Companion_98();
Companion_instance_99 = new Companion_99();
Companion_instance_100 = new Companion_100();
Companion_instance_101 = new Companion_101();
Companion_instance_102 = new Companion_102();
Companion_instance_103 = new Companion_103();
Companion_instance_105 = new Companion_105();
Companion_instance_108 = new Companion_108();
Companion_instance_109 = new Companion_109();
Companion_instance_110 = new Companion_110();
Companion_instance_111 = new Companion_111();
Companion_instance_112 = new Companion_112();
Companion_instance_113 = new Companion_113();
Companion_instance_114 = new Companion_114();
Companion_instance_115 = new Companion_115();
Companion_instance_116 = new Companion_116();
Companion_instance_117 = new Companion_117();
Companion_instance_118 = new Companion_118();
Companion_instance_119 = new Companion_119();
Companion_instance_120 = new Companion_120();
Companion_instance_122 = new Companion_122();
Companion_instance_123 = new Companion_123();
Companion_instance_124 = new Companion_124();
Companion_instance_125 = new Companion_125();
Companion_instance_129 = new Companion_129();
//endregion
//region block: exports
AnalyticsAuthErrorCode.values = values;
AnalyticsAuthErrorCode.valueOf = valueOf;
defineProp(AnalyticsAuthErrorCode, 'InvalidPassword', AnalyticsAuthErrorCode_InvalidPassword_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'InvalidMagicLink', AnalyticsAuthErrorCode_InvalidMagicLink_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'InvalidTotp', AnalyticsAuthErrorCode_InvalidTotp_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'InvalidPasskey', AnalyticsAuthErrorCode_InvalidPasskey_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'InvalidAppLock', AnalyticsAuthErrorCode_InvalidAppLock_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'AppLockUnavailable', AnalyticsAuthErrorCode_AppLockUnavailable_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'NetworkError', AnalyticsAuthErrorCode_NetworkError_getInstance, VOID, true);
defineProp(AnalyticsAuthErrorCode, 'Unknown', AnalyticsAuthErrorCode_Unknown_getInstance, VOID, true);
AnalyticsAuthMethod.values = values_0;
AnalyticsAuthMethod.valueOf = valueOf_0;
defineProp(AnalyticsAuthMethod, 'Email', AnalyticsAuthMethod_Email_getInstance, VOID, true);
defineProp(AnalyticsAuthMethod, 'Password', AnalyticsAuthMethod_Password_getInstance, VOID, true);
defineProp(AnalyticsAuthMethod, 'MagicLink', AnalyticsAuthMethod_MagicLink_getInstance, VOID, true);
defineProp(AnalyticsAuthMethod, 'Passkey', AnalyticsAuthMethod_Passkey_getInstance, VOID, true);
defineProp(AnalyticsAuthMethod, 'Totp', AnalyticsAuthMethod_Totp_getInstance, VOID, true);
defineProp(AnalyticsAuthMethod, 'SecurityConfig', AnalyticsAuthMethod_SecurityConfig_getInstance, VOID, true);
defineProp(AnalyticsAuthMethod, 'PayoutSetting', AnalyticsAuthMethod_PayoutSetting_getInstance, VOID, true);
AnalyticsAuthStage.values = values_1;
AnalyticsAuthStage.valueOf = valueOf_1;
defineProp(AnalyticsAuthStage, 'Initiated', AnalyticsAuthStage_Initiated_getInstance, VOID, true);
defineProp(AnalyticsAuthStage, 'Success', AnalyticsAuthStage_Success_getInstance, VOID, true);
defineProp(AnalyticsAuthStage, 'Failed', AnalyticsAuthStage_Failed_getInstance, VOID, true);
defineProp(AnalyticsAuthStage, 'Resend', AnalyticsAuthStage_Resend_getInstance, VOID, true);
defineProp(AnalyticsAuthStage, 'Retry', AnalyticsAuthStage_Retry_getInstance, VOID, true);
defineProp(AnalyticsAuthStage, 'MethodSwitch', AnalyticsAuthStage_MethodSwitch_getInstance, VOID, true);
defineProp(AnalyticsAuthStage, 'Back', AnalyticsAuthStage_Back_getInstance, VOID, true);
var AnalyticsChartType = {getInstance: AnalyticsChartType_getInstance};
var AnalyticsClickId = {getInstance: AnalyticsClickId_getInstance};
var AnalyticsContentId = {getInstance: AnalyticsContentId_getInstance};
AnalyticsContentType.values = values_2;
AnalyticsContentType.valueOf = valueOf_2;
defineProp(AnalyticsContentType, 'Property', AnalyticsContentType_Property_getInstance, VOID, true);
defineProp(AnalyticsContentType, 'Tooltip', AnalyticsContentType_Tooltip_getInstance, VOID, true);
var AnalyticsCtaId = {getInstance: AnalyticsCtaId_getInstance};
var AnalyticsDestination = {getInstance: AnalyticsDestination_getInstance};
var AnalyticsDropdownId = {getInstance: AnalyticsDropdownId_getInstance};
var AnalyticsEvents = {getInstance: AnalyticsEvents_getInstance};
var AnalyticsFilterType = {getInstance: AnalyticsFilterType_getInstance};
var AnalyticsFormId = {getInstance: AnalyticsFormId_getInstance};
AnalyticsFormOutcome.values = values_3;
AnalyticsFormOutcome.valueOf = valueOf_3;
defineProp(AnalyticsFormOutcome, 'Success', AnalyticsFormOutcome_Success_getInstance, VOID, true);
var AnalyticsLinkId = {getInstance: AnalyticsLinkId_getInstance};
var AnalyticsNavLocation = {getInstance: AnalyticsNavLocation_getInstance};
var AnalyticsParams = {getInstance: AnalyticsParams_getInstance};
AnalyticsPaymentType.values = values_4;
AnalyticsPaymentType.valueOf = valueOf_4;
defineProp(AnalyticsPaymentType, 'BankTransfer', AnalyticsPaymentType_BankTransfer_getInstance, VOID, true);
var AnalyticsScreenName = {getInstance: AnalyticsScreenName_getInstance};
var AnalyticsTimeRange = {getInstance: AnalyticsTimeRange_getInstance};
AnalyticsTransactionStage.values = values_5;
AnalyticsTransactionStage.valueOf = valueOf_5;
defineProp(AnalyticsTransactionStage, 'Initiated', AnalyticsTransactionStage_Initiated_getInstance, VOID, true);
defineProp(AnalyticsTransactionStage, 'Reserved', AnalyticsTransactionStage_Reserved_getInstance, VOID, true);
defineProp(AnalyticsTransactionStage, 'Pending', AnalyticsTransactionStage_Pending_getInstance, VOID, true);
AnalyticsTransactionType.values = values_6;
AnalyticsTransactionType.valueOf = valueOf_6;
defineProp(AnalyticsTransactionType, 'Buy', AnalyticsTransactionType_Buy_getInstance, VOID, true);
defineProp(AnalyticsTransactionType, 'Sell', AnalyticsTransactionType_Sell_getInstance, VOID, true);
var AnalyticsUserProperties = {getInstance: AnalyticsUserProperties_getInstance};
var AnalyticsValue = {getInstance: AnalyticsValue_getInstance};
defineProp(PasswordlessRequest, 'Companion', Companion_getInstance_2, VOID, true);
defineProp(PasswordlessResponse, 'Companion', Companion_getInstance_3, VOID, true);
defineProp(ProfileResponse, 'Companion', Companion_getInstance_4, VOID, true);
defineProp(RenewJWTRequest, 'Companion', Companion_getInstance_5, VOID, true);
defineProp(TokenResponse, 'Companion', Companion_getInstance_6, VOID, true);
defineProp(VerifyAuthRequest, 'Companion', Companion_getInstance_7, VOID, true);
defineProp(VerifyAuthResponse, 'Companion', Companion_getInstance_8, VOID, true);
defineProp(RequestChallengeResponse, 'Companion', Companion_getInstance_9, VOID, true);
defineProp(RequestChallengeResponsePublicKey, 'Companion', Companion_getInstance_10, VOID, true);
defineProp(RequestChallengeResponseAllowCredential, 'Companion', Companion_getInstance_11, VOID, true);
defineProp(VersionResponse, 'Companion', Companion_getInstance_12, VOID, true);
AccountStatus.values = values_7;
AccountStatus.valueOf = valueOf_7;
defineProp(AccountStatus, 'None', AccountStatus_None_getInstance, VOID, true);
defineProp(AccountStatus, 'Pending', AccountStatus_Pending_getInstance, VOID, true);
defineProp(AccountStatus, 'KycDeclined', AccountStatus_KycDeclined_getInstance, VOID, true);
defineProp(AccountStatus, 'KycVerified', AccountStatus_KycVerified_getInstance, VOID, true);
defineProp(AccountStatus, 'Complete', AccountStatus_Complete_getInstance, VOID, true);
defineProp(AccountStatus, 'Companion', Companion_getInstance_13, VOID, true);
ApiFeedbackSurveyTypeEnum.values = values_8;
ApiFeedbackSurveyTypeEnum.valueOf = valueOf_8;
defineProp(ApiFeedbackSurveyTypeEnum, 'none', ApiFeedbackSurveyTypeEnum_none_getInstance, VOID, true);
defineProp(ApiFeedbackSurveyTypeEnum, 'firstCompletedTransaction', ApiFeedbackSurveyTypeEnum_firstCompletedTransaction_getInstance, VOID, true);
defineProp(ApiFeedbackSurveyTypeEnum, 'firstCancelledTransaction', ApiFeedbackSurveyTypeEnum_firstCancelledTransaction_getInstance, VOID, true);
defineProp(ApiFeedbackSurveyTypeEnum, 'Companion', Companion_getInstance_14, VOID, true);
DevicePlatformEnum.values = values_9;
DevicePlatformEnum.valueOf = valueOf_9;
defineProp(DevicePlatformEnum, 'Android', DevicePlatformEnum_Android_getInstance, VOID, true);
defineProp(DevicePlatformEnum, 'Ios', DevicePlatformEnum_Ios_getInstance, VOID, true);
defineProp(DevicePlatformEnum, 'Web', DevicePlatformEnum_Web_getInstance, VOID, true);
defineProp(DevicePlatformEnum, 'Companion', Companion_getInstance_15, VOID, true);
FeedbackSurveyStatusEnum.values = values_10;
FeedbackSurveyStatusEnum.valueOf = valueOf_10;
defineProp(FeedbackSurveyStatusEnum, 'None', FeedbackSurveyStatusEnum_None_getInstance, VOID, true);
defineProp(FeedbackSurveyStatusEnum, 'Show', FeedbackSurveyStatusEnum_Show_getInstance, VOID, true);
defineProp(FeedbackSurveyStatusEnum, 'Done', FeedbackSurveyStatusEnum_Done_getInstance, VOID, true);
defineProp(FeedbackSurveyStatusEnum, 'Companion', Companion_getInstance_16, VOID, true);
InvestorTierEnum.values = values_11;
InvestorTierEnum.valueOf = valueOf_11;
defineProp(InvestorTierEnum, 'Enthusiast', InvestorTierEnum_Enthusiast_getInstance, VOID, true);
defineProp(InvestorTierEnum, 'Insider', InvestorTierEnum_Insider_getInstance, VOID, true);
defineProp(InvestorTierEnum, 'Trailblazer', InvestorTierEnum_Trailblazer_getInstance, VOID, true);
defineProp(InvestorTierEnum, 'Connoisseur', InvestorTierEnum_Connoisseur_getInstance, VOID, true);
defineProp(InvestorTierEnum, 'Visionary', InvestorTierEnum_Visionary_getInstance, VOID, true);
defineProp(InvestorTierEnum, 'Companion', Companion_getInstance_17, VOID, true);
LoginMethod.values = values_12;
LoginMethod.valueOf = valueOf_12;
defineProp(LoginMethod, 'magicLink', LoginMethod_magicLink_getInstance, VOID, true);
defineProp(LoginMethod, 'password', LoginMethod_password_getInstance, VOID, true);
defineProp(LoginMethod, 'webauthn', LoginMethod_webauthn_getInstance, VOID, true);
defineProp(LoginMethod, 'Companion', Companion_getInstance_18, VOID, true);
PermissionScope.values = values_13;
PermissionScope.valueOf = valueOf_13;
defineProp(PermissionScope, 'basic', PermissionScope_basic_getInstance, VOID, true);
defineProp(PermissionScope, 'security', PermissionScope_security_getInstance, VOID, true);
defineProp(PermissionScope, 'Companion', Companion_getInstance_19, VOID, true);
SecretType.values = values_14;
SecretType.valueOf = valueOf_14;
defineProp(SecretType, 'password', SecretType_password_getInstance, VOID, true);
defineProp(SecretType, 'magicLink', SecretType_magicLink_getInstance, VOID, true);
defineProp(SecretType, 'totp', SecretType_totp_getInstance, VOID, true);
defineProp(SecretType, 'webauthn', SecretType_webauthn_getInstance, VOID, true);
defineProp(SecretType, 'Companion', Companion_getInstance_20, VOID, true);
TransactionTypeEnum.values = values_15;
TransactionTypeEnum.valueOf = valueOf_15;
defineProp(TransactionTypeEnum, 'buy', TransactionTypeEnum_buy_getInstance, VOID, true);
defineProp(TransactionTypeEnum, 'sell', TransactionTypeEnum_sell_getInstance, VOID, true);
defineProp(TransactionTypeEnum, 'Companion', Companion_getInstance_21, VOID, true);
TransactionStatusEnum.values = values_16;
TransactionStatusEnum.valueOf = valueOf_16;
defineProp(TransactionStatusEnum, 'completed', TransactionStatusEnum_completed_getInstance, VOID, true);
defineProp(TransactionStatusEnum, 'cancelled', TransactionStatusEnum_cancelled_getInstance, VOID, true);
defineProp(TransactionStatusEnum, 'reserved', TransactionStatusEnum_reserved_getInstance, VOID, true);
defineProp(TransactionStatusEnum, 'pending', TransactionStatusEnum_pending_getInstance, VOID, true);
defineProp(TransactionStatusEnum, 'custom', TransactionStatusEnum_custom_getInstance, VOID, true);
defineProp(TransactionStatusEnum, 'Companion', Companion_getInstance_22, VOID, true);
TwoFactor.values = values_17;
TwoFactor.valueOf = valueOf_17;
defineProp(TwoFactor, 'totp', TwoFactor_totp_getInstance, VOID, true);
defineProp(TwoFactor, 'webauthn', TwoFactor_webauthn_getInstance, VOID, true);
defineProp(TwoFactor, 'Companion', Companion_getInstance_23, VOID, true);
ErrorCode.values = values_18;
ErrorCode.valueOf = valueOf_18;
defineProp(ErrorCode, 'InvalidEmail', ErrorCode_InvalidEmail_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidPassword', ErrorCode_InvalidPassword_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidBearerToken', ErrorCode_InvalidBearerToken_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidTotpCode', ErrorCode_InvalidTotpCode_getInstance, VOID, true);
defineProp(ErrorCode, 'PasswordTooShort', ErrorCode_PasswordTooShort_getInstance, VOID, true);
defineProp(ErrorCode, 'DuplicateLabel', ErrorCode_DuplicateLabel_getInstance, VOID, true);
defineProp(ErrorCode, 'SessionExpired', ErrorCode_SessionExpired_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidSession', ErrorCode_InvalidSession_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidSecret', ErrorCode_InvalidSecret_getInstance, VOID, true);
defineProp(ErrorCode, 'MissingIPAddress', ErrorCode_MissingIPAddress_getInstance, VOID, true);
defineProp(ErrorCode, 'WebauthnNotEnabled', ErrorCode_WebauthnNotEnabled_getInstance, VOID, true);
defineProp(ErrorCode, 'WebauthnIdError', ErrorCode_WebauthnIdError_getInstance, VOID, true);
defineProp(ErrorCode, 'WebauthnPasskeyRegistrationError', ErrorCode_WebauthnPasskeyRegistrationError_getInstance, VOID, true);
defineProp(ErrorCode, 'SecurityLevelRequired', ErrorCode_SecurityLevelRequired_getInstance, VOID, true);
defineProp(ErrorCode, 'BasicLevelRequired', ErrorCode_BasicLevelRequired_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidPasswordStrength', ErrorCode_InvalidPasswordStrength_getInstance, VOID, true);
defineProp(ErrorCode, 'PermissionDenied', ErrorCode_PermissionDenied_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidUserId', ErrorCode_InvalidUserId_getInstance, VOID, true);
defineProp(ErrorCode, 'UserProfileNotFound', ErrorCode_UserProfileNotFound_getInstance, VOID, true);
defineProp(ErrorCode, 'AccountClosed', ErrorCode_AccountClosed_getInstance, VOID, true);
defineProp(ErrorCode, 'UploadFail', ErrorCode_UploadFail_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidPropertyId', ErrorCode_InvalidPropertyId_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidStatus', ErrorCode_InvalidStatus_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidTarget', ErrorCode_InvalidTarget_getInstance, VOID, true);
defineProp(ErrorCode, 'MissSessionToken', ErrorCode_MissSessionToken_getInstance, VOID, true);
defineProp(ErrorCode, 'ExpireSession', ErrorCode_ExpireSession_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidSessionIdFormat', ErrorCode_InvalidSessionIdFormat_getInstance, VOID, true);
defineProp(ErrorCode, 'SessionIdUnavailable', ErrorCode_SessionIdUnavailable_getInstance, VOID, true);
defineProp(ErrorCode, 'RoleNotFound', ErrorCode_RoleNotFound_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidShares', ErrorCode_InvalidShares_getInstance, VOID, true);
defineProp(ErrorCode, 'NotEnoughShares', ErrorCode_NotEnoughShares_getInstance, VOID, true);
defineProp(ErrorCode, 'UnauthorizedAction', ErrorCode_UnauthorizedAction_getInstance, VOID, true);
defineProp(ErrorCode, 'TransactionNotFound', ErrorCode_TransactionNotFound_getInstance, VOID, true);
defineProp(ErrorCode, 'CalendarNotFound', ErrorCode_CalendarNotFound_getInstance, VOID, true);
defineProp(ErrorCode, 'TransactionInProgress', ErrorCode_TransactionInProgress_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidTransactionType', ErrorCode_InvalidTransactionType_getInstance, VOID, true);
defineProp(ErrorCode, 'UnverifiedBankAccount', ErrorCode_UnverifiedBankAccount_getInstance, VOID, true);
defineProp(ErrorCode, 'ParseError', ErrorCode_ParseError_getInstance, VOID, true);
defineProp(ErrorCode, 'ShuftiKeyConfigurationError', ErrorCode_ShuftiKeyConfigurationError_getInstance, VOID, true);
defineProp(ErrorCode, 'CalculationOverflow', ErrorCode_CalculationOverflow_getInstance, VOID, true);
defineProp(ErrorCode, 'UnauthorizedTransactionDueToKyc', ErrorCode_UnauthorizedTransactionDueToKyc_getInstance, VOID, true);
defineProp(ErrorCode, 'KycAlreadyInProgress', ErrorCode_KycAlreadyInProgress_getInstance, VOID, true);
defineProp(ErrorCode, 'UserNotFound', ErrorCode_UserNotFound_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidDividendPayoutRecordId', ErrorCode_InvalidDividendPayoutRecordId_getInstance, VOID, true);
defineProp(ErrorCode, 'NotFoundPayoutRecord', ErrorCode_NotFoundPayoutRecord_getInstance, VOID, true);
defineProp(ErrorCode, 'FileSaveError', ErrorCode_FileSaveError_getInstance, VOID, true);
defineProp(ErrorCode, 'FileReadError', ErrorCode_FileReadError_getInstance, VOID, true);
defineProp(ErrorCode, 'FileUploadError', ErrorCode_FileUploadError_getInstance, VOID, true);
defineProp(ErrorCode, 'TokenExpired', ErrorCode_TokenExpired_getInstance, VOID, true);
defineProp(ErrorCode, 'NoWebauthnDevice', ErrorCode_NoWebauthnDevice_getInstance, VOID, true);
defineProp(ErrorCode, 'MissingEnvironmentVariable', ErrorCode_MissingEnvironmentVariable_getInstance, VOID, true);
defineProp(ErrorCode, 'TokenPasswordInvalid', ErrorCode_TokenPasswordInvalid_getInstance, VOID, true);
defineProp(ErrorCode, 'NotEnoughMaturedShares', ErrorCode_NotEnoughMaturedShares_getInstance, VOID, true);
defineProp(ErrorCode, 'TransactionAlreadyCompleted', ErrorCode_TransactionAlreadyCompleted_getInstance, VOID, true);
defineProp(ErrorCode, 'TransactionAlreadyCancelled', ErrorCode_TransactionAlreadyCancelled_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidThreshold', ErrorCode_InvalidThreshold_getInstance, VOID, true);
defineProp(ErrorCode, 'FcmInvalidToken', ErrorCode_FcmInvalidToken_getInstance, VOID, true);
defineProp(ErrorCode, 'CannotDeleteSelf', ErrorCode_CannotDeleteSelf_getInstance, VOID, true);
defineProp(ErrorCode, 'LastSuperAdmin', ErrorCode_LastSuperAdmin_getInstance, VOID, true);
defineProp(ErrorCode, 'DatabaseError', ErrorCode_DatabaseError_getInstance, VOID, true);
defineProp(ErrorCode, 'WebauthnProcessError', ErrorCode_WebauthnProcessError_getInstance, VOID, true);
defineProp(ErrorCode, 'WrongOrigin', ErrorCode_WrongOrigin_getInstance, VOID, true);
defineProp(ErrorCode, 'PasswordCryptoError', ErrorCode_PasswordCryptoError_getInstance, VOID, true);
defineProp(ErrorCode, 'TotpError', ErrorCode_TotpError_getInstance, VOID, true);
defineProp(ErrorCode, 'PasswordStrengthError', ErrorCode_PasswordStrengthError_getInstance, VOID, true);
defineProp(ErrorCode, 'TokenParseError', ErrorCode_TokenParseError_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidUuidFormat', ErrorCode_InvalidUuidFormat_getInstance, VOID, true);
defineProp(ErrorCode, 'InvalidDateFormat', ErrorCode_InvalidDateFormat_getInstance, VOID, true);
defineProp(ErrorCode, 'PasskeyVerificationError', ErrorCode_PasskeyVerificationError_getInstance, VOID, true);
defineProp(ErrorCode, 'PasskeyRegistrationError', ErrorCode_PasskeyRegistrationError_getInstance, VOID, true);
defineProp(ErrorCode, 'PostmarkError', ErrorCode_PostmarkError_getInstance, VOID, true);
defineProp(ErrorCode, 'StrapiError', ErrorCode_StrapiError_getInstance, VOID, true);
defineProp(ErrorCode, 'ShuftiVerificationFailed', ErrorCode_ShuftiVerificationFailed_getInstance, VOID, true);
defineProp(ErrorCode, 'ShuftiRequestError', ErrorCode_ShuftiRequestError_getInstance, VOID, true);
defineProp(ErrorCode, 'ShuftiResponseError', ErrorCode_ShuftiResponseError_getInstance, VOID, true);
defineProp(ErrorCode, 'ZendeskRequestError', ErrorCode_ZendeskRequestError_getInstance, VOID, true);
defineProp(ErrorCode, 'ZendeskResponseError', ErrorCode_ZendeskResponseError_getInstance, VOID, true);
defineProp(ErrorCode, 'ZendeskTokenError', ErrorCode_ZendeskTokenError_getInstance, VOID, true);
defineProp(ErrorCode, 'StrapiUnexpectedContentType', ErrorCode_StrapiUnexpectedContentType_getInstance, VOID, true);
defineProp(ErrorCode, 'StrapiUnavailable', ErrorCode_StrapiUnavailable_getInstance, VOID, true);
defineProp(ErrorCode, 'UnknownError', ErrorCode_UnknownError_getInstance, VOID, true);
defineProp(ErrorCode, 'Companion', Companion_getInstance_24, VOID, true);
defineProp(MohaApiError, 'Companion', Companion_getInstance_25, VOID, true);
defineProp(Dividend, 'Companion', Companion_getInstance_26, VOID, true);
DividendPeriodStatus.values = values_19;
DividendPeriodStatus.valueOf = valueOf_19;
defineProp(DividendPeriodStatus, 'paid', DividendPeriodStatus_paid_getInstance, VOID, true);
defineProp(DividendPeriodStatus, 'partially_paid', DividendPeriodStatus_partially_paid_getInstance, VOID, true);
defineProp(DividendPeriodStatus, 'pending', DividendPeriodStatus_pending_getInstance, VOID, true);
defineProp(DividendPeriodStatus, 'Companion', Companion_getInstance_27, VOID, true);
PayoutStatus.values = values_20;
PayoutStatus.valueOf = valueOf_20;
defineProp(PayoutStatus, 'paid', PayoutStatus_paid_getInstance, VOID, true);
defineProp(PayoutStatus, 'pending', PayoutStatus_pending_getInstance, VOID, true);
defineProp(PayoutStatus, 'Companion', Companion_getInstance_28, VOID, true);
DivEarningsBreakdownType.values = values_21;
DivEarningsBreakdownType.valueOf = valueOf_21;
defineProp(DivEarningsBreakdownType, 'paid', DivEarningsBreakdownType_paid_getInstance, VOID, true);
defineProp(DivEarningsBreakdownType, 'projected', DivEarningsBreakdownType_projected_getInstance, VOID, true);
defineProp(DivEarningsBreakdownType, 'fee', DivEarningsBreakdownType_fee_getInstance, VOID, true);
defineProp(DivEarningsBreakdownType, 'Companion', Companion_getInstance_29, VOID, true);
defineProp(DivEarningsBreakdown, 'Companion', Companion_getInstance_30, VOID, true);
defineProp(DividendPeriodPayout, 'Companion', Companion_getInstance_31, VOID, true);
defineProp(DividendPeriod, 'Companion', Companion_getInstance_32, VOID, true);
defineProp(Fund, 'Companion', Companion_getInstance_33, VOID, true);
defineProp(TickersResponse, 'Companion', Companion_getInstance_34, VOID, true);
defineProp(KycReferenceResponse, 'Companion', Companion_getInstance_35, VOID, true);
defineProp(ShuftiMobileConfigResponse, 'Companion', Companion_getInstance_36, VOID, true);
VerifyKycResponse.Success = Success;
defineProp(VerifyKycResponse.Success, 'Companion', Companion_getInstance_37, VOID, true);
VerifyKycResponse.Error = Error_0;
defineProp(VerifyKycResponse.Error, 'Companion', Companion_getInstance_38, VOID, true);
defineProp(VerifyKycResponse, 'Companion', Companion_getInstance_39, VOID, true);
defineProp(VerifyKyErrorDetails, 'Companion', Companion_getInstance_40, VOID, true);
defineProp(OverallPortfolio, 'Companion', Companion_getInstance_41, VOID, true);
defineProp(EstimatedDividend, 'Companion', Companion_getInstance_42, VOID, true);
defineProp(Position, 'Companion', Companion_getInstance_43, VOID, true);
defineProp(Portfolio, 'Companion', Companion_getInstance_44, VOID, true);
defineProp(LotDetail, 'Companion', Companion_getInstance_45, VOID, true);
defineProp(ChartPoint, 'Companion', Companion_getInstance_46, VOID, true);
defineProp(CreatePropertyRequest, 'Companion', Companion_getInstance_47, VOID, true);
defineProp(CreatePropertyResponse, 'Companion', Companion_getInstance_48, VOID, true);
defineProp(UploadHoldingsRequest, 'Companion', Companion_getInstance_49, VOID, true);
defineProp(ActivateTotpResponse, 'Companion', Companion_getInstance_90, VOID, true);
defineProp(EnablePasswordRequest, 'Companion', Companion_getInstance_91, VOID, true);
defineProp(GetUserSettingsResponseEnable, 'Companion', Companion_getInstance_92, VOID, true);
defineProp(GetUserSettingsResponseWebAuthn, 'Companion', Companion_getInstance_93, VOID, true);
defineProp(WebAuthnDevice, 'Companion', Companion_getInstance_94, VOID, true);
defineProp(GetUserSettingsResponse, 'Companion', Companion_getInstance_95, VOID, true);
defineProp(RegisterWebAuthnRequest, 'Companion', Companion_getInstance_96, VOID, true);
defineProp(RegisterWebAuthnRequestResponse, 'Companion', Companion_getInstance_97, VOID, true);
defineProp(RegisterWebAuthnRequestClientExtensionResults, 'Companion', Companion_getInstance_98, VOID, true);
defineProp(RegisterWebAuthnRequestCredProps, 'Companion', Companion_getInstance_99, VOID, true);
defineProp(SetDefault2FARequest, 'Companion', Companion_getInstance_100, VOID, true);
defineProp(StartRegisterWebAuthnRequest, 'Companion', Companion_getInstance_101, VOID, true);
defineProp(PublicKeyCredentialCreationRp, 'Companion', Companion_getInstance_102, VOID, true);
defineProp(PublicKeyCredentialCreationUser, 'Companion', Companion_getInstance_103, VOID, true);
defineProp(PublicKeyCredentialCreationPubKeyCredParam, 'Companion', Companion_getInstance_104, VOID, true);
defineProp(PublicKeyCredentialCreationAuthenticatorSelection, 'Companion', Companion_getInstance_105, VOID, true);
defineProp(PublicKeyCredentialCreationExtensions, 'Companion', Companion_getInstance_106, VOID, true);
defineProp(MHPublicKeyCredentialCreationOptions, 'Companion', Companion_getInstance_107, VOID, true);
defineProp(StartRegisterWebAuthnResponse, 'Companion', Companion_getInstance_108, VOID, true);
defineProp(FeedbackSurveyStatusRequest, 'Companion', Companion_getInstance_109, VOID, true);
defineProp(SupportFormResponse, 'Companion', Companion_getInstance_110, VOID, true);
defineProp(SupportFormTicketResponse, 'Companion', Companion_getInstance_111, VOID, true);
defineProp(SupportFormTicketResponseTicket, 'Companion', Companion_getInstance_112, VOID, true);
defineProp(SupportFormUploadResponse, 'Companion', Companion_getInstance_113, VOID, true);
defineProp(SupportFormUploadResponseUpload, 'Companion', Companion_getInstance_114, VOID, true);
defineProp(SupportFormUploadResponseUploadAttachment, 'Companion', Companion_getInstance_115, VOID, true);
defineProp(IsoDate, 'Companion', Companion_getInstance_116, VOID, true);
defineProp(IsoTimestamp, 'Companion', Companion_getInstance_117, VOID, true);
defineProp(UuidString, 'Companion', Companion_getInstance_118, VOID, true);
defineProp(AccountHolderDetailsRequest, 'Companion', Companion_getInstance_119, VOID, true);
defineProp(BankDetails, 'Companion', Companion_getInstance_120, VOID, true);
defineProp(BankDetailsResponse, 'Companion', Companion_getInstance_121, VOID, true);
defineProp(PayoutBankDetails, 'Companion', Companion_getInstance_122, VOID, true);
defineProp(PersonalDetails, 'Companion', Companion_getInstance_123, VOID, true);
defineProp(RegisterFcmTokenRequest, 'Companion', Companion_getInstance_124, VOID, true);
defineProp(RegisterFcmTokenResponse, 'Companion', Companion_getInstance_125, VOID, true);
defineProp(ReserveShareInfoResponse, 'Companion', Companion_getInstance_126, VOID, true);
defineProp(ReserveSharesResponse, 'Companion', Companion_getInstance_127, VOID, true);
defineProp(SellSharesResponse, 'Companion', Companion_getInstance_128, VOID, true);
defineProp(TransactSharesRequest, 'Companion', Companion_getInstance_129, VOID, true);
defineProp(TransactionRecord, 'Companion', Companion_getInstance_130, VOID, true);
defineProp(TransactionStatus, 'Companion', Companion_getInstance_131, VOID, true);
defineProp(UpdateThresholdRequest, 'Companion', Companion_getInstance_132, VOID, true);
defineProp(UpdateTransactionStatusRequest, 'Companion', Companion_getInstance_133, VOID, true);
export {
  AnalyticsAuthErrorCode as AnalyticsAuthErrorCode,
  AnalyticsAuthMethod as AnalyticsAuthMethod,
  AnalyticsAuthStage as AnalyticsAuthStage,
  AnalyticsChartType as AnalyticsChartType,
  AnalyticsClickId as AnalyticsClickId,
  AnalyticsContentId as AnalyticsContentId,
  AnalyticsContentType as AnalyticsContentType,
  AnalyticsCtaId as AnalyticsCtaId,
  AnalyticsDestination as AnalyticsDestination,
  AnalyticsDropdownId as AnalyticsDropdownId,
  AnalyticsEvents as AnalyticsEvents,
  AnalyticsFilterType as AnalyticsFilterType,
  AnalyticsFormId as AnalyticsFormId,
  AnalyticsFormOutcome as AnalyticsFormOutcome,
  AnalyticsLinkId as AnalyticsLinkId,
  AnalyticsNavLocation as AnalyticsNavLocation,
  AnalyticsParams as AnalyticsParams,
  AnalyticsPaymentType as AnalyticsPaymentType,
  AnalyticsScreenName as AnalyticsScreenName,
  AnalyticsTimeRange as AnalyticsTimeRange,
  AnalyticsTransactionStage as AnalyticsTransactionStage,
  AnalyticsTransactionType as AnalyticsTransactionType,
  AnalyticsUserProperties as AnalyticsUserProperties,
  AnalyticsValue as AnalyticsValue,
  PasswordlessRequest as PasswordlessRequest,
  PasswordlessResponse as PasswordlessResponse,
  ProfileResponse as ProfileResponse,
  RenewJWTRequest as RenewJWTRequest,
  TokenResponse as TokenResponse,
  VerifyAuthRequest as VerifyAuthRequest,
  VerifyAuthResponse as VerifyAuthResponse,
  RequestChallengeResponse as RequestChallengeResponse,
  RequestChallengeResponsePublicKey as RequestChallengeResponsePublicKey,
  RequestChallengeResponseAllowCredential as RequestChallengeResponseAllowCredential,
  VersionResponse as VersionResponse,
  AccountStatus as AccountStatus,
  ApiFeedbackSurveyTypeEnum as ApiFeedbackSurveyTypeEnum,
  DevicePlatformEnum as DevicePlatformEnum,
  FeedbackSurveyStatusEnum as FeedbackSurveyStatusEnum,
  InvestorTierEnum as InvestorTierEnum,
  LoginMethod as LoginMethod,
  PermissionScope as PermissionScope,
  SecretType as SecretType,
  TransactionTypeEnum as TransactionTypeEnum,
  TransactionStatusEnum as TransactionStatusEnum,
  TwoFactor as TwoFactor,
  ErrorCode as ErrorCode,
  MohaApiError as MohaApiError,
  Dividend as Dividend,
  DividendPeriodStatus as DividendPeriodStatus,
  PayoutStatus as PayoutStatus,
  DivEarningsBreakdownType as DivEarningsBreakdownType,
  DivEarningsBreakdown as DivEarningsBreakdown,
  DividendPeriodPayout as DividendPeriodPayout,
  DividendPeriod as DividendPeriod,
  Fund as Fund,
  TickersResponse as TickersResponse,
  KycReferenceResponse as KycReferenceResponse,
  ShuftiMobileConfigResponse as ShuftiMobileConfigResponse,
  VerifyKycResponse as VerifyKycResponse,
  VerifyKyErrorDetails as VerifyKyErrorDetails,
  OverallPortfolio as OverallPortfolio,
  EstimatedDividend as EstimatedDividend,
  Position as Position,
  Portfolio as Portfolio,
  LotDetail as LotDetail,
  ChartPoint as ChartPoint,
  CreatePropertyRequest as CreatePropertyRequest,
  CreatePropertyResponse as CreatePropertyResponse,
  UploadHoldingsRequest as UploadHoldingsRequest,
  ActivateTotpResponse as ActivateTotpResponse,
  EnablePasswordRequest as EnablePasswordRequest,
  GetUserSettingsResponseEnable as GetUserSettingsResponseEnable,
  GetUserSettingsResponseWebAuthn as GetUserSettingsResponseWebAuthn,
  WebAuthnDevice as WebAuthnDevice,
  GetUserSettingsResponse as GetUserSettingsResponse,
  RegisterWebAuthnRequest as RegisterWebAuthnRequest,
  RegisterWebAuthnRequestResponse as RegisterWebAuthnRequestResponse,
  RegisterWebAuthnRequestClientExtensionResults as RegisterWebAuthnRequestClientExtensionResults,
  RegisterWebAuthnRequestCredProps as RegisterWebAuthnRequestCredProps,
  SetDefault2FARequest as SetDefault2FARequest,
  StartRegisterWebAuthnRequest as StartRegisterWebAuthnRequest,
  PublicKeyCredentialCreationRp as PublicKeyCredentialCreationRp,
  PublicKeyCredentialCreationUser as PublicKeyCredentialCreationUser,
  PublicKeyCredentialCreationPubKeyCredParam as PublicKeyCredentialCreationPubKeyCredParam,
  PublicKeyCredentialCreationAuthenticatorSelection as PublicKeyCredentialCreationAuthenticatorSelection,
  PublicKeyCredentialCreationExtensions as PublicKeyCredentialCreationExtensions,
  MHPublicKeyCredentialCreationOptions as MHPublicKeyCredentialCreationOptions,
  StartRegisterWebAuthnResponse as StartRegisterWebAuthnResponse,
  FeedbackSurveyStatusRequest as FeedbackSurveyStatusRequest,
  SupportFormResponse as SupportFormResponse,
  SupportFormTicketResponse as SupportFormTicketResponse,
  SupportFormTicketResponseTicket as SupportFormTicketResponseTicket,
  SupportFormUploadResponse as SupportFormUploadResponse,
  SupportFormUploadResponseUpload as SupportFormUploadResponseUpload,
  SupportFormUploadResponseUploadAttachment as SupportFormUploadResponseUploadAttachment,
  IsoDate as IsoDate,
  IsoTimestamp as IsoTimestamp,
  UuidString as UuidString,
  AccountHolderDetailsRequest as AccountHolderDetailsRequest,
  BankDetails as BankDetails,
  BankDetailsResponse as BankDetailsResponse,
  PayoutBankDetails as PayoutBankDetails,
  PersonalDetails as PersonalDetails,
  RegisterFcmTokenRequest as RegisterFcmTokenRequest,
  RegisterFcmTokenResponse as RegisterFcmTokenResponse,
  ReserveShareInfoResponse as ReserveShareInfoResponse,
  ReserveSharesResponse as ReserveSharesResponse,
  SellSharesResponse as SellSharesResponse,
  TransactSharesRequest as TransactSharesRequest,
  TransactionRecord as TransactionRecord,
  TransactionStatus as TransactionStatus,
  UpdateThresholdRequest as UpdateThresholdRequest,
  UpdateTransactionStatusRequest as UpdateTransactionStatusRequest,
};
export {
  get_entries as get_entries3ifkndp1evolz,
  get_entries_0 as get_entries14ydze8nsb9e,
  get_entries_1 as get_entries2p7wnxtcj1mg5,
  get_entries_2 as get_entries2j5earejsv5ll,
  get_entries_3 as get_entries18myouobfih0c,
  get_entries_4 as get_entries2jxp3jwj8froh,
  get_entries_5 as get_entries1hx5le0fn1rqb,
  get_entries_6 as get_entries6c9v1m45yee0,
  PasswordlessRequest as PasswordlessRequest35wgt3vqxfmfe,
  PasswordlessResponse as PasswordlessResponset2pukmuyxlqa,
  ProfileResponse as ProfileResponse1o2in0ldjf9dd,
  RenewJWTRequest as RenewJWTRequest1mk3dv6s0dxeq,
  TokenResponse as TokenResponse2q0j6memfvdik,
  VerifyAuthRequest as VerifyAuthRequestu1m6r8fkyrbk,
  VerifyAuthResponse as VerifyAuthResponse2hw1uz6y4xldx,
  VersionResponse as VersionResponse4fxzdp0imuew,
  MohaApiError as MohaApiError1mmj01q2n107f,
  Dividend as Dividend13uy3v3ufon5g,
  Fund as Fund17cmmx1pdv9pv,
  TickersResponse as TickersResponse2u2m8giidacbh,
  KycReferenceResponse as KycReferenceResponseylis1axq1mp5,
  ShuftiMobileConfigResponse as ShuftiMobileConfigResponse2nxm2vjfkxsam,
  VerifyKycResponse as VerifyKycResponse2nyh26qvpb0iy,
  OverallPortfolio as OverallPortfoliooz253xxrtek0,
  Portfolio as Portfolio1nte626ctd28b,
  Passwordless as Passwordless1yui2e9rtxuag,
  Profile as Profile2kyfxvidnvm0x,
  Renew as Renew1256nwjdynoc7,
  ShuftiReference as ShuftiReference30tdeqyl0am3,
  ShuftiVerification as ShuftiVerification37levmshekzil,
  Verify as Verify1kyi6v8mtpv41,
  ByPath_0 as ByPath2wk1gttq1bcqz,
  ByPath as ByPath1btaysd3jmnk0,
  ByTicker as ByTickeraf3fakg1gmc,
  Dividends as Dividendsomkj29yro5s2,
  List as Listqdr0lx4qfnk5,
  Password as Password3rxi03j666k2h,
  SetDefault2FA as SetDefault2FA32erb9m6knvua,
  Settings as Settingsrvlk809zxbiu,
  Totp as Totp32aml8smjkcvq,
  WebAuthnByUuid as WebAuthnByUuid2ujvvl5lomat8,
  WebAuthnRegister as WebAuthnRegister2qsohci2t743w,
  WebAuthn as WebAuthn341k1ojgztdp3,
  MobileConfig as MobileConfig1v89eswuf6liu,
  BankAccountBeneficiary as BankAccountBeneficiary2hi08vd7s1419,
  BankAccount as BankAccount2h6kihe2j15ka,
  CreateTransaction as CreateTransaction1rwbxkscuawwe,
  DepositBankDetail as DepositBankDetail3c7ox53yfv5d6,
  FeedbackSurvey as FeedbackSurvey3vp82nhlnjeia,
  PayoutBank as PayoutBankcr094lapo4no,
  PortfolioByTicker as PortfolioByTicker1a41vlv52es5k,
  Portfolios as Portfolios1vutefzwya11b,
  Reservation as Reservationcxsdyviyf7c7,
  ShuftiAccessToken as ShuftiAccessToken2mu6h4jz47uv3,
  TransactionById as TransactionById1wqr6nbx6q9xd,
  Transactions as Transactions2tzyceteo9zng,
  UpdateThreshold as UpdateThreshold1l4tvml2lck57,
  VersionRoute as VersionRoute2gru9rkiwxh8k,
  ActivateTotpResponse as ActivateTotpResponse31jprqh7ytuxi,
  EnablePasswordRequest as EnablePasswordRequest1n787h4pe3ymu,
  GetUserSettingsResponse as GetUserSettingsResponse9segeiap3s4v,
  RegisterWebAuthnRequest as RegisterWebAuthnRequest1frhf8dw2vrmi,
  SetDefault2FARequest as SetDefault2FARequestd9d6jmuequ1x,
  StartRegisterWebAuthnRequest as StartRegisterWebAuthnRequest2vwvxjg3es17p,
  StartRegisterWebAuthnResponse as StartRegisterWebAuthnResponse2em292n560d0j,
  FeedbackSurveyStatusRequest as FeedbackSurveyStatusRequest34o64wn9c73vc,
  UuidString as UuidString17vl2rqksifzl,
  toIsoDate as toIsoDate9wlhacait6cj,
  AccountHolderDetailsRequest as AccountHolderDetailsRequest25097omkyp3s8,
  BankDetailsResponse as BankDetailsResponse3n9eqzg4tilye,
  BankDetails as BankDetails2hea5mi3p2nyu,
  PayoutBankDetails as PayoutBankDetailsokvg5cxx2txs,
  ReserveShareInfoResponse as ReserveShareInfoResponsezkcsy8rluynx,
  ReserveSharesResponse as ReserveSharesResponse7mcipwfl2avr,
  SellSharesResponse as SellSharesResponse2425bwyp1nn16,
  TransactSharesRequest as TransactSharesRequestlxs3z80yw3l2,
  TransactionRecord as TransactionRecord1r30zj3s1jfxv,
  UpdateThresholdRequest as UpdateThresholdRequestdn288ps6v22l,
  UpdateTransactionStatusRequest as UpdateTransactionStatusRequest2m31i89cy262p,
  ErrorCode_BasicLevelRequired_getInstance as ErrorCode_BasicLevelRequired_getInstancejjhdbowdispi,
  ErrorCode_DatabaseError_getInstance as ErrorCode_DatabaseError_getInstance3a2jcugf768ty,
  ErrorCode_ExpireSession_getInstance as ErrorCode_ExpireSession_getInstance120s0scs2fy40,
  ErrorCode_InvalidBearerToken_getInstance as ErrorCode_InvalidBearerToken_getInstance12qy5q2fwveay,
  ErrorCode_InvalidSession_getInstance as ErrorCode_InvalidSession_getInstance2x0hhaejup2dc,
  ErrorCode_MissSessionToken_getInstance as ErrorCode_MissSessionToken_getInstance16u8lquvpoa5v,
  ErrorCode_SecurityLevelRequired_getInstance as ErrorCode_SecurityLevelRequired_getInstance2r7yttgr3ep4e,
  ErrorCode_SessionExpired_getInstance as ErrorCode_SessionExpired_getInstance1laf5jm549jto,
  ErrorCode_SessionIdUnavailable_getInstance as ErrorCode_SessionIdUnavailable_getInstance2qvo44fhhien0,
  ErrorCode_TokenExpired_getInstance as ErrorCode_TokenExpired_getInstancevh7wgc97urrh,
  ErrorCode_TokenParseError_getInstance as ErrorCode_TokenParseError_getInstanceha10gsgytx7v,
  ErrorCode_UnknownError_getInstance as ErrorCode_UnknownError_getInstancebgjycztnhdbs,
  ErrorCode_UserProfileNotFound_getInstance as ErrorCode_UserProfileNotFound_getInstance31wyg3wnit9zn,
  AnalyticsChartType_instance as AnalyticsChartType_instance39lnbx1yaz45q,
  AnalyticsClickId_instance as AnalyticsClickId_instance3s2xw7v0ou659,
  AnalyticsContentId_instance as AnalyticsContentId_instance32jauqd33hibe,
  AnalyticsCtaId_instance as AnalyticsCtaId_instance3lq5z5tu546yd,
  AnalyticsDestination_instance as AnalyticsDestination_instanceo3dj3cu0pblk,
  AnalyticsDropdownId_instance as AnalyticsDropdownId_instance2fih60yf8eh25,
  AnalyticsEvents_instance as AnalyticsEvents_instancedhqwkudd24nb,
  AnalyticsFilterType_instance as AnalyticsFilterType_instanceflphg47twsrz,
  AnalyticsFormId_instance as AnalyticsFormId_instanceqbqtx3mk6ei2,
  AnalyticsLinkId_instance as AnalyticsLinkId_instance1k9rfjip9dlmq,
  AnalyticsNavLocation_instance as AnalyticsNavLocation_instance294no1166fls2,
  AnalyticsParams_instance as AnalyticsParams_instance1xtro2vygt6vd,
  AnalyticsScreenName_instance as AnalyticsScreenName_instance1gwhp2c5j7ecv,
  AnalyticsTimeRange_instance as AnalyticsTimeRange_instance1vg7g76xr57io,
  AnalyticsValue_instance as AnalyticsValue_instancea5ou2w9av6rr,
  LocalDateSerializer_getInstance as LocalDateSerializer_getInstances6oxxhf7qst,
};
//endregion

//# sourceMappingURL=MoreHarvest-shared.mjs.map
